webpackJsonp([1],Array(39).concat([
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  app: {
    test: window.location.hostname === 'test.m.wkbins.com' || window.location.hostname === 'test1.m.wkbins.com'
  },
  images: {
    root: 'static/images/',
    banner: 'banner.png',
    wkbLogo: 'wkb_logo.png',
    partnerLogo: 'hengqin_logo.png' },
  navs: [{
    name: '产品介绍',
    ref: 'nav1'
  }, {
    name: '常见问题',
    ref: 'nav2'
  }, {
    name: '用户评价',
    ref: 'nav3'
  }, {
    name: '理赔流程',
    ref: 'nav4'
  }],
  audio: 'static/audios/bossm4a.m4a',
  questions: [{
    q: '为什么悟空保定制的产品性价比是完爆香港保险的？',
    a: '香港保险一直都是低价优质的保险代言词，但也存在以下弊端：复杂产品设计导致销售误导，高额渠道成本导致价格昂贵，冗长服务流程导致体验不好。 悟空保产品理念是：产品极简，价格最低，体验最好！1、将理财和风险保障分开，产品标准，易比价，让普通百姓从此看懂保险，而不至于被误导；2、将定价和渠道费用压缩，成本下降，更实惠，让普通百姓从此少花金钱，却拥有高额保障；3、将投保和理赔服务挂网，线上体验，更便捷，让普通百姓从此自主选择，且免受杂乱骚扰。'
  }, {
    q: '为什么要购买定期寿险？',
    a: '定期寿险的功能是阶段性规避家庭主要经济支柱因为风险而全残或离去，用高额的保险赔偿金替代原本未来可以持续攀升的薪资等收入，来履行父母赡养、孩子抚养和配偶责任等未竟的人生义务，让家人的生活品质不降低，活得更有尊严！ 定期寿险的本质是对家人的爱与责任，让家人有安全感，希望每个家庭都有一份至尊保，后顾无忧，将爱进行到底！ 买保险，再也不用去香港，只找悟空保！'
  }, {
    q: '从悟空保购买保险有什么优势？',
    a: '1.产品真正回归保障，行业原创且独家销售；2.价格完爆香港保险，降低成本，提升保额，提升家庭风险保障杠杆；3.产品保额高达百万，免体检，无需提供房车、收入等隐私材料，用户体验大幅提升。'
  }, {
    q: '至尊保定期寿险的购买有地区限制吗？',
    a: '全国（不含港澳台）各地均可投保。'
  }, {
    q: '至尊保定期寿险可以给家人投保吗？',
    a: '仅限为本人投保，不接受为他人投保。'
  }, {
    q: '至尊保定期寿险有等待期吗？',
    a: '至尊保定期寿险，等待期仅90天。'
  }],
  h5Questions: [{
    q: '为什么要购买定期寿险？',
    a: '定期寿险的功能是阶段性规避家庭主要经济支柱因为风险而全残或离去，用高额的保险赔偿金替代原本未来可以持续攀升的薪资等收入，来履行父母赡养、孩子抚养和配偶责任等未竟的人生义务，让家人的生活品质不降低，活得更有尊严！ 定期寿险的本质是对家人的爱与责任，让家人有安全感，希望每个家庭都有一份至尊保，后顾无忧，将爱进行到底！ 买保险，再也不用去香港，只找悟空保！'
  }, {
    q: '至尊保定期寿险的购买有地区限制吗？',
    a: '全国（不含港澳台）各地均可投保。'
  }, {
    q: '至尊保定期寿险可以给家人投保吗？',
    a: '仅限为本人投保，不接受为他人投保。'
  }, {
    q: '至尊保定期寿险有等待期吗？',
    a: '至尊保定期寿险，等待期仅90天。'
  }],
  processNotice: 'static/docs/lipeixuzhi.html' });

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getMeasurePayment: function getMeasurePayment(that) {
    var data = {
      productCode: that.$store.state.order.productId,
      sex: that.sex,
      age: that.$store.getters.ageFromBirthday,
      payType: that.paymentPeriod,
      durationPeriodValue: that.$store.state.order.insurancePeriod,
      durationPeriodType: '1',
      coverageMultiples: that.$store.state.order.insuranceAmount
    };
    if (that.$store.state.order.insurancePeriod === '60' || that.$store.state.order.insurancePeriod === '65' || that.$store.state.order.insurancePeriod === '70') {
      data.durationPeriodType = '2';
    }
    var queryString = '?sex=' + data.sex + '&age=' + data.age + '&payType=' + data.payType + '&durationPeriodValue=' + data.durationPeriodValue + '&durationPeriodType=' + data.durationPeriodType + '&productCode=' + data.productCode + '&innerCode=' + that.$route.params.userId + '&utm_source=' + (that.$route.query.utm_source || '') + '&calculationCode=' + (that.$route.query.calculationCode || '') + '&coverageMultiples=' + data.coverageMultiples;
    that.$http.get('/api/illness/getFee' + queryString).then(function (response) {
      that.$store.commit('updateMeasurePayment', response.data);
    });
  },
  getPaymentByIDNumber: function getPaymentByIDNumber(that) {
    var data = {
      productCode: that.$store.state.order.productId,
      sex: that.$store.getters.sexFromIDNumber,
      age: that.$store.getters.ageFromIDNumber,
      payType: that.paymentPeriod,
      durationPeriodValue: that.$store.state.order.insurancePeriod,
      durationPeriodType: '1'
    };
    if (that.$store.state.order.insurancePeriod === '60' || that.$store.state.order.insurancePeriod === '65' || that.$store.state.order.insurancePeriod === '70') {
      data.durationPeriodType = '2';
    }
    var queryString = '?sex=' + data.sex + '&age=' + data.age + '&payType=' + data.payType + '&durationPeriodValue=' + data.durationPeriodValue + '&durationPeriodType=' + data.durationPeriodType + '&productCode=' + data.productCode + '&innerCode=' + that.$route.params.userId + '&utm_source=' + that.$route.query.utm_source;
    that.$http.get('/api/illness/getFee' + queryString).then(function (response) {
      that.$store.commit('updatePaymentByIDNumber', response.data);
    });
  },
  getH5Configuration: function getH5Configuration(that) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      that.$http.get('/api/channel/hqdqx/queryCustomInfo/' + that.$store.state.order.userId + '/' + that.$store.state.order.productId).then(function (response) {
        for (var i in response.data) {
          that.$set(that.$store.state.h5.configuration, i, response.data[i]);
        }
        if (response.data === null) {
          that.$set(that.$store.state.h5.configuration, 'isNull', true);
        } else {
          that.$set(that.$store.state.h5.configuration, 'isNull', false);
        }
        resolve(response.data);
      });
    });
  }
});

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isWX: function isWX() {
    return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ? true : false;
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCookie: function getCookie(cname) {
    var myCookie = null;
    if (document.cookie.length > 0) {
      var cstart = document.cookie.indexOf(cname + '=');
      if (cstart !== -1) {
        cstart = cstart + cname.length + 1;
        var cend = document.cookie.indexOf(';', cstart);
        if (cend === -1) cend = document.cookie.length;
        myCookie = unescape(document.cookie.substring(cstart, cend));
      }
    }

    return myCookie;
  },
  setCookie: function setCookie(cname, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = cname + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString()) + ';path=/';
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (birthday) {
  if (typeof birthday !== 'string') {
    return null;
  }

  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthday)) {
    return null;
  }

  var birthdayArr = birthday.split('-');
  var birthdayYear = Number(birthdayArr[0]);
  var birthdayMonth = Number(birthdayArr[1]);
  var birthdayDate = Number(birthdayArr[2]);

  var nowUTC = new Date();
  var nowYear = nowUTC.getFullYear();
  var nowMonth = nowUTC.getMonth() + 1;
  var nowDate = nowUTC.getDate();

  var y = nowYear - birthdayYear;
  if (nowMonth < birthdayMonth || nowMonth === birthdayMonth && nowDate < birthdayDate) {
    y--;
  }

  if (y < 0) {
    return null;
  }

  return y;
});

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "北京市",
		"value": "110000"
	},
	{
		"name": "天津市",
		"value": "120000"
	},
	{
		"name": "河北省",
		"value": "130000"
	},
	{
		"name": "山西省",
		"value": "140000"
	},
	{
		"name": "内蒙古自治区",
		"value": "150000"
	},
	{
		"name": "辽宁省",
		"value": "210000"
	},
	{
		"name": "吉林省",
		"value": "220000"
	},
	{
		"name": "黑龙江省",
		"value": "230000"
	},
	{
		"name": "上海市",
		"value": "310000"
	},
	{
		"name": "江苏省",
		"value": "320000"
	},
	{
		"name": "浙江省",
		"value": "330000"
	},
	{
		"name": "安徽省",
		"value": "340000"
	},
	{
		"name": "福建省",
		"value": "350000"
	},
	{
		"name": "江西省",
		"value": "360000"
	},
	{
		"name": "山东省",
		"value": "370000"
	},
	{
		"name": "河南省",
		"value": "410000"
	},
	{
		"name": "湖北省",
		"value": "420000"
	},
	{
		"name": "湖南省",
		"value": "430000"
	},
	{
		"name": "广东省",
		"value": "440000"
	},
	{
		"name": "广西壮族自治区",
		"value": "450000"
	},
	{
		"name": "海南省",
		"value": "460000"
	},
	{
		"name": "重庆市",
		"value": "500000"
	},
	{
		"name": "四川省",
		"value": "510000"
	},
	{
		"name": "贵州省",
		"value": "520000"
	},
	{
		"name": "云南省",
		"value": "530000"
	},
	{
		"name": "西藏自治区",
		"value": "540000"
	},
	{
		"name": "陕西省",
		"value": "610000"
	},
	{
		"name": "甘肃省",
		"value": "620000"
	},
	{
		"name": "青海省",
		"value": "630000"
	},
	{
		"name": "宁夏回族自治区",
		"value": "640000"
	},
	{
		"name": "新疆维吾尔自治区",
		"value": "650000"
	},
	{
		"name": "市辖区",
		"value": "110100",
		"parent": "110000"
	},
	{
		"name": "东城区",
		"value": "110101",
		"parent": "110100"
	},
	{
		"name": "西城区",
		"value": "110102",
		"parent": "110100"
	},
	{
		"name": "朝阳区",
		"value": "110105",
		"parent": "110100"
	},
	{
		"name": "丰台区",
		"value": "110106",
		"parent": "110100"
	},
	{
		"name": "石景山区",
		"value": "110107",
		"parent": "110100"
	},
	{
		"name": "海淀区",
		"value": "110108",
		"parent": "110100"
	},
	{
		"name": "门头沟区",
		"value": "110109",
		"parent": "110100"
	},
	{
		"name": "房山区",
		"value": "110111",
		"parent": "110100"
	},
	{
		"name": "通州区",
		"value": "110112",
		"parent": "110100"
	},
	{
		"name": "顺义区",
		"value": "110113",
		"parent": "110100"
	},
	{
		"name": "昌平区",
		"value": "110114",
		"parent": "110100"
	},
	{
		"name": "大兴区",
		"value": "110115",
		"parent": "110100"
	},
	{
		"name": "怀柔区",
		"value": "110116",
		"parent": "110100"
	},
	{
		"name": "平谷区",
		"value": "110117",
		"parent": "110100"
	},
	{
		"name": "密云县",
		"value": "110228",
		"parent": "110100"
	},
	{
		"name": "延庆县",
		"value": "110229",
		"parent": "110100"
	},
	{
		"name": "市辖区",
		"value": "120100",
		"parent": "120000"
	},
	{
		"name": "和平区",
		"value": "120101",
		"parent": "120100"
	},
	{
		"name": "河东区",
		"value": "120102",
		"parent": "120100"
	},
	{
		"name": "河西区",
		"value": "120103",
		"parent": "120100"
	},
	{
		"name": "南开区",
		"value": "120104",
		"parent": "120100"
	},
	{
		"name": "河北区",
		"value": "120105",
		"parent": "120100"
	},
	{
		"name": "红桥区",
		"value": "120106",
		"parent": "120100"
	},
	{
		"name": "东丽区",
		"value": "120110",
		"parent": "120100"
	},
	{
		"name": "西青区",
		"value": "120111",
		"parent": "120100"
	},
	{
		"name": "津南区",
		"value": "120112",
		"parent": "120100"
	},
	{
		"name": "北辰区",
		"value": "120113",
		"parent": "120100"
	},
	{
		"name": "武清区",
		"value": "120114",
		"parent": "120100"
	},
	{
		"name": "宝坻区",
		"value": "120115",
		"parent": "120100"
	},
	{
		"name": "滨海新区",
		"value": "120116",
		"parent": "120100"
	},
	{
		"name": "宁河区",
		"value": "120117",
		"parent": "120100"
	},
	{
		"name": "静海区",
		"value": "120118",
		"parent": "120100"
	},
	{
		"name": "蓟县",
		"value": "120225",
		"parent": "120100"
	},
	{
		"name": "石家庄市",
		"value": "130100",
		"parent": "130000"
	},
	{
		"name": "唐山市",
		"value": "130200",
		"parent": "130000"
	},
	{
		"name": "秦皇岛市",
		"value": "130300",
		"parent": "130000"
	},
	{
		"name": "邯郸市",
		"value": "130400",
		"parent": "130000"
	},
	{
		"name": "邢台市",
		"value": "130500",
		"parent": "130000"
	},
	{
		"name": "保定市",
		"value": "130600",
		"parent": "130000"
	},
	{
		"name": "张家口市",
		"value": "130700",
		"parent": "130000"
	},
	{
		"name": "承德市",
		"value": "130800",
		"parent": "130000"
	},
	{
		"name": "沧州市",
		"value": "130900",
		"parent": "130000"
	},
	{
		"name": "廊坊市",
		"value": "131000",
		"parent": "130000"
	},
	{
		"name": "衡水市",
		"value": "131100",
		"parent": "130000"
	},
	{
		"name": "定州市",
		"value": "139001",
		"parent": "130000"
	},
	{
		"name": "辛集市",
		"value": "139002",
		"parent": "130000"
	},
	{
		"name": "长安区",
		"value": "130102",
		"parent": "130100"
	},
	{
		"name": "桥西区",
		"value": "130104",
		"parent": "130100"
	},
	{
		"name": "新华区",
		"value": "130105",
		"parent": "130100"
	},
	{
		"name": "井陉矿区",
		"value": "130107",
		"parent": "130100"
	},
	{
		"name": "裕华区",
		"value": "130108",
		"parent": "130100"
	},
	{
		"name": "藁城区",
		"value": "130109",
		"parent": "130100"
	},
	{
		"name": "鹿泉区",
		"value": "130110",
		"parent": "130100"
	},
	{
		"name": "栾城区",
		"value": "130111",
		"parent": "130100"
	},
	{
		"name": "井陉县",
		"value": "130121",
		"parent": "130100"
	},
	{
		"name": "正定县",
		"value": "130123",
		"parent": "130100"
	},
	{
		"name": "行唐县",
		"value": "130125",
		"parent": "130100"
	},
	{
		"name": "灵寿县",
		"value": "130126",
		"parent": "130100"
	},
	{
		"name": "高邑县",
		"value": "130127",
		"parent": "130100"
	},
	{
		"name": "深泽县",
		"value": "130128",
		"parent": "130100"
	},
	{
		"name": "赞皇县",
		"value": "130129",
		"parent": "130100"
	},
	{
		"name": "无极县",
		"value": "130130",
		"parent": "130100"
	},
	{
		"name": "平山县",
		"value": "130131",
		"parent": "130100"
	},
	{
		"name": "元氏县",
		"value": "130132",
		"parent": "130100"
	},
	{
		"name": "赵县",
		"value": "130133",
		"parent": "130100"
	},
	{
		"name": "晋州市",
		"value": "130183",
		"parent": "130100"
	},
	{
		"name": "新乐市",
		"value": "130184",
		"parent": "130100"
	},
	{
		"name": "路南区",
		"value": "130202",
		"parent": "130200"
	},
	{
		"name": "路北区",
		"value": "130203",
		"parent": "130200"
	},
	{
		"name": "古冶区",
		"value": "130204",
		"parent": "130200"
	},
	{
		"name": "开平区",
		"value": "130205",
		"parent": "130200"
	},
	{
		"name": "丰南区",
		"value": "130207",
		"parent": "130200"
	},
	{
		"name": "丰润区",
		"value": "130208",
		"parent": "130200"
	},
	{
		"name": "曹妃甸区",
		"value": "130209",
		"parent": "130200"
	},
	{
		"name": "滦县",
		"value": "130223",
		"parent": "130200"
	},
	{
		"name": "滦南县",
		"value": "130224",
		"parent": "130200"
	},
	{
		"name": "乐亭县",
		"value": "130225",
		"parent": "130200"
	},
	{
		"name": "迁西县",
		"value": "130227",
		"parent": "130200"
	},
	{
		"name": "玉田县",
		"value": "130229",
		"parent": "130200"
	},
	{
		"name": "遵化市",
		"value": "130281",
		"parent": "130200"
	},
	{
		"name": "迁安市",
		"value": "130283",
		"parent": "130200"
	},
	{
		"name": "海港区",
		"value": "130302",
		"parent": "130300"
	},
	{
		"name": "山海关区",
		"value": "130303",
		"parent": "130300"
	},
	{
		"name": "北戴河区",
		"value": "130304",
		"parent": "130300"
	},
	{
		"name": "抚宁区",
		"value": "130306",
		"parent": "130300"
	},
	{
		"name": "青龙满族自治县",
		"value": "130321",
		"parent": "130300"
	},
	{
		"name": "昌黎县",
		"value": "130322",
		"parent": "130300"
	},
	{
		"name": "卢龙县",
		"value": "130324",
		"parent": "130300"
	},
	{
		"name": "邯山区",
		"value": "130402",
		"parent": "130400"
	},
	{
		"name": "丛台区",
		"value": "130403",
		"parent": "130400"
	},
	{
		"name": "复兴区",
		"value": "130404",
		"parent": "130400"
	},
	{
		"name": "峰峰矿区",
		"value": "130406",
		"parent": "130400"
	},
	{
		"name": "邯郸县",
		"value": "130421",
		"parent": "130400"
	},
	{
		"name": "临漳县",
		"value": "130423",
		"parent": "130400"
	},
	{
		"name": "成安县",
		"value": "130424",
		"parent": "130400"
	},
	{
		"name": "大名县",
		"value": "130425",
		"parent": "130400"
	},
	{
		"name": "涉县",
		"value": "130426",
		"parent": "130400"
	},
	{
		"name": "磁县",
		"value": "130427",
		"parent": "130400"
	},
	{
		"name": "肥乡县",
		"value": "130428",
		"parent": "130400"
	},
	{
		"name": "永年县",
		"value": "130429",
		"parent": "130400"
	},
	{
		"name": "邱县",
		"value": "130430",
		"parent": "130400"
	},
	{
		"name": "鸡泽县",
		"value": "130431",
		"parent": "130400"
	},
	{
		"name": "广平县",
		"value": "130432",
		"parent": "130400"
	},
	{
		"name": "馆陶县",
		"value": "130433",
		"parent": "130400"
	},
	{
		"name": "魏县",
		"value": "130434",
		"parent": "130400"
	},
	{
		"name": "曲周县",
		"value": "130435",
		"parent": "130400"
	},
	{
		"name": "武安市",
		"value": "130481",
		"parent": "130400"
	},
	{
		"name": "桥东区",
		"value": "130502",
		"parent": "130500"
	},
	{
		"name": "桥西区",
		"value": "130503",
		"parent": "130500"
	},
	{
		"name": "邢台县",
		"value": "130521",
		"parent": "130500"
	},
	{
		"name": "临城县",
		"value": "130522",
		"parent": "130500"
	},
	{
		"name": "内丘县",
		"value": "130523",
		"parent": "130500"
	},
	{
		"name": "柏乡县",
		"value": "130524",
		"parent": "130500"
	},
	{
		"name": "隆尧县",
		"value": "130525",
		"parent": "130500"
	},
	{
		"name": "任县",
		"value": "130526",
		"parent": "130500"
	},
	{
		"name": "南和县",
		"value": "130527",
		"parent": "130500"
	},
	{
		"name": "宁晋县",
		"value": "130528",
		"parent": "130500"
	},
	{
		"name": "巨鹿县",
		"value": "130529",
		"parent": "130500"
	},
	{
		"name": "新河县",
		"value": "130530",
		"parent": "130500"
	},
	{
		"name": "广宗县",
		"value": "130531",
		"parent": "130500"
	},
	{
		"name": "平乡县",
		"value": "130532",
		"parent": "130500"
	},
	{
		"name": "威县",
		"value": "130533",
		"parent": "130500"
	},
	{
		"name": "清河县",
		"value": "130534",
		"parent": "130500"
	},
	{
		"name": "临西县",
		"value": "130535",
		"parent": "130500"
	},
	{
		"name": "南宫市",
		"value": "130581",
		"parent": "130500"
	},
	{
		"name": "沙河市",
		"value": "130582",
		"parent": "130500"
	},
	{
		"name": "竞秀区",
		"value": "130602",
		"parent": "130600"
	},
	{
		"name": "莲池区",
		"value": "130606",
		"parent": "130600"
	},
	{
		"name": "满城区",
		"value": "130607",
		"parent": "130600"
	},
	{
		"name": "清苑区",
		"value": "130608",
		"parent": "130600"
	},
	{
		"name": "徐水区",
		"value": "130609",
		"parent": "130600"
	},
	{
		"name": "涞水县",
		"value": "130623",
		"parent": "130600"
	},
	{
		"name": "阜平县",
		"value": "130624",
		"parent": "130600"
	},
	{
		"name": "定兴县",
		"value": "130626",
		"parent": "130600"
	},
	{
		"name": "唐县",
		"value": "130627",
		"parent": "130600"
	},
	{
		"name": "高阳县",
		"value": "130628",
		"parent": "130600"
	},
	{
		"name": "容城县",
		"value": "130629",
		"parent": "130600"
	},
	{
		"name": "涞源县",
		"value": "130630",
		"parent": "130600"
	},
	{
		"name": "望都县",
		"value": "130631",
		"parent": "130600"
	},
	{
		"name": "安新县",
		"value": "130632",
		"parent": "130600"
	},
	{
		"name": "易县",
		"value": "130633",
		"parent": "130600"
	},
	{
		"name": "曲阳县",
		"value": "130634",
		"parent": "130600"
	},
	{
		"name": "蠡县",
		"value": "130635",
		"parent": "130600"
	},
	{
		"name": "顺平县",
		"value": "130636",
		"parent": "130600"
	},
	{
		"name": "博野县",
		"value": "130637",
		"parent": "130600"
	},
	{
		"name": "雄县",
		"value": "130638",
		"parent": "130600"
	},
	{
		"name": "涿州市",
		"value": "130681",
		"parent": "130600"
	},
	{
		"name": "安国市",
		"value": "130683",
		"parent": "130600"
	},
	{
		"name": "高碑店市",
		"value": "130684",
		"parent": "130600"
	},
	{
		"name": "桥东区",
		"value": "130702",
		"parent": "130700"
	},
	{
		"name": "桥西区",
		"value": "130703",
		"parent": "130700"
	},
	{
		"name": "宣化区",
		"value": "130705",
		"parent": "130700"
	},
	{
		"name": "下花园区",
		"value": "130706",
		"parent": "130700"
	},
	{
		"name": "宣化县",
		"value": "130721",
		"parent": "130700"
	},
	{
		"name": "张北县",
		"value": "130722",
		"parent": "130700"
	},
	{
		"name": "康保县",
		"value": "130723",
		"parent": "130700"
	},
	{
		"name": "沽源县",
		"value": "130724",
		"parent": "130700"
	},
	{
		"name": "尚义县",
		"value": "130725",
		"parent": "130700"
	},
	{
		"name": "蔚县",
		"value": "130726",
		"parent": "130700"
	},
	{
		"name": "阳原县",
		"value": "130727",
		"parent": "130700"
	},
	{
		"name": "怀安县",
		"value": "130728",
		"parent": "130700"
	},
	{
		"name": "万全县",
		"value": "130729",
		"parent": "130700"
	},
	{
		"name": "怀来县",
		"value": "130730",
		"parent": "130700"
	},
	{
		"name": "涿鹿县",
		"value": "130731",
		"parent": "130700"
	},
	{
		"name": "赤城县",
		"value": "130732",
		"parent": "130700"
	},
	{
		"name": "崇礼县",
		"value": "130733",
		"parent": "130700"
	},
	{
		"name": "双桥区",
		"value": "130802",
		"parent": "130800"
	},
	{
		"name": "双滦区",
		"value": "130803",
		"parent": "130800"
	},
	{
		"name": "鹰手营子矿区",
		"value": "130804",
		"parent": "130800"
	},
	{
		"name": "承德县",
		"value": "130821",
		"parent": "130800"
	},
	{
		"name": "兴隆县",
		"value": "130822",
		"parent": "130800"
	},
	{
		"name": "平泉县",
		"value": "130823",
		"parent": "130800"
	},
	{
		"name": "滦平县",
		"value": "130824",
		"parent": "130800"
	},
	{
		"name": "隆化县",
		"value": "130825",
		"parent": "130800"
	},
	{
		"name": "丰宁满族自治县",
		"value": "130826",
		"parent": "130800"
	},
	{
		"name": "宽城满族自治县",
		"value": "130827",
		"parent": "130800"
	},
	{
		"name": "围场满族蒙古族自治县",
		"value": "130828",
		"parent": "130800"
	},
	{
		"name": "新华区",
		"value": "130902",
		"parent": "130900"
	},
	{
		"name": "运河区",
		"value": "130903",
		"parent": "130900"
	},
	{
		"name": "沧县",
		"value": "130921",
		"parent": "130900"
	},
	{
		"name": "青县",
		"value": "130922",
		"parent": "130900"
	},
	{
		"name": "东光县",
		"value": "130923",
		"parent": "130900"
	},
	{
		"name": "海兴县",
		"value": "130924",
		"parent": "130900"
	},
	{
		"name": "盐山县",
		"value": "130925",
		"parent": "130900"
	},
	{
		"name": "肃宁县",
		"value": "130926",
		"parent": "130900"
	},
	{
		"name": "南皮县",
		"value": "130927",
		"parent": "130900"
	},
	{
		"name": "吴桥县",
		"value": "130928",
		"parent": "130900"
	},
	{
		"name": "献县",
		"value": "130929",
		"parent": "130900"
	},
	{
		"name": "孟村回族自治县",
		"value": "130930",
		"parent": "130900"
	},
	{
		"name": "泊头市",
		"value": "130981",
		"parent": "130900"
	},
	{
		"name": "任丘市",
		"value": "130982",
		"parent": "130900"
	},
	{
		"name": "黄骅市",
		"value": "130983",
		"parent": "130900"
	},
	{
		"name": "河间市",
		"value": "130984",
		"parent": "130900"
	},
	{
		"name": "安次区",
		"value": "131002",
		"parent": "131000"
	},
	{
		"name": "广阳区",
		"value": "131003",
		"parent": "131000"
	},
	{
		"name": "固安县",
		"value": "131022",
		"parent": "131000"
	},
	{
		"name": "永清县",
		"value": "131023",
		"parent": "131000"
	},
	{
		"name": "香河县",
		"value": "131024",
		"parent": "131000"
	},
	{
		"name": "大城县",
		"value": "131025",
		"parent": "131000"
	},
	{
		"name": "文安县",
		"value": "131026",
		"parent": "131000"
	},
	{
		"name": "大厂回族自治县",
		"value": "131028",
		"parent": "131000"
	},
	{
		"name": "霸州市",
		"value": "131081",
		"parent": "131000"
	},
	{
		"name": "三河市",
		"value": "131082",
		"parent": "131000"
	},
	{
		"name": "桃城区",
		"value": "131102",
		"parent": "131100"
	},
	{
		"name": "枣强县",
		"value": "131121",
		"parent": "131100"
	},
	{
		"name": "武邑县",
		"value": "131122",
		"parent": "131100"
	},
	{
		"name": "武强县",
		"value": "131123",
		"parent": "131100"
	},
	{
		"name": "饶阳县",
		"value": "131124",
		"parent": "131100"
	},
	{
		"name": "安平县",
		"value": "131125",
		"parent": "131100"
	},
	{
		"name": "故城县",
		"value": "131126",
		"parent": "131100"
	},
	{
		"name": "景县",
		"value": "131127",
		"parent": "131100"
	},
	{
		"name": "阜城县",
		"value": "131128",
		"parent": "131100"
	},
	{
		"name": "冀州市",
		"value": "131181",
		"parent": "131100"
	},
	{
		"name": "深州市",
		"value": "131182",
		"parent": "131100"
	},
	{
		"name": "太原市",
		"value": "140100",
		"parent": "140000"
	},
	{
		"name": "大同市",
		"value": "140200",
		"parent": "140000"
	},
	{
		"name": "阳泉市",
		"value": "140300",
		"parent": "140000"
	},
	{
		"name": "长治市",
		"value": "140400",
		"parent": "140000"
	},
	{
		"name": "晋城市",
		"value": "140500",
		"parent": "140000"
	},
	{
		"name": "朔州市",
		"value": "140600",
		"parent": "140000"
	},
	{
		"name": "晋中市",
		"value": "140700",
		"parent": "140000"
	},
	{
		"name": "运城市",
		"value": "140800",
		"parent": "140000"
	},
	{
		"name": "忻州市",
		"value": "140900",
		"parent": "140000"
	},
	{
		"name": "临汾市",
		"value": "141000",
		"parent": "140000"
	},
	{
		"name": "吕梁市",
		"value": "141100",
		"parent": "140000"
	},
	{
		"name": "小店区",
		"value": "140105",
		"parent": "140100"
	},
	{
		"name": "迎泽区",
		"value": "140106",
		"parent": "140100"
	},
	{
		"name": "杏花岭区",
		"value": "140107",
		"parent": "140100"
	},
	{
		"name": "尖草坪区",
		"value": "140108",
		"parent": "140100"
	},
	{
		"name": "万柏林区",
		"value": "140109",
		"parent": "140100"
	},
	{
		"name": "晋源区",
		"value": "140110",
		"parent": "140100"
	},
	{
		"name": "清徐县",
		"value": "140121",
		"parent": "140100"
	},
	{
		"name": "阳曲县",
		"value": "140122",
		"parent": "140100"
	},
	{
		"name": "娄烦县",
		"value": "140123",
		"parent": "140100"
	},
	{
		"name": "古交市",
		"value": "140181",
		"parent": "140100"
	},
	{
		"name": "城区",
		"value": "140202",
		"parent": "140200"
	},
	{
		"name": "矿区",
		"value": "140203",
		"parent": "140200"
	},
	{
		"name": "南郊区",
		"value": "140211",
		"parent": "140200"
	},
	{
		"name": "新荣区",
		"value": "140212",
		"parent": "140200"
	},
	{
		"name": "阳高县",
		"value": "140221",
		"parent": "140200"
	},
	{
		"name": "天镇县",
		"value": "140222",
		"parent": "140200"
	},
	{
		"name": "广灵县",
		"value": "140223",
		"parent": "140200"
	},
	{
		"name": "灵丘县",
		"value": "140224",
		"parent": "140200"
	},
	{
		"name": "浑源县",
		"value": "140225",
		"parent": "140200"
	},
	{
		"name": "左云县",
		"value": "140226",
		"parent": "140200"
	},
	{
		"name": "大同县",
		"value": "140227",
		"parent": "140200"
	},
	{
		"name": "城区",
		"value": "140302",
		"parent": "140300"
	},
	{
		"name": "矿区",
		"value": "140303",
		"parent": "140300"
	},
	{
		"name": "郊区",
		"value": "140311",
		"parent": "140300"
	},
	{
		"name": "平定县",
		"value": "140321",
		"parent": "140300"
	},
	{
		"name": "盂县",
		"value": "140322",
		"parent": "140300"
	},
	{
		"name": "城区",
		"value": "140402",
		"parent": "140400"
	},
	{
		"name": "郊区",
		"value": "140411",
		"parent": "140400"
	},
	{
		"name": "长治县",
		"value": "140421",
		"parent": "140400"
	},
	{
		"name": "襄垣县",
		"value": "140423",
		"parent": "140400"
	},
	{
		"name": "屯留县",
		"value": "140424",
		"parent": "140400"
	},
	{
		"name": "平顺县",
		"value": "140425",
		"parent": "140400"
	},
	{
		"name": "黎城县",
		"value": "140426",
		"parent": "140400"
	},
	{
		"name": "壶关县",
		"value": "140427",
		"parent": "140400"
	},
	{
		"name": "长子县",
		"value": "140428",
		"parent": "140400"
	},
	{
		"name": "武乡县",
		"value": "140429",
		"parent": "140400"
	},
	{
		"name": "沁县",
		"value": "140430",
		"parent": "140400"
	},
	{
		"name": "沁源县",
		"value": "140431",
		"parent": "140400"
	},
	{
		"name": "潞城市",
		"value": "140481",
		"parent": "140400"
	},
	{
		"name": "城区",
		"value": "140502",
		"parent": "140500"
	},
	{
		"name": "沁水县",
		"value": "140521",
		"parent": "140500"
	},
	{
		"name": "阳城县",
		"value": "140522",
		"parent": "140500"
	},
	{
		"name": "陵川县",
		"value": "140524",
		"parent": "140500"
	},
	{
		"name": "泽州县",
		"value": "140525",
		"parent": "140500"
	},
	{
		"name": "高平市",
		"value": "140581",
		"parent": "140500"
	},
	{
		"name": "朔城区",
		"value": "140602",
		"parent": "140600"
	},
	{
		"name": "平鲁区",
		"value": "140603",
		"parent": "140600"
	},
	{
		"name": "山阴县",
		"value": "140621",
		"parent": "140600"
	},
	{
		"name": "应县",
		"value": "140622",
		"parent": "140600"
	},
	{
		"name": "右玉县",
		"value": "140623",
		"parent": "140600"
	},
	{
		"name": "怀仁县",
		"value": "140624",
		"parent": "140600"
	},
	{
		"name": "榆次区",
		"value": "140702",
		"parent": "140700"
	},
	{
		"name": "榆社县",
		"value": "140721",
		"parent": "140700"
	},
	{
		"name": "左权县",
		"value": "140722",
		"parent": "140700"
	},
	{
		"name": "和顺县",
		"value": "140723",
		"parent": "140700"
	},
	{
		"name": "昔阳县",
		"value": "140724",
		"parent": "140700"
	},
	{
		"name": "寿阳县",
		"value": "140725",
		"parent": "140700"
	},
	{
		"name": "太谷县",
		"value": "140726",
		"parent": "140700"
	},
	{
		"name": "祁县",
		"value": "140727",
		"parent": "140700"
	},
	{
		"name": "平遥县",
		"value": "140728",
		"parent": "140700"
	},
	{
		"name": "灵石县",
		"value": "140729",
		"parent": "140700"
	},
	{
		"name": "介休市",
		"value": "140781",
		"parent": "140700"
	},
	{
		"name": "盐湖区",
		"value": "140802",
		"parent": "140800"
	},
	{
		"name": "临猗县",
		"value": "140821",
		"parent": "140800"
	},
	{
		"name": "万荣县",
		"value": "140822",
		"parent": "140800"
	},
	{
		"name": "闻喜县",
		"value": "140823",
		"parent": "140800"
	},
	{
		"name": "稷山县",
		"value": "140824",
		"parent": "140800"
	},
	{
		"name": "新绛县",
		"value": "140825",
		"parent": "140800"
	},
	{
		"name": "绛县",
		"value": "140826",
		"parent": "140800"
	},
	{
		"name": "垣曲县",
		"value": "140827",
		"parent": "140800"
	},
	{
		"name": "夏县",
		"value": "140828",
		"parent": "140800"
	},
	{
		"name": "平陆县",
		"value": "140829",
		"parent": "140800"
	},
	{
		"name": "芮城县",
		"value": "140830",
		"parent": "140800"
	},
	{
		"name": "永济市",
		"value": "140881",
		"parent": "140800"
	},
	{
		"name": "河津市",
		"value": "140882",
		"parent": "140800"
	},
	{
		"name": "忻府区",
		"value": "140902",
		"parent": "140900"
	},
	{
		"name": "定襄县",
		"value": "140921",
		"parent": "140900"
	},
	{
		"name": "五台县",
		"value": "140922",
		"parent": "140900"
	},
	{
		"name": "代县",
		"value": "140923",
		"parent": "140900"
	},
	{
		"name": "繁峙县",
		"value": "140924",
		"parent": "140900"
	},
	{
		"name": "宁武县",
		"value": "140925",
		"parent": "140900"
	},
	{
		"name": "静乐县",
		"value": "140926",
		"parent": "140900"
	},
	{
		"name": "神池县",
		"value": "140927",
		"parent": "140900"
	},
	{
		"name": "五寨县",
		"value": "140928",
		"parent": "140900"
	},
	{
		"name": "岢岚县",
		"value": "140929",
		"parent": "140900"
	},
	{
		"name": "河曲县",
		"value": "140930",
		"parent": "140900"
	},
	{
		"name": "保德县",
		"value": "140931",
		"parent": "140900"
	},
	{
		"name": "偏关县",
		"value": "140932",
		"parent": "140900"
	},
	{
		"name": "原平市",
		"value": "140981",
		"parent": "140900"
	},
	{
		"name": "尧都区",
		"value": "141002",
		"parent": "141000"
	},
	{
		"name": "曲沃县",
		"value": "141021",
		"parent": "141000"
	},
	{
		"name": "翼城县",
		"value": "141022",
		"parent": "141000"
	},
	{
		"name": "襄汾县",
		"value": "141023",
		"parent": "141000"
	},
	{
		"name": "洪洞县",
		"value": "141024",
		"parent": "141000"
	},
	{
		"name": "古县",
		"value": "141025",
		"parent": "141000"
	},
	{
		"name": "安泽县",
		"value": "141026",
		"parent": "141000"
	},
	{
		"name": "浮山县",
		"value": "141027",
		"parent": "141000"
	},
	{
		"name": "吉县",
		"value": "141028",
		"parent": "141000"
	},
	{
		"name": "乡宁县",
		"value": "141029",
		"parent": "141000"
	},
	{
		"name": "大宁县",
		"value": "141030",
		"parent": "141000"
	},
	{
		"name": "隰县",
		"value": "141031",
		"parent": "141000"
	},
	{
		"name": "永和县",
		"value": "141032",
		"parent": "141000"
	},
	{
		"name": "蒲县",
		"value": "141033",
		"parent": "141000"
	},
	{
		"name": "汾西县",
		"value": "141034",
		"parent": "141000"
	},
	{
		"name": "侯马市",
		"value": "141081",
		"parent": "141000"
	},
	{
		"name": "霍州市",
		"value": "141082",
		"parent": "141000"
	},
	{
		"name": "离石区",
		"value": "141102",
		"parent": "141100"
	},
	{
		"name": "文水县",
		"value": "141121",
		"parent": "141100"
	},
	{
		"name": "交城县",
		"value": "141122",
		"parent": "141100"
	},
	{
		"name": "兴县",
		"value": "141123",
		"parent": "141100"
	},
	{
		"name": "临县",
		"value": "141124",
		"parent": "141100"
	},
	{
		"name": "柳林县",
		"value": "141125",
		"parent": "141100"
	},
	{
		"name": "石楼县",
		"value": "141126",
		"parent": "141100"
	},
	{
		"name": "岚县",
		"value": "141127",
		"parent": "141100"
	},
	{
		"name": "方山县",
		"value": "141128",
		"parent": "141100"
	},
	{
		"name": "中阳县",
		"value": "141129",
		"parent": "141100"
	},
	{
		"name": "交口县",
		"value": "141130",
		"parent": "141100"
	},
	{
		"name": "孝义市",
		"value": "141181",
		"parent": "141100"
	},
	{
		"name": "汾阳市",
		"value": "141182",
		"parent": "141100"
	},
	{
		"name": "呼和浩特市",
		"value": "150100",
		"parent": "150000"
	},
	{
		"name": "包头市",
		"value": "150200",
		"parent": "150000"
	},
	{
		"name": "乌海市",
		"value": "150300",
		"parent": "150000"
	},
	{
		"name": "赤峰市",
		"value": "150400",
		"parent": "150000"
	},
	{
		"name": "通辽市",
		"value": "150500",
		"parent": "150000"
	},
	{
		"name": "鄂尔多斯市",
		"value": "150600",
		"parent": "150000"
	},
	{
		"name": "呼伦贝尔市",
		"value": "150700",
		"parent": "150000"
	},
	{
		"name": "巴彦淖尔市",
		"value": "150800",
		"parent": "150000"
	},
	{
		"name": "乌兰察布市",
		"value": "150900",
		"parent": "150000"
	},
	{
		"name": "兴安盟",
		"value": "152200",
		"parent": "150000"
	},
	{
		"name": "锡林郭勒盟",
		"value": "152500",
		"parent": "150000"
	},
	{
		"name": "阿拉善盟",
		"value": "152900",
		"parent": "150000"
	},
	{
		"name": "新城区",
		"value": "150102",
		"parent": "150100"
	},
	{
		"name": "回民区",
		"value": "150103",
		"parent": "150100"
	},
	{
		"name": "玉泉区",
		"value": "150104",
		"parent": "150100"
	},
	{
		"name": "赛罕区",
		"value": "150105",
		"parent": "150100"
	},
	{
		"name": "土默特左旗",
		"value": "150121",
		"parent": "150100"
	},
	{
		"name": "托克托县",
		"value": "150122",
		"parent": "150100"
	},
	{
		"name": "和林格尔县",
		"value": "150123",
		"parent": "150100"
	},
	{
		"name": "清水河县",
		"value": "150124",
		"parent": "150100"
	},
	{
		"name": "武川县",
		"value": "150125",
		"parent": "150100"
	},
	{
		"name": "东河区",
		"value": "150202",
		"parent": "150200"
	},
	{
		"name": "昆都仑区",
		"value": "150203",
		"parent": "150200"
	},
	{
		"name": "青山区",
		"value": "150204",
		"parent": "150200"
	},
	{
		"name": "石拐区",
		"value": "150205",
		"parent": "150200"
	},
	{
		"name": "白云鄂博矿区",
		"value": "150206",
		"parent": "150200"
	},
	{
		"name": "九原区",
		"value": "150207",
		"parent": "150200"
	},
	{
		"name": "土默特右旗",
		"value": "150221",
		"parent": "150200"
	},
	{
		"name": "固阳县",
		"value": "150222",
		"parent": "150200"
	},
	{
		"name": "达尔罕茂明安联合旗",
		"value": "150223",
		"parent": "150200"
	},
	{
		"name": "海勃湾区",
		"value": "150302",
		"parent": "150300"
	},
	{
		"name": "海南区",
		"value": "150303",
		"parent": "150300"
	},
	{
		"name": "乌达区",
		"value": "150304",
		"parent": "150300"
	},
	{
		"name": "红山区",
		"value": "150402",
		"parent": "150400"
	},
	{
		"name": "元宝山区",
		"value": "150403",
		"parent": "150400"
	},
	{
		"name": "松山区",
		"value": "150404",
		"parent": "150400"
	},
	{
		"name": "阿鲁科尔沁旗",
		"value": "150421",
		"parent": "150400"
	},
	{
		"name": "巴林左旗",
		"value": "150422",
		"parent": "150400"
	},
	{
		"name": "巴林右旗",
		"value": "150423",
		"parent": "150400"
	},
	{
		"name": "林西县",
		"value": "150424",
		"parent": "150400"
	},
	{
		"name": "克什克腾旗",
		"value": "150425",
		"parent": "150400"
	},
	{
		"name": "翁牛特旗",
		"value": "150426",
		"parent": "150400"
	},
	{
		"name": "喀喇沁旗",
		"value": "150428",
		"parent": "150400"
	},
	{
		"name": "宁城县",
		"value": "150429",
		"parent": "150400"
	},
	{
		"name": "敖汉旗",
		"value": "150430",
		"parent": "150400"
	},
	{
		"name": "科尔沁区",
		"value": "150502",
		"parent": "150500"
	},
	{
		"name": "科尔沁左翼中旗",
		"value": "150521",
		"parent": "150500"
	},
	{
		"name": "科尔沁左翼后旗",
		"value": "150522",
		"parent": "150500"
	},
	{
		"name": "开鲁县",
		"value": "150523",
		"parent": "150500"
	},
	{
		"name": "库伦旗",
		"value": "150524",
		"parent": "150500"
	},
	{
		"name": "奈曼旗",
		"value": "150525",
		"parent": "150500"
	},
	{
		"name": "扎鲁特旗",
		"value": "150526",
		"parent": "150500"
	},
	{
		"name": "霍林郭勒市",
		"value": "150581",
		"parent": "150500"
	},
	{
		"name": "东胜区",
		"value": "150602",
		"parent": "150600"
	},
	{
		"name": "达拉特旗",
		"value": "150621",
		"parent": "150600"
	},
	{
		"name": "准格尔旗",
		"value": "150622",
		"parent": "150600"
	},
	{
		"name": "鄂托克前旗",
		"value": "150623",
		"parent": "150600"
	},
	{
		"name": "鄂托克旗",
		"value": "150624",
		"parent": "150600"
	},
	{
		"name": "杭锦旗",
		"value": "150625",
		"parent": "150600"
	},
	{
		"name": "乌审旗",
		"value": "150626",
		"parent": "150600"
	},
	{
		"name": "伊金霍洛旗",
		"value": "150627",
		"parent": "150600"
	},
	{
		"name": "海拉尔区",
		"value": "150702",
		"parent": "150700"
	},
	{
		"name": "扎赉诺尔区",
		"value": "150703",
		"parent": "150700"
	},
	{
		"name": "阿荣旗",
		"value": "150721",
		"parent": "150700"
	},
	{
		"name": "莫力达瓦达斡尔族自治旗",
		"value": "150722",
		"parent": "150700"
	},
	{
		"name": "鄂伦春自治旗",
		"value": "150723",
		"parent": "150700"
	},
	{
		"name": "鄂温克族自治旗",
		"value": "150724",
		"parent": "150700"
	},
	{
		"name": "陈巴尔虎旗",
		"value": "150725",
		"parent": "150700"
	},
	{
		"name": "新巴尔虎左旗",
		"value": "150726",
		"parent": "150700"
	},
	{
		"name": "新巴尔虎右旗",
		"value": "150727",
		"parent": "150700"
	},
	{
		"name": "满洲里市",
		"value": "150781",
		"parent": "150700"
	},
	{
		"name": "牙克石市",
		"value": "150782",
		"parent": "150700"
	},
	{
		"name": "扎兰屯市",
		"value": "150783",
		"parent": "150700"
	},
	{
		"name": "额尔古纳市",
		"value": "150784",
		"parent": "150700"
	},
	{
		"name": "根河市",
		"value": "150785",
		"parent": "150700"
	},
	{
		"name": "临河区",
		"value": "150802",
		"parent": "150800"
	},
	{
		"name": "五原县",
		"value": "150821",
		"parent": "150800"
	},
	{
		"name": "磴口县",
		"value": "150822",
		"parent": "150800"
	},
	{
		"name": "乌拉特前旗",
		"value": "150823",
		"parent": "150800"
	},
	{
		"name": "乌拉特中旗",
		"value": "150824",
		"parent": "150800"
	},
	{
		"name": "乌拉特后旗",
		"value": "150825",
		"parent": "150800"
	},
	{
		"name": "杭锦后旗",
		"value": "150826",
		"parent": "150800"
	},
	{
		"name": "集宁区",
		"value": "150902",
		"parent": "150900"
	},
	{
		"name": "卓资县",
		"value": "150921",
		"parent": "150900"
	},
	{
		"name": "化德县",
		"value": "150922",
		"parent": "150900"
	},
	{
		"name": "商都县",
		"value": "150923",
		"parent": "150900"
	},
	{
		"name": "兴和县",
		"value": "150924",
		"parent": "150900"
	},
	{
		"name": "凉城县",
		"value": "150925",
		"parent": "150900"
	},
	{
		"name": "察哈尔右翼前旗",
		"value": "150926",
		"parent": "150900"
	},
	{
		"name": "察哈尔右翼中旗",
		"value": "150927",
		"parent": "150900"
	},
	{
		"name": "察哈尔右翼后旗",
		"value": "150928",
		"parent": "150900"
	},
	{
		"name": "四子王旗",
		"value": "150929",
		"parent": "150900"
	},
	{
		"name": "丰镇市",
		"value": "150981",
		"parent": "150900"
	},
	{
		"name": "乌兰浩特市",
		"value": "152201",
		"parent": "152200"
	},
	{
		"name": "阿尔山市",
		"value": "152202",
		"parent": "152200"
	},
	{
		"name": "科尔沁右翼前旗",
		"value": "152221",
		"parent": "152200"
	},
	{
		"name": "科尔沁右翼中旗",
		"value": "152222",
		"parent": "152200"
	},
	{
		"name": "扎赉特旗",
		"value": "152223",
		"parent": "152200"
	},
	{
		"name": "突泉县",
		"value": "152224",
		"parent": "152200"
	},
	{
		"name": "二连浩特市",
		"value": "152501",
		"parent": "152500"
	},
	{
		"name": "锡林浩特市",
		"value": "152502",
		"parent": "152500"
	},
	{
		"name": "阿巴嘎旗",
		"value": "152522",
		"parent": "152500"
	},
	{
		"name": "苏尼特左旗",
		"value": "152523",
		"parent": "152500"
	},
	{
		"name": "苏尼特右旗",
		"value": "152524",
		"parent": "152500"
	},
	{
		"name": "东乌珠穆沁旗",
		"value": "152525",
		"parent": "152500"
	},
	{
		"name": "西乌珠穆沁旗",
		"value": "152526",
		"parent": "152500"
	},
	{
		"name": "太仆寺旗",
		"value": "152527",
		"parent": "152500"
	},
	{
		"name": "镶黄旗",
		"value": "152528",
		"parent": "152500"
	},
	{
		"name": "正镶白旗",
		"value": "152529",
		"parent": "152500"
	},
	{
		"name": "正蓝旗",
		"value": "152530",
		"parent": "152500"
	},
	{
		"name": "多伦县",
		"value": "152531",
		"parent": "152500"
	},
	{
		"name": "阿拉善左旗",
		"value": "152921",
		"parent": "152900"
	},
	{
		"name": "阿拉善右旗",
		"value": "152922",
		"parent": "152900"
	},
	{
		"name": "额济纳旗",
		"value": "152923",
		"parent": "152900"
	},
	{
		"name": "沈阳市",
		"value": "210100",
		"parent": "210000"
	},
	{
		"name": "大连市",
		"value": "210200",
		"parent": "210000"
	},
	{
		"name": "鞍山市",
		"value": "210300",
		"parent": "210000"
	},
	{
		"name": "抚顺市",
		"value": "210400",
		"parent": "210000"
	},
	{
		"name": "本溪市",
		"value": "210500",
		"parent": "210000"
	},
	{
		"name": "丹东市",
		"value": "210600",
		"parent": "210000"
	},
	{
		"name": "锦州市",
		"value": "210700",
		"parent": "210000"
	},
	{
		"name": "营口市",
		"value": "210800",
		"parent": "210000"
	},
	{
		"name": "阜新市",
		"value": "210900",
		"parent": "210000"
	},
	{
		"name": "辽阳市",
		"value": "211000",
		"parent": "210000"
	},
	{
		"name": "盘锦市",
		"value": "211100",
		"parent": "210000"
	},
	{
		"name": "铁岭市",
		"value": "211200",
		"parent": "210000"
	},
	{
		"name": "朝阳市",
		"value": "211300",
		"parent": "210000"
	},
	{
		"name": "葫芦岛市",
		"value": "211400",
		"parent": "210000"
	},
	{
		"name": "和平区",
		"value": "210102",
		"parent": "210100"
	},
	{
		"name": "沈河区",
		"value": "210103",
		"parent": "210100"
	},
	{
		"name": "大东区",
		"value": "210104",
		"parent": "210100"
	},
	{
		"name": "皇姑区",
		"value": "210105",
		"parent": "210100"
	},
	{
		"name": "铁西区",
		"value": "210106",
		"parent": "210100"
	},
	{
		"name": "苏家屯区",
		"value": "210111",
		"parent": "210100"
	},
	{
		"name": "浑南区",
		"value": "210112",
		"parent": "210100"
	},
	{
		"name": "沈北新区",
		"value": "210113",
		"parent": "210100"
	},
	{
		"name": "于洪区",
		"value": "210114",
		"parent": "210100"
	},
	{
		"name": "辽中县",
		"value": "210122",
		"parent": "210100"
	},
	{
		"name": "康平县",
		"value": "210123",
		"parent": "210100"
	},
	{
		"name": "法库县",
		"value": "210124",
		"parent": "210100"
	},
	{
		"name": "新民市",
		"value": "210181",
		"parent": "210100"
	},
	{
		"name": "中山区",
		"value": "210202",
		"parent": "210200"
	},
	{
		"name": "西岗区",
		"value": "210203",
		"parent": "210200"
	},
	{
		"name": "沙河口区",
		"value": "210204",
		"parent": "210200"
	},
	{
		"name": "甘井子区",
		"value": "210211",
		"parent": "210200"
	},
	{
		"name": "旅顺口区",
		"value": "210212",
		"parent": "210200"
	},
	{
		"name": "金州区",
		"value": "210213",
		"parent": "210200"
	},
	{
		"name": "长海县",
		"value": "210224",
		"parent": "210200"
	},
	{
		"name": "瓦房店市",
		"value": "210281",
		"parent": "210200"
	},
	{
		"name": "普兰店市",
		"value": "210282",
		"parent": "210200"
	},
	{
		"name": "庄河市",
		"value": "210283",
		"parent": "210200"
	},
	{
		"name": "铁东区",
		"value": "210302",
		"parent": "210300"
	},
	{
		"name": "铁西区",
		"value": "210303",
		"parent": "210300"
	},
	{
		"name": "立山区",
		"value": "210304",
		"parent": "210300"
	},
	{
		"name": "千山区",
		"value": "210311",
		"parent": "210300"
	},
	{
		"name": "台安县",
		"value": "210321",
		"parent": "210300"
	},
	{
		"name": "岫岩满族自治县",
		"value": "210323",
		"parent": "210300"
	},
	{
		"name": "海城市",
		"value": "210381",
		"parent": "210300"
	},
	{
		"name": "新抚区",
		"value": "210402",
		"parent": "210400"
	},
	{
		"name": "东洲区",
		"value": "210403",
		"parent": "210400"
	},
	{
		"name": "望花区",
		"value": "210404",
		"parent": "210400"
	},
	{
		"name": "顺城区",
		"value": "210411",
		"parent": "210400"
	},
	{
		"name": "抚顺县",
		"value": "210421",
		"parent": "210400"
	},
	{
		"name": "新宾满族自治县",
		"value": "210422",
		"parent": "210400"
	},
	{
		"name": "清原满族自治县",
		"value": "210423",
		"parent": "210400"
	},
	{
		"name": "平山区",
		"value": "210502",
		"parent": "210500"
	},
	{
		"name": "溪湖区",
		"value": "210503",
		"parent": "210500"
	},
	{
		"name": "明山区",
		"value": "210504",
		"parent": "210500"
	},
	{
		"name": "南芬区",
		"value": "210505",
		"parent": "210500"
	},
	{
		"name": "本溪满族自治县",
		"value": "210521",
		"parent": "210500"
	},
	{
		"name": "桓仁满族自治县",
		"value": "210522",
		"parent": "210500"
	},
	{
		"name": "元宝区",
		"value": "210602",
		"parent": "210600"
	},
	{
		"name": "振兴区",
		"value": "210603",
		"parent": "210600"
	},
	{
		"name": "振安区",
		"value": "210604",
		"parent": "210600"
	},
	{
		"name": "宽甸满族自治县",
		"value": "210624",
		"parent": "210600"
	},
	{
		"name": "东港市",
		"value": "210681",
		"parent": "210600"
	},
	{
		"name": "凤城市",
		"value": "210682",
		"parent": "210600"
	},
	{
		"name": "古塔区",
		"value": "210702",
		"parent": "210700"
	},
	{
		"name": "凌河区",
		"value": "210703",
		"parent": "210700"
	},
	{
		"name": "太和区",
		"value": "210711",
		"parent": "210700"
	},
	{
		"name": "黑山县",
		"value": "210726",
		"parent": "210700"
	},
	{
		"name": "义县",
		"value": "210727",
		"parent": "210700"
	},
	{
		"name": "凌海市",
		"value": "210781",
		"parent": "210700"
	},
	{
		"name": "北镇市",
		"value": "210782",
		"parent": "210700"
	},
	{
		"name": "站前区",
		"value": "210802",
		"parent": "210800"
	},
	{
		"name": "西市区",
		"value": "210803",
		"parent": "210800"
	},
	{
		"name": "鲅鱼圈区",
		"value": "210804",
		"parent": "210800"
	},
	{
		"name": "老边区",
		"value": "210811",
		"parent": "210800"
	},
	{
		"name": "盖州市",
		"value": "210881",
		"parent": "210800"
	},
	{
		"name": "大石桥市",
		"value": "210882",
		"parent": "210800"
	},
	{
		"name": "海州区",
		"value": "210902",
		"parent": "210900"
	},
	{
		"name": "新邱区",
		"value": "210903",
		"parent": "210900"
	},
	{
		"name": "太平区",
		"value": "210904",
		"parent": "210900"
	},
	{
		"name": "清河门区",
		"value": "210905",
		"parent": "210900"
	},
	{
		"name": "细河区",
		"value": "210911",
		"parent": "210900"
	},
	{
		"name": "阜新蒙古族自治县",
		"value": "210921",
		"parent": "210900"
	},
	{
		"name": "彰武县",
		"value": "210922",
		"parent": "210900"
	},
	{
		"name": "白塔区",
		"value": "211002",
		"parent": "211000"
	},
	{
		"name": "文圣区",
		"value": "211003",
		"parent": "211000"
	},
	{
		"name": "宏伟区",
		"value": "211004",
		"parent": "211000"
	},
	{
		"name": "弓长岭区",
		"value": "211005",
		"parent": "211000"
	},
	{
		"name": "太子河区",
		"value": "211011",
		"parent": "211000"
	},
	{
		"name": "辽阳县",
		"value": "211021",
		"parent": "211000"
	},
	{
		"name": "灯塔市",
		"value": "211081",
		"parent": "211000"
	},
	{
		"name": "双台子区",
		"value": "211102",
		"parent": "211100"
	},
	{
		"name": "兴隆台区",
		"value": "211103",
		"parent": "211100"
	},
	{
		"name": "大洼县",
		"value": "211121",
		"parent": "211100"
	},
	{
		"name": "盘山县",
		"value": "211122",
		"parent": "211100"
	},
	{
		"name": "银州区",
		"value": "211202",
		"parent": "211200"
	},
	{
		"name": "清河区",
		"value": "211204",
		"parent": "211200"
	},
	{
		"name": "铁岭县",
		"value": "211221",
		"parent": "211200"
	},
	{
		"name": "西丰县",
		"value": "211223",
		"parent": "211200"
	},
	{
		"name": "昌图县",
		"value": "211224",
		"parent": "211200"
	},
	{
		"name": "调兵山市",
		"value": "211281",
		"parent": "211200"
	},
	{
		"name": "开原市",
		"value": "211282",
		"parent": "211200"
	},
	{
		"name": "双塔区",
		"value": "211302",
		"parent": "211300"
	},
	{
		"name": "龙城区",
		"value": "211303",
		"parent": "211300"
	},
	{
		"name": "朝阳县",
		"value": "211321",
		"parent": "211300"
	},
	{
		"name": "建平县",
		"value": "211322",
		"parent": "211300"
	},
	{
		"name": "喀喇沁左翼蒙古族自治县",
		"value": "211324",
		"parent": "211300"
	},
	{
		"name": "北票市",
		"value": "211381",
		"parent": "211300"
	},
	{
		"name": "凌源市",
		"value": "211382",
		"parent": "211300"
	},
	{
		"name": "连山区",
		"value": "211402",
		"parent": "211400"
	},
	{
		"name": "龙港区",
		"value": "211403",
		"parent": "211400"
	},
	{
		"name": "南票区",
		"value": "211404",
		"parent": "211400"
	},
	{
		"name": "绥中县",
		"value": "211421",
		"parent": "211400"
	},
	{
		"name": "建昌县",
		"value": "211422",
		"parent": "211400"
	},
	{
		"name": "兴城市",
		"value": "211481",
		"parent": "211400"
	},
	{
		"name": "长春市",
		"value": "220100",
		"parent": "220000"
	},
	{
		"name": "吉林市",
		"value": "220200",
		"parent": "220000"
	},
	{
		"name": "四平市",
		"value": "220300",
		"parent": "220000"
	},
	{
		"name": "辽源市",
		"value": "220400",
		"parent": "220000"
	},
	{
		"name": "通化市",
		"value": "220500",
		"parent": "220000"
	},
	{
		"name": "白山市",
		"value": "220600",
		"parent": "220000"
	},
	{
		"name": "松原市",
		"value": "220700",
		"parent": "220000"
	},
	{
		"name": "白城市",
		"value": "220800",
		"parent": "220000"
	},
	{
		"name": "延边朝鲜族自治州",
		"value": "222400",
		"parent": "220000"
	},
	{
		"name": "南关区",
		"value": "220102",
		"parent": "220100"
	},
	{
		"name": "宽城区",
		"value": "220103",
		"parent": "220100"
	},
	{
		"name": "朝阳区",
		"value": "220104",
		"parent": "220100"
	},
	{
		"name": "二道区",
		"value": "220105",
		"parent": "220100"
	},
	{
		"name": "绿园区",
		"value": "220106",
		"parent": "220100"
	},
	{
		"name": "双阳区",
		"value": "220112",
		"parent": "220100"
	},
	{
		"name": "九台区",
		"value": "220113",
		"parent": "220100"
	},
	{
		"name": "农安县",
		"value": "220122",
		"parent": "220100"
	},
	{
		"name": "榆树市",
		"value": "220182",
		"parent": "220100"
	},
	{
		"name": "德惠市",
		"value": "220183",
		"parent": "220100"
	},
	{
		"name": "昌邑区",
		"value": "220202",
		"parent": "220200"
	},
	{
		"name": "龙潭区",
		"value": "220203",
		"parent": "220200"
	},
	{
		"name": "船营区",
		"value": "220204",
		"parent": "220200"
	},
	{
		"name": "丰满区",
		"value": "220211",
		"parent": "220200"
	},
	{
		"name": "永吉县",
		"value": "220221",
		"parent": "220200"
	},
	{
		"name": "蛟河市",
		"value": "220281",
		"parent": "220200"
	},
	{
		"name": "桦甸市",
		"value": "220282",
		"parent": "220200"
	},
	{
		"name": "舒兰市",
		"value": "220283",
		"parent": "220200"
	},
	{
		"name": "磐石市",
		"value": "220284",
		"parent": "220200"
	},
	{
		"name": "铁西区",
		"value": "220302",
		"parent": "220300"
	},
	{
		"name": "铁东区",
		"value": "220303",
		"parent": "220300"
	},
	{
		"name": "梨树县",
		"value": "220322",
		"parent": "220300"
	},
	{
		"name": "伊通满族自治县",
		"value": "220323",
		"parent": "220300"
	},
	{
		"name": "公主岭市",
		"value": "220381",
		"parent": "220300"
	},
	{
		"name": "双辽市",
		"value": "220382",
		"parent": "220300"
	},
	{
		"name": "龙山区",
		"value": "220402",
		"parent": "220400"
	},
	{
		"name": "西安区",
		"value": "220403",
		"parent": "220400"
	},
	{
		"name": "东丰县",
		"value": "220421",
		"parent": "220400"
	},
	{
		"name": "东辽县",
		"value": "220422",
		"parent": "220400"
	},
	{
		"name": "东昌区",
		"value": "220502",
		"parent": "220500"
	},
	{
		"name": "二道江区",
		"value": "220503",
		"parent": "220500"
	},
	{
		"name": "通化县",
		"value": "220521",
		"parent": "220500"
	},
	{
		"name": "辉南县",
		"value": "220523",
		"parent": "220500"
	},
	{
		"name": "柳河县",
		"value": "220524",
		"parent": "220500"
	},
	{
		"name": "梅河口市",
		"value": "220581",
		"parent": "220500"
	},
	{
		"name": "集安市",
		"value": "220582",
		"parent": "220500"
	},
	{
		"name": "浑江区",
		"value": "220602",
		"parent": "220600"
	},
	{
		"name": "江源区",
		"value": "220605",
		"parent": "220600"
	},
	{
		"name": "抚松县",
		"value": "220621",
		"parent": "220600"
	},
	{
		"name": "靖宇县",
		"value": "220622",
		"parent": "220600"
	},
	{
		"name": "长白朝鲜族自治县",
		"value": "220623",
		"parent": "220600"
	},
	{
		"name": "临江市",
		"value": "220681",
		"parent": "220600"
	},
	{
		"name": "宁江区",
		"value": "220702",
		"parent": "220700"
	},
	{
		"name": "前郭尔罗斯蒙古族自治县",
		"value": "220721",
		"parent": "220700"
	},
	{
		"name": "长岭县",
		"value": "220722",
		"parent": "220700"
	},
	{
		"name": "乾安县",
		"value": "220723",
		"parent": "220700"
	},
	{
		"name": "扶余市",
		"value": "220781",
		"parent": "220700"
	},
	{
		"name": "洮北区",
		"value": "220802",
		"parent": "220800"
	},
	{
		"name": "镇赉县",
		"value": "220821",
		"parent": "220800"
	},
	{
		"name": "通榆县",
		"value": "220822",
		"parent": "220800"
	},
	{
		"name": "洮南市",
		"value": "220881",
		"parent": "220800"
	},
	{
		"name": "大安市",
		"value": "220882",
		"parent": "220800"
	},
	{
		"name": "延吉市",
		"value": "222401",
		"parent": "222400"
	},
	{
		"name": "图们市",
		"value": "222402",
		"parent": "222400"
	},
	{
		"name": "敦化市",
		"value": "222403",
		"parent": "222400"
	},
	{
		"name": "珲春市",
		"value": "222404",
		"parent": "222400"
	},
	{
		"name": "龙井市",
		"value": "222405",
		"parent": "222400"
	},
	{
		"name": "和龙市",
		"value": "222406",
		"parent": "222400"
	},
	{
		"name": "汪清县",
		"value": "222424",
		"parent": "222400"
	},
	{
		"name": "安图县",
		"value": "222426",
		"parent": "222400"
	},
	{
		"name": "哈尔滨市",
		"value": "230100",
		"parent": "230000"
	},
	{
		"name": "齐齐哈尔市",
		"value": "230200",
		"parent": "230000"
	},
	{
		"name": "鸡西市",
		"value": "230300",
		"parent": "230000"
	},
	{
		"name": "鹤岗市",
		"value": "230400",
		"parent": "230000"
	},
	{
		"name": "双鸭山市",
		"value": "230500",
		"parent": "230000"
	},
	{
		"name": "大庆市",
		"value": "230600",
		"parent": "230000"
	},
	{
		"name": "伊春市",
		"value": "230700",
		"parent": "230000"
	},
	{
		"name": "佳木斯市",
		"value": "230800",
		"parent": "230000"
	},
	{
		"name": "七台河市",
		"value": "230900",
		"parent": "230000"
	},
	{
		"name": "牡丹江市",
		"value": "231000",
		"parent": "230000"
	},
	{
		"name": "黑河市",
		"value": "231100",
		"parent": "230000"
	},
	{
		"name": "绥化市",
		"value": "231200",
		"parent": "230000"
	},
	{
		"name": "大兴安岭地区",
		"value": "232700",
		"parent": "230000"
	},
	{
		"name": "道里区",
		"value": "230102",
		"parent": "230100"
	},
	{
		"name": "南岗区",
		"value": "230103",
		"parent": "230100"
	},
	{
		"name": "道外区",
		"value": "230104",
		"parent": "230100"
	},
	{
		"name": "平房区",
		"value": "230108",
		"parent": "230100"
	},
	{
		"name": "松北区",
		"value": "230109",
		"parent": "230100"
	},
	{
		"name": "香坊区",
		"value": "230110",
		"parent": "230100"
	},
	{
		"name": "呼兰区",
		"value": "230111",
		"parent": "230100"
	},
	{
		"name": "阿城区",
		"value": "230112",
		"parent": "230100"
	},
	{
		"name": "双城区",
		"value": "230113",
		"parent": "230100"
	},
	{
		"name": "依兰县",
		"value": "230123",
		"parent": "230100"
	},
	{
		"name": "方正县",
		"value": "230124",
		"parent": "230100"
	},
	{
		"name": "宾县",
		"value": "230125",
		"parent": "230100"
	},
	{
		"name": "巴彦县",
		"value": "230126",
		"parent": "230100"
	},
	{
		"name": "木兰县",
		"value": "230127",
		"parent": "230100"
	},
	{
		"name": "通河县",
		"value": "230128",
		"parent": "230100"
	},
	{
		"name": "延寿县",
		"value": "230129",
		"parent": "230100"
	},
	{
		"name": "尚志市",
		"value": "230183",
		"parent": "230100"
	},
	{
		"name": "五常市",
		"value": "230184",
		"parent": "230100"
	},
	{
		"name": "龙沙区",
		"value": "230202",
		"parent": "230200"
	},
	{
		"name": "建华区",
		"value": "230203",
		"parent": "230200"
	},
	{
		"name": "铁锋区",
		"value": "230204",
		"parent": "230200"
	},
	{
		"name": "昂昂溪区",
		"value": "230205",
		"parent": "230200"
	},
	{
		"name": "富拉尔基区",
		"value": "230206",
		"parent": "230200"
	},
	{
		"name": "碾子山区",
		"value": "230207",
		"parent": "230200"
	},
	{
		"name": "梅里斯达斡尔族区",
		"value": "230208",
		"parent": "230200"
	},
	{
		"name": "龙江县",
		"value": "230221",
		"parent": "230200"
	},
	{
		"name": "依安县",
		"value": "230223",
		"parent": "230200"
	},
	{
		"name": "泰来县",
		"value": "230224",
		"parent": "230200"
	},
	{
		"name": "甘南县",
		"value": "230225",
		"parent": "230200"
	},
	{
		"name": "富裕县",
		"value": "230227",
		"parent": "230200"
	},
	{
		"name": "克山县",
		"value": "230229",
		"parent": "230200"
	},
	{
		"name": "克东县",
		"value": "230230",
		"parent": "230200"
	},
	{
		"name": "拜泉县",
		"value": "230231",
		"parent": "230200"
	},
	{
		"name": "讷河市",
		"value": "230281",
		"parent": "230200"
	},
	{
		"name": "鸡冠区",
		"value": "230302",
		"parent": "230300"
	},
	{
		"name": "恒山区",
		"value": "230303",
		"parent": "230300"
	},
	{
		"name": "滴道区",
		"value": "230304",
		"parent": "230300"
	},
	{
		"name": "梨树区",
		"value": "230305",
		"parent": "230300"
	},
	{
		"name": "城子河区",
		"value": "230306",
		"parent": "230300"
	},
	{
		"name": "麻山区",
		"value": "230307",
		"parent": "230300"
	},
	{
		"name": "鸡东县",
		"value": "230321",
		"parent": "230300"
	},
	{
		"name": "虎林市",
		"value": "230381",
		"parent": "230300"
	},
	{
		"name": "密山市",
		"value": "230382",
		"parent": "230300"
	},
	{
		"name": "向阳区",
		"value": "230402",
		"parent": "230400"
	},
	{
		"name": "工农区",
		"value": "230403",
		"parent": "230400"
	},
	{
		"name": "南山区",
		"value": "230404",
		"parent": "230400"
	},
	{
		"name": "兴安区",
		"value": "230405",
		"parent": "230400"
	},
	{
		"name": "东山区",
		"value": "230406",
		"parent": "230400"
	},
	{
		"name": "兴山区",
		"value": "230407",
		"parent": "230400"
	},
	{
		"name": "萝北县",
		"value": "230421",
		"parent": "230400"
	},
	{
		"name": "绥滨县",
		"value": "230422",
		"parent": "230400"
	},
	{
		"name": "尖山区",
		"value": "230502",
		"parent": "230500"
	},
	{
		"name": "岭东区",
		"value": "230503",
		"parent": "230500"
	},
	{
		"name": "四方台区",
		"value": "230505",
		"parent": "230500"
	},
	{
		"name": "宝山区",
		"value": "230506",
		"parent": "230500"
	},
	{
		"name": "集贤县",
		"value": "230521",
		"parent": "230500"
	},
	{
		"name": "友谊县",
		"value": "230522",
		"parent": "230500"
	},
	{
		"name": "宝清县",
		"value": "230523",
		"parent": "230500"
	},
	{
		"name": "饶河县",
		"value": "230524",
		"parent": "230500"
	},
	{
		"name": "萨尔图区",
		"value": "230602",
		"parent": "230600"
	},
	{
		"name": "龙凤区",
		"value": "230603",
		"parent": "230600"
	},
	{
		"name": "让胡路区",
		"value": "230604",
		"parent": "230600"
	},
	{
		"name": "红岗区",
		"value": "230605",
		"parent": "230600"
	},
	{
		"name": "大同区",
		"value": "230606",
		"parent": "230600"
	},
	{
		"name": "肇州县",
		"value": "230621",
		"parent": "230600"
	},
	{
		"name": "肇源县",
		"value": "230622",
		"parent": "230600"
	},
	{
		"name": "林甸县",
		"value": "230623",
		"parent": "230600"
	},
	{
		"name": "杜尔伯特蒙古族自治县",
		"value": "230624",
		"parent": "230600"
	},
	{
		"name": "伊春区",
		"value": "230702",
		"parent": "230700"
	},
	{
		"name": "南岔区",
		"value": "230703",
		"parent": "230700"
	},
	{
		"name": "友好区",
		"value": "230704",
		"parent": "230700"
	},
	{
		"name": "西林区",
		"value": "230705",
		"parent": "230700"
	},
	{
		"name": "翠峦区",
		"value": "230706",
		"parent": "230700"
	},
	{
		"name": "新青区",
		"value": "230707",
		"parent": "230700"
	},
	{
		"name": "美溪区",
		"value": "230708",
		"parent": "230700"
	},
	{
		"name": "金山屯区",
		"value": "230709",
		"parent": "230700"
	},
	{
		"name": "五营区",
		"value": "230710",
		"parent": "230700"
	},
	{
		"name": "乌马河区",
		"value": "230711",
		"parent": "230700"
	},
	{
		"name": "汤旺河区",
		"value": "230712",
		"parent": "230700"
	},
	{
		"name": "带岭区",
		"value": "230713",
		"parent": "230700"
	},
	{
		"name": "乌伊岭区",
		"value": "230714",
		"parent": "230700"
	},
	{
		"name": "红星区",
		"value": "230715",
		"parent": "230700"
	},
	{
		"name": "上甘岭区",
		"value": "230716",
		"parent": "230700"
	},
	{
		"name": "嘉荫县",
		"value": "230722",
		"parent": "230700"
	},
	{
		"name": "铁力市",
		"value": "230781",
		"parent": "230700"
	},
	{
		"name": "向阳区",
		"value": "230803",
		"parent": "230800"
	},
	{
		"name": "前进区",
		"value": "230804",
		"parent": "230800"
	},
	{
		"name": "东风区",
		"value": "230805",
		"parent": "230800"
	},
	{
		"name": "郊区",
		"value": "230811",
		"parent": "230800"
	},
	{
		"name": "桦南县",
		"value": "230822",
		"parent": "230800"
	},
	{
		"name": "桦川县",
		"value": "230826",
		"parent": "230800"
	},
	{
		"name": "汤原县",
		"value": "230828",
		"parent": "230800"
	},
	{
		"name": "抚远县",
		"value": "230833",
		"parent": "230800"
	},
	{
		"name": "同江市",
		"value": "230881",
		"parent": "230800"
	},
	{
		"name": "富锦市",
		"value": "230882",
		"parent": "230800"
	},
	{
		"name": "新兴区",
		"value": "230902",
		"parent": "230900"
	},
	{
		"name": "桃山区",
		"value": "230903",
		"parent": "230900"
	},
	{
		"name": "茄子河区",
		"value": "230904",
		"parent": "230900"
	},
	{
		"name": "勃利县",
		"value": "230921",
		"parent": "230900"
	},
	{
		"name": "东安区",
		"value": "231002",
		"parent": "231000"
	},
	{
		"name": "阳明区",
		"value": "231003",
		"parent": "231000"
	},
	{
		"name": "爱民区",
		"value": "231004",
		"parent": "231000"
	},
	{
		"name": "西安区",
		"value": "231005",
		"parent": "231000"
	},
	{
		"name": "东宁县",
		"value": "231024",
		"parent": "231000"
	},
	{
		"name": "林口县",
		"value": "231025",
		"parent": "231000"
	},
	{
		"name": "绥芬河市",
		"value": "231081",
		"parent": "231000"
	},
	{
		"name": "海林市",
		"value": "231083",
		"parent": "231000"
	},
	{
		"name": "宁安市",
		"value": "231084",
		"parent": "231000"
	},
	{
		"name": "穆棱市",
		"value": "231085",
		"parent": "231000"
	},
	{
		"name": "爱辉区",
		"value": "231102",
		"parent": "231100"
	},
	{
		"name": "嫩江县",
		"value": "231121",
		"parent": "231100"
	},
	{
		"name": "逊克县",
		"value": "231123",
		"parent": "231100"
	},
	{
		"name": "孙吴县",
		"value": "231124",
		"parent": "231100"
	},
	{
		"name": "北安市",
		"value": "231181",
		"parent": "231100"
	},
	{
		"name": "五大连池市",
		"value": "231182",
		"parent": "231100"
	},
	{
		"name": "北林区",
		"value": "231202",
		"parent": "231200"
	},
	{
		"name": "望奎县",
		"value": "231221",
		"parent": "231200"
	},
	{
		"name": "兰西县",
		"value": "231222",
		"parent": "231200"
	},
	{
		"name": "青冈县",
		"value": "231223",
		"parent": "231200"
	},
	{
		"name": "庆安县",
		"value": "231224",
		"parent": "231200"
	},
	{
		"name": "明水县",
		"value": "231225",
		"parent": "231200"
	},
	{
		"name": "绥棱县",
		"value": "231226",
		"parent": "231200"
	},
	{
		"name": "安达市",
		"value": "231281",
		"parent": "231200"
	},
	{
		"name": "肇东市",
		"value": "231282",
		"parent": "231200"
	},
	{
		"name": "海伦市",
		"value": "231283",
		"parent": "231200"
	},
	{
		"name": "呼玛县",
		"value": "232721",
		"parent": "232700"
	},
	{
		"name": "塔河县",
		"value": "232722",
		"parent": "232700"
	},
	{
		"name": "漠河县",
		"value": "232723",
		"parent": "232700"
	},
	{
		"name": "市辖区",
		"value": "310100",
		"parent": "310000"
	},
	{
		"name": "黄浦区",
		"value": "310101",
		"parent": "310100"
	},
	{
		"name": "徐汇区",
		"value": "310104",
		"parent": "310100"
	},
	{
		"name": "长宁区",
		"value": "310105",
		"parent": "310100"
	},
	{
		"name": "静安区",
		"value": "310106",
		"parent": "310100"
	},
	{
		"name": "普陀区",
		"value": "310107",
		"parent": "310100"
	},
	{
		"name": "闸北区",
		"value": "310108",
		"parent": "310100"
	},
	{
		"name": "虹口区",
		"value": "310109",
		"parent": "310100"
	},
	{
		"name": "杨浦区",
		"value": "310110",
		"parent": "310100"
	},
	{
		"name": "闵行区",
		"value": "310112",
		"parent": "310100"
	},
	{
		"name": "宝山区",
		"value": "310113",
		"parent": "310100"
	},
	{
		"name": "嘉定区",
		"value": "310114",
		"parent": "310100"
	},
	{
		"name": "浦东新区",
		"value": "310115",
		"parent": "310100"
	},
	{
		"name": "金山区",
		"value": "310116",
		"parent": "310100"
	},
	{
		"name": "松江区",
		"value": "310117",
		"parent": "310100"
	},
	{
		"name": "青浦区",
		"value": "310118",
		"parent": "310100"
	},
	{
		"name": "奉贤区",
		"value": "310120",
		"parent": "310100"
	},
	{
		"name": "崇明县",
		"value": "310230",
		"parent": "310100"
	},
	{
		"name": "南京市",
		"value": "320100",
		"parent": "320000"
	},
	{
		"name": "无锡市",
		"value": "320200",
		"parent": "320000"
	},
	{
		"name": "徐州市",
		"value": "320300",
		"parent": "320000"
	},
	{
		"name": "常州市",
		"value": "320400",
		"parent": "320000"
	},
	{
		"name": "苏州市",
		"value": "320500",
		"parent": "320000"
	},
	{
		"name": "南通市",
		"value": "320600",
		"parent": "320000"
	},
	{
		"name": "连云港市",
		"value": "320700",
		"parent": "320000"
	},
	{
		"name": "淮安市",
		"value": "320800",
		"parent": "320000"
	},
	{
		"name": "盐城市",
		"value": "320900",
		"parent": "320000"
	},
	{
		"name": "扬州市",
		"value": "321000",
		"parent": "320000"
	},
	{
		"name": "镇江市",
		"value": "321100",
		"parent": "320000"
	},
	{
		"name": "泰州市",
		"value": "321200",
		"parent": "320000"
	},
	{
		"name": "宿迁市",
		"value": "321300",
		"parent": "320000"
	},
	{
		"name": "玄武区",
		"value": "320102",
		"parent": "320100"
	},
	{
		"name": "秦淮区",
		"value": "320104",
		"parent": "320100"
	},
	{
		"name": "建邺区",
		"value": "320105",
		"parent": "320100"
	},
	{
		"name": "鼓楼区",
		"value": "320106",
		"parent": "320100"
	},
	{
		"name": "浦口区",
		"value": "320111",
		"parent": "320100"
	},
	{
		"name": "栖霞区",
		"value": "320113",
		"parent": "320100"
	},
	{
		"name": "雨花台区",
		"value": "320114",
		"parent": "320100"
	},
	{
		"name": "江宁区",
		"value": "320115",
		"parent": "320100"
	},
	{
		"name": "六合区",
		"value": "320116",
		"parent": "320100"
	},
	{
		"name": "溧水区",
		"value": "320117",
		"parent": "320100"
	},
	{
		"name": "高淳区",
		"value": "320118",
		"parent": "320100"
	},
	{
		"name": "崇安区",
		"value": "320202",
		"parent": "320200"
	},
	{
		"name": "南长区",
		"value": "320203",
		"parent": "320200"
	},
	{
		"name": "北塘区",
		"value": "320204",
		"parent": "320200"
	},
	{
		"name": "锡山区",
		"value": "320205",
		"parent": "320200"
	},
	{
		"name": "惠山区",
		"value": "320206",
		"parent": "320200"
	},
	{
		"name": "滨湖区",
		"value": "320211",
		"parent": "320200"
	},
	{
		"name": "江阴市",
		"value": "320281",
		"parent": "320200"
	},
	{
		"name": "宜兴市",
		"value": "320282",
		"parent": "320200"
	},
	{
		"name": "鼓楼区",
		"value": "320302",
		"parent": "320300"
	},
	{
		"name": "云龙区",
		"value": "320303",
		"parent": "320300"
	},
	{
		"name": "贾汪区",
		"value": "320305",
		"parent": "320300"
	},
	{
		"name": "泉山区",
		"value": "320311",
		"parent": "320300"
	},
	{
		"name": "铜山区",
		"value": "320312",
		"parent": "320300"
	},
	{
		"name": "丰县",
		"value": "320321",
		"parent": "320300"
	},
	{
		"name": "沛县",
		"value": "320322",
		"parent": "320300"
	},
	{
		"name": "睢宁县",
		"value": "320324",
		"parent": "320300"
	},
	{
		"name": "新沂市",
		"value": "320381",
		"parent": "320300"
	},
	{
		"name": "邳州市",
		"value": "320382",
		"parent": "320300"
	},
	{
		"name": "天宁区",
		"value": "320402",
		"parent": "320400"
	},
	{
		"name": "钟楼区",
		"value": "320404",
		"parent": "320400"
	},
	{
		"name": "新北区",
		"value": "320411",
		"parent": "320400"
	},
	{
		"name": "武进区",
		"value": "320412",
		"parent": "320400"
	},
	{
		"name": "金坛区",
		"value": "320413",
		"parent": "320400"
	},
	{
		"name": "溧阳市",
		"value": "320481",
		"parent": "320400"
	},
	{
		"name": "虎丘区",
		"value": "320505",
		"parent": "320500"
	},
	{
		"name": "吴中区",
		"value": "320506",
		"parent": "320500"
	},
	{
		"name": "相城区",
		"value": "320507",
		"parent": "320500"
	},
	{
		"name": "姑苏区",
		"value": "320508",
		"parent": "320500"
	},
	{
		"name": "吴江区",
		"value": "320509",
		"parent": "320500"
	},
	{
		"name": "常熟市",
		"value": "320581",
		"parent": "320500"
	},
	{
		"name": "张家港市",
		"value": "320582",
		"parent": "320500"
	},
	{
		"name": "昆山市",
		"value": "320583",
		"parent": "320500"
	},
	{
		"name": "太仓市",
		"value": "320585",
		"parent": "320500"
	},
	{
		"name": "崇川区",
		"value": "320602",
		"parent": "320600"
	},
	{
		"name": "港闸区",
		"value": "320611",
		"parent": "320600"
	},
	{
		"name": "通州区",
		"value": "320612",
		"parent": "320600"
	},
	{
		"name": "海安县",
		"value": "320621",
		"parent": "320600"
	},
	{
		"name": "如东县",
		"value": "320623",
		"parent": "320600"
	},
	{
		"name": "启东市",
		"value": "320681",
		"parent": "320600"
	},
	{
		"name": "如皋市",
		"value": "320682",
		"parent": "320600"
	},
	{
		"name": "海门市",
		"value": "320684",
		"parent": "320600"
	},
	{
		"name": "连云区",
		"value": "320703",
		"parent": "320700"
	},
	{
		"name": "海州区",
		"value": "320706",
		"parent": "320700"
	},
	{
		"name": "赣榆区",
		"value": "320707",
		"parent": "320700"
	},
	{
		"name": "东海县",
		"value": "320722",
		"parent": "320700"
	},
	{
		"name": "灌云县",
		"value": "320723",
		"parent": "320700"
	},
	{
		"name": "灌南县",
		"value": "320724",
		"parent": "320700"
	},
	{
		"name": "清河区",
		"value": "320802",
		"parent": "320800"
	},
	{
		"name": "淮安区",
		"value": "320803",
		"parent": "320800"
	},
	{
		"name": "淮阴区",
		"value": "320804",
		"parent": "320800"
	},
	{
		"name": "清浦区",
		"value": "320811",
		"parent": "320800"
	},
	{
		"name": "涟水县",
		"value": "320826",
		"parent": "320800"
	},
	{
		"name": "洪泽县",
		"value": "320829",
		"parent": "320800"
	},
	{
		"name": "盱眙县",
		"value": "320830",
		"parent": "320800"
	},
	{
		"name": "金湖县",
		"value": "320831",
		"parent": "320800"
	},
	{
		"name": "亭湖区",
		"value": "320902",
		"parent": "320900"
	},
	{
		"name": "盐都区",
		"value": "320903",
		"parent": "320900"
	},
	{
		"name": "大丰区",
		"value": "320904",
		"parent": "320900"
	},
	{
		"name": "响水县",
		"value": "320921",
		"parent": "320900"
	},
	{
		"name": "滨海县",
		"value": "320922",
		"parent": "320900"
	},
	{
		"name": "阜宁县",
		"value": "320923",
		"parent": "320900"
	},
	{
		"name": "射阳县",
		"value": "320924",
		"parent": "320900"
	},
	{
		"name": "建湖县",
		"value": "320925",
		"parent": "320900"
	},
	{
		"name": "东台市",
		"value": "320981",
		"parent": "320900"
	},
	{
		"name": "广陵区",
		"value": "321002",
		"parent": "321000"
	},
	{
		"name": "邗江区",
		"value": "321003",
		"parent": "321000"
	},
	{
		"name": "江都区",
		"value": "321012",
		"parent": "321000"
	},
	{
		"name": "宝应县",
		"value": "321023",
		"parent": "321000"
	},
	{
		"name": "仪征市",
		"value": "321081",
		"parent": "321000"
	},
	{
		"name": "高邮市",
		"value": "321084",
		"parent": "321000"
	},
	{
		"name": "京口区",
		"value": "321102",
		"parent": "321100"
	},
	{
		"name": "润州区",
		"value": "321111",
		"parent": "321100"
	},
	{
		"name": "丹徒区",
		"value": "321112",
		"parent": "321100"
	},
	{
		"name": "丹阳市",
		"value": "321181",
		"parent": "321100"
	},
	{
		"name": "扬中市",
		"value": "321182",
		"parent": "321100"
	},
	{
		"name": "句容市",
		"value": "321183",
		"parent": "321100"
	},
	{
		"name": "海陵区",
		"value": "321202",
		"parent": "321200"
	},
	{
		"name": "高港区",
		"value": "321203",
		"parent": "321200"
	},
	{
		"name": "姜堰区",
		"value": "321204",
		"parent": "321200"
	},
	{
		"name": "兴化市",
		"value": "321281",
		"parent": "321200"
	},
	{
		"name": "靖江市",
		"value": "321282",
		"parent": "321200"
	},
	{
		"name": "泰兴市",
		"value": "321283",
		"parent": "321200"
	},
	{
		"name": "宿城区",
		"value": "321302",
		"parent": "321300"
	},
	{
		"name": "宿豫区",
		"value": "321311",
		"parent": "321300"
	},
	{
		"name": "沭阳县",
		"value": "321322",
		"parent": "321300"
	},
	{
		"name": "泗阳县",
		"value": "321323",
		"parent": "321300"
	},
	{
		"name": "泗洪县",
		"value": "321324",
		"parent": "321300"
	},
	{
		"name": "杭州市",
		"value": "330100",
		"parent": "330000"
	},
	{
		"name": "宁波市",
		"value": "330200",
		"parent": "330000"
	},
	{
		"name": "温州市",
		"value": "330300",
		"parent": "330000"
	},
	{
		"name": "嘉兴市",
		"value": "330400",
		"parent": "330000"
	},
	{
		"name": "湖州市",
		"value": "330500",
		"parent": "330000"
	},
	{
		"name": "绍兴市",
		"value": "330600",
		"parent": "330000"
	},
	{
		"name": "金华市",
		"value": "330700",
		"parent": "330000"
	},
	{
		"name": "衢州市",
		"value": "330800",
		"parent": "330000"
	},
	{
		"name": "舟山市",
		"value": "330900",
		"parent": "330000"
	},
	{
		"name": "台州市",
		"value": "331000",
		"parent": "330000"
	},
	{
		"name": "丽水市",
		"value": "331100",
		"parent": "330000"
	},
	{
		"name": "上城区",
		"value": "330102",
		"parent": "330100"
	},
	{
		"name": "下城区",
		"value": "330103",
		"parent": "330100"
	},
	{
		"name": "江干区",
		"value": "330104",
		"parent": "330100"
	},
	{
		"name": "拱墅区",
		"value": "330105",
		"parent": "330100"
	},
	{
		"name": "西湖区",
		"value": "330106",
		"parent": "330100"
	},
	{
		"name": "滨江区",
		"value": "330108",
		"parent": "330100"
	},
	{
		"name": "萧山区",
		"value": "330109",
		"parent": "330100"
	},
	{
		"name": "余杭区",
		"value": "330110",
		"parent": "330100"
	},
	{
		"name": "富阳区",
		"value": "330111",
		"parent": "330100"
	},
	{
		"name": "桐庐县",
		"value": "330122",
		"parent": "330100"
	},
	{
		"name": "淳安县",
		"value": "330127",
		"parent": "330100"
	},
	{
		"name": "建德市",
		"value": "330182",
		"parent": "330100"
	},
	{
		"name": "临安市",
		"value": "330185",
		"parent": "330100"
	},
	{
		"name": "海曙区",
		"value": "330203",
		"parent": "330200"
	},
	{
		"name": "江东区",
		"value": "330204",
		"parent": "330200"
	},
	{
		"name": "江北区",
		"value": "330205",
		"parent": "330200"
	},
	{
		"name": "北仑区",
		"value": "330206",
		"parent": "330200"
	},
	{
		"name": "镇海区",
		"value": "330211",
		"parent": "330200"
	},
	{
		"name": "鄞州区",
		"value": "330212",
		"parent": "330200"
	},
	{
		"name": "象山县",
		"value": "330225",
		"parent": "330200"
	},
	{
		"name": "宁海县",
		"value": "330226",
		"parent": "330200"
	},
	{
		"name": "余姚市",
		"value": "330281",
		"parent": "330200"
	},
	{
		"name": "慈溪市",
		"value": "330282",
		"parent": "330200"
	},
	{
		"name": "奉化市",
		"value": "330283",
		"parent": "330200"
	},
	{
		"name": "鹿城区",
		"value": "330302",
		"parent": "330300"
	},
	{
		"name": "龙湾区",
		"value": "330303",
		"parent": "330300"
	},
	{
		"name": "瓯海区",
		"value": "330304",
		"parent": "330300"
	},
	{
		"name": "洞头区",
		"value": "330305",
		"parent": "330300"
	},
	{
		"name": "永嘉县",
		"value": "330324",
		"parent": "330300"
	},
	{
		"name": "平阳县",
		"value": "330326",
		"parent": "330300"
	},
	{
		"name": "苍南县",
		"value": "330327",
		"parent": "330300"
	},
	{
		"name": "文成县",
		"value": "330328",
		"parent": "330300"
	},
	{
		"name": "泰顺县",
		"value": "330329",
		"parent": "330300"
	},
	{
		"name": "瑞安市",
		"value": "330381",
		"parent": "330300"
	},
	{
		"name": "乐清市",
		"value": "330382",
		"parent": "330300"
	},
	{
		"name": "南湖区",
		"value": "330402",
		"parent": "330400"
	},
	{
		"name": "秀洲区",
		"value": "330411",
		"parent": "330400"
	},
	{
		"name": "嘉善县",
		"value": "330421",
		"parent": "330400"
	},
	{
		"name": "海盐县",
		"value": "330424",
		"parent": "330400"
	},
	{
		"name": "海宁市",
		"value": "330481",
		"parent": "330400"
	},
	{
		"name": "平湖市",
		"value": "330482",
		"parent": "330400"
	},
	{
		"name": "桐乡市",
		"value": "330483",
		"parent": "330400"
	},
	{
		"name": "吴兴区",
		"value": "330502",
		"parent": "330500"
	},
	{
		"name": "南浔区",
		"value": "330503",
		"parent": "330500"
	},
	{
		"name": "德清县",
		"value": "330521",
		"parent": "330500"
	},
	{
		"name": "长兴县",
		"value": "330522",
		"parent": "330500"
	},
	{
		"name": "安吉县",
		"value": "330523",
		"parent": "330500"
	},
	{
		"name": "越城区",
		"value": "330602",
		"parent": "330600"
	},
	{
		"name": "柯桥区",
		"value": "330603",
		"parent": "330600"
	},
	{
		"name": "上虞区",
		"value": "330604",
		"parent": "330600"
	},
	{
		"name": "新昌县",
		"value": "330624",
		"parent": "330600"
	},
	{
		"name": "诸暨市",
		"value": "330681",
		"parent": "330600"
	},
	{
		"name": "嵊州市",
		"value": "330683",
		"parent": "330600"
	},
	{
		"name": "婺城区",
		"value": "330702",
		"parent": "330700"
	},
	{
		"name": "金东区",
		"value": "330703",
		"parent": "330700"
	},
	{
		"name": "武义县",
		"value": "330723",
		"parent": "330700"
	},
	{
		"name": "浦江县",
		"value": "330726",
		"parent": "330700"
	},
	{
		"name": "磐安县",
		"value": "330727",
		"parent": "330700"
	},
	{
		"name": "兰溪市",
		"value": "330781",
		"parent": "330700"
	},
	{
		"name": "义乌市",
		"value": "330782",
		"parent": "330700"
	},
	{
		"name": "东阳市",
		"value": "330783",
		"parent": "330700"
	},
	{
		"name": "永康市",
		"value": "330784",
		"parent": "330700"
	},
	{
		"name": "柯城区",
		"value": "330802",
		"parent": "330800"
	},
	{
		"name": "衢江区",
		"value": "330803",
		"parent": "330800"
	},
	{
		"name": "常山县",
		"value": "330822",
		"parent": "330800"
	},
	{
		"name": "开化县",
		"value": "330824",
		"parent": "330800"
	},
	{
		"name": "龙游县",
		"value": "330825",
		"parent": "330800"
	},
	{
		"name": "江山市",
		"value": "330881",
		"parent": "330800"
	},
	{
		"name": "定海区",
		"value": "330902",
		"parent": "330900"
	},
	{
		"name": "普陀区",
		"value": "330903",
		"parent": "330900"
	},
	{
		"name": "岱山县",
		"value": "330921",
		"parent": "330900"
	},
	{
		"name": "嵊泗县",
		"value": "330922",
		"parent": "330900"
	},
	{
		"name": "椒江区",
		"value": "331002",
		"parent": "331000"
	},
	{
		"name": "黄岩区",
		"value": "331003",
		"parent": "331000"
	},
	{
		"name": "路桥区",
		"value": "331004",
		"parent": "331000"
	},
	{
		"name": "玉环县",
		"value": "331021",
		"parent": "331000"
	},
	{
		"name": "三门县",
		"value": "331022",
		"parent": "331000"
	},
	{
		"name": "天台县",
		"value": "331023",
		"parent": "331000"
	},
	{
		"name": "仙居县",
		"value": "331024",
		"parent": "331000"
	},
	{
		"name": "温岭市",
		"value": "331081",
		"parent": "331000"
	},
	{
		"name": "临海市",
		"value": "331082",
		"parent": "331000"
	},
	{
		"name": "莲都区",
		"value": "331102",
		"parent": "331100"
	},
	{
		"name": "青田县",
		"value": "331121",
		"parent": "331100"
	},
	{
		"name": "缙云县",
		"value": "331122",
		"parent": "331100"
	},
	{
		"name": "遂昌县",
		"value": "331123",
		"parent": "331100"
	},
	{
		"name": "松阳县",
		"value": "331124",
		"parent": "331100"
	},
	{
		"name": "云和县",
		"value": "331125",
		"parent": "331100"
	},
	{
		"name": "庆元县",
		"value": "331126",
		"parent": "331100"
	},
	{
		"name": "景宁畲族自治县",
		"value": "331127",
		"parent": "331100"
	},
	{
		"name": "龙泉市",
		"value": "331181",
		"parent": "331100"
	},
	{
		"name": "合肥市",
		"value": "340100",
		"parent": "340000"
	},
	{
		"name": "芜湖市",
		"value": "340200",
		"parent": "340000"
	},
	{
		"name": "蚌埠市",
		"value": "340300",
		"parent": "340000"
	},
	{
		"name": "淮南市",
		"value": "340400",
		"parent": "340000"
	},
	{
		"name": "马鞍山市",
		"value": "340500",
		"parent": "340000"
	},
	{
		"name": "淮北市",
		"value": "340600",
		"parent": "340000"
	},
	{
		"name": "铜陵市",
		"value": "340700",
		"parent": "340000"
	},
	{
		"name": "安庆市",
		"value": "340800",
		"parent": "340000"
	},
	{
		"name": "黄山市",
		"value": "341000",
		"parent": "340000"
	},
	{
		"name": "滁州市",
		"value": "341100",
		"parent": "340000"
	},
	{
		"name": "阜阳市",
		"value": "341200",
		"parent": "340000"
	},
	{
		"name": "宿州市",
		"value": "341300",
		"parent": "340000"
	},
	{
		"name": "六安市",
		"value": "341500",
		"parent": "340000"
	},
	{
		"name": "亳州市",
		"value": "341600",
		"parent": "340000"
	},
	{
		"name": "池州市",
		"value": "341700",
		"parent": "340000"
	},
	{
		"name": "宣城市",
		"value": "341800",
		"parent": "340000"
	},
	{
		"name": "瑶海区",
		"value": "340102",
		"parent": "340100"
	},
	{
		"name": "庐阳区",
		"value": "340103",
		"parent": "340100"
	},
	{
		"name": "蜀山区",
		"value": "340104",
		"parent": "340100"
	},
	{
		"name": "包河区",
		"value": "340111",
		"parent": "340100"
	},
	{
		"name": "长丰县",
		"value": "340121",
		"parent": "340100"
	},
	{
		"name": "肥东县",
		"value": "340122",
		"parent": "340100"
	},
	{
		"name": "肥西县",
		"value": "340123",
		"parent": "340100"
	},
	{
		"name": "庐江县",
		"value": "340124",
		"parent": "340100"
	},
	{
		"name": "巢湖市",
		"value": "340181",
		"parent": "340100"
	},
	{
		"name": "镜湖区",
		"value": "340202",
		"parent": "340200"
	},
	{
		"name": "弋江区",
		"value": "340203",
		"parent": "340200"
	},
	{
		"name": "鸠江区",
		"value": "340207",
		"parent": "340200"
	},
	{
		"name": "三山区",
		"value": "340208",
		"parent": "340200"
	},
	{
		"name": "芜湖县",
		"value": "340221",
		"parent": "340200"
	},
	{
		"name": "繁昌县",
		"value": "340222",
		"parent": "340200"
	},
	{
		"name": "南陵县",
		"value": "340223",
		"parent": "340200"
	},
	{
		"name": "无为县",
		"value": "340225",
		"parent": "340200"
	},
	{
		"name": "龙子湖区",
		"value": "340302",
		"parent": "340300"
	},
	{
		"name": "蚌山区",
		"value": "340303",
		"parent": "340300"
	},
	{
		"name": "禹会区",
		"value": "340304",
		"parent": "340300"
	},
	{
		"name": "淮上区",
		"value": "340311",
		"parent": "340300"
	},
	{
		"name": "怀远县",
		"value": "340321",
		"parent": "340300"
	},
	{
		"name": "五河县",
		"value": "340322",
		"parent": "340300"
	},
	{
		"name": "固镇县",
		"value": "340323",
		"parent": "340300"
	},
	{
		"name": "大通区",
		"value": "340402",
		"parent": "340400"
	},
	{
		"name": "田家庵区",
		"value": "340403",
		"parent": "340400"
	},
	{
		"name": "谢家集区",
		"value": "340404",
		"parent": "340400"
	},
	{
		"name": "八公山区",
		"value": "340405",
		"parent": "340400"
	},
	{
		"name": "潘集区",
		"value": "340406",
		"parent": "340400"
	},
	{
		"name": "凤台县",
		"value": "340421",
		"parent": "340400"
	},
	{
		"name": "花山区",
		"value": "340503",
		"parent": "340500"
	},
	{
		"name": "雨山区",
		"value": "340504",
		"parent": "340500"
	},
	{
		"name": "博望区",
		"value": "340506",
		"parent": "340500"
	},
	{
		"name": "当涂县",
		"value": "340521",
		"parent": "340500"
	},
	{
		"name": "含山县",
		"value": "340522",
		"parent": "340500"
	},
	{
		"name": "和县",
		"value": "340523",
		"parent": "340500"
	},
	{
		"name": "杜集区",
		"value": "340602",
		"parent": "340600"
	},
	{
		"name": "相山区",
		"value": "340603",
		"parent": "340600"
	},
	{
		"name": "烈山区",
		"value": "340604",
		"parent": "340600"
	},
	{
		"name": "濉溪县",
		"value": "340621",
		"parent": "340600"
	},
	{
		"name": "铜官山区",
		"value": "340702",
		"parent": "340700"
	},
	{
		"name": "狮子山区",
		"value": "340703",
		"parent": "340700"
	},
	{
		"name": "郊区",
		"value": "340711",
		"parent": "340700"
	},
	{
		"name": "铜陵县",
		"value": "340721",
		"parent": "340700"
	},
	{
		"name": "迎江区",
		"value": "340802",
		"parent": "340800"
	},
	{
		"name": "大观区",
		"value": "340803",
		"parent": "340800"
	},
	{
		"name": "宜秀区",
		"value": "340811",
		"parent": "340800"
	},
	{
		"name": "怀宁县",
		"value": "340822",
		"parent": "340800"
	},
	{
		"name": "枞阳县",
		"value": "340823",
		"parent": "340800"
	},
	{
		"name": "潜山县",
		"value": "340824",
		"parent": "340800"
	},
	{
		"name": "太湖县",
		"value": "340825",
		"parent": "340800"
	},
	{
		"name": "宿松县",
		"value": "340826",
		"parent": "340800"
	},
	{
		"name": "望江县",
		"value": "340827",
		"parent": "340800"
	},
	{
		"name": "岳西县",
		"value": "340828",
		"parent": "340800"
	},
	{
		"name": "桐城市",
		"value": "340881",
		"parent": "340800"
	},
	{
		"name": "屯溪区",
		"value": "341002",
		"parent": "341000"
	},
	{
		"name": "黄山区",
		"value": "341003",
		"parent": "341000"
	},
	{
		"name": "徽州区",
		"value": "341004",
		"parent": "341000"
	},
	{
		"name": "歙县",
		"value": "341021",
		"parent": "341000"
	},
	{
		"name": "休宁县",
		"value": "341022",
		"parent": "341000"
	},
	{
		"name": "黟县",
		"value": "341023",
		"parent": "341000"
	},
	{
		"name": "祁门县",
		"value": "341024",
		"parent": "341000"
	},
	{
		"name": "琅琊区",
		"value": "341102",
		"parent": "341100"
	},
	{
		"name": "南谯区",
		"value": "341103",
		"parent": "341100"
	},
	{
		"name": "来安县",
		"value": "341122",
		"parent": "341100"
	},
	{
		"name": "全椒县",
		"value": "341124",
		"parent": "341100"
	},
	{
		"name": "定远县",
		"value": "341125",
		"parent": "341100"
	},
	{
		"name": "凤阳县",
		"value": "341126",
		"parent": "341100"
	},
	{
		"name": "天长市",
		"value": "341181",
		"parent": "341100"
	},
	{
		"name": "明光市",
		"value": "341182",
		"parent": "341100"
	},
	{
		"name": "颍州区",
		"value": "341202",
		"parent": "341200"
	},
	{
		"name": "颍东区",
		"value": "341203",
		"parent": "341200"
	},
	{
		"name": "颍泉区",
		"value": "341204",
		"parent": "341200"
	},
	{
		"name": "临泉县",
		"value": "341221",
		"parent": "341200"
	},
	{
		"name": "太和县",
		"value": "341222",
		"parent": "341200"
	},
	{
		"name": "阜南县",
		"value": "341225",
		"parent": "341200"
	},
	{
		"name": "颍上县",
		"value": "341226",
		"parent": "341200"
	},
	{
		"name": "界首市",
		"value": "341282",
		"parent": "341200"
	},
	{
		"name": "埇桥区",
		"value": "341302",
		"parent": "341300"
	},
	{
		"name": "砀山县",
		"value": "341321",
		"parent": "341300"
	},
	{
		"name": "萧县",
		"value": "341322",
		"parent": "341300"
	},
	{
		"name": "灵璧县",
		"value": "341323",
		"parent": "341300"
	},
	{
		"name": "泗县",
		"value": "341324",
		"parent": "341300"
	},
	{
		"name": "金安区",
		"value": "341502",
		"parent": "341500"
	},
	{
		"name": "裕安区",
		"value": "341503",
		"parent": "341500"
	},
	{
		"name": "寿县",
		"value": "341521",
		"parent": "341500"
	},
	{
		"name": "霍邱县",
		"value": "341522",
		"parent": "341500"
	},
	{
		"name": "舒城县",
		"value": "341523",
		"parent": "341500"
	},
	{
		"name": "金寨县",
		"value": "341524",
		"parent": "341500"
	},
	{
		"name": "霍山县",
		"value": "341525",
		"parent": "341500"
	},
	{
		"name": "谯城区",
		"value": "341602",
		"parent": "341600"
	},
	{
		"name": "涡阳县",
		"value": "341621",
		"parent": "341600"
	},
	{
		"name": "蒙城县",
		"value": "341622",
		"parent": "341600"
	},
	{
		"name": "利辛县",
		"value": "341623",
		"parent": "341600"
	},
	{
		"name": "贵池区",
		"value": "341702",
		"parent": "341700"
	},
	{
		"name": "东至县",
		"value": "341721",
		"parent": "341700"
	},
	{
		"name": "石台县",
		"value": "341722",
		"parent": "341700"
	},
	{
		"name": "青阳县",
		"value": "341723",
		"parent": "341700"
	},
	{
		"name": "宣州区",
		"value": "341802",
		"parent": "341800"
	},
	{
		"name": "郎溪县",
		"value": "341821",
		"parent": "341800"
	},
	{
		"name": "广德县",
		"value": "341822",
		"parent": "341800"
	},
	{
		"name": "泾县",
		"value": "341823",
		"parent": "341800"
	},
	{
		"name": "绩溪县",
		"value": "341824",
		"parent": "341800"
	},
	{
		"name": "旌德县",
		"value": "341825",
		"parent": "341800"
	},
	{
		"name": "宁国市",
		"value": "341881",
		"parent": "341800"
	},
	{
		"name": "福州市",
		"value": "350100",
		"parent": "350000"
	},
	{
		"name": "厦门市",
		"value": "350200",
		"parent": "350000"
	},
	{
		"name": "莆田市",
		"value": "350300",
		"parent": "350000"
	},
	{
		"name": "三明市",
		"value": "350400",
		"parent": "350000"
	},
	{
		"name": "泉州市",
		"value": "350500",
		"parent": "350000"
	},
	{
		"name": "漳州市",
		"value": "350600",
		"parent": "350000"
	},
	{
		"name": "南平市",
		"value": "350700",
		"parent": "350000"
	},
	{
		"name": "龙岩市",
		"value": "350800",
		"parent": "350000"
	},
	{
		"name": "宁德市",
		"value": "350900",
		"parent": "350000"
	},
	{
		"name": "鼓楼区",
		"value": "350102",
		"parent": "350100"
	},
	{
		"name": "台江区",
		"value": "350103",
		"parent": "350100"
	},
	{
		"name": "仓山区",
		"value": "350104",
		"parent": "350100"
	},
	{
		"name": "马尾区",
		"value": "350105",
		"parent": "350100"
	},
	{
		"name": "晋安区",
		"value": "350111",
		"parent": "350100"
	},
	{
		"name": "闽侯县",
		"value": "350121",
		"parent": "350100"
	},
	{
		"name": "连江县",
		"value": "350122",
		"parent": "350100"
	},
	{
		"name": "罗源县",
		"value": "350123",
		"parent": "350100"
	},
	{
		"name": "闽清县",
		"value": "350124",
		"parent": "350100"
	},
	{
		"name": "永泰县",
		"value": "350125",
		"parent": "350100"
	},
	{
		"name": "平潭县",
		"value": "350128",
		"parent": "350100"
	},
	{
		"name": "福清市",
		"value": "350181",
		"parent": "350100"
	},
	{
		"name": "长乐市",
		"value": "350182",
		"parent": "350100"
	},
	{
		"name": "思明区",
		"value": "350203",
		"parent": "350200"
	},
	{
		"name": "海沧区",
		"value": "350205",
		"parent": "350200"
	},
	{
		"name": "湖里区",
		"value": "350206",
		"parent": "350200"
	},
	{
		"name": "集美区",
		"value": "350211",
		"parent": "350200"
	},
	{
		"name": "同安区",
		"value": "350212",
		"parent": "350200"
	},
	{
		"name": "翔安区",
		"value": "350213",
		"parent": "350200"
	},
	{
		"name": "城厢区",
		"value": "350302",
		"parent": "350300"
	},
	{
		"name": "涵江区",
		"value": "350303",
		"parent": "350300"
	},
	{
		"name": "荔城区",
		"value": "350304",
		"parent": "350300"
	},
	{
		"name": "秀屿区",
		"value": "350305",
		"parent": "350300"
	},
	{
		"name": "仙游县",
		"value": "350322",
		"parent": "350300"
	},
	{
		"name": "梅列区",
		"value": "350402",
		"parent": "350400"
	},
	{
		"name": "三元区",
		"value": "350403",
		"parent": "350400"
	},
	{
		"name": "明溪县",
		"value": "350421",
		"parent": "350400"
	},
	{
		"name": "清流县",
		"value": "350423",
		"parent": "350400"
	},
	{
		"name": "宁化县",
		"value": "350424",
		"parent": "350400"
	},
	{
		"name": "大田县",
		"value": "350425",
		"parent": "350400"
	},
	{
		"name": "尤溪县",
		"value": "350426",
		"parent": "350400"
	},
	{
		"name": "沙县",
		"value": "350427",
		"parent": "350400"
	},
	{
		"name": "将乐县",
		"value": "350428",
		"parent": "350400"
	},
	{
		"name": "泰宁县",
		"value": "350429",
		"parent": "350400"
	},
	{
		"name": "建宁县",
		"value": "350430",
		"parent": "350400"
	},
	{
		"name": "永安市",
		"value": "350481",
		"parent": "350400"
	},
	{
		"name": "鲤城区",
		"value": "350502",
		"parent": "350500"
	},
	{
		"name": "丰泽区",
		"value": "350503",
		"parent": "350500"
	},
	{
		"name": "洛江区",
		"value": "350504",
		"parent": "350500"
	},
	{
		"name": "泉港区",
		"value": "350505",
		"parent": "350500"
	},
	{
		"name": "惠安县",
		"value": "350521",
		"parent": "350500"
	},
	{
		"name": "安溪县",
		"value": "350524",
		"parent": "350500"
	},
	{
		"name": "永春县",
		"value": "350525",
		"parent": "350500"
	},
	{
		"name": "德化县",
		"value": "350526",
		"parent": "350500"
	},
	{
		"name": "金门县",
		"value": "350527",
		"parent": "350500"
	},
	{
		"name": "石狮市",
		"value": "350581",
		"parent": "350500"
	},
	{
		"name": "晋江市",
		"value": "350582",
		"parent": "350500"
	},
	{
		"name": "南安市",
		"value": "350583",
		"parent": "350500"
	},
	{
		"name": "芗城区",
		"value": "350602",
		"parent": "350600"
	},
	{
		"name": "龙文区",
		"value": "350603",
		"parent": "350600"
	},
	{
		"name": "云霄县",
		"value": "350622",
		"parent": "350600"
	},
	{
		"name": "漳浦县",
		"value": "350623",
		"parent": "350600"
	},
	{
		"name": "诏安县",
		"value": "350624",
		"parent": "350600"
	},
	{
		"name": "长泰县",
		"value": "350625",
		"parent": "350600"
	},
	{
		"name": "东山县",
		"value": "350626",
		"parent": "350600"
	},
	{
		"name": "南靖县",
		"value": "350627",
		"parent": "350600"
	},
	{
		"name": "平和县",
		"value": "350628",
		"parent": "350600"
	},
	{
		"name": "华安县",
		"value": "350629",
		"parent": "350600"
	},
	{
		"name": "龙海市",
		"value": "350681",
		"parent": "350600"
	},
	{
		"name": "延平区",
		"value": "350702",
		"parent": "350700"
	},
	{
		"name": "建阳区",
		"value": "350703",
		"parent": "350700"
	},
	{
		"name": "顺昌县",
		"value": "350721",
		"parent": "350700"
	},
	{
		"name": "浦城县",
		"value": "350722",
		"parent": "350700"
	},
	{
		"name": "光泽县",
		"value": "350723",
		"parent": "350700"
	},
	{
		"name": "松溪县",
		"value": "350724",
		"parent": "350700"
	},
	{
		"name": "政和县",
		"value": "350725",
		"parent": "350700"
	},
	{
		"name": "邵武市",
		"value": "350781",
		"parent": "350700"
	},
	{
		"name": "武夷山市",
		"value": "350782",
		"parent": "350700"
	},
	{
		"name": "建瓯市",
		"value": "350783",
		"parent": "350700"
	},
	{
		"name": "新罗区",
		"value": "350802",
		"parent": "350800"
	},
	{
		"name": "永定区",
		"value": "350803",
		"parent": "350800"
	},
	{
		"name": "长汀县",
		"value": "350821",
		"parent": "350800"
	},
	{
		"name": "上杭县",
		"value": "350823",
		"parent": "350800"
	},
	{
		"name": "武平县",
		"value": "350824",
		"parent": "350800"
	},
	{
		"name": "连城县",
		"value": "350825",
		"parent": "350800"
	},
	{
		"name": "漳平市",
		"value": "350881",
		"parent": "350800"
	},
	{
		"name": "蕉城区",
		"value": "350902",
		"parent": "350900"
	},
	{
		"name": "霞浦县",
		"value": "350921",
		"parent": "350900"
	},
	{
		"name": "古田县",
		"value": "350922",
		"parent": "350900"
	},
	{
		"name": "屏南县",
		"value": "350923",
		"parent": "350900"
	},
	{
		"name": "寿宁县",
		"value": "350924",
		"parent": "350900"
	},
	{
		"name": "周宁县",
		"value": "350925",
		"parent": "350900"
	},
	{
		"name": "柘荣县",
		"value": "350926",
		"parent": "350900"
	},
	{
		"name": "福安市",
		"value": "350981",
		"parent": "350900"
	},
	{
		"name": "福鼎市",
		"value": "350982",
		"parent": "350900"
	},
	{
		"name": "南昌市",
		"value": "360100",
		"parent": "360000"
	},
	{
		"name": "景德镇市",
		"value": "360200",
		"parent": "360000"
	},
	{
		"name": "萍乡市",
		"value": "360300",
		"parent": "360000"
	},
	{
		"name": "九江市",
		"value": "360400",
		"parent": "360000"
	},
	{
		"name": "新余市",
		"value": "360500",
		"parent": "360000"
	},
	{
		"name": "鹰潭市",
		"value": "360600",
		"parent": "360000"
	},
	{
		"name": "赣州市",
		"value": "360700",
		"parent": "360000"
	},
	{
		"name": "吉安市",
		"value": "360800",
		"parent": "360000"
	},
	{
		"name": "宜春市",
		"value": "360900",
		"parent": "360000"
	},
	{
		"name": "抚州市",
		"value": "361000",
		"parent": "360000"
	},
	{
		"name": "上饶市",
		"value": "361100",
		"parent": "360000"
	},
	{
		"name": "东湖区",
		"value": "360102",
		"parent": "360100"
	},
	{
		"name": "西湖区",
		"value": "360103",
		"parent": "360100"
	},
	{
		"name": "青云谱区",
		"value": "360104",
		"parent": "360100"
	},
	{
		"name": "湾里区",
		"value": "360105",
		"parent": "360100"
	},
	{
		"name": "青山湖区",
		"value": "360111",
		"parent": "360100"
	},
	{
		"name": "新建区",
		"value": "360112",
		"parent": "360100"
	},
	{
		"name": "南昌县",
		"value": "360121",
		"parent": "360100"
	},
	{
		"name": "安义县",
		"value": "360123",
		"parent": "360100"
	},
	{
		"name": "进贤县",
		"value": "360124",
		"parent": "360100"
	},
	{
		"name": "昌江区",
		"value": "360202",
		"parent": "360200"
	},
	{
		"name": "珠山区",
		"value": "360203",
		"parent": "360200"
	},
	{
		"name": "浮梁县",
		"value": "360222",
		"parent": "360200"
	},
	{
		"name": "乐平市",
		"value": "360281",
		"parent": "360200"
	},
	{
		"name": "安源区",
		"value": "360302",
		"parent": "360300"
	},
	{
		"name": "湘东区",
		"value": "360313",
		"parent": "360300"
	},
	{
		"name": "莲花县",
		"value": "360321",
		"parent": "360300"
	},
	{
		"name": "上栗县",
		"value": "360322",
		"parent": "360300"
	},
	{
		"name": "芦溪县",
		"value": "360323",
		"parent": "360300"
	},
	{
		"name": "庐山区",
		"value": "360402",
		"parent": "360400"
	},
	{
		"name": "浔阳区",
		"value": "360403",
		"parent": "360400"
	},
	{
		"name": "九江县",
		"value": "360421",
		"parent": "360400"
	},
	{
		"name": "武宁县",
		"value": "360423",
		"parent": "360400"
	},
	{
		"name": "修水县",
		"value": "360424",
		"parent": "360400"
	},
	{
		"name": "永修县",
		"value": "360425",
		"parent": "360400"
	},
	{
		"name": "德安县",
		"value": "360426",
		"parent": "360400"
	},
	{
		"name": "星子县",
		"value": "360427",
		"parent": "360400"
	},
	{
		"name": "都昌县",
		"value": "360428",
		"parent": "360400"
	},
	{
		"name": "湖口县",
		"value": "360429",
		"parent": "360400"
	},
	{
		"name": "彭泽县",
		"value": "360430",
		"parent": "360400"
	},
	{
		"name": "瑞昌市",
		"value": "360481",
		"parent": "360400"
	},
	{
		"name": "共青城市",
		"value": "360482",
		"parent": "360400"
	},
	{
		"name": "渝水区",
		"value": "360502",
		"parent": "360500"
	},
	{
		"name": "分宜县",
		"value": "360521",
		"parent": "360500"
	},
	{
		"name": "月湖区",
		"value": "360602",
		"parent": "360600"
	},
	{
		"name": "余江县",
		"value": "360622",
		"parent": "360600"
	},
	{
		"name": "贵溪市",
		"value": "360681",
		"parent": "360600"
	},
	{
		"name": "章贡区",
		"value": "360702",
		"parent": "360700"
	},
	{
		"name": "南康区",
		"value": "360703",
		"parent": "360700"
	},
	{
		"name": "赣县",
		"value": "360721",
		"parent": "360700"
	},
	{
		"name": "信丰县",
		"value": "360722",
		"parent": "360700"
	},
	{
		"name": "大余县",
		"value": "360723",
		"parent": "360700"
	},
	{
		"name": "上犹县",
		"value": "360724",
		"parent": "360700"
	},
	{
		"name": "崇义县",
		"value": "360725",
		"parent": "360700"
	},
	{
		"name": "安远县",
		"value": "360726",
		"parent": "360700"
	},
	{
		"name": "龙南县",
		"value": "360727",
		"parent": "360700"
	},
	{
		"name": "定南县",
		"value": "360728",
		"parent": "360700"
	},
	{
		"name": "全南县",
		"value": "360729",
		"parent": "360700"
	},
	{
		"name": "宁都县",
		"value": "360730",
		"parent": "360700"
	},
	{
		"name": "于都县",
		"value": "360731",
		"parent": "360700"
	},
	{
		"name": "兴国县",
		"value": "360732",
		"parent": "360700"
	},
	{
		"name": "会昌县",
		"value": "360733",
		"parent": "360700"
	},
	{
		"name": "寻乌县",
		"value": "360734",
		"parent": "360700"
	},
	{
		"name": "石城县",
		"value": "360735",
		"parent": "360700"
	},
	{
		"name": "瑞金市",
		"value": "360781",
		"parent": "360700"
	},
	{
		"name": "吉州区",
		"value": "360802",
		"parent": "360800"
	},
	{
		"name": "青原区",
		"value": "360803",
		"parent": "360800"
	},
	{
		"name": "吉安县",
		"value": "360821",
		"parent": "360800"
	},
	{
		"name": "吉水县",
		"value": "360822",
		"parent": "360800"
	},
	{
		"name": "峡江县",
		"value": "360823",
		"parent": "360800"
	},
	{
		"name": "新干县",
		"value": "360824",
		"parent": "360800"
	},
	{
		"name": "永丰县",
		"value": "360825",
		"parent": "360800"
	},
	{
		"name": "泰和县",
		"value": "360826",
		"parent": "360800"
	},
	{
		"name": "遂川县",
		"value": "360827",
		"parent": "360800"
	},
	{
		"name": "万安县",
		"value": "360828",
		"parent": "360800"
	},
	{
		"name": "安福县",
		"value": "360829",
		"parent": "360800"
	},
	{
		"name": "永新县",
		"value": "360830",
		"parent": "360800"
	},
	{
		"name": "井冈山市",
		"value": "360881",
		"parent": "360800"
	},
	{
		"name": "袁州区",
		"value": "360902",
		"parent": "360900"
	},
	{
		"name": "奉新县",
		"value": "360921",
		"parent": "360900"
	},
	{
		"name": "万载县",
		"value": "360922",
		"parent": "360900"
	},
	{
		"name": "上高县",
		"value": "360923",
		"parent": "360900"
	},
	{
		"name": "宜丰县",
		"value": "360924",
		"parent": "360900"
	},
	{
		"name": "靖安县",
		"value": "360925",
		"parent": "360900"
	},
	{
		"name": "铜鼓县",
		"value": "360926",
		"parent": "360900"
	},
	{
		"name": "丰城市",
		"value": "360981",
		"parent": "360900"
	},
	{
		"name": "樟树市",
		"value": "360982",
		"parent": "360900"
	},
	{
		"name": "高安市",
		"value": "360983",
		"parent": "360900"
	},
	{
		"name": "临川区",
		"value": "361002",
		"parent": "361000"
	},
	{
		"name": "南城县",
		"value": "361021",
		"parent": "361000"
	},
	{
		"name": "黎川县",
		"value": "361022",
		"parent": "361000"
	},
	{
		"name": "南丰县",
		"value": "361023",
		"parent": "361000"
	},
	{
		"name": "崇仁县",
		"value": "361024",
		"parent": "361000"
	},
	{
		"name": "乐安县",
		"value": "361025",
		"parent": "361000"
	},
	{
		"name": "宜黄县",
		"value": "361026",
		"parent": "361000"
	},
	{
		"name": "金溪县",
		"value": "361027",
		"parent": "361000"
	},
	{
		"name": "资溪县",
		"value": "361028",
		"parent": "361000"
	},
	{
		"name": "东乡县",
		"value": "361029",
		"parent": "361000"
	},
	{
		"name": "广昌县",
		"value": "361030",
		"parent": "361000"
	},
	{
		"name": "信州区",
		"value": "361102",
		"parent": "361100"
	},
	{
		"name": "广丰区",
		"value": "361103",
		"parent": "361100"
	},
	{
		"name": "上饶县",
		"value": "361121",
		"parent": "361100"
	},
	{
		"name": "玉山县",
		"value": "361123",
		"parent": "361100"
	},
	{
		"name": "铅山县",
		"value": "361124",
		"parent": "361100"
	},
	{
		"name": "横峰县",
		"value": "361125",
		"parent": "361100"
	},
	{
		"name": "弋阳县",
		"value": "361126",
		"parent": "361100"
	},
	{
		"name": "余干县",
		"value": "361127",
		"parent": "361100"
	},
	{
		"name": "鄱阳县",
		"value": "361128",
		"parent": "361100"
	},
	{
		"name": "万年县",
		"value": "361129",
		"parent": "361100"
	},
	{
		"name": "婺源县",
		"value": "361130",
		"parent": "361100"
	},
	{
		"name": "德兴市",
		"value": "361181",
		"parent": "361100"
	},
	{
		"name": "济南市",
		"value": "370100",
		"parent": "370000"
	},
	{
		"name": "青岛市",
		"value": "370200",
		"parent": "370000"
	},
	{
		"name": "淄博市",
		"value": "370300",
		"parent": "370000"
	},
	{
		"name": "枣庄市",
		"value": "370400",
		"parent": "370000"
	},
	{
		"name": "东营市",
		"value": "370500",
		"parent": "370000"
	},
	{
		"name": "烟台市",
		"value": "370600",
		"parent": "370000"
	},
	{
		"name": "潍坊市",
		"value": "370700",
		"parent": "370000"
	},
	{
		"name": "济宁市",
		"value": "370800",
		"parent": "370000"
	},
	{
		"name": "泰安市",
		"value": "370900",
		"parent": "370000"
	},
	{
		"name": "威海市",
		"value": "371000",
		"parent": "370000"
	},
	{
		"name": "日照市",
		"value": "371100",
		"parent": "370000"
	},
	{
		"name": "莱芜市",
		"value": "371200",
		"parent": "370000"
	},
	{
		"name": "临沂市",
		"value": "371300",
		"parent": "370000"
	},
	{
		"name": "德州市",
		"value": "371400",
		"parent": "370000"
	},
	{
		"name": "聊城市",
		"value": "371500",
		"parent": "370000"
	},
	{
		"name": "滨州市",
		"value": "371600",
		"parent": "370000"
	},
	{
		"name": "菏泽市",
		"value": "371700",
		"parent": "370000"
	},
	{
		"name": "历下区",
		"value": "370102",
		"parent": "370100"
	},
	{
		"name": "市中区",
		"value": "370103",
		"parent": "370100"
	},
	{
		"name": "槐荫区",
		"value": "370104",
		"parent": "370100"
	},
	{
		"name": "天桥区",
		"value": "370105",
		"parent": "370100"
	},
	{
		"name": "历城区",
		"value": "370112",
		"parent": "370100"
	},
	{
		"name": "长清区",
		"value": "370113",
		"parent": "370100"
	},
	{
		"name": "平阴县",
		"value": "370124",
		"parent": "370100"
	},
	{
		"name": "济阳县",
		"value": "370125",
		"parent": "370100"
	},
	{
		"name": "商河县",
		"value": "370126",
		"parent": "370100"
	},
	{
		"name": "章丘市",
		"value": "370181",
		"parent": "370100"
	},
	{
		"name": "市南区",
		"value": "370202",
		"parent": "370200"
	},
	{
		"name": "市北区",
		"value": "370203",
		"parent": "370200"
	},
	{
		"name": "黄岛区",
		"value": "370211",
		"parent": "370200"
	},
	{
		"name": "崂山区",
		"value": "370212",
		"parent": "370200"
	},
	{
		"name": "李沧区",
		"value": "370213",
		"parent": "370200"
	},
	{
		"name": "城阳区",
		"value": "370214",
		"parent": "370200"
	},
	{
		"name": "胶州市",
		"value": "370281",
		"parent": "370200"
	},
	{
		"name": "即墨市",
		"value": "370282",
		"parent": "370200"
	},
	{
		"name": "平度市",
		"value": "370283",
		"parent": "370200"
	},
	{
		"name": "莱西市",
		"value": "370285",
		"parent": "370200"
	},
	{
		"name": "淄川区",
		"value": "370302",
		"parent": "370300"
	},
	{
		"name": "张店区",
		"value": "370303",
		"parent": "370300"
	},
	{
		"name": "博山区",
		"value": "370304",
		"parent": "370300"
	},
	{
		"name": "临淄区",
		"value": "370305",
		"parent": "370300"
	},
	{
		"name": "周村区",
		"value": "370306",
		"parent": "370300"
	},
	{
		"name": "桓台县",
		"value": "370321",
		"parent": "370300"
	},
	{
		"name": "高青县",
		"value": "370322",
		"parent": "370300"
	},
	{
		"name": "沂源县",
		"value": "370323",
		"parent": "370300"
	},
	{
		"name": "市中区",
		"value": "370402",
		"parent": "370400"
	},
	{
		"name": "薛城区",
		"value": "370403",
		"parent": "370400"
	},
	{
		"name": "峄城区",
		"value": "370404",
		"parent": "370400"
	},
	{
		"name": "台儿庄区",
		"value": "370405",
		"parent": "370400"
	},
	{
		"name": "山亭区",
		"value": "370406",
		"parent": "370400"
	},
	{
		"name": "滕州市",
		"value": "370481",
		"parent": "370400"
	},
	{
		"name": "东营区",
		"value": "370502",
		"parent": "370500"
	},
	{
		"name": "河口区",
		"value": "370503",
		"parent": "370500"
	},
	{
		"name": "垦利县",
		"value": "370521",
		"parent": "370500"
	},
	{
		"name": "利津县",
		"value": "370522",
		"parent": "370500"
	},
	{
		"name": "广饶县",
		"value": "370523",
		"parent": "370500"
	},
	{
		"name": "芝罘区",
		"value": "370602",
		"parent": "370600"
	},
	{
		"name": "福山区",
		"value": "370611",
		"parent": "370600"
	},
	{
		"name": "牟平区",
		"value": "370612",
		"parent": "370600"
	},
	{
		"name": "莱山区",
		"value": "370613",
		"parent": "370600"
	},
	{
		"name": "长岛县",
		"value": "370634",
		"parent": "370600"
	},
	{
		"name": "龙口市",
		"value": "370681",
		"parent": "370600"
	},
	{
		"name": "莱阳市",
		"value": "370682",
		"parent": "370600"
	},
	{
		"name": "莱州市",
		"value": "370683",
		"parent": "370600"
	},
	{
		"name": "蓬莱市",
		"value": "370684",
		"parent": "370600"
	},
	{
		"name": "招远市",
		"value": "370685",
		"parent": "370600"
	},
	{
		"name": "栖霞市",
		"value": "370686",
		"parent": "370600"
	},
	{
		"name": "海阳市",
		"value": "370687",
		"parent": "370600"
	},
	{
		"name": "潍城区",
		"value": "370702",
		"parent": "370700"
	},
	{
		"name": "寒亭区",
		"value": "370703",
		"parent": "370700"
	},
	{
		"name": "坊子区",
		"value": "370704",
		"parent": "370700"
	},
	{
		"name": "奎文区",
		"value": "370705",
		"parent": "370700"
	},
	{
		"name": "临朐县",
		"value": "370724",
		"parent": "370700"
	},
	{
		"name": "昌乐县",
		"value": "370725",
		"parent": "370700"
	},
	{
		"name": "青州市",
		"value": "370781",
		"parent": "370700"
	},
	{
		"name": "诸城市",
		"value": "370782",
		"parent": "370700"
	},
	{
		"name": "寿光市",
		"value": "370783",
		"parent": "370700"
	},
	{
		"name": "安丘市",
		"value": "370784",
		"parent": "370700"
	},
	{
		"name": "高密市",
		"value": "370785",
		"parent": "370700"
	},
	{
		"name": "昌邑市",
		"value": "370786",
		"parent": "370700"
	},
	{
		"name": "任城区",
		"value": "370811",
		"parent": "370800"
	},
	{
		"name": "兖州区",
		"value": "370812",
		"parent": "370800"
	},
	{
		"name": "微山县",
		"value": "370826",
		"parent": "370800"
	},
	{
		"name": "鱼台县",
		"value": "370827",
		"parent": "370800"
	},
	{
		"name": "金乡县",
		"value": "370828",
		"parent": "370800"
	},
	{
		"name": "嘉祥县",
		"value": "370829",
		"parent": "370800"
	},
	{
		"name": "汶上县",
		"value": "370830",
		"parent": "370800"
	},
	{
		"name": "泗水县",
		"value": "370831",
		"parent": "370800"
	},
	{
		"name": "梁山县",
		"value": "370832",
		"parent": "370800"
	},
	{
		"name": "曲阜市",
		"value": "370881",
		"parent": "370800"
	},
	{
		"name": "邹城市",
		"value": "370883",
		"parent": "370800"
	},
	{
		"name": "泰山区",
		"value": "370902",
		"parent": "370900"
	},
	{
		"name": "岱岳区",
		"value": "370911",
		"parent": "370900"
	},
	{
		"name": "宁阳县",
		"value": "370921",
		"parent": "370900"
	},
	{
		"name": "东平县",
		"value": "370923",
		"parent": "370900"
	},
	{
		"name": "新泰市",
		"value": "370982",
		"parent": "370900"
	},
	{
		"name": "肥城市",
		"value": "370983",
		"parent": "370900"
	},
	{
		"name": "环翠区",
		"value": "371002",
		"parent": "371000"
	},
	{
		"name": "文登区",
		"value": "371003",
		"parent": "371000"
	},
	{
		"name": "荣成市",
		"value": "371082",
		"parent": "371000"
	},
	{
		"name": "乳山市",
		"value": "371083",
		"parent": "371000"
	},
	{
		"name": "东港区",
		"value": "371102",
		"parent": "371100"
	},
	{
		"name": "岚山区",
		"value": "371103",
		"parent": "371100"
	},
	{
		"name": "五莲县",
		"value": "371121",
		"parent": "371100"
	},
	{
		"name": "莒县",
		"value": "371122",
		"parent": "371100"
	},
	{
		"name": "莱城区",
		"value": "371202",
		"parent": "371200"
	},
	{
		"name": "钢城区",
		"value": "371203",
		"parent": "371200"
	},
	{
		"name": "兰山区",
		"value": "371302",
		"parent": "371300"
	},
	{
		"name": "罗庄区",
		"value": "371311",
		"parent": "371300"
	},
	{
		"name": "河东区",
		"value": "371312",
		"parent": "371300"
	},
	{
		"name": "沂南县",
		"value": "371321",
		"parent": "371300"
	},
	{
		"name": "郯城县",
		"value": "371322",
		"parent": "371300"
	},
	{
		"name": "沂水县",
		"value": "371323",
		"parent": "371300"
	},
	{
		"name": "兰陵县",
		"value": "371324",
		"parent": "371300"
	},
	{
		"name": "费县",
		"value": "371325",
		"parent": "371300"
	},
	{
		"name": "平邑县",
		"value": "371326",
		"parent": "371300"
	},
	{
		"name": "莒南县",
		"value": "371327",
		"parent": "371300"
	},
	{
		"name": "蒙阴县",
		"value": "371328",
		"parent": "371300"
	},
	{
		"name": "临沭县",
		"value": "371329",
		"parent": "371300"
	},
	{
		"name": "德城区",
		"value": "371402",
		"parent": "371400"
	},
	{
		"name": "陵城区",
		"value": "371403",
		"parent": "371400"
	},
	{
		"name": "宁津县",
		"value": "371422",
		"parent": "371400"
	},
	{
		"name": "庆云县",
		"value": "371423",
		"parent": "371400"
	},
	{
		"name": "临邑县",
		"value": "371424",
		"parent": "371400"
	},
	{
		"name": "齐河县",
		"value": "371425",
		"parent": "371400"
	},
	{
		"name": "平原县",
		"value": "371426",
		"parent": "371400"
	},
	{
		"name": "夏津县",
		"value": "371427",
		"parent": "371400"
	},
	{
		"name": "武城县",
		"value": "371428",
		"parent": "371400"
	},
	{
		"name": "乐陵市",
		"value": "371481",
		"parent": "371400"
	},
	{
		"name": "禹城市",
		"value": "371482",
		"parent": "371400"
	},
	{
		"name": "东昌府区",
		"value": "371502",
		"parent": "371500"
	},
	{
		"name": "阳谷县",
		"value": "371521",
		"parent": "371500"
	},
	{
		"name": "莘县",
		"value": "371522",
		"parent": "371500"
	},
	{
		"name": "茌平县",
		"value": "371523",
		"parent": "371500"
	},
	{
		"name": "东阿县",
		"value": "371524",
		"parent": "371500"
	},
	{
		"name": "冠县",
		"value": "371525",
		"parent": "371500"
	},
	{
		"name": "高唐县",
		"value": "371526",
		"parent": "371500"
	},
	{
		"name": "临清市",
		"value": "371581",
		"parent": "371500"
	},
	{
		"name": "滨城区",
		"value": "371602",
		"parent": "371600"
	},
	{
		"name": "沾化区",
		"value": "371603",
		"parent": "371600"
	},
	{
		"name": "惠民县",
		"value": "371621",
		"parent": "371600"
	},
	{
		"name": "阳信县",
		"value": "371622",
		"parent": "371600"
	},
	{
		"name": "无棣县",
		"value": "371623",
		"parent": "371600"
	},
	{
		"name": "博兴县",
		"value": "371625",
		"parent": "371600"
	},
	{
		"name": "邹平县",
		"value": "371626",
		"parent": "371600"
	},
	{
		"name": "牡丹区",
		"value": "371702",
		"parent": "371700"
	},
	{
		"name": "曹县",
		"value": "371721",
		"parent": "371700"
	},
	{
		"name": "单县",
		"value": "371722",
		"parent": "371700"
	},
	{
		"name": "成武县",
		"value": "371723",
		"parent": "371700"
	},
	{
		"name": "巨野县",
		"value": "371724",
		"parent": "371700"
	},
	{
		"name": "郓城县",
		"value": "371725",
		"parent": "371700"
	},
	{
		"name": "鄄城县",
		"value": "371726",
		"parent": "371700"
	},
	{
		"name": "定陶县",
		"value": "371727",
		"parent": "371700"
	},
	{
		"name": "东明县",
		"value": "371728",
		"parent": "371700"
	},
	{
		"name": "郑州市",
		"value": "410100",
		"parent": "410000"
	},
	{
		"name": "开封市",
		"value": "410200",
		"parent": "410000"
	},
	{
		"name": "洛阳市",
		"value": "410300",
		"parent": "410000"
	},
	{
		"name": "平顶山市",
		"value": "410400",
		"parent": "410000"
	},
	{
		"name": "安阳市",
		"value": "410500",
		"parent": "410000"
	},
	{
		"name": "鹤壁市",
		"value": "410600",
		"parent": "410000"
	},
	{
		"name": "新乡市",
		"value": "410700",
		"parent": "410000"
	},
	{
		"name": "焦作市",
		"value": "410800",
		"parent": "410000"
	},
	{
		"name": "濮阳市",
		"value": "410900",
		"parent": "410000"
	},
	{
		"name": "许昌市",
		"value": "411000",
		"parent": "410000"
	},
	{
		"name": "漯河市",
		"value": "411100",
		"parent": "410000"
	},
	{
		"name": "三门峡市",
		"value": "411200",
		"parent": "410000"
	},
	{
		"name": "南阳市",
		"value": "411300",
		"parent": "410000"
	},
	{
		"name": "商丘市",
		"value": "411400",
		"parent": "410000"
	},
	{
		"name": "信阳市",
		"value": "411500",
		"parent": "410000"
	},
	{
		"name": "周口市",
		"value": "411600",
		"parent": "410000"
	},
	{
		"name": "驻马店市",
		"value": "411700",
		"parent": "410000"
	},
	{
		"name": "济源市",
		"value": "419001",
		"parent": "410000"
	},
	{
		"name": "中原区",
		"value": "410102",
		"parent": "410100"
	},
	{
		"name": "二七区",
		"value": "410103",
		"parent": "410100"
	},
	{
		"name": "管城回族区",
		"value": "410104",
		"parent": "410100"
	},
	{
		"name": "金水区",
		"value": "410105",
		"parent": "410100"
	},
	{
		"name": "上街区",
		"value": "410106",
		"parent": "410100"
	},
	{
		"name": "惠济区",
		"value": "410108",
		"parent": "410100"
	},
	{
		"name": "中牟县",
		"value": "410122",
		"parent": "410100"
	},
	{
		"name": "巩义市",
		"value": "410181",
		"parent": "410100"
	},
	{
		"name": "荥阳市",
		"value": "410182",
		"parent": "410100"
	},
	{
		"name": "新密市",
		"value": "410183",
		"parent": "410100"
	},
	{
		"name": "新郑市",
		"value": "410184",
		"parent": "410100"
	},
	{
		"name": "登封市",
		"value": "410185",
		"parent": "410100"
	},
	{
		"name": "龙亭区",
		"value": "410202",
		"parent": "410200"
	},
	{
		"name": "顺河回族区",
		"value": "410203",
		"parent": "410200"
	},
	{
		"name": "鼓楼区",
		"value": "410204",
		"parent": "410200"
	},
	{
		"name": "禹王台区",
		"value": "410205",
		"parent": "410200"
	},
	{
		"name": "金明区",
		"value": "410211",
		"parent": "410200"
	},
	{
		"name": "祥符区",
		"value": "410212",
		"parent": "410200"
	},
	{
		"name": "杞县",
		"value": "410221",
		"parent": "410200"
	},
	{
		"name": "通许县",
		"value": "410222",
		"parent": "410200"
	},
	{
		"name": "尉氏县",
		"value": "410223",
		"parent": "410200"
	},
	{
		"name": "兰考县",
		"value": "410225",
		"parent": "410200"
	},
	{
		"name": "老城区",
		"value": "410302",
		"parent": "410300"
	},
	{
		"name": "西工区",
		"value": "410303",
		"parent": "410300"
	},
	{
		"name": "瀍河回族区",
		"value": "410304",
		"parent": "410300"
	},
	{
		"name": "涧西区",
		"value": "410305",
		"parent": "410300"
	},
	{
		"name": "吉利区",
		"value": "410306",
		"parent": "410300"
	},
	{
		"name": "洛龙区",
		"value": "410311",
		"parent": "410300"
	},
	{
		"name": "孟津县",
		"value": "410322",
		"parent": "410300"
	},
	{
		"name": "新安县",
		"value": "410323",
		"parent": "410300"
	},
	{
		"name": "栾川县",
		"value": "410324",
		"parent": "410300"
	},
	{
		"name": "嵩县",
		"value": "410325",
		"parent": "410300"
	},
	{
		"name": "汝阳县",
		"value": "410326",
		"parent": "410300"
	},
	{
		"name": "宜阳县",
		"value": "410327",
		"parent": "410300"
	},
	{
		"name": "洛宁县",
		"value": "410328",
		"parent": "410300"
	},
	{
		"name": "伊川县",
		"value": "410329",
		"parent": "410300"
	},
	{
		"name": "偃师市",
		"value": "410381",
		"parent": "410300"
	},
	{
		"name": "新华区",
		"value": "410402",
		"parent": "410400"
	},
	{
		"name": "卫东区",
		"value": "410403",
		"parent": "410400"
	},
	{
		"name": "石龙区",
		"value": "410404",
		"parent": "410400"
	},
	{
		"name": "湛河区",
		"value": "410411",
		"parent": "410400"
	},
	{
		"name": "宝丰县",
		"value": "410421",
		"parent": "410400"
	},
	{
		"name": "叶县",
		"value": "410422",
		"parent": "410400"
	},
	{
		"name": "鲁山县",
		"value": "410423",
		"parent": "410400"
	},
	{
		"name": "郏县",
		"value": "410425",
		"parent": "410400"
	},
	{
		"name": "舞钢市",
		"value": "410481",
		"parent": "410400"
	},
	{
		"name": "汝州市",
		"value": "410482",
		"parent": "410400"
	},
	{
		"name": "文峰区",
		"value": "410502",
		"parent": "410500"
	},
	{
		"name": "北关区",
		"value": "410503",
		"parent": "410500"
	},
	{
		"name": "殷都区",
		"value": "410505",
		"parent": "410500"
	},
	{
		"name": "龙安区",
		"value": "410506",
		"parent": "410500"
	},
	{
		"name": "安阳县",
		"value": "410522",
		"parent": "410500"
	},
	{
		"name": "汤阴县",
		"value": "410523",
		"parent": "410500"
	},
	{
		"name": "滑县",
		"value": "410526",
		"parent": "410500"
	},
	{
		"name": "内黄县",
		"value": "410527",
		"parent": "410500"
	},
	{
		"name": "林州市",
		"value": "410581",
		"parent": "410500"
	},
	{
		"name": "鹤山区",
		"value": "410602",
		"parent": "410600"
	},
	{
		"name": "山城区",
		"value": "410603",
		"parent": "410600"
	},
	{
		"name": "淇滨区",
		"value": "410611",
		"parent": "410600"
	},
	{
		"name": "浚县",
		"value": "410621",
		"parent": "410600"
	},
	{
		"name": "淇县",
		"value": "410622",
		"parent": "410600"
	},
	{
		"name": "红旗区",
		"value": "410702",
		"parent": "410700"
	},
	{
		"name": "卫滨区",
		"value": "410703",
		"parent": "410700"
	},
	{
		"name": "凤泉区",
		"value": "410704",
		"parent": "410700"
	},
	{
		"name": "牧野区",
		"value": "410711",
		"parent": "410700"
	},
	{
		"name": "新乡县",
		"value": "410721",
		"parent": "410700"
	},
	{
		"name": "获嘉县",
		"value": "410724",
		"parent": "410700"
	},
	{
		"name": "原阳县",
		"value": "410725",
		"parent": "410700"
	},
	{
		"name": "延津县",
		"value": "410726",
		"parent": "410700"
	},
	{
		"name": "封丘县",
		"value": "410727",
		"parent": "410700"
	},
	{
		"name": "长垣县",
		"value": "410728",
		"parent": "410700"
	},
	{
		"name": "卫辉市",
		"value": "410781",
		"parent": "410700"
	},
	{
		"name": "辉县市",
		"value": "410782",
		"parent": "410700"
	},
	{
		"name": "解放区",
		"value": "410802",
		"parent": "410800"
	},
	{
		"name": "中站区",
		"value": "410803",
		"parent": "410800"
	},
	{
		"name": "马村区",
		"value": "410804",
		"parent": "410800"
	},
	{
		"name": "山阳区",
		"value": "410811",
		"parent": "410800"
	},
	{
		"name": "修武县",
		"value": "410821",
		"parent": "410800"
	},
	{
		"name": "博爱县",
		"value": "410822",
		"parent": "410800"
	},
	{
		"name": "武陟县",
		"value": "410823",
		"parent": "410800"
	},
	{
		"name": "温县",
		"value": "410825",
		"parent": "410800"
	},
	{
		"name": "沁阳市",
		"value": "410882",
		"parent": "410800"
	},
	{
		"name": "孟州市",
		"value": "410883",
		"parent": "410800"
	},
	{
		"name": "华龙区",
		"value": "410902",
		"parent": "410900"
	},
	{
		"name": "清丰县",
		"value": "410922",
		"parent": "410900"
	},
	{
		"name": "南乐县",
		"value": "410923",
		"parent": "410900"
	},
	{
		"name": "范县",
		"value": "410926",
		"parent": "410900"
	},
	{
		"name": "台前县",
		"value": "410927",
		"parent": "410900"
	},
	{
		"name": "濮阳县",
		"value": "410928",
		"parent": "410900"
	},
	{
		"name": "魏都区",
		"value": "411002",
		"parent": "411000"
	},
	{
		"name": "许昌县",
		"value": "411023",
		"parent": "411000"
	},
	{
		"name": "鄢陵县",
		"value": "411024",
		"parent": "411000"
	},
	{
		"name": "襄城县",
		"value": "411025",
		"parent": "411000"
	},
	{
		"name": "禹州市",
		"value": "411081",
		"parent": "411000"
	},
	{
		"name": "长葛市",
		"value": "411082",
		"parent": "411000"
	},
	{
		"name": "源汇区",
		"value": "411102",
		"parent": "411100"
	},
	{
		"name": "郾城区",
		"value": "411103",
		"parent": "411100"
	},
	{
		"name": "召陵区",
		"value": "411104",
		"parent": "411100"
	},
	{
		"name": "舞阳县",
		"value": "411121",
		"parent": "411100"
	},
	{
		"name": "临颍县",
		"value": "411122",
		"parent": "411100"
	},
	{
		"name": "湖滨区",
		"value": "411202",
		"parent": "411200"
	},
	{
		"name": "渑池县",
		"value": "411221",
		"parent": "411200"
	},
	{
		"name": "陕县",
		"value": "411222",
		"parent": "411200"
	},
	{
		"name": "卢氏县",
		"value": "411224",
		"parent": "411200"
	},
	{
		"name": "义马市",
		"value": "411281",
		"parent": "411200"
	},
	{
		"name": "灵宝市",
		"value": "411282",
		"parent": "411200"
	},
	{
		"name": "宛城区",
		"value": "411302",
		"parent": "411300"
	},
	{
		"name": "卧龙区",
		"value": "411303",
		"parent": "411300"
	},
	{
		"name": "南召县",
		"value": "411321",
		"parent": "411300"
	},
	{
		"name": "方城县",
		"value": "411322",
		"parent": "411300"
	},
	{
		"name": "西峡县",
		"value": "411323",
		"parent": "411300"
	},
	{
		"name": "镇平县",
		"value": "411324",
		"parent": "411300"
	},
	{
		"name": "内乡县",
		"value": "411325",
		"parent": "411300"
	},
	{
		"name": "淅川县",
		"value": "411326",
		"parent": "411300"
	},
	{
		"name": "社旗县",
		"value": "411327",
		"parent": "411300"
	},
	{
		"name": "唐河县",
		"value": "411328",
		"parent": "411300"
	},
	{
		"name": "新野县",
		"value": "411329",
		"parent": "411300"
	},
	{
		"name": "桐柏县",
		"value": "411330",
		"parent": "411300"
	},
	{
		"name": "邓州市",
		"value": "411381",
		"parent": "411300"
	},
	{
		"name": "梁园区",
		"value": "411402",
		"parent": "411400"
	},
	{
		"name": "睢阳区",
		"value": "411403",
		"parent": "411400"
	},
	{
		"name": "民权县",
		"value": "411421",
		"parent": "411400"
	},
	{
		"name": "睢县",
		"value": "411422",
		"parent": "411400"
	},
	{
		"name": "宁陵县",
		"value": "411423",
		"parent": "411400"
	},
	{
		"name": "柘城县",
		"value": "411424",
		"parent": "411400"
	},
	{
		"name": "虞城县",
		"value": "411425",
		"parent": "411400"
	},
	{
		"name": "夏邑县",
		"value": "411426",
		"parent": "411400"
	},
	{
		"name": "永城市",
		"value": "411481",
		"parent": "411400"
	},
	{
		"name": "浉河区",
		"value": "411502",
		"parent": "411500"
	},
	{
		"name": "平桥区",
		"value": "411503",
		"parent": "411500"
	},
	{
		"name": "罗山县",
		"value": "411521",
		"parent": "411500"
	},
	{
		"name": "光山县",
		"value": "411522",
		"parent": "411500"
	},
	{
		"name": "新县",
		"value": "411523",
		"parent": "411500"
	},
	{
		"name": "商城县",
		"value": "411524",
		"parent": "411500"
	},
	{
		"name": "固始县",
		"value": "411525",
		"parent": "411500"
	},
	{
		"name": "潢川县",
		"value": "411526",
		"parent": "411500"
	},
	{
		"name": "淮滨县",
		"value": "411527",
		"parent": "411500"
	},
	{
		"name": "息县",
		"value": "411528",
		"parent": "411500"
	},
	{
		"name": "川汇区",
		"value": "411602",
		"parent": "411600"
	},
	{
		"name": "扶沟县",
		"value": "411621",
		"parent": "411600"
	},
	{
		"name": "西华县",
		"value": "411622",
		"parent": "411600"
	},
	{
		"name": "商水县",
		"value": "411623",
		"parent": "411600"
	},
	{
		"name": "沈丘县",
		"value": "411624",
		"parent": "411600"
	},
	{
		"name": "郸城县",
		"value": "411625",
		"parent": "411600"
	},
	{
		"name": "淮阳县",
		"value": "411626",
		"parent": "411600"
	},
	{
		"name": "太康县",
		"value": "411627",
		"parent": "411600"
	},
	{
		"name": "鹿邑县",
		"value": "411628",
		"parent": "411600"
	},
	{
		"name": "项城市",
		"value": "411681",
		"parent": "411600"
	},
	{
		"name": "驿城区",
		"value": "411702",
		"parent": "411700"
	},
	{
		"name": "西平县",
		"value": "411721",
		"parent": "411700"
	},
	{
		"name": "上蔡县",
		"value": "411722",
		"parent": "411700"
	},
	{
		"name": "平舆县",
		"value": "411723",
		"parent": "411700"
	},
	{
		"name": "正阳县",
		"value": "411724",
		"parent": "411700"
	},
	{
		"name": "确山县",
		"value": "411725",
		"parent": "411700"
	},
	{
		"name": "泌阳县",
		"value": "411726",
		"parent": "411700"
	},
	{
		"name": "汝南县",
		"value": "411727",
		"parent": "411700"
	},
	{
		"name": "遂平县",
		"value": "411728",
		"parent": "411700"
	},
	{
		"name": "新蔡县",
		"value": "411729",
		"parent": "411700"
	},
	{
		"name": "武汉市",
		"value": "420100",
		"parent": "420000"
	},
	{
		"name": "黄石市",
		"value": "420200",
		"parent": "420000"
	},
	{
		"name": "十堰市",
		"value": "420300",
		"parent": "420000"
	},
	{
		"name": "宜昌市",
		"value": "420500",
		"parent": "420000"
	},
	{
		"name": "襄阳市",
		"value": "420600",
		"parent": "420000"
	},
	{
		"name": "鄂州市",
		"value": "420700",
		"parent": "420000"
	},
	{
		"name": "荆门市",
		"value": "420800",
		"parent": "420000"
	},
	{
		"name": "孝感市",
		"value": "420900",
		"parent": "420000"
	},
	{
		"name": "荆州市",
		"value": "421000",
		"parent": "420000"
	},
	{
		"name": "黄冈市",
		"value": "421100",
		"parent": "420000"
	},
	{
		"name": "咸宁市",
		"value": "421200",
		"parent": "420000"
	},
	{
		"name": "随州市",
		"value": "421300",
		"parent": "420000"
	},
	{
		"name": "恩施土家族苗族自治州",
		"value": "422800",
		"parent": "420000"
	},
	{
		"name": "仙桃市",
		"value": "429004",
		"parent": "420000"
	},
	{
		"name": "潜江市",
		"value": "429005",
		"parent": "420000"
	},
	{
		"name": "天门市",
		"value": "429006",
		"parent": "420000"
	},
	{
		"name": "神农架林区",
		"value": "429021",
		"parent": "420000"
	},
	{
		"name": "江岸区",
		"value": "420102",
		"parent": "420100"
	},
	{
		"name": "江汉区",
		"value": "420103",
		"parent": "420100"
	},
	{
		"name": "硚口区",
		"value": "420104",
		"parent": "420100"
	},
	{
		"name": "汉阳区",
		"value": "420105",
		"parent": "420100"
	},
	{
		"name": "武昌区",
		"value": "420106",
		"parent": "420100"
	},
	{
		"name": "青山区",
		"value": "420107",
		"parent": "420100"
	},
	{
		"name": "洪山区",
		"value": "420111",
		"parent": "420100"
	},
	{
		"name": "东西湖区",
		"value": "420112",
		"parent": "420100"
	},
	{
		"name": "汉南区",
		"value": "420113",
		"parent": "420100"
	},
	{
		"name": "蔡甸区",
		"value": "420114",
		"parent": "420100"
	},
	{
		"name": "江夏区",
		"value": "420115",
		"parent": "420100"
	},
	{
		"name": "黄陂区",
		"value": "420116",
		"parent": "420100"
	},
	{
		"name": "新洲区",
		"value": "420117",
		"parent": "420100"
	},
	{
		"name": "黄石港区",
		"value": "420202",
		"parent": "420200"
	},
	{
		"name": "西塞山区",
		"value": "420203",
		"parent": "420200"
	},
	{
		"name": "下陆区",
		"value": "420204",
		"parent": "420200"
	},
	{
		"name": "铁山区",
		"value": "420205",
		"parent": "420200"
	},
	{
		"name": "阳新县",
		"value": "420222",
		"parent": "420200"
	},
	{
		"name": "大冶市",
		"value": "420281",
		"parent": "420200"
	},
	{
		"name": "茅箭区",
		"value": "420302",
		"parent": "420300"
	},
	{
		"name": "张湾区",
		"value": "420303",
		"parent": "420300"
	},
	{
		"name": "郧阳区",
		"value": "420304",
		"parent": "420300"
	},
	{
		"name": "郧西县",
		"value": "420322",
		"parent": "420300"
	},
	{
		"name": "竹山县",
		"value": "420323",
		"parent": "420300"
	},
	{
		"name": "竹溪县",
		"value": "420324",
		"parent": "420300"
	},
	{
		"name": "房县",
		"value": "420325",
		"parent": "420300"
	},
	{
		"name": "丹江口市",
		"value": "420381",
		"parent": "420300"
	},
	{
		"name": "西陵区",
		"value": "420502",
		"parent": "420500"
	},
	{
		"name": "伍家岗区",
		"value": "420503",
		"parent": "420500"
	},
	{
		"name": "点军区",
		"value": "420504",
		"parent": "420500"
	},
	{
		"name": "猇亭区",
		"value": "420505",
		"parent": "420500"
	},
	{
		"name": "夷陵区",
		"value": "420506",
		"parent": "420500"
	},
	{
		"name": "远安县",
		"value": "420525",
		"parent": "420500"
	},
	{
		"name": "兴山县",
		"value": "420526",
		"parent": "420500"
	},
	{
		"name": "秭归县",
		"value": "420527",
		"parent": "420500"
	},
	{
		"name": "长阳土家族自治县",
		"value": "420528",
		"parent": "420500"
	},
	{
		"name": "五峰土家族自治县",
		"value": "420529",
		"parent": "420500"
	},
	{
		"name": "宜都市",
		"value": "420581",
		"parent": "420500"
	},
	{
		"name": "当阳市",
		"value": "420582",
		"parent": "420500"
	},
	{
		"name": "枝江市",
		"value": "420583",
		"parent": "420500"
	},
	{
		"name": "襄城区",
		"value": "420602",
		"parent": "420600"
	},
	{
		"name": "樊城区",
		"value": "420606",
		"parent": "420600"
	},
	{
		"name": "襄州区",
		"value": "420607",
		"parent": "420600"
	},
	{
		"name": "南漳县",
		"value": "420624",
		"parent": "420600"
	},
	{
		"name": "谷城县",
		"value": "420625",
		"parent": "420600"
	},
	{
		"name": "保康县",
		"value": "420626",
		"parent": "420600"
	},
	{
		"name": "老河口市",
		"value": "420682",
		"parent": "420600"
	},
	{
		"name": "枣阳市",
		"value": "420683",
		"parent": "420600"
	},
	{
		"name": "宜城市",
		"value": "420684",
		"parent": "420600"
	},
	{
		"name": "梁子湖区",
		"value": "420702",
		"parent": "420700"
	},
	{
		"name": "华容区",
		"value": "420703",
		"parent": "420700"
	},
	{
		"name": "鄂城区",
		"value": "420704",
		"parent": "420700"
	},
	{
		"name": "东宝区",
		"value": "420802",
		"parent": "420800"
	},
	{
		"name": "掇刀区",
		"value": "420804",
		"parent": "420800"
	},
	{
		"name": "京山县",
		"value": "420821",
		"parent": "420800"
	},
	{
		"name": "沙洋县",
		"value": "420822",
		"parent": "420800"
	},
	{
		"name": "钟祥市",
		"value": "420881",
		"parent": "420800"
	},
	{
		"name": "孝南区",
		"value": "420902",
		"parent": "420900"
	},
	{
		"name": "孝昌县",
		"value": "420921",
		"parent": "420900"
	},
	{
		"name": "大悟县",
		"value": "420922",
		"parent": "420900"
	},
	{
		"name": "云梦县",
		"value": "420923",
		"parent": "420900"
	},
	{
		"name": "应城市",
		"value": "420981",
		"parent": "420900"
	},
	{
		"name": "安陆市",
		"value": "420982",
		"parent": "420900"
	},
	{
		"name": "汉川市",
		"value": "420984",
		"parent": "420900"
	},
	{
		"name": "沙市区",
		"value": "421002",
		"parent": "421000"
	},
	{
		"name": "荆州区",
		"value": "421003",
		"parent": "421000"
	},
	{
		"name": "公安县",
		"value": "421022",
		"parent": "421000"
	},
	{
		"name": "监利县",
		"value": "421023",
		"parent": "421000"
	},
	{
		"name": "江陵县",
		"value": "421024",
		"parent": "421000"
	},
	{
		"name": "石首市",
		"value": "421081",
		"parent": "421000"
	},
	{
		"name": "洪湖市",
		"value": "421083",
		"parent": "421000"
	},
	{
		"name": "松滋市",
		"value": "421087",
		"parent": "421000"
	},
	{
		"name": "黄州区",
		"value": "421102",
		"parent": "421100"
	},
	{
		"name": "团风县",
		"value": "421121",
		"parent": "421100"
	},
	{
		"name": "红安县",
		"value": "421122",
		"parent": "421100"
	},
	{
		"name": "罗田县",
		"value": "421123",
		"parent": "421100"
	},
	{
		"name": "英山县",
		"value": "421124",
		"parent": "421100"
	},
	{
		"name": "浠水县",
		"value": "421125",
		"parent": "421100"
	},
	{
		"name": "蕲春县",
		"value": "421126",
		"parent": "421100"
	},
	{
		"name": "黄梅县",
		"value": "421127",
		"parent": "421100"
	},
	{
		"name": "麻城市",
		"value": "421181",
		"parent": "421100"
	},
	{
		"name": "武穴市",
		"value": "421182",
		"parent": "421100"
	},
	{
		"name": "咸安区",
		"value": "421202",
		"parent": "421200"
	},
	{
		"name": "嘉鱼县",
		"value": "421221",
		"parent": "421200"
	},
	{
		"name": "通城县",
		"value": "421222",
		"parent": "421200"
	},
	{
		"name": "崇阳县",
		"value": "421223",
		"parent": "421200"
	},
	{
		"name": "通山县",
		"value": "421224",
		"parent": "421200"
	},
	{
		"name": "赤壁市",
		"value": "421281",
		"parent": "421200"
	},
	{
		"name": "曾都区",
		"value": "421303",
		"parent": "421300"
	},
	{
		"name": "随县",
		"value": "421321",
		"parent": "421300"
	},
	{
		"name": "广水市",
		"value": "421381",
		"parent": "421300"
	},
	{
		"name": "恩施市",
		"value": "422801",
		"parent": "422800"
	},
	{
		"name": "利川市",
		"value": "422802",
		"parent": "422800"
	},
	{
		"name": "建始县",
		"value": "422822",
		"parent": "422800"
	},
	{
		"name": "巴东县",
		"value": "422823",
		"parent": "422800"
	},
	{
		"name": "宣恩县",
		"value": "422825",
		"parent": "422800"
	},
	{
		"name": "咸丰县",
		"value": "422826",
		"parent": "422800"
	},
	{
		"name": "来凤县",
		"value": "422827",
		"parent": "422800"
	},
	{
		"name": "鹤峰县",
		"value": "422828",
		"parent": "422800"
	},
	{
		"name": "长沙市",
		"value": "430100",
		"parent": "430000"
	},
	{
		"name": "株洲市",
		"value": "430200",
		"parent": "430000"
	},
	{
		"name": "湘潭市",
		"value": "430300",
		"parent": "430000"
	},
	{
		"name": "衡阳市",
		"value": "430400",
		"parent": "430000"
	},
	{
		"name": "邵阳市",
		"value": "430500",
		"parent": "430000"
	},
	{
		"name": "岳阳市",
		"value": "430600",
		"parent": "430000"
	},
	{
		"name": "常德市",
		"value": "430700",
		"parent": "430000"
	},
	{
		"name": "张家界市",
		"value": "430800",
		"parent": "430000"
	},
	{
		"name": "益阳市",
		"value": "430900",
		"parent": "430000"
	},
	{
		"name": "郴州市",
		"value": "431000",
		"parent": "430000"
	},
	{
		"name": "永州市",
		"value": "431100",
		"parent": "430000"
	},
	{
		"name": "怀化市",
		"value": "431200",
		"parent": "430000"
	},
	{
		"name": "娄底市",
		"value": "431300",
		"parent": "430000"
	},
	{
		"name": "湘西土家族苗族自治州",
		"value": "433100",
		"parent": "430000"
	},
	{
		"name": "芙蓉区",
		"value": "430102",
		"parent": "430100"
	},
	{
		"name": "天心区",
		"value": "430103",
		"parent": "430100"
	},
	{
		"name": "岳麓区",
		"value": "430104",
		"parent": "430100"
	},
	{
		"name": "开福区",
		"value": "430105",
		"parent": "430100"
	},
	{
		"name": "雨花区",
		"value": "430111",
		"parent": "430100"
	},
	{
		"name": "望城区",
		"value": "430112",
		"parent": "430100"
	},
	{
		"name": "长沙县",
		"value": "430121",
		"parent": "430100"
	},
	{
		"name": "宁乡县",
		"value": "430124",
		"parent": "430100"
	},
	{
		"name": "浏阳市",
		"value": "430181",
		"parent": "430100"
	},
	{
		"name": "荷塘区",
		"value": "430202",
		"parent": "430200"
	},
	{
		"name": "芦淞区",
		"value": "430203",
		"parent": "430200"
	},
	{
		"name": "石峰区",
		"value": "430204",
		"parent": "430200"
	},
	{
		"name": "天元区",
		"value": "430211",
		"parent": "430200"
	},
	{
		"name": "株洲县",
		"value": "430221",
		"parent": "430200"
	},
	{
		"name": "攸县",
		"value": "430223",
		"parent": "430200"
	},
	{
		"name": "茶陵县",
		"value": "430224",
		"parent": "430200"
	},
	{
		"name": "炎陵县",
		"value": "430225",
		"parent": "430200"
	},
	{
		"name": "醴陵市",
		"value": "430281",
		"parent": "430200"
	},
	{
		"name": "雨湖区",
		"value": "430302",
		"parent": "430300"
	},
	{
		"name": "岳塘区",
		"value": "430304",
		"parent": "430300"
	},
	{
		"name": "湘潭县",
		"value": "430321",
		"parent": "430300"
	},
	{
		"name": "湘乡市",
		"value": "430381",
		"parent": "430300"
	},
	{
		"name": "韶山市",
		"value": "430382",
		"parent": "430300"
	},
	{
		"name": "珠晖区",
		"value": "430405",
		"parent": "430400"
	},
	{
		"name": "雁峰区",
		"value": "430406",
		"parent": "430400"
	},
	{
		"name": "石鼓区",
		"value": "430407",
		"parent": "430400"
	},
	{
		"name": "蒸湘区",
		"value": "430408",
		"parent": "430400"
	},
	{
		"name": "南岳区",
		"value": "430412",
		"parent": "430400"
	},
	{
		"name": "衡阳县",
		"value": "430421",
		"parent": "430400"
	},
	{
		"name": "衡南县",
		"value": "430422",
		"parent": "430400"
	},
	{
		"name": "衡山县",
		"value": "430423",
		"parent": "430400"
	},
	{
		"name": "衡东县",
		"value": "430424",
		"parent": "430400"
	},
	{
		"name": "祁东县",
		"value": "430426",
		"parent": "430400"
	},
	{
		"name": "耒阳市",
		"value": "430481",
		"parent": "430400"
	},
	{
		"name": "常宁市",
		"value": "430482",
		"parent": "430400"
	},
	{
		"name": "双清区",
		"value": "430502",
		"parent": "430500"
	},
	{
		"name": "大祥区",
		"value": "430503",
		"parent": "430500"
	},
	{
		"name": "北塔区",
		"value": "430511",
		"parent": "430500"
	},
	{
		"name": "邵东县",
		"value": "430521",
		"parent": "430500"
	},
	{
		"name": "新邵县",
		"value": "430522",
		"parent": "430500"
	},
	{
		"name": "邵阳县",
		"value": "430523",
		"parent": "430500"
	},
	{
		"name": "隆回县",
		"value": "430524",
		"parent": "430500"
	},
	{
		"name": "洞口县",
		"value": "430525",
		"parent": "430500"
	},
	{
		"name": "绥宁县",
		"value": "430527",
		"parent": "430500"
	},
	{
		"name": "新宁县",
		"value": "430528",
		"parent": "430500"
	},
	{
		"name": "城步苗族自治县",
		"value": "430529",
		"parent": "430500"
	},
	{
		"name": "武冈市",
		"value": "430581",
		"parent": "430500"
	},
	{
		"name": "岳阳楼区",
		"value": "430602",
		"parent": "430600"
	},
	{
		"name": "云溪区",
		"value": "430603",
		"parent": "430600"
	},
	{
		"name": "君山区",
		"value": "430611",
		"parent": "430600"
	},
	{
		"name": "岳阳县",
		"value": "430621",
		"parent": "430600"
	},
	{
		"name": "华容县",
		"value": "430623",
		"parent": "430600"
	},
	{
		"name": "湘阴县",
		"value": "430624",
		"parent": "430600"
	},
	{
		"name": "平江县",
		"value": "430626",
		"parent": "430600"
	},
	{
		"name": "汨罗市",
		"value": "430681",
		"parent": "430600"
	},
	{
		"name": "临湘市",
		"value": "430682",
		"parent": "430600"
	},
	{
		"name": "武陵区",
		"value": "430702",
		"parent": "430700"
	},
	{
		"name": "鼎城区",
		"value": "430703",
		"parent": "430700"
	},
	{
		"name": "安乡县",
		"value": "430721",
		"parent": "430700"
	},
	{
		"name": "汉寿县",
		"value": "430722",
		"parent": "430700"
	},
	{
		"name": "澧县",
		"value": "430723",
		"parent": "430700"
	},
	{
		"name": "临澧县",
		"value": "430724",
		"parent": "430700"
	},
	{
		"name": "桃源县",
		"value": "430725",
		"parent": "430700"
	},
	{
		"name": "石门县",
		"value": "430726",
		"parent": "430700"
	},
	{
		"name": "津市市",
		"value": "430781",
		"parent": "430700"
	},
	{
		"name": "永定区",
		"value": "430802",
		"parent": "430800"
	},
	{
		"name": "武陵源区",
		"value": "430811",
		"parent": "430800"
	},
	{
		"name": "慈利县",
		"value": "430821",
		"parent": "430800"
	},
	{
		"name": "桑植县",
		"value": "430822",
		"parent": "430800"
	},
	{
		"name": "资阳区",
		"value": "430902",
		"parent": "430900"
	},
	{
		"name": "赫山区",
		"value": "430903",
		"parent": "430900"
	},
	{
		"name": "南县",
		"value": "430921",
		"parent": "430900"
	},
	{
		"name": "桃江县",
		"value": "430922",
		"parent": "430900"
	},
	{
		"name": "安化县",
		"value": "430923",
		"parent": "430900"
	},
	{
		"name": "沅江市",
		"value": "430981",
		"parent": "430900"
	},
	{
		"name": "北湖区",
		"value": "431002",
		"parent": "431000"
	},
	{
		"name": "苏仙区",
		"value": "431003",
		"parent": "431000"
	},
	{
		"name": "桂阳县",
		"value": "431021",
		"parent": "431000"
	},
	{
		"name": "宜章县",
		"value": "431022",
		"parent": "431000"
	},
	{
		"name": "永兴县",
		"value": "431023",
		"parent": "431000"
	},
	{
		"name": "嘉禾县",
		"value": "431024",
		"parent": "431000"
	},
	{
		"name": "临武县",
		"value": "431025",
		"parent": "431000"
	},
	{
		"name": "汝城县",
		"value": "431026",
		"parent": "431000"
	},
	{
		"name": "桂东县",
		"value": "431027",
		"parent": "431000"
	},
	{
		"name": "安仁县",
		"value": "431028",
		"parent": "431000"
	},
	{
		"name": "资兴市",
		"value": "431081",
		"parent": "431000"
	},
	{
		"name": "零陵区",
		"value": "431102",
		"parent": "431100"
	},
	{
		"name": "冷水滩区",
		"value": "431103",
		"parent": "431100"
	},
	{
		"name": "祁阳县",
		"value": "431121",
		"parent": "431100"
	},
	{
		"name": "东安县",
		"value": "431122",
		"parent": "431100"
	},
	{
		"name": "双牌县",
		"value": "431123",
		"parent": "431100"
	},
	{
		"name": "道县",
		"value": "431124",
		"parent": "431100"
	},
	{
		"name": "江永县",
		"value": "431125",
		"parent": "431100"
	},
	{
		"name": "宁远县",
		"value": "431126",
		"parent": "431100"
	},
	{
		"name": "蓝山县",
		"value": "431127",
		"parent": "431100"
	},
	{
		"name": "新田县",
		"value": "431128",
		"parent": "431100"
	},
	{
		"name": "江华瑶族自治县",
		"value": "431129",
		"parent": "431100"
	},
	{
		"name": "鹤城区",
		"value": "431202",
		"parent": "431200"
	},
	{
		"name": "中方县",
		"value": "431221",
		"parent": "431200"
	},
	{
		"name": "沅陵县",
		"value": "431222",
		"parent": "431200"
	},
	{
		"name": "辰溪县",
		"value": "431223",
		"parent": "431200"
	},
	{
		"name": "溆浦县",
		"value": "431224",
		"parent": "431200"
	},
	{
		"name": "会同县",
		"value": "431225",
		"parent": "431200"
	},
	{
		"name": "麻阳苗族自治县",
		"value": "431226",
		"parent": "431200"
	},
	{
		"name": "新晃侗族自治县",
		"value": "431227",
		"parent": "431200"
	},
	{
		"name": "芷江侗族自治县",
		"value": "431228",
		"parent": "431200"
	},
	{
		"name": "靖州苗族侗族自治县",
		"value": "431229",
		"parent": "431200"
	},
	{
		"name": "通道侗族自治县",
		"value": "431230",
		"parent": "431200"
	},
	{
		"name": "洪江市",
		"value": "431281",
		"parent": "431200"
	},
	{
		"name": "娄星区",
		"value": "431302",
		"parent": "431300"
	},
	{
		"name": "双峰县",
		"value": "431321",
		"parent": "431300"
	},
	{
		"name": "新化县",
		"value": "431322",
		"parent": "431300"
	},
	{
		"name": "冷水江市",
		"value": "431381",
		"parent": "431300"
	},
	{
		"name": "涟源市",
		"value": "431382",
		"parent": "431300"
	},
	{
		"name": "吉首市",
		"value": "433101",
		"parent": "433100"
	},
	{
		"name": "泸溪县",
		"value": "433122",
		"parent": "433100"
	},
	{
		"name": "凤凰县",
		"value": "433123",
		"parent": "433100"
	},
	{
		"name": "花垣县",
		"value": "433124",
		"parent": "433100"
	},
	{
		"name": "保靖县",
		"value": "433125",
		"parent": "433100"
	},
	{
		"name": "古丈县",
		"value": "433126",
		"parent": "433100"
	},
	{
		"name": "永顺县",
		"value": "433127",
		"parent": "433100"
	},
	{
		"name": "龙山县",
		"value": "433130",
		"parent": "433100"
	},
	{
		"name": "广州市",
		"value": "440100",
		"parent": "440000"
	},
	{
		"name": "韶关市",
		"value": "440200",
		"parent": "440000"
	},
	{
		"name": "深圳市",
		"value": "440300",
		"parent": "440000"
	},
	{
		"name": "珠海市",
		"value": "440400",
		"parent": "440000"
	},
	{
		"name": "汕头市",
		"value": "440500",
		"parent": "440000"
	},
	{
		"name": "佛山市",
		"value": "440600",
		"parent": "440000"
	},
	{
		"name": "江门市",
		"value": "440700",
		"parent": "440000"
	},
	{
		"name": "湛江市",
		"value": "440800",
		"parent": "440000"
	},
	{
		"name": "茂名市",
		"value": "440900",
		"parent": "440000"
	},
	{
		"name": "肇庆市",
		"value": "441200",
		"parent": "440000"
	},
	{
		"name": "惠州市",
		"value": "441300",
		"parent": "440000"
	},
	{
		"name": "梅州市",
		"value": "441400",
		"parent": "440000"
	},
	{
		"name": "汕尾市",
		"value": "441500",
		"parent": "440000"
	},
	{
		"name": "河源市",
		"value": "441600",
		"parent": "440000"
	},
	{
		"name": "阳江市",
		"value": "441700",
		"parent": "440000"
	},
	{
		"name": "清远市",
		"value": "441800",
		"parent": "440000"
	},
	{
		"name": "东莞市",
		"value": "441900",
		"parent": "440000"
	},
	{
		"name": "中山市",
		"value": "442000",
		"parent": "440000"
	},
	{
		"name": "潮州市",
		"value": "445100",
		"parent": "440000"
	},
	{
		"name": "揭阳市",
		"value": "445200",
		"parent": "440000"
	},
	{
		"name": "云浮市",
		"value": "445300",
		"parent": "440000"
	},
	{
		"name": "荔湾区",
		"value": "440103",
		"parent": "440100"
	},
	{
		"name": "越秀区",
		"value": "440104",
		"parent": "440100"
	},
	{
		"name": "海珠区",
		"value": "440105",
		"parent": "440100"
	},
	{
		"name": "天河区",
		"value": "440106",
		"parent": "440100"
	},
	{
		"name": "白云区",
		"value": "440111",
		"parent": "440100"
	},
	{
		"name": "黄埔区",
		"value": "440112",
		"parent": "440100"
	},
	{
		"name": "番禺区",
		"value": "440113",
		"parent": "440100"
	},
	{
		"name": "花都区",
		"value": "440114",
		"parent": "440100"
	},
	{
		"name": "南沙区",
		"value": "440115",
		"parent": "440100"
	},
	{
		"name": "从化区",
		"value": "440117",
		"parent": "440100"
	},
	{
		"name": "增城区",
		"value": "440118",
		"parent": "440100"
	},
	{
		"name": "武江区",
		"value": "440203",
		"parent": "440200"
	},
	{
		"name": "浈江区",
		"value": "440204",
		"parent": "440200"
	},
	{
		"name": "曲江区",
		"value": "440205",
		"parent": "440200"
	},
	{
		"name": "始兴县",
		"value": "440222",
		"parent": "440200"
	},
	{
		"name": "仁化县",
		"value": "440224",
		"parent": "440200"
	},
	{
		"name": "翁源县",
		"value": "440229",
		"parent": "440200"
	},
	{
		"name": "乳源瑶族自治县",
		"value": "440232",
		"parent": "440200"
	},
	{
		"name": "新丰县",
		"value": "440233",
		"parent": "440200"
	},
	{
		"name": "乐昌市",
		"value": "440281",
		"parent": "440200"
	},
	{
		"name": "南雄市",
		"value": "440282",
		"parent": "440200"
	},
	{
		"name": "罗湖区",
		"value": "440303",
		"parent": "440300"
	},
	{
		"name": "福田区",
		"value": "440304",
		"parent": "440300"
	},
	{
		"name": "南山区",
		"value": "440305",
		"parent": "440300"
	},
	{
		"name": "宝安区",
		"value": "440306",
		"parent": "440300"
	},
	{
		"name": "龙岗区",
		"value": "440307",
		"parent": "440300"
	},
	{
		"name": "盐田区",
		"value": "440308",
		"parent": "440300"
	},
	{
		"name": "香洲区",
		"value": "440402",
		"parent": "440400"
	},
	{
		"name": "斗门区",
		"value": "440403",
		"parent": "440400"
	},
	{
		"name": "金湾区",
		"value": "440404",
		"parent": "440400"
	},
	{
		"name": "龙湖区",
		"value": "440507",
		"parent": "440500"
	},
	{
		"name": "金平区",
		"value": "440511",
		"parent": "440500"
	},
	{
		"name": "濠江区",
		"value": "440512",
		"parent": "440500"
	},
	{
		"name": "潮阳区",
		"value": "440513",
		"parent": "440500"
	},
	{
		"name": "潮南区",
		"value": "440514",
		"parent": "440500"
	},
	{
		"name": "澄海区",
		"value": "440515",
		"parent": "440500"
	},
	{
		"name": "南澳县",
		"value": "440523",
		"parent": "440500"
	},
	{
		"name": "禅城区",
		"value": "440604",
		"parent": "440600"
	},
	{
		"name": "南海区",
		"value": "440605",
		"parent": "440600"
	},
	{
		"name": "顺德区",
		"value": "440606",
		"parent": "440600"
	},
	{
		"name": "三水区",
		"value": "440607",
		"parent": "440600"
	},
	{
		"name": "高明区",
		"value": "440608",
		"parent": "440600"
	},
	{
		"name": "蓬江区",
		"value": "440703",
		"parent": "440700"
	},
	{
		"name": "江海区",
		"value": "440704",
		"parent": "440700"
	},
	{
		"name": "新会区",
		"value": "440705",
		"parent": "440700"
	},
	{
		"name": "台山市",
		"value": "440781",
		"parent": "440700"
	},
	{
		"name": "开平市",
		"value": "440783",
		"parent": "440700"
	},
	{
		"name": "鹤山市",
		"value": "440784",
		"parent": "440700"
	},
	{
		"name": "恩平市",
		"value": "440785",
		"parent": "440700"
	},
	{
		"name": "赤坎区",
		"value": "440802",
		"parent": "440800"
	},
	{
		"name": "霞山区",
		"value": "440803",
		"parent": "440800"
	},
	{
		"name": "坡头区",
		"value": "440804",
		"parent": "440800"
	},
	{
		"name": "麻章区",
		"value": "440811",
		"parent": "440800"
	},
	{
		"name": "遂溪县",
		"value": "440823",
		"parent": "440800"
	},
	{
		"name": "徐闻县",
		"value": "440825",
		"parent": "440800"
	},
	{
		"name": "廉江市",
		"value": "440881",
		"parent": "440800"
	},
	{
		"name": "雷州市",
		"value": "440882",
		"parent": "440800"
	},
	{
		"name": "吴川市",
		"value": "440883",
		"parent": "440800"
	},
	{
		"name": "茂南区",
		"value": "440902",
		"parent": "440900"
	},
	{
		"name": "电白区",
		"value": "440904",
		"parent": "440900"
	},
	{
		"name": "高州市",
		"value": "440981",
		"parent": "440900"
	},
	{
		"name": "化州市",
		"value": "440982",
		"parent": "440900"
	},
	{
		"name": "信宜市",
		"value": "440983",
		"parent": "440900"
	},
	{
		"name": "端州区",
		"value": "441202",
		"parent": "441200"
	},
	{
		"name": "鼎湖区",
		"value": "441203",
		"parent": "441200"
	},
	{
		"name": "高要区",
		"value": "441204",
		"parent": "441200"
	},
	{
		"name": "广宁县",
		"value": "441223",
		"parent": "441200"
	},
	{
		"name": "怀集县",
		"value": "441224",
		"parent": "441200"
	},
	{
		"name": "封开县",
		"value": "441225",
		"parent": "441200"
	},
	{
		"name": "德庆县",
		"value": "441226",
		"parent": "441200"
	},
	{
		"name": "四会市",
		"value": "441284",
		"parent": "441200"
	},
	{
		"name": "惠城区",
		"value": "441302",
		"parent": "441300"
	},
	{
		"name": "惠阳区",
		"value": "441303",
		"parent": "441300"
	},
	{
		"name": "博罗县",
		"value": "441322",
		"parent": "441300"
	},
	{
		"name": "惠东县",
		"value": "441323",
		"parent": "441300"
	},
	{
		"name": "龙门县",
		"value": "441324",
		"parent": "441300"
	},
	{
		"name": "梅江区",
		"value": "441402",
		"parent": "441400"
	},
	{
		"name": "梅县区",
		"value": "441403",
		"parent": "441400"
	},
	{
		"name": "大埔县",
		"value": "441422",
		"parent": "441400"
	},
	{
		"name": "丰顺县",
		"value": "441423",
		"parent": "441400"
	},
	{
		"name": "五华县",
		"value": "441424",
		"parent": "441400"
	},
	{
		"name": "平远县",
		"value": "441426",
		"parent": "441400"
	},
	{
		"name": "蕉岭县",
		"value": "441427",
		"parent": "441400"
	},
	{
		"name": "兴宁市",
		"value": "441481",
		"parent": "441400"
	},
	{
		"name": "城区",
		"value": "441502",
		"parent": "441500"
	},
	{
		"name": "海丰县",
		"value": "441521",
		"parent": "441500"
	},
	{
		"name": "陆河县",
		"value": "441523",
		"parent": "441500"
	},
	{
		"name": "陆丰市",
		"value": "441581",
		"parent": "441500"
	},
	{
		"name": "源城区",
		"value": "441602",
		"parent": "441600"
	},
	{
		"name": "紫金县",
		"value": "441621",
		"parent": "441600"
	},
	{
		"name": "龙川县",
		"value": "441622",
		"parent": "441600"
	},
	{
		"name": "连平县",
		"value": "441623",
		"parent": "441600"
	},
	{
		"name": "和平县",
		"value": "441624",
		"parent": "441600"
	},
	{
		"name": "东源县",
		"value": "441625",
		"parent": "441600"
	},
	{
		"name": "江城区",
		"value": "441702",
		"parent": "441700"
	},
	{
		"name": "阳东区",
		"value": "441704",
		"parent": "441700"
	},
	{
		"name": "阳西县",
		"value": "441721",
		"parent": "441700"
	},
	{
		"name": "阳春市",
		"value": "441781",
		"parent": "441700"
	},
	{
		"name": "清城区",
		"value": "441802",
		"parent": "441800"
	},
	{
		"name": "清新区",
		"value": "441803",
		"parent": "441800"
	},
	{
		"name": "佛冈县",
		"value": "441821",
		"parent": "441800"
	},
	{
		"name": "阳山县",
		"value": "441823",
		"parent": "441800"
	},
	{
		"name": "连山壮族瑶族自治县",
		"value": "441825",
		"parent": "441800"
	},
	{
		"name": "连南瑶族自治县",
		"value": "441826",
		"parent": "441800"
	},
	{
		"name": "英德市",
		"value": "441881",
		"parent": "441800"
	},
	{
		"name": "连州市",
		"value": "441882",
		"parent": "441800"
	},
	{
		"name": "湘桥区",
		"value": "445102",
		"parent": "445100"
	},
	{
		"name": "潮安区",
		"value": "445103",
		"parent": "445100"
	},
	{
		"name": "饶平县",
		"value": "445122",
		"parent": "445100"
	},
	{
		"name": "榕城区",
		"value": "445202",
		"parent": "445200"
	},
	{
		"name": "揭东区",
		"value": "445203",
		"parent": "445200"
	},
	{
		"name": "揭西县",
		"value": "445222",
		"parent": "445200"
	},
	{
		"name": "惠来县",
		"value": "445224",
		"parent": "445200"
	},
	{
		"name": "普宁市",
		"value": "445281",
		"parent": "445200"
	},
	{
		"name": "云城区",
		"value": "445302",
		"parent": "445300"
	},
	{
		"name": "云安区",
		"value": "445303",
		"parent": "445300"
	},
	{
		"name": "新兴县",
		"value": "445321",
		"parent": "445300"
	},
	{
		"name": "郁南县",
		"value": "445322",
		"parent": "445300"
	},
	{
		"name": "罗定市",
		"value": "445381",
		"parent": "445300"
	},
	{
		"name": "南宁市",
		"value": "450100",
		"parent": "450000"
	},
	{
		"name": "柳州市",
		"value": "450200",
		"parent": "450000"
	},
	{
		"name": "桂林市",
		"value": "450300",
		"parent": "450000"
	},
	{
		"name": "梧州市",
		"value": "450400",
		"parent": "450000"
	},
	{
		"name": "北海市",
		"value": "450500",
		"parent": "450000"
	},
	{
		"name": "防城港市",
		"value": "450600",
		"parent": "450000"
	},
	{
		"name": "钦州市",
		"value": "450700",
		"parent": "450000"
	},
	{
		"name": "贵港市",
		"value": "450800",
		"parent": "450000"
	},
	{
		"name": "玉林市",
		"value": "450900",
		"parent": "450000"
	},
	{
		"name": "百色市",
		"value": "451000",
		"parent": "450000"
	},
	{
		"name": "贺州市",
		"value": "451100",
		"parent": "450000"
	},
	{
		"name": "河池市",
		"value": "451200",
		"parent": "450000"
	},
	{
		"name": "来宾市",
		"value": "451300",
		"parent": "450000"
	},
	{
		"name": "崇左市",
		"value": "451400",
		"parent": "450000"
	},
	{
		"name": "兴宁区",
		"value": "450102",
		"parent": "450100"
	},
	{
		"name": "青秀区",
		"value": "450103",
		"parent": "450100"
	},
	{
		"name": "江南区",
		"value": "450105",
		"parent": "450100"
	},
	{
		"name": "西乡塘区",
		"value": "450107",
		"parent": "450100"
	},
	{
		"name": "良庆区",
		"value": "450108",
		"parent": "450100"
	},
	{
		"name": "邕宁区",
		"value": "450109",
		"parent": "450100"
	},
	{
		"name": "武鸣区",
		"value": "450110",
		"parent": "450100"
	},
	{
		"name": "隆安县",
		"value": "450123",
		"parent": "450100"
	},
	{
		"name": "马山县",
		"value": "450124",
		"parent": "450100"
	},
	{
		"name": "上林县",
		"value": "450125",
		"parent": "450100"
	},
	{
		"name": "宾阳县",
		"value": "450126",
		"parent": "450100"
	},
	{
		"name": "横县",
		"value": "450127",
		"parent": "450100"
	},
	{
		"name": "城中区",
		"value": "450202",
		"parent": "450200"
	},
	{
		"name": "鱼峰区",
		"value": "450203",
		"parent": "450200"
	},
	{
		"name": "柳南区",
		"value": "450204",
		"parent": "450200"
	},
	{
		"name": "柳北区",
		"value": "450205",
		"parent": "450200"
	},
	{
		"name": "柳江县",
		"value": "450221",
		"parent": "450200"
	},
	{
		"name": "柳城县",
		"value": "450222",
		"parent": "450200"
	},
	{
		"name": "鹿寨县",
		"value": "450223",
		"parent": "450200"
	},
	{
		"name": "融安县",
		"value": "450224",
		"parent": "450200"
	},
	{
		"name": "融水苗族自治县",
		"value": "450225",
		"parent": "450200"
	},
	{
		"name": "三江侗族自治县",
		"value": "450226",
		"parent": "450200"
	},
	{
		"name": "秀峰区",
		"value": "450302",
		"parent": "450300"
	},
	{
		"name": "叠彩区",
		"value": "450303",
		"parent": "450300"
	},
	{
		"name": "象山区",
		"value": "450304",
		"parent": "450300"
	},
	{
		"name": "七星区",
		"value": "450305",
		"parent": "450300"
	},
	{
		"name": "雁山区",
		"value": "450311",
		"parent": "450300"
	},
	{
		"name": "临桂区",
		"value": "450312",
		"parent": "450300"
	},
	{
		"name": "阳朔县",
		"value": "450321",
		"parent": "450300"
	},
	{
		"name": "灵川县",
		"value": "450323",
		"parent": "450300"
	},
	{
		"name": "全州县",
		"value": "450324",
		"parent": "450300"
	},
	{
		"name": "兴安县",
		"value": "450325",
		"parent": "450300"
	},
	{
		"name": "永福县",
		"value": "450326",
		"parent": "450300"
	},
	{
		"name": "灌阳县",
		"value": "450327",
		"parent": "450300"
	},
	{
		"name": "龙胜各族自治县",
		"value": "450328",
		"parent": "450300"
	},
	{
		"name": "资源县",
		"value": "450329",
		"parent": "450300"
	},
	{
		"name": "平乐县",
		"value": "450330",
		"parent": "450300"
	},
	{
		"name": "荔浦县",
		"value": "450331",
		"parent": "450300"
	},
	{
		"name": "恭城瑶族自治县",
		"value": "450332",
		"parent": "450300"
	},
	{
		"name": "万秀区",
		"value": "450403",
		"parent": "450400"
	},
	{
		"name": "长洲区",
		"value": "450405",
		"parent": "450400"
	},
	{
		"name": "龙圩区",
		"value": "450406",
		"parent": "450400"
	},
	{
		"name": "苍梧县",
		"value": "450421",
		"parent": "450400"
	},
	{
		"name": "藤县",
		"value": "450422",
		"parent": "450400"
	},
	{
		"name": "蒙山县",
		"value": "450423",
		"parent": "450400"
	},
	{
		"name": "岑溪市",
		"value": "450481",
		"parent": "450400"
	},
	{
		"name": "海城区",
		"value": "450502",
		"parent": "450500"
	},
	{
		"name": "银海区",
		"value": "450503",
		"parent": "450500"
	},
	{
		"name": "铁山港区",
		"value": "450512",
		"parent": "450500"
	},
	{
		"name": "合浦县",
		"value": "450521",
		"parent": "450500"
	},
	{
		"name": "港口区",
		"value": "450602",
		"parent": "450600"
	},
	{
		"name": "防城区",
		"value": "450603",
		"parent": "450600"
	},
	{
		"name": "上思县",
		"value": "450621",
		"parent": "450600"
	},
	{
		"name": "东兴市",
		"value": "450681",
		"parent": "450600"
	},
	{
		"name": "钦南区",
		"value": "450702",
		"parent": "450700"
	},
	{
		"name": "钦北区",
		"value": "450703",
		"parent": "450700"
	},
	{
		"name": "灵山县",
		"value": "450721",
		"parent": "450700"
	},
	{
		"name": "浦北县",
		"value": "450722",
		"parent": "450700"
	},
	{
		"name": "港北区",
		"value": "450802",
		"parent": "450800"
	},
	{
		"name": "港南区",
		"value": "450803",
		"parent": "450800"
	},
	{
		"name": "覃塘区",
		"value": "450804",
		"parent": "450800"
	},
	{
		"name": "平南县",
		"value": "450821",
		"parent": "450800"
	},
	{
		"name": "桂平市",
		"value": "450881",
		"parent": "450800"
	},
	{
		"name": "玉州区",
		"value": "450902",
		"parent": "450900"
	},
	{
		"name": "福绵区",
		"value": "450903",
		"parent": "450900"
	},
	{
		"name": "容县",
		"value": "450921",
		"parent": "450900"
	},
	{
		"name": "陆川县",
		"value": "450922",
		"parent": "450900"
	},
	{
		"name": "博白县",
		"value": "450923",
		"parent": "450900"
	},
	{
		"name": "兴业县",
		"value": "450924",
		"parent": "450900"
	},
	{
		"name": "北流市",
		"value": "450981",
		"parent": "450900"
	},
	{
		"name": "右江区",
		"value": "451002",
		"parent": "451000"
	},
	{
		"name": "田阳县",
		"value": "451021",
		"parent": "451000"
	},
	{
		"name": "田东县",
		"value": "451022",
		"parent": "451000"
	},
	{
		"name": "平果县",
		"value": "451023",
		"parent": "451000"
	},
	{
		"name": "德保县",
		"value": "451024",
		"parent": "451000"
	},
	{
		"name": "那坡县",
		"value": "451026",
		"parent": "451000"
	},
	{
		"name": "凌云县",
		"value": "451027",
		"parent": "451000"
	},
	{
		"name": "乐业县",
		"value": "451028",
		"parent": "451000"
	},
	{
		"name": "田林县",
		"value": "451029",
		"parent": "451000"
	},
	{
		"name": "西林县",
		"value": "451030",
		"parent": "451000"
	},
	{
		"name": "隆林各族自治县",
		"value": "451031",
		"parent": "451000"
	},
	{
		"name": "靖西市",
		"value": "451081",
		"parent": "451000"
	},
	{
		"name": "八步区",
		"value": "451102",
		"parent": "451100"
	},
	{
		"name": "昭平县",
		"value": "451121",
		"parent": "451100"
	},
	{
		"name": "钟山县",
		"value": "451122",
		"parent": "451100"
	},
	{
		"name": "富川瑶族自治县",
		"value": "451123",
		"parent": "451100"
	},
	{
		"name": "金城江区",
		"value": "451202",
		"parent": "451200"
	},
	{
		"name": "南丹县",
		"value": "451221",
		"parent": "451200"
	},
	{
		"name": "天峨县",
		"value": "451222",
		"parent": "451200"
	},
	{
		"name": "凤山县",
		"value": "451223",
		"parent": "451200"
	},
	{
		"name": "东兰县",
		"value": "451224",
		"parent": "451200"
	},
	{
		"name": "罗城仫佬族自治县",
		"value": "451225",
		"parent": "451200"
	},
	{
		"name": "环江毛南族自治县",
		"value": "451226",
		"parent": "451200"
	},
	{
		"name": "巴马瑶族自治县",
		"value": "451227",
		"parent": "451200"
	},
	{
		"name": "都安瑶族自治县",
		"value": "451228",
		"parent": "451200"
	},
	{
		"name": "大化瑶族自治县",
		"value": "451229",
		"parent": "451200"
	},
	{
		"name": "宜州市",
		"value": "451281",
		"parent": "451200"
	},
	{
		"name": "兴宾区",
		"value": "451302",
		"parent": "451300"
	},
	{
		"name": "忻城县",
		"value": "451321",
		"parent": "451300"
	},
	{
		"name": "象州县",
		"value": "451322",
		"parent": "451300"
	},
	{
		"name": "武宣县",
		"value": "451323",
		"parent": "451300"
	},
	{
		"name": "金秀瑶族自治县",
		"value": "451324",
		"parent": "451300"
	},
	{
		"name": "合山市",
		"value": "451381",
		"parent": "451300"
	},
	{
		"name": "江州区",
		"value": "451402",
		"parent": "451400"
	},
	{
		"name": "扶绥县",
		"value": "451421",
		"parent": "451400"
	},
	{
		"name": "宁明县",
		"value": "451422",
		"parent": "451400"
	},
	{
		"name": "龙州县",
		"value": "451423",
		"parent": "451400"
	},
	{
		"name": "大新县",
		"value": "451424",
		"parent": "451400"
	},
	{
		"name": "天等县",
		"value": "451425",
		"parent": "451400"
	},
	{
		"name": "凭祥市",
		"value": "451481",
		"parent": "451400"
	},
	{
		"name": "海口市",
		"value": "460100",
		"parent": "460000"
	},
	{
		"name": "三亚市",
		"value": "460200",
		"parent": "460000"
	},
	{
		"name": "三沙市",
		"value": "460300",
		"parent": "460000"
	},
	{
		"name": "五指山市",
		"value": "469001",
		"parent": "460000"
	},
	{
		"name": "琼海市",
		"value": "469002",
		"parent": "460000"
	},
	{
		"name": "儋州市",
		"value": "469003",
		"parent": "460000"
	},
	{
		"name": "文昌市",
		"value": "469005",
		"parent": "460000"
	},
	{
		"name": "万宁市",
		"value": "469006",
		"parent": "460000"
	},
	{
		"name": "东方市",
		"value": "469007",
		"parent": "460000"
	},
	{
		"name": "定安县",
		"value": "469021",
		"parent": "460000"
	},
	{
		"name": "屯昌县",
		"value": "469022",
		"parent": "460000"
	},
	{
		"name": "澄迈县",
		"value": "469023",
		"parent": "460000"
	},
	{
		"name": "临高县",
		"value": "469024",
		"parent": "460000"
	},
	{
		"name": "白沙黎族自治县",
		"value": "469025",
		"parent": "460000"
	},
	{
		"name": "昌江黎族自治县",
		"value": "469026",
		"parent": "460000"
	},
	{
		"name": "乐东黎族自治县",
		"value": "469027",
		"parent": "460000"
	},
	{
		"name": "陵水黎族自治县",
		"value": "469028",
		"parent": "460000"
	},
	{
		"name": "保亭黎族苗族自治县",
		"value": "469029",
		"parent": "460000"
	},
	{
		"name": "琼中黎族苗族自治县",
		"value": "469030",
		"parent": "460000"
	},
	{
		"name": "秀英区",
		"value": "460105",
		"parent": "460100"
	},
	{
		"name": "龙华区",
		"value": "460106",
		"parent": "460100"
	},
	{
		"name": "琼山区",
		"value": "460107",
		"parent": "460100"
	},
	{
		"name": "美兰区",
		"value": "460108",
		"parent": "460100"
	},
	{
		"name": "海棠区",
		"value": "460202",
		"parent": "460200"
	},
	{
		"name": "吉阳区",
		"value": "460203",
		"parent": "460200"
	},
	{
		"name": "天涯区",
		"value": "460204",
		"parent": "460200"
	},
	{
		"name": "崖州区",
		"value": "460205",
		"parent": "460200"
	},
	{
		"name": "西沙群岛",
		"value": "460321",
		"parent": "460300"
	},
	{
		"name": "南沙群岛",
		"value": "460322",
		"parent": "460300"
	},
	{
		"name": "中沙群岛的岛礁及其海域",
		"value": "460323",
		"parent": "460300"
	},
	{
		"name": "市辖区",
		"value": "500100",
		"parent": "500000"
	},
	{
		"name": "万州区",
		"value": "500101",
		"parent": "500100"
	},
	{
		"name": "涪陵区",
		"value": "500102",
		"parent": "500100"
	},
	{
		"name": "渝中区",
		"value": "500103",
		"parent": "500100"
	},
	{
		"name": "大渡口区",
		"value": "500104",
		"parent": "500100"
	},
	{
		"name": "江北区",
		"value": "500105",
		"parent": "500100"
	},
	{
		"name": "沙坪坝区",
		"value": "500106",
		"parent": "500100"
	},
	{
		"name": "九龙坡区",
		"value": "500107",
		"parent": "500100"
	},
	{
		"name": "南岸区",
		"value": "500108",
		"parent": "500100"
	},
	{
		"name": "北碚区",
		"value": "500109",
		"parent": "500100"
	},
	{
		"name": "綦江区",
		"value": "500110",
		"parent": "500100"
	},
	{
		"name": "大足区",
		"value": "500111",
		"parent": "500100"
	},
	{
		"name": "渝北区",
		"value": "500112",
		"parent": "500100"
	},
	{
		"name": "巴南区",
		"value": "500113",
		"parent": "500100"
	},
	{
		"name": "黔江区",
		"value": "500114",
		"parent": "500100"
	},
	{
		"name": "长寿区",
		"value": "500115",
		"parent": "500100"
	},
	{
		"name": "江津区",
		"value": "500116",
		"parent": "500100"
	},
	{
		"name": "合川区",
		"value": "500117",
		"parent": "500100"
	},
	{
		"name": "永川区",
		"value": "500118",
		"parent": "500100"
	},
	{
		"name": "南川区",
		"value": "500119",
		"parent": "500100"
	},
	{
		"name": "璧山区",
		"value": "500120",
		"parent": "500100"
	},
	{
		"name": "铜梁区",
		"value": "500151",
		"parent": "500100"
	},
	{
		"name": "潼南区",
		"value": "500152",
		"parent": "500100"
	},
	{
		"name": "荣昌区",
		"value": "500153",
		"parent": "500100"
	},
	{
		"name": "梁平县",
		"value": "500228",
		"parent": "500100"
	},
	{
		"name": "城口县",
		"value": "500229",
		"parent": "500100"
	},
	{
		"name": "丰都县",
		"value": "500230",
		"parent": "500100"
	},
	{
		"name": "垫江县",
		"value": "500231",
		"parent": "500100"
	},
	{
		"name": "武隆县",
		"value": "500232",
		"parent": "500100"
	},
	{
		"name": "忠县",
		"value": "500233",
		"parent": "500100"
	},
	{
		"name": "开县",
		"value": "500234",
		"parent": "500100"
	},
	{
		"name": "云阳县",
		"value": "500235",
		"parent": "500100"
	},
	{
		"name": "奉节县",
		"value": "500236",
		"parent": "500100"
	},
	{
		"name": "巫山县",
		"value": "500237",
		"parent": "500100"
	},
	{
		"name": "巫溪县",
		"value": "500238",
		"parent": "500100"
	},
	{
		"name": "石柱土家族自治县",
		"value": "500240",
		"parent": "500100"
	},
	{
		"name": "秀山土家族苗族自治县",
		"value": "500241",
		"parent": "500100"
	},
	{
		"name": "酉阳土家族苗族自治县",
		"value": "500242",
		"parent": "500100"
	},
	{
		"name": "彭水苗族土家族自治县",
		"value": "500243",
		"parent": "500100"
	},
	{
		"name": "成都市",
		"value": "510100",
		"parent": "510000"
	},
	{
		"name": "自贡市",
		"value": "510300",
		"parent": "510000"
	},
	{
		"name": "攀枝花市",
		"value": "510400",
		"parent": "510000"
	},
	{
		"name": "泸州市",
		"value": "510500",
		"parent": "510000"
	},
	{
		"name": "德阳市",
		"value": "510600",
		"parent": "510000"
	},
	{
		"name": "绵阳市",
		"value": "510700",
		"parent": "510000"
	},
	{
		"name": "广元市",
		"value": "510800",
		"parent": "510000"
	},
	{
		"name": "遂宁市",
		"value": "510900",
		"parent": "510000"
	},
	{
		"name": "内江市",
		"value": "511000",
		"parent": "510000"
	},
	{
		"name": "乐山市",
		"value": "511100",
		"parent": "510000"
	},
	{
		"name": "南充市",
		"value": "511300",
		"parent": "510000"
	},
	{
		"name": "眉山市",
		"value": "511400",
		"parent": "510000"
	},
	{
		"name": "宜宾市",
		"value": "511500",
		"parent": "510000"
	},
	{
		"name": "广安市",
		"value": "511600",
		"parent": "510000"
	},
	{
		"name": "达州市",
		"value": "511700",
		"parent": "510000"
	},
	{
		"name": "雅安市",
		"value": "511800",
		"parent": "510000"
	},
	{
		"name": "巴中市",
		"value": "511900",
		"parent": "510000"
	},
	{
		"name": "资阳市",
		"value": "512000",
		"parent": "510000"
	},
	{
		"name": "阿坝藏族羌族自治州",
		"value": "513200",
		"parent": "510000"
	},
	{
		"name": "甘孜藏族自治州",
		"value": "513300",
		"parent": "510000"
	},
	{
		"name": "凉山彝族自治州",
		"value": "513400",
		"parent": "510000"
	},
	{
		"name": "锦江区",
		"value": "510104",
		"parent": "510100"
	},
	{
		"name": "青羊区",
		"value": "510105",
		"parent": "510100"
	},
	{
		"name": "金牛区",
		"value": "510106",
		"parent": "510100"
	},
	{
		"name": "武侯区",
		"value": "510107",
		"parent": "510100"
	},
	{
		"name": "成华区",
		"value": "510108",
		"parent": "510100"
	},
	{
		"name": "龙泉驿区",
		"value": "510112",
		"parent": "510100"
	},
	{
		"name": "青白江区",
		"value": "510113",
		"parent": "510100"
	},
	{
		"name": "新都区",
		"value": "510114",
		"parent": "510100"
	},
	{
		"name": "温江区",
		"value": "510115",
		"parent": "510100"
	},
	{
		"name": "金堂县",
		"value": "510121",
		"parent": "510100"
	},
	{
		"name": "双流县",
		"value": "510122",
		"parent": "510100"
	},
	{
		"name": "郫县",
		"value": "510124",
		"parent": "510100"
	},
	{
		"name": "大邑县",
		"value": "510129",
		"parent": "510100"
	},
	{
		"name": "蒲江县",
		"value": "510131",
		"parent": "510100"
	},
	{
		"name": "新津县",
		"value": "510132",
		"parent": "510100"
	},
	{
		"name": "都江堰市",
		"value": "510181",
		"parent": "510100"
	},
	{
		"name": "彭州市",
		"value": "510182",
		"parent": "510100"
	},
	{
		"name": "邛崃市",
		"value": "510183",
		"parent": "510100"
	},
	{
		"name": "崇州市",
		"value": "510184",
		"parent": "510100"
	},
	{
		"name": "自流井区",
		"value": "510302",
		"parent": "510300"
	},
	{
		"name": "贡井区",
		"value": "510303",
		"parent": "510300"
	},
	{
		"name": "大安区",
		"value": "510304",
		"parent": "510300"
	},
	{
		"name": "沿滩区",
		"value": "510311",
		"parent": "510300"
	},
	{
		"name": "荣县",
		"value": "510321",
		"parent": "510300"
	},
	{
		"name": "富顺县",
		"value": "510322",
		"parent": "510300"
	},
	{
		"name": "东区",
		"value": "510402",
		"parent": "510400"
	},
	{
		"name": "西区",
		"value": "510403",
		"parent": "510400"
	},
	{
		"name": "仁和区",
		"value": "510411",
		"parent": "510400"
	},
	{
		"name": "米易县",
		"value": "510421",
		"parent": "510400"
	},
	{
		"name": "盐边县",
		"value": "510422",
		"parent": "510400"
	},
	{
		"name": "江阳区",
		"value": "510502",
		"parent": "510500"
	},
	{
		"name": "纳溪区",
		"value": "510503",
		"parent": "510500"
	},
	{
		"name": "龙马潭区",
		"value": "510504",
		"parent": "510500"
	},
	{
		"name": "泸县",
		"value": "510521",
		"parent": "510500"
	},
	{
		"name": "合江县",
		"value": "510522",
		"parent": "510500"
	},
	{
		"name": "叙永县",
		"value": "510524",
		"parent": "510500"
	},
	{
		"name": "古蔺县",
		"value": "510525",
		"parent": "510500"
	},
	{
		"name": "旌阳区",
		"value": "510603",
		"parent": "510600"
	},
	{
		"name": "中江县",
		"value": "510623",
		"parent": "510600"
	},
	{
		"name": "罗江县",
		"value": "510626",
		"parent": "510600"
	},
	{
		"name": "广汉市",
		"value": "510681",
		"parent": "510600"
	},
	{
		"name": "什邡市",
		"value": "510682",
		"parent": "510600"
	},
	{
		"name": "绵竹市",
		"value": "510683",
		"parent": "510600"
	},
	{
		"name": "涪城区",
		"value": "510703",
		"parent": "510700"
	},
	{
		"name": "游仙区",
		"value": "510704",
		"parent": "510700"
	},
	{
		"name": "三台县",
		"value": "510722",
		"parent": "510700"
	},
	{
		"name": "盐亭县",
		"value": "510723",
		"parent": "510700"
	},
	{
		"name": "安县",
		"value": "510724",
		"parent": "510700"
	},
	{
		"name": "梓潼县",
		"value": "510725",
		"parent": "510700"
	},
	{
		"name": "北川羌族自治县",
		"value": "510726",
		"parent": "510700"
	},
	{
		"name": "平武县",
		"value": "510727",
		"parent": "510700"
	},
	{
		"name": "江油市",
		"value": "510781",
		"parent": "510700"
	},
	{
		"name": "利州区",
		"value": "510802",
		"parent": "510800"
	},
	{
		"name": "昭化区",
		"value": "510811",
		"parent": "510800"
	},
	{
		"name": "朝天区",
		"value": "510812",
		"parent": "510800"
	},
	{
		"name": "旺苍县",
		"value": "510821",
		"parent": "510800"
	},
	{
		"name": "青川县",
		"value": "510822",
		"parent": "510800"
	},
	{
		"name": "剑阁县",
		"value": "510823",
		"parent": "510800"
	},
	{
		"name": "苍溪县",
		"value": "510824",
		"parent": "510800"
	},
	{
		"name": "船山区",
		"value": "510903",
		"parent": "510900"
	},
	{
		"name": "安居区",
		"value": "510904",
		"parent": "510900"
	},
	{
		"name": "蓬溪县",
		"value": "510921",
		"parent": "510900"
	},
	{
		"name": "射洪县",
		"value": "510922",
		"parent": "510900"
	},
	{
		"name": "大英县",
		"value": "510923",
		"parent": "510900"
	},
	{
		"name": "市中区",
		"value": "511002",
		"parent": "511000"
	},
	{
		"name": "东兴区",
		"value": "511011",
		"parent": "511000"
	},
	{
		"name": "威远县",
		"value": "511024",
		"parent": "511000"
	},
	{
		"name": "资中县",
		"value": "511025",
		"parent": "511000"
	},
	{
		"name": "隆昌县",
		"value": "511028",
		"parent": "511000"
	},
	{
		"name": "市中区",
		"value": "511102",
		"parent": "511100"
	},
	{
		"name": "沙湾区",
		"value": "511111",
		"parent": "511100"
	},
	{
		"name": "五通桥区",
		"value": "511112",
		"parent": "511100"
	},
	{
		"name": "金口河区",
		"value": "511113",
		"parent": "511100"
	},
	{
		"name": "犍为县",
		"value": "511123",
		"parent": "511100"
	},
	{
		"name": "井研县",
		"value": "511124",
		"parent": "511100"
	},
	{
		"name": "夹江县",
		"value": "511126",
		"parent": "511100"
	},
	{
		"name": "沐川县",
		"value": "511129",
		"parent": "511100"
	},
	{
		"name": "峨边彝族自治县",
		"value": "511132",
		"parent": "511100"
	},
	{
		"name": "马边彝族自治县",
		"value": "511133",
		"parent": "511100"
	},
	{
		"name": "峨眉山市",
		"value": "511181",
		"parent": "511100"
	},
	{
		"name": "顺庆区",
		"value": "511302",
		"parent": "511300"
	},
	{
		"name": "高坪区",
		"value": "511303",
		"parent": "511300"
	},
	{
		"name": "嘉陵区",
		"value": "511304",
		"parent": "511300"
	},
	{
		"name": "南部县",
		"value": "511321",
		"parent": "511300"
	},
	{
		"name": "营山县",
		"value": "511322",
		"parent": "511300"
	},
	{
		"name": "蓬安县",
		"value": "511323",
		"parent": "511300"
	},
	{
		"name": "仪陇县",
		"value": "511324",
		"parent": "511300"
	},
	{
		"name": "西充县",
		"value": "511325",
		"parent": "511300"
	},
	{
		"name": "阆中市",
		"value": "511381",
		"parent": "511300"
	},
	{
		"name": "东坡区",
		"value": "511402",
		"parent": "511400"
	},
	{
		"name": "彭山区",
		"value": "511403",
		"parent": "511400"
	},
	{
		"name": "仁寿县",
		"value": "511421",
		"parent": "511400"
	},
	{
		"name": "洪雅县",
		"value": "511423",
		"parent": "511400"
	},
	{
		"name": "丹棱县",
		"value": "511424",
		"parent": "511400"
	},
	{
		"name": "青神县",
		"value": "511425",
		"parent": "511400"
	},
	{
		"name": "翠屏区",
		"value": "511502",
		"parent": "511500"
	},
	{
		"name": "南溪区",
		"value": "511503",
		"parent": "511500"
	},
	{
		"name": "宜宾县",
		"value": "511521",
		"parent": "511500"
	},
	{
		"name": "江安县",
		"value": "511523",
		"parent": "511500"
	},
	{
		"name": "长宁县",
		"value": "511524",
		"parent": "511500"
	},
	{
		"name": "高县",
		"value": "511525",
		"parent": "511500"
	},
	{
		"name": "珙县",
		"value": "511526",
		"parent": "511500"
	},
	{
		"name": "筠连县",
		"value": "511527",
		"parent": "511500"
	},
	{
		"name": "兴文县",
		"value": "511528",
		"parent": "511500"
	},
	{
		"name": "屏山县",
		"value": "511529",
		"parent": "511500"
	},
	{
		"name": "广安区",
		"value": "511602",
		"parent": "511600"
	},
	{
		"name": "前锋区",
		"value": "511603",
		"parent": "511600"
	},
	{
		"name": "岳池县",
		"value": "511621",
		"parent": "511600"
	},
	{
		"name": "武胜县",
		"value": "511622",
		"parent": "511600"
	},
	{
		"name": "邻水县",
		"value": "511623",
		"parent": "511600"
	},
	{
		"name": "华蓥市",
		"value": "511681",
		"parent": "511600"
	},
	{
		"name": "通川区",
		"value": "511702",
		"parent": "511700"
	},
	{
		"name": "达川区",
		"value": "511703",
		"parent": "511700"
	},
	{
		"name": "宣汉县",
		"value": "511722",
		"parent": "511700"
	},
	{
		"name": "开江县",
		"value": "511723",
		"parent": "511700"
	},
	{
		"name": "大竹县",
		"value": "511724",
		"parent": "511700"
	},
	{
		"name": "渠县",
		"value": "511725",
		"parent": "511700"
	},
	{
		"name": "万源市",
		"value": "511781",
		"parent": "511700"
	},
	{
		"name": "雨城区",
		"value": "511802",
		"parent": "511800"
	},
	{
		"name": "名山区",
		"value": "511803",
		"parent": "511800"
	},
	{
		"name": "荥经县",
		"value": "511822",
		"parent": "511800"
	},
	{
		"name": "汉源县",
		"value": "511823",
		"parent": "511800"
	},
	{
		"name": "石棉县",
		"value": "511824",
		"parent": "511800"
	},
	{
		"name": "天全县",
		"value": "511825",
		"parent": "511800"
	},
	{
		"name": "芦山县",
		"value": "511826",
		"parent": "511800"
	},
	{
		"name": "宝兴县",
		"value": "511827",
		"parent": "511800"
	},
	{
		"name": "巴州区",
		"value": "511902",
		"parent": "511900"
	},
	{
		"name": "恩阳区",
		"value": "511903",
		"parent": "511900"
	},
	{
		"name": "通江县",
		"value": "511921",
		"parent": "511900"
	},
	{
		"name": "南江县",
		"value": "511922",
		"parent": "511900"
	},
	{
		"name": "平昌县",
		"value": "511923",
		"parent": "511900"
	},
	{
		"name": "雁江区",
		"value": "512002",
		"parent": "512000"
	},
	{
		"name": "安岳县",
		"value": "512021",
		"parent": "512000"
	},
	{
		"name": "乐至县",
		"value": "512022",
		"parent": "512000"
	},
	{
		"name": "简阳市",
		"value": "512081",
		"parent": "512000"
	},
	{
		"name": "汶川县",
		"value": "513221",
		"parent": "513200"
	},
	{
		"name": "理县",
		"value": "513222",
		"parent": "513200"
	},
	{
		"name": "茂县",
		"value": "513223",
		"parent": "513200"
	},
	{
		"name": "松潘县",
		"value": "513224",
		"parent": "513200"
	},
	{
		"name": "九寨沟县",
		"value": "513225",
		"parent": "513200"
	},
	{
		"name": "金川县",
		"value": "513226",
		"parent": "513200"
	},
	{
		"name": "小金县",
		"value": "513227",
		"parent": "513200"
	},
	{
		"name": "黑水县",
		"value": "513228",
		"parent": "513200"
	},
	{
		"name": "马尔康县",
		"value": "513229",
		"parent": "513200"
	},
	{
		"name": "壤塘县",
		"value": "513230",
		"parent": "513200"
	},
	{
		"name": "阿坝县",
		"value": "513231",
		"parent": "513200"
	},
	{
		"name": "若尔盖县",
		"value": "513232",
		"parent": "513200"
	},
	{
		"name": "红原县",
		"value": "513233",
		"parent": "513200"
	},
	{
		"name": "康定市",
		"value": "513301",
		"parent": "513300"
	},
	{
		"name": "泸定县",
		"value": "513322",
		"parent": "513300"
	},
	{
		"name": "丹巴县",
		"value": "513323",
		"parent": "513300"
	},
	{
		"name": "九龙县",
		"value": "513324",
		"parent": "513300"
	},
	{
		"name": "雅江县",
		"value": "513325",
		"parent": "513300"
	},
	{
		"name": "道孚县",
		"value": "513326",
		"parent": "513300"
	},
	{
		"name": "炉霍县",
		"value": "513327",
		"parent": "513300"
	},
	{
		"name": "甘孜县",
		"value": "513328",
		"parent": "513300"
	},
	{
		"name": "新龙县",
		"value": "513329",
		"parent": "513300"
	},
	{
		"name": "德格县",
		"value": "513330",
		"parent": "513300"
	},
	{
		"name": "白玉县",
		"value": "513331",
		"parent": "513300"
	},
	{
		"name": "石渠县",
		"value": "513332",
		"parent": "513300"
	},
	{
		"name": "色达县",
		"value": "513333",
		"parent": "513300"
	},
	{
		"name": "理塘县",
		"value": "513334",
		"parent": "513300"
	},
	{
		"name": "巴塘县",
		"value": "513335",
		"parent": "513300"
	},
	{
		"name": "乡城县",
		"value": "513336",
		"parent": "513300"
	},
	{
		"name": "稻城县",
		"value": "513337",
		"parent": "513300"
	},
	{
		"name": "得荣县",
		"value": "513338",
		"parent": "513300"
	},
	{
		"name": "西昌市",
		"value": "513401",
		"parent": "513400"
	},
	{
		"name": "木里藏族自治县",
		"value": "513422",
		"parent": "513400"
	},
	{
		"name": "盐源县",
		"value": "513423",
		"parent": "513400"
	},
	{
		"name": "德昌县",
		"value": "513424",
		"parent": "513400"
	},
	{
		"name": "会理县",
		"value": "513425",
		"parent": "513400"
	},
	{
		"name": "会东县",
		"value": "513426",
		"parent": "513400"
	},
	{
		"name": "宁南县",
		"value": "513427",
		"parent": "513400"
	},
	{
		"name": "普格县",
		"value": "513428",
		"parent": "513400"
	},
	{
		"name": "布拖县",
		"value": "513429",
		"parent": "513400"
	},
	{
		"name": "金阳县",
		"value": "513430",
		"parent": "513400"
	},
	{
		"name": "昭觉县",
		"value": "513431",
		"parent": "513400"
	},
	{
		"name": "喜德县",
		"value": "513432",
		"parent": "513400"
	},
	{
		"name": "冕宁县",
		"value": "513433",
		"parent": "513400"
	},
	{
		"name": "越西县",
		"value": "513434",
		"parent": "513400"
	},
	{
		"name": "甘洛县",
		"value": "513435",
		"parent": "513400"
	},
	{
		"name": "美姑县",
		"value": "513436",
		"parent": "513400"
	},
	{
		"name": "雷波县",
		"value": "513437",
		"parent": "513400"
	},
	{
		"name": "贵阳市",
		"value": "520100",
		"parent": "520000"
	},
	{
		"name": "六盘水市",
		"value": "520200",
		"parent": "520000"
	},
	{
		"name": "遵义市",
		"value": "520300",
		"parent": "520000"
	},
	{
		"name": "安顺市",
		"value": "520400",
		"parent": "520000"
	},
	{
		"name": "毕节市",
		"value": "520500",
		"parent": "520000"
	},
	{
		"name": "铜仁市",
		"value": "520600",
		"parent": "520000"
	},
	{
		"name": "黔西南布依族苗族自治州",
		"value": "522300",
		"parent": "520000"
	},
	{
		"name": "黔东南苗族侗族自治州",
		"value": "522600",
		"parent": "520000"
	},
	{
		"name": "黔南布依族苗族自治州",
		"value": "522700",
		"parent": "520000"
	},
	{
		"name": "南明区",
		"value": "520102",
		"parent": "520100"
	},
	{
		"name": "云岩区",
		"value": "520103",
		"parent": "520100"
	},
	{
		"name": "花溪区",
		"value": "520111",
		"parent": "520100"
	},
	{
		"name": "乌当区",
		"value": "520112",
		"parent": "520100"
	},
	{
		"name": "白云区",
		"value": "520113",
		"parent": "520100"
	},
	{
		"name": "观山湖区",
		"value": "520115",
		"parent": "520100"
	},
	{
		"name": "开阳县",
		"value": "520121",
		"parent": "520100"
	},
	{
		"name": "息烽县",
		"value": "520122",
		"parent": "520100"
	},
	{
		"name": "修文县",
		"value": "520123",
		"parent": "520100"
	},
	{
		"name": "清镇市",
		"value": "520181",
		"parent": "520100"
	},
	{
		"name": "钟山区",
		"value": "520201",
		"parent": "520200"
	},
	{
		"name": "六枝特区",
		"value": "520203",
		"parent": "520200"
	},
	{
		"name": "水城县",
		"value": "520221",
		"parent": "520200"
	},
	{
		"name": "盘县",
		"value": "520222",
		"parent": "520200"
	},
	{
		"name": "红花岗区",
		"value": "520302",
		"parent": "520300"
	},
	{
		"name": "汇川区",
		"value": "520303",
		"parent": "520300"
	},
	{
		"name": "遵义县",
		"value": "520321",
		"parent": "520300"
	},
	{
		"name": "桐梓县",
		"value": "520322",
		"parent": "520300"
	},
	{
		"name": "绥阳县",
		"value": "520323",
		"parent": "520300"
	},
	{
		"name": "正安县",
		"value": "520324",
		"parent": "520300"
	},
	{
		"name": "道真仡佬族苗族自治县",
		"value": "520325",
		"parent": "520300"
	},
	{
		"name": "务川仡佬族苗族自治县",
		"value": "520326",
		"parent": "520300"
	},
	{
		"name": "凤冈县",
		"value": "520327",
		"parent": "520300"
	},
	{
		"name": "湄潭县",
		"value": "520328",
		"parent": "520300"
	},
	{
		"name": "余庆县",
		"value": "520329",
		"parent": "520300"
	},
	{
		"name": "习水县",
		"value": "520330",
		"parent": "520300"
	},
	{
		"name": "赤水市",
		"value": "520381",
		"parent": "520300"
	},
	{
		"name": "仁怀市",
		"value": "520382",
		"parent": "520300"
	},
	{
		"name": "西秀区",
		"value": "520402",
		"parent": "520400"
	},
	{
		"name": "平坝区",
		"value": "520403",
		"parent": "520400"
	},
	{
		"name": "普定县",
		"value": "520422",
		"parent": "520400"
	},
	{
		"name": "镇宁布依族苗族自治县",
		"value": "520423",
		"parent": "520400"
	},
	{
		"name": "关岭布依族苗族自治县",
		"value": "520424",
		"parent": "520400"
	},
	{
		"name": "紫云苗族布依族自治县",
		"value": "520425",
		"parent": "520400"
	},
	{
		"name": "七星关区",
		"value": "520502",
		"parent": "520500"
	},
	{
		"name": "大方县",
		"value": "520521",
		"parent": "520500"
	},
	{
		"name": "黔西县",
		"value": "520522",
		"parent": "520500"
	},
	{
		"name": "金沙县",
		"value": "520523",
		"parent": "520500"
	},
	{
		"name": "织金县",
		"value": "520524",
		"parent": "520500"
	},
	{
		"name": "纳雍县",
		"value": "520525",
		"parent": "520500"
	},
	{
		"name": "威宁彝族回族苗族自治县",
		"value": "520526",
		"parent": "520500"
	},
	{
		"name": "赫章县",
		"value": "520527",
		"parent": "520500"
	},
	{
		"name": "碧江区",
		"value": "520602",
		"parent": "520600"
	},
	{
		"name": "万山区",
		"value": "520603",
		"parent": "520600"
	},
	{
		"name": "江口县",
		"value": "520621",
		"parent": "520600"
	},
	{
		"name": "玉屏侗族自治县",
		"value": "520622",
		"parent": "520600"
	},
	{
		"name": "石阡县",
		"value": "520623",
		"parent": "520600"
	},
	{
		"name": "思南县",
		"value": "520624",
		"parent": "520600"
	},
	{
		"name": "印江土家族苗族自治县",
		"value": "520625",
		"parent": "520600"
	},
	{
		"name": "德江县",
		"value": "520626",
		"parent": "520600"
	},
	{
		"name": "沿河土家族自治县",
		"value": "520627",
		"parent": "520600"
	},
	{
		"name": "松桃苗族自治县",
		"value": "520628",
		"parent": "520600"
	},
	{
		"name": "兴义市",
		"value": "522301",
		"parent": "522300"
	},
	{
		"name": "兴仁县",
		"value": "522322",
		"parent": "522300"
	},
	{
		"name": "普安县",
		"value": "522323",
		"parent": "522300"
	},
	{
		"name": "晴隆县",
		"value": "522324",
		"parent": "522300"
	},
	{
		"name": "贞丰县",
		"value": "522325",
		"parent": "522300"
	},
	{
		"name": "望谟县",
		"value": "522326",
		"parent": "522300"
	},
	{
		"name": "册亨县",
		"value": "522327",
		"parent": "522300"
	},
	{
		"name": "安龙县",
		"value": "522328",
		"parent": "522300"
	},
	{
		"name": "凯里市",
		"value": "522601",
		"parent": "522600"
	},
	{
		"name": "黄平县",
		"value": "522622",
		"parent": "522600"
	},
	{
		"name": "施秉县",
		"value": "522623",
		"parent": "522600"
	},
	{
		"name": "三穗县",
		"value": "522624",
		"parent": "522600"
	},
	{
		"name": "镇远县",
		"value": "522625",
		"parent": "522600"
	},
	{
		"name": "岑巩县",
		"value": "522626",
		"parent": "522600"
	},
	{
		"name": "天柱县",
		"value": "522627",
		"parent": "522600"
	},
	{
		"name": "锦屏县",
		"value": "522628",
		"parent": "522600"
	},
	{
		"name": "剑河县",
		"value": "522629",
		"parent": "522600"
	},
	{
		"name": "台江县",
		"value": "522630",
		"parent": "522600"
	},
	{
		"name": "黎平县",
		"value": "522631",
		"parent": "522600"
	},
	{
		"name": "榕江县",
		"value": "522632",
		"parent": "522600"
	},
	{
		"name": "从江县",
		"value": "522633",
		"parent": "522600"
	},
	{
		"name": "雷山县",
		"value": "522634",
		"parent": "522600"
	},
	{
		"name": "麻江县",
		"value": "522635",
		"parent": "522600"
	},
	{
		"name": "丹寨县",
		"value": "522636",
		"parent": "522600"
	},
	{
		"name": "都匀市",
		"value": "522701",
		"parent": "522700"
	},
	{
		"name": "福泉市",
		"value": "522702",
		"parent": "522700"
	},
	{
		"name": "荔波县",
		"value": "522722",
		"parent": "522700"
	},
	{
		"name": "贵定县",
		"value": "522723",
		"parent": "522700"
	},
	{
		"name": "瓮安县",
		"value": "522725",
		"parent": "522700"
	},
	{
		"name": "独山县",
		"value": "522726",
		"parent": "522700"
	},
	{
		"name": "平塘县",
		"value": "522727",
		"parent": "522700"
	},
	{
		"name": "罗甸县",
		"value": "522728",
		"parent": "522700"
	},
	{
		"name": "长顺县",
		"value": "522729",
		"parent": "522700"
	},
	{
		"name": "龙里县",
		"value": "522730",
		"parent": "522700"
	},
	{
		"name": "惠水县",
		"value": "522731",
		"parent": "522700"
	},
	{
		"name": "三都水族自治县",
		"value": "522732",
		"parent": "522700"
	},
	{
		"name": "昆明市",
		"value": "530100",
		"parent": "530000"
	},
	{
		"name": "曲靖市",
		"value": "530300",
		"parent": "530000"
	},
	{
		"name": "玉溪市",
		"value": "530400",
		"parent": "530000"
	},
	{
		"name": "保山市",
		"value": "530500",
		"parent": "530000"
	},
	{
		"name": "昭通市",
		"value": "530600",
		"parent": "530000"
	},
	{
		"name": "丽江市",
		"value": "530700",
		"parent": "530000"
	},
	{
		"name": "普洱市",
		"value": "530800",
		"parent": "530000"
	},
	{
		"name": "临沧市",
		"value": "530900",
		"parent": "530000"
	},
	{
		"name": "楚雄彝族自治州",
		"value": "532300",
		"parent": "530000"
	},
	{
		"name": "红河哈尼族彝族自治州",
		"value": "532500",
		"parent": "530000"
	},
	{
		"name": "文山壮族苗族自治州",
		"value": "532600",
		"parent": "530000"
	},
	{
		"name": "西双版纳傣族自治州",
		"value": "532800",
		"parent": "530000"
	},
	{
		"name": "大理白族自治州",
		"value": "532900",
		"parent": "530000"
	},
	{
		"name": "德宏傣族景颇族自治州",
		"value": "533100",
		"parent": "530000"
	},
	{
		"name": "怒江傈僳族自治州",
		"value": "533300",
		"parent": "530000"
	},
	{
		"name": "迪庆藏族自治州",
		"value": "533400",
		"parent": "530000"
	},
	{
		"name": "五华区",
		"value": "530102",
		"parent": "530100"
	},
	{
		"name": "盘龙区",
		"value": "530103",
		"parent": "530100"
	},
	{
		"name": "官渡区",
		"value": "530111",
		"parent": "530100"
	},
	{
		"name": "西山区",
		"value": "530112",
		"parent": "530100"
	},
	{
		"name": "东川区",
		"value": "530113",
		"parent": "530100"
	},
	{
		"name": "呈贡区",
		"value": "530114",
		"parent": "530100"
	},
	{
		"name": "晋宁县",
		"value": "530122",
		"parent": "530100"
	},
	{
		"name": "富民县",
		"value": "530124",
		"parent": "530100"
	},
	{
		"name": "宜良县",
		"value": "530125",
		"parent": "530100"
	},
	{
		"name": "石林彝族自治县",
		"value": "530126",
		"parent": "530100"
	},
	{
		"name": "嵩明县",
		"value": "530127",
		"parent": "530100"
	},
	{
		"name": "禄劝彝族苗族自治县",
		"value": "530128",
		"parent": "530100"
	},
	{
		"name": "寻甸回族彝族自治县",
		"value": "530129",
		"parent": "530100"
	},
	{
		"name": "安宁市",
		"value": "530181",
		"parent": "530100"
	},
	{
		"name": "麒麟区",
		"value": "530302",
		"parent": "530300"
	},
	{
		"name": "马龙县",
		"value": "530321",
		"parent": "530300"
	},
	{
		"name": "陆良县",
		"value": "530322",
		"parent": "530300"
	},
	{
		"name": "师宗县",
		"value": "530323",
		"parent": "530300"
	},
	{
		"name": "罗平县",
		"value": "530324",
		"parent": "530300"
	},
	{
		"name": "富源县",
		"value": "530325",
		"parent": "530300"
	},
	{
		"name": "会泽县",
		"value": "530326",
		"parent": "530300"
	},
	{
		"name": "沾益县",
		"value": "530328",
		"parent": "530300"
	},
	{
		"name": "宣威市",
		"value": "530381",
		"parent": "530300"
	},
	{
		"name": "红塔区",
		"value": "530402",
		"parent": "530400"
	},
	{
		"name": "江川县",
		"value": "530421",
		"parent": "530400"
	},
	{
		"name": "澄江县",
		"value": "530422",
		"parent": "530400"
	},
	{
		"name": "通海县",
		"value": "530423",
		"parent": "530400"
	},
	{
		"name": "华宁县",
		"value": "530424",
		"parent": "530400"
	},
	{
		"name": "易门县",
		"value": "530425",
		"parent": "530400"
	},
	{
		"name": "峨山彝族自治县",
		"value": "530426",
		"parent": "530400"
	},
	{
		"name": "新平彝族傣族自治县",
		"value": "530427",
		"parent": "530400"
	},
	{
		"name": "元江哈尼族彝族傣族自治县",
		"value": "530428",
		"parent": "530400"
	},
	{
		"name": "隆阳区",
		"value": "530502",
		"parent": "530500"
	},
	{
		"name": "施甸县",
		"value": "530521",
		"parent": "530500"
	},
	{
		"name": "龙陵县",
		"value": "530523",
		"parent": "530500"
	},
	{
		"name": "昌宁县",
		"value": "530524",
		"parent": "530500"
	},
	{
		"name": "腾冲市",
		"value": "530581",
		"parent": "530500"
	},
	{
		"name": "昭阳区",
		"value": "530602",
		"parent": "530600"
	},
	{
		"name": "鲁甸县",
		"value": "530621",
		"parent": "530600"
	},
	{
		"name": "巧家县",
		"value": "530622",
		"parent": "530600"
	},
	{
		"name": "盐津县",
		"value": "530623",
		"parent": "530600"
	},
	{
		"name": "大关县",
		"value": "530624",
		"parent": "530600"
	},
	{
		"name": "永善县",
		"value": "530625",
		"parent": "530600"
	},
	{
		"name": "绥江县",
		"value": "530626",
		"parent": "530600"
	},
	{
		"name": "镇雄县",
		"value": "530627",
		"parent": "530600"
	},
	{
		"name": "彝良县",
		"value": "530628",
		"parent": "530600"
	},
	{
		"name": "威信县",
		"value": "530629",
		"parent": "530600"
	},
	{
		"name": "水富县",
		"value": "530630",
		"parent": "530600"
	},
	{
		"name": "古城区",
		"value": "530702",
		"parent": "530700"
	},
	{
		"name": "玉龙纳西族自治县",
		"value": "530721",
		"parent": "530700"
	},
	{
		"name": "永胜县",
		"value": "530722",
		"parent": "530700"
	},
	{
		"name": "华坪县",
		"value": "530723",
		"parent": "530700"
	},
	{
		"name": "宁蒗彝族自治县",
		"value": "530724",
		"parent": "530700"
	},
	{
		"name": "思茅区",
		"value": "530802",
		"parent": "530800"
	},
	{
		"name": "宁洱哈尼族彝族自治县",
		"value": "530821",
		"parent": "530800"
	},
	{
		"name": "墨江哈尼族自治县",
		"value": "530822",
		"parent": "530800"
	},
	{
		"name": "景东彝族自治县",
		"value": "530823",
		"parent": "530800"
	},
	{
		"name": "景谷傣族彝族自治县",
		"value": "530824",
		"parent": "530800"
	},
	{
		"name": "镇沅彝族哈尼族拉祜族自治县",
		"value": "530825",
		"parent": "530800"
	},
	{
		"name": "江城哈尼族彝族自治县",
		"value": "530826",
		"parent": "530800"
	},
	{
		"name": "孟连傣族拉祜族佤族自治县",
		"value": "530827",
		"parent": "530800"
	},
	{
		"name": "澜沧拉祜族自治县",
		"value": "530828",
		"parent": "530800"
	},
	{
		"name": "西盟佤族自治县",
		"value": "530829",
		"parent": "530800"
	},
	{
		"name": "临翔区",
		"value": "530902",
		"parent": "530900"
	},
	{
		"name": "凤庆县",
		"value": "530921",
		"parent": "530900"
	},
	{
		"name": "云县",
		"value": "530922",
		"parent": "530900"
	},
	{
		"name": "永德县",
		"value": "530923",
		"parent": "530900"
	},
	{
		"name": "镇康县",
		"value": "530924",
		"parent": "530900"
	},
	{
		"name": "双江拉祜族佤族布朗族傣族自治县",
		"value": "530925",
		"parent": "530900"
	},
	{
		"name": "耿马傣族佤族自治县",
		"value": "530926",
		"parent": "530900"
	},
	{
		"name": "沧源佤族自治县",
		"value": "530927",
		"parent": "530900"
	},
	{
		"name": "楚雄市",
		"value": "532301",
		"parent": "532300"
	},
	{
		"name": "双柏县",
		"value": "532322",
		"parent": "532300"
	},
	{
		"name": "牟定县",
		"value": "532323",
		"parent": "532300"
	},
	{
		"name": "南华县",
		"value": "532324",
		"parent": "532300"
	},
	{
		"name": "姚安县",
		"value": "532325",
		"parent": "532300"
	},
	{
		"name": "大姚县",
		"value": "532326",
		"parent": "532300"
	},
	{
		"name": "永仁县",
		"value": "532327",
		"parent": "532300"
	},
	{
		"name": "元谋县",
		"value": "532328",
		"parent": "532300"
	},
	{
		"name": "武定县",
		"value": "532329",
		"parent": "532300"
	},
	{
		"name": "禄丰县",
		"value": "532331",
		"parent": "532300"
	},
	{
		"name": "个旧市",
		"value": "532501",
		"parent": "532500"
	},
	{
		"name": "开远市",
		"value": "532502",
		"parent": "532500"
	},
	{
		"name": "蒙自市",
		"value": "532503",
		"parent": "532500"
	},
	{
		"name": "弥勒市",
		"value": "532504",
		"parent": "532500"
	},
	{
		"name": "屏边苗族自治县",
		"value": "532523",
		"parent": "532500"
	},
	{
		"name": "建水县",
		"value": "532524",
		"parent": "532500"
	},
	{
		"name": "石屏县",
		"value": "532525",
		"parent": "532500"
	},
	{
		"name": "泸西县",
		"value": "532527",
		"parent": "532500"
	},
	{
		"name": "元阳县",
		"value": "532528",
		"parent": "532500"
	},
	{
		"name": "红河县",
		"value": "532529",
		"parent": "532500"
	},
	{
		"name": "金平苗族瑶族傣族自治县",
		"value": "532530",
		"parent": "532500"
	},
	{
		"name": "绿春县",
		"value": "532531",
		"parent": "532500"
	},
	{
		"name": "河口瑶族自治县",
		"value": "532532",
		"parent": "532500"
	},
	{
		"name": "文山市",
		"value": "532601",
		"parent": "532600"
	},
	{
		"name": "砚山县",
		"value": "532622",
		"parent": "532600"
	},
	{
		"name": "西畴县",
		"value": "532623",
		"parent": "532600"
	},
	{
		"name": "麻栗坡县",
		"value": "532624",
		"parent": "532600"
	},
	{
		"name": "马关县",
		"value": "532625",
		"parent": "532600"
	},
	{
		"name": "丘北县",
		"value": "532626",
		"parent": "532600"
	},
	{
		"name": "广南县",
		"value": "532627",
		"parent": "532600"
	},
	{
		"name": "富宁县",
		"value": "532628",
		"parent": "532600"
	},
	{
		"name": "景洪市",
		"value": "532801",
		"parent": "532800"
	},
	{
		"name": "勐海县",
		"value": "532822",
		"parent": "532800"
	},
	{
		"name": "勐腊县",
		"value": "532823",
		"parent": "532800"
	},
	{
		"name": "大理市",
		"value": "532901",
		"parent": "532900"
	},
	{
		"name": "漾濞彝族自治县",
		"value": "532922",
		"parent": "532900"
	},
	{
		"name": "祥云县",
		"value": "532923",
		"parent": "532900"
	},
	{
		"name": "宾川县",
		"value": "532924",
		"parent": "532900"
	},
	{
		"name": "弥渡县",
		"value": "532925",
		"parent": "532900"
	},
	{
		"name": "南涧彝族自治县",
		"value": "532926",
		"parent": "532900"
	},
	{
		"name": "巍山彝族回族自治县",
		"value": "532927",
		"parent": "532900"
	},
	{
		"name": "永平县",
		"value": "532928",
		"parent": "532900"
	},
	{
		"name": "云龙县",
		"value": "532929",
		"parent": "532900"
	},
	{
		"name": "洱源县",
		"value": "532930",
		"parent": "532900"
	},
	{
		"name": "剑川县",
		"value": "532931",
		"parent": "532900"
	},
	{
		"name": "鹤庆县",
		"value": "532932",
		"parent": "532900"
	},
	{
		"name": "瑞丽市",
		"value": "533102",
		"parent": "533100"
	},
	{
		"name": "芒市",
		"value": "533103",
		"parent": "533100"
	},
	{
		"name": "梁河县",
		"value": "533122",
		"parent": "533100"
	},
	{
		"name": "盈江县",
		"value": "533123",
		"parent": "533100"
	},
	{
		"name": "陇川县",
		"value": "533124",
		"parent": "533100"
	},
	{
		"name": "泸水县",
		"value": "533321",
		"parent": "533300"
	},
	{
		"name": "福贡县",
		"value": "533323",
		"parent": "533300"
	},
	{
		"name": "贡山独龙族怒族自治县",
		"value": "533324",
		"parent": "533300"
	},
	{
		"name": "兰坪白族普米族自治县",
		"value": "533325",
		"parent": "533300"
	},
	{
		"name": "香格里拉市",
		"value": "533401",
		"parent": "533400"
	},
	{
		"name": "德钦县",
		"value": "533422",
		"parent": "533400"
	},
	{
		"name": "维西傈僳族自治县",
		"value": "533423",
		"parent": "533400"
	},
	{
		"name": "拉萨市",
		"value": "540100",
		"parent": "540000"
	},
	{
		"name": "日喀则市",
		"value": "540200",
		"parent": "540000"
	},
	{
		"name": "昌都市",
		"value": "540300",
		"parent": "540000"
	},
	{
		"name": "林芝市",
		"value": "540400",
		"parent": "540000"
	},
	{
		"name": "山南地区",
		"value": "542200",
		"parent": "540000"
	},
	{
		"name": "那曲地区",
		"value": "542400",
		"parent": "540000"
	},
	{
		"name": "阿里地区",
		"value": "542500",
		"parent": "540000"
	},
	{
		"name": "城关区",
		"value": "540102",
		"parent": "540100"
	},
	{
		"name": "林周县",
		"value": "540121",
		"parent": "540100"
	},
	{
		"name": "当雄县",
		"value": "540122",
		"parent": "540100"
	},
	{
		"name": "尼木县",
		"value": "540123",
		"parent": "540100"
	},
	{
		"name": "曲水县",
		"value": "540124",
		"parent": "540100"
	},
	{
		"name": "堆龙德庆县",
		"value": "540125",
		"parent": "540100"
	},
	{
		"name": "达孜县",
		"value": "540126",
		"parent": "540100"
	},
	{
		"name": "墨竹工卡县",
		"value": "540127",
		"parent": "540100"
	},
	{
		"name": "桑珠孜区",
		"value": "540202",
		"parent": "540200"
	},
	{
		"name": "南木林县",
		"value": "540221",
		"parent": "540200"
	},
	{
		"name": "江孜县",
		"value": "540222",
		"parent": "540200"
	},
	{
		"name": "定日县",
		"value": "540223",
		"parent": "540200"
	},
	{
		"name": "萨迦县",
		"value": "540224",
		"parent": "540200"
	},
	{
		"name": "拉孜县",
		"value": "540225",
		"parent": "540200"
	},
	{
		"name": "昂仁县",
		"value": "540226",
		"parent": "540200"
	},
	{
		"name": "谢通门县",
		"value": "540227",
		"parent": "540200"
	},
	{
		"name": "白朗县",
		"value": "540228",
		"parent": "540200"
	},
	{
		"name": "仁布县",
		"value": "540229",
		"parent": "540200"
	},
	{
		"name": "康马县",
		"value": "540230",
		"parent": "540200"
	},
	{
		"name": "定结县",
		"value": "540231",
		"parent": "540200"
	},
	{
		"name": "仲巴县",
		"value": "540232",
		"parent": "540200"
	},
	{
		"name": "亚东县",
		"value": "540233",
		"parent": "540200"
	},
	{
		"name": "吉隆县",
		"value": "540234",
		"parent": "540200"
	},
	{
		"name": "聂拉木县",
		"value": "540235",
		"parent": "540200"
	},
	{
		"name": "萨嘎县",
		"value": "540236",
		"parent": "540200"
	},
	{
		"name": "岗巴县",
		"value": "540237",
		"parent": "540200"
	},
	{
		"name": "卡若区",
		"value": "540302",
		"parent": "540300"
	},
	{
		"name": "江达县",
		"value": "540321",
		"parent": "540300"
	},
	{
		"name": "贡觉县",
		"value": "540322",
		"parent": "540300"
	},
	{
		"name": "类乌齐县",
		"value": "540323",
		"parent": "540300"
	},
	{
		"name": "丁青县",
		"value": "540324",
		"parent": "540300"
	},
	{
		"name": "察雅县",
		"value": "540325",
		"parent": "540300"
	},
	{
		"name": "八宿县",
		"value": "540326",
		"parent": "540300"
	},
	{
		"name": "左贡县",
		"value": "540327",
		"parent": "540300"
	},
	{
		"name": "芒康县",
		"value": "540328",
		"parent": "540300"
	},
	{
		"name": "洛隆县",
		"value": "540329",
		"parent": "540300"
	},
	{
		"name": "边坝县",
		"value": "540330",
		"parent": "540300"
	},
	{
		"name": "巴宜区",
		"value": "540402",
		"parent": "540400"
	},
	{
		"name": "工布江达县",
		"value": "540421",
		"parent": "540400"
	},
	{
		"name": "米林县",
		"value": "540422",
		"parent": "540400"
	},
	{
		"name": "墨脱县",
		"value": "540423",
		"parent": "540400"
	},
	{
		"name": "波密县",
		"value": "540424",
		"parent": "540400"
	},
	{
		"name": "察隅县",
		"value": "540425",
		"parent": "540400"
	},
	{
		"name": "朗县",
		"value": "540426",
		"parent": "540400"
	},
	{
		"name": "乃东县",
		"value": "542221",
		"parent": "542200"
	},
	{
		"name": "扎囊县",
		"value": "542222",
		"parent": "542200"
	},
	{
		"name": "贡嘎县",
		"value": "542223",
		"parent": "542200"
	},
	{
		"name": "桑日县",
		"value": "542224",
		"parent": "542200"
	},
	{
		"name": "琼结县",
		"value": "542225",
		"parent": "542200"
	},
	{
		"name": "曲松县",
		"value": "542226",
		"parent": "542200"
	},
	{
		"name": "措美县",
		"value": "542227",
		"parent": "542200"
	},
	{
		"name": "洛扎县",
		"value": "542228",
		"parent": "542200"
	},
	{
		"name": "加查县",
		"value": "542229",
		"parent": "542200"
	},
	{
		"name": "隆子县",
		"value": "542231",
		"parent": "542200"
	},
	{
		"name": "错那县",
		"value": "542232",
		"parent": "542200"
	},
	{
		"name": "浪卡子县",
		"value": "542233",
		"parent": "542200"
	},
	{
		"name": "那曲县",
		"value": "542421",
		"parent": "542400"
	},
	{
		"name": "嘉黎县",
		"value": "542422",
		"parent": "542400"
	},
	{
		"name": "比如县",
		"value": "542423",
		"parent": "542400"
	},
	{
		"name": "聂荣县",
		"value": "542424",
		"parent": "542400"
	},
	{
		"name": "安多县",
		"value": "542425",
		"parent": "542400"
	},
	{
		"name": "申扎县",
		"value": "542426",
		"parent": "542400"
	},
	{
		"name": "索县",
		"value": "542427",
		"parent": "542400"
	},
	{
		"name": "班戈县",
		"value": "542428",
		"parent": "542400"
	},
	{
		"name": "巴青县",
		"value": "542429",
		"parent": "542400"
	},
	{
		"name": "尼玛县",
		"value": "542430",
		"parent": "542400"
	},
	{
		"name": "双湖县",
		"value": "542431",
		"parent": "542400"
	},
	{
		"name": "普兰县",
		"value": "542521",
		"parent": "542500"
	},
	{
		"name": "札达县",
		"value": "542522",
		"parent": "542500"
	},
	{
		"name": "噶尔县",
		"value": "542523",
		"parent": "542500"
	},
	{
		"name": "日土县",
		"value": "542524",
		"parent": "542500"
	},
	{
		"name": "革吉县",
		"value": "542525",
		"parent": "542500"
	},
	{
		"name": "改则县",
		"value": "542526",
		"parent": "542500"
	},
	{
		"name": "措勤县",
		"value": "542527",
		"parent": "542500"
	},
	{
		"name": "西安市",
		"value": "610100",
		"parent": "610000"
	},
	{
		"name": "铜川市",
		"value": "610200",
		"parent": "610000"
	},
	{
		"name": "宝鸡市",
		"value": "610300",
		"parent": "610000"
	},
	{
		"name": "咸阳市",
		"value": "610400",
		"parent": "610000"
	},
	{
		"name": "渭南市",
		"value": "610500",
		"parent": "610000"
	},
	{
		"name": "延安市",
		"value": "610600",
		"parent": "610000"
	},
	{
		"name": "汉中市",
		"value": "610700",
		"parent": "610000"
	},
	{
		"name": "榆林市",
		"value": "610800",
		"parent": "610000"
	},
	{
		"name": "安康市",
		"value": "610900",
		"parent": "610000"
	},
	{
		"name": "商洛市",
		"value": "611000",
		"parent": "610000"
	},
	{
		"name": "新城区",
		"value": "610102",
		"parent": "610100"
	},
	{
		"name": "碑林区",
		"value": "610103",
		"parent": "610100"
	},
	{
		"name": "莲湖区",
		"value": "610104",
		"parent": "610100"
	},
	{
		"name": "灞桥区",
		"value": "610111",
		"parent": "610100"
	},
	{
		"name": "未央区",
		"value": "610112",
		"parent": "610100"
	},
	{
		"name": "雁塔区",
		"value": "610113",
		"parent": "610100"
	},
	{
		"name": "阎良区",
		"value": "610114",
		"parent": "610100"
	},
	{
		"name": "临潼区",
		"value": "610115",
		"parent": "610100"
	},
	{
		"name": "长安区",
		"value": "610116",
		"parent": "610100"
	},
	{
		"name": "高陵区",
		"value": "610117",
		"parent": "610100"
	},
	{
		"name": "蓝田县",
		"value": "610122",
		"parent": "610100"
	},
	{
		"name": "周至县",
		"value": "610124",
		"parent": "610100"
	},
	{
		"name": "户县",
		"value": "610125",
		"parent": "610100"
	},
	{
		"name": "王益区",
		"value": "610202",
		"parent": "610200"
	},
	{
		"name": "印台区",
		"value": "610203",
		"parent": "610200"
	},
	{
		"name": "耀州区",
		"value": "610204",
		"parent": "610200"
	},
	{
		"name": "宜君县",
		"value": "610222",
		"parent": "610200"
	},
	{
		"name": "渭滨区",
		"value": "610302",
		"parent": "610300"
	},
	{
		"name": "金台区",
		"value": "610303",
		"parent": "610300"
	},
	{
		"name": "陈仓区",
		"value": "610304",
		"parent": "610300"
	},
	{
		"name": "凤翔县",
		"value": "610322",
		"parent": "610300"
	},
	{
		"name": "岐山县",
		"value": "610323",
		"parent": "610300"
	},
	{
		"name": "扶风县",
		"value": "610324",
		"parent": "610300"
	},
	{
		"name": "眉县",
		"value": "610326",
		"parent": "610300"
	},
	{
		"name": "陇县",
		"value": "610327",
		"parent": "610300"
	},
	{
		"name": "千阳县",
		"value": "610328",
		"parent": "610300"
	},
	{
		"name": "麟游县",
		"value": "610329",
		"parent": "610300"
	},
	{
		"name": "凤县",
		"value": "610330",
		"parent": "610300"
	},
	{
		"name": "太白县",
		"value": "610331",
		"parent": "610300"
	},
	{
		"name": "秦都区",
		"value": "610402",
		"parent": "610400"
	},
	{
		"name": "杨陵区",
		"value": "610403",
		"parent": "610400"
	},
	{
		"name": "渭城区",
		"value": "610404",
		"parent": "610400"
	},
	{
		"name": "三原县",
		"value": "610422",
		"parent": "610400"
	},
	{
		"name": "泾阳县",
		"value": "610423",
		"parent": "610400"
	},
	{
		"name": "乾县",
		"value": "610424",
		"parent": "610400"
	},
	{
		"name": "礼泉县",
		"value": "610425",
		"parent": "610400"
	},
	{
		"name": "永寿县",
		"value": "610426",
		"parent": "610400"
	},
	{
		"name": "彬县",
		"value": "610427",
		"parent": "610400"
	},
	{
		"name": "长武县",
		"value": "610428",
		"parent": "610400"
	},
	{
		"name": "旬邑县",
		"value": "610429",
		"parent": "610400"
	},
	{
		"name": "淳化县",
		"value": "610430",
		"parent": "610400"
	},
	{
		"name": "武功县",
		"value": "610431",
		"parent": "610400"
	},
	{
		"name": "兴平市",
		"value": "610481",
		"parent": "610400"
	},
	{
		"name": "临渭区",
		"value": "610502",
		"parent": "610500"
	},
	{
		"name": "华县",
		"value": "610521",
		"parent": "610500"
	},
	{
		"name": "潼关县",
		"value": "610522",
		"parent": "610500"
	},
	{
		"name": "大荔县",
		"value": "610523",
		"parent": "610500"
	},
	{
		"name": "合阳县",
		"value": "610524",
		"parent": "610500"
	},
	{
		"name": "澄城县",
		"value": "610525",
		"parent": "610500"
	},
	{
		"name": "蒲城县",
		"value": "610526",
		"parent": "610500"
	},
	{
		"name": "白水县",
		"value": "610527",
		"parent": "610500"
	},
	{
		"name": "富平县",
		"value": "610528",
		"parent": "610500"
	},
	{
		"name": "韩城市",
		"value": "610581",
		"parent": "610500"
	},
	{
		"name": "华阴市",
		"value": "610582",
		"parent": "610500"
	},
	{
		"name": "宝塔区",
		"value": "610602",
		"parent": "610600"
	},
	{
		"name": "延长县",
		"value": "610621",
		"parent": "610600"
	},
	{
		"name": "延川县",
		"value": "610622",
		"parent": "610600"
	},
	{
		"name": "子长县",
		"value": "610623",
		"parent": "610600"
	},
	{
		"name": "安塞县",
		"value": "610624",
		"parent": "610600"
	},
	{
		"name": "志丹县",
		"value": "610625",
		"parent": "610600"
	},
	{
		"name": "吴起县",
		"value": "610626",
		"parent": "610600"
	},
	{
		"name": "甘泉县",
		"value": "610627",
		"parent": "610600"
	},
	{
		"name": "富县",
		"value": "610628",
		"parent": "610600"
	},
	{
		"name": "洛川县",
		"value": "610629",
		"parent": "610600"
	},
	{
		"name": "宜川县",
		"value": "610630",
		"parent": "610600"
	},
	{
		"name": "黄龙县",
		"value": "610631",
		"parent": "610600"
	},
	{
		"name": "黄陵县",
		"value": "610632",
		"parent": "610600"
	},
	{
		"name": "汉台区",
		"value": "610702",
		"parent": "610700"
	},
	{
		"name": "南郑县",
		"value": "610721",
		"parent": "610700"
	},
	{
		"name": "城固县",
		"value": "610722",
		"parent": "610700"
	},
	{
		"name": "洋县",
		"value": "610723",
		"parent": "610700"
	},
	{
		"name": "西乡县",
		"value": "610724",
		"parent": "610700"
	},
	{
		"name": "勉县",
		"value": "610725",
		"parent": "610700"
	},
	{
		"name": "宁强县",
		"value": "610726",
		"parent": "610700"
	},
	{
		"name": "略阳县",
		"value": "610727",
		"parent": "610700"
	},
	{
		"name": "镇巴县",
		"value": "610728",
		"parent": "610700"
	},
	{
		"name": "留坝县",
		"value": "610729",
		"parent": "610700"
	},
	{
		"name": "佛坪县",
		"value": "610730",
		"parent": "610700"
	},
	{
		"name": "榆阳区",
		"value": "610802",
		"parent": "610800"
	},
	{
		"name": "神木县",
		"value": "610821",
		"parent": "610800"
	},
	{
		"name": "府谷县",
		"value": "610822",
		"parent": "610800"
	},
	{
		"name": "横山县",
		"value": "610823",
		"parent": "610800"
	},
	{
		"name": "靖边县",
		"value": "610824",
		"parent": "610800"
	},
	{
		"name": "定边县",
		"value": "610825",
		"parent": "610800"
	},
	{
		"name": "绥德县",
		"value": "610826",
		"parent": "610800"
	},
	{
		"name": "米脂县",
		"value": "610827",
		"parent": "610800"
	},
	{
		"name": "佳县",
		"value": "610828",
		"parent": "610800"
	},
	{
		"name": "吴堡县",
		"value": "610829",
		"parent": "610800"
	},
	{
		"name": "清涧县",
		"value": "610830",
		"parent": "610800"
	},
	{
		"name": "子洲县",
		"value": "610831",
		"parent": "610800"
	},
	{
		"name": "汉滨区",
		"value": "610902",
		"parent": "610900"
	},
	{
		"name": "汉阴县",
		"value": "610921",
		"parent": "610900"
	},
	{
		"name": "石泉县",
		"value": "610922",
		"parent": "610900"
	},
	{
		"name": "宁陕县",
		"value": "610923",
		"parent": "610900"
	},
	{
		"name": "紫阳县",
		"value": "610924",
		"parent": "610900"
	},
	{
		"name": "岚皋县",
		"value": "610925",
		"parent": "610900"
	},
	{
		"name": "平利县",
		"value": "610926",
		"parent": "610900"
	},
	{
		"name": "镇坪县",
		"value": "610927",
		"parent": "610900"
	},
	{
		"name": "旬阳县",
		"value": "610928",
		"parent": "610900"
	},
	{
		"name": "白河县",
		"value": "610929",
		"parent": "610900"
	},
	{
		"name": "商州区",
		"value": "611002",
		"parent": "611000"
	},
	{
		"name": "洛南县",
		"value": "611021",
		"parent": "611000"
	},
	{
		"name": "丹凤县",
		"value": "611022",
		"parent": "611000"
	},
	{
		"name": "商南县",
		"value": "611023",
		"parent": "611000"
	},
	{
		"name": "山阳县",
		"value": "611024",
		"parent": "611000"
	},
	{
		"name": "镇安县",
		"value": "611025",
		"parent": "611000"
	},
	{
		"name": "柞水县",
		"value": "611026",
		"parent": "611000"
	},
	{
		"name": "兰州市",
		"value": "620100",
		"parent": "620000"
	},
	{
		"name": "嘉峪关市",
		"value": "620200",
		"parent": "620000"
	},
	{
		"name": "金昌市",
		"value": "620300",
		"parent": "620000"
	},
	{
		"name": "白银市",
		"value": "620400",
		"parent": "620000"
	},
	{
		"name": "天水市",
		"value": "620500",
		"parent": "620000"
	},
	{
		"name": "武威市",
		"value": "620600",
		"parent": "620000"
	},
	{
		"name": "张掖市",
		"value": "620700",
		"parent": "620000"
	},
	{
		"name": "平凉市",
		"value": "620800",
		"parent": "620000"
	},
	{
		"name": "酒泉市",
		"value": "620900",
		"parent": "620000"
	},
	{
		"name": "庆阳市",
		"value": "621000",
		"parent": "620000"
	},
	{
		"name": "定西市",
		"value": "621100",
		"parent": "620000"
	},
	{
		"name": "陇南市",
		"value": "621200",
		"parent": "620000"
	},
	{
		"name": "临夏回族自治州",
		"value": "622900",
		"parent": "620000"
	},
	{
		"name": "甘南藏族自治州",
		"value": "623000",
		"parent": "620000"
	},
	{
		"name": "城关区",
		"value": "620102",
		"parent": "620100"
	},
	{
		"name": "七里河区",
		"value": "620103",
		"parent": "620100"
	},
	{
		"name": "西固区",
		"value": "620104",
		"parent": "620100"
	},
	{
		"name": "安宁区",
		"value": "620105",
		"parent": "620100"
	},
	{
		"name": "红古区",
		"value": "620111",
		"parent": "620100"
	},
	{
		"name": "永登县",
		"value": "620121",
		"parent": "620100"
	},
	{
		"name": "皋兰县",
		"value": "620122",
		"parent": "620100"
	},
	{
		"name": "榆中县",
		"value": "620123",
		"parent": "620100"
	},
	{
		"name": "金川区",
		"value": "620302",
		"parent": "620300"
	},
	{
		"name": "永昌县",
		"value": "620321",
		"parent": "620300"
	},
	{
		"name": "白银区",
		"value": "620402",
		"parent": "620400"
	},
	{
		"name": "平川区",
		"value": "620403",
		"parent": "620400"
	},
	{
		"name": "靖远县",
		"value": "620421",
		"parent": "620400"
	},
	{
		"name": "会宁县",
		"value": "620422",
		"parent": "620400"
	},
	{
		"name": "景泰县",
		"value": "620423",
		"parent": "620400"
	},
	{
		"name": "秦州区",
		"value": "620502",
		"parent": "620500"
	},
	{
		"name": "麦积区",
		"value": "620503",
		"parent": "620500"
	},
	{
		"name": "清水县",
		"value": "620521",
		"parent": "620500"
	},
	{
		"name": "秦安县",
		"value": "620522",
		"parent": "620500"
	},
	{
		"name": "甘谷县",
		"value": "620523",
		"parent": "620500"
	},
	{
		"name": "武山县",
		"value": "620524",
		"parent": "620500"
	},
	{
		"name": "张家川回族自治县",
		"value": "620525",
		"parent": "620500"
	},
	{
		"name": "凉州区",
		"value": "620602",
		"parent": "620600"
	},
	{
		"name": "民勤县",
		"value": "620621",
		"parent": "620600"
	},
	{
		"name": "古浪县",
		"value": "620622",
		"parent": "620600"
	},
	{
		"name": "天祝藏族自治县",
		"value": "620623",
		"parent": "620600"
	},
	{
		"name": "甘州区",
		"value": "620702",
		"parent": "620700"
	},
	{
		"name": "肃南裕固族自治县",
		"value": "620721",
		"parent": "620700"
	},
	{
		"name": "民乐县",
		"value": "620722",
		"parent": "620700"
	},
	{
		"name": "临泽县",
		"value": "620723",
		"parent": "620700"
	},
	{
		"name": "高台县",
		"value": "620724",
		"parent": "620700"
	},
	{
		"name": "山丹县",
		"value": "620725",
		"parent": "620700"
	},
	{
		"name": "崆峒区",
		"value": "620802",
		"parent": "620800"
	},
	{
		"name": "泾川县",
		"value": "620821",
		"parent": "620800"
	},
	{
		"name": "灵台县",
		"value": "620822",
		"parent": "620800"
	},
	{
		"name": "崇信县",
		"value": "620823",
		"parent": "620800"
	},
	{
		"name": "华亭县",
		"value": "620824",
		"parent": "620800"
	},
	{
		"name": "庄浪县",
		"value": "620825",
		"parent": "620800"
	},
	{
		"name": "静宁县",
		"value": "620826",
		"parent": "620800"
	},
	{
		"name": "肃州区",
		"value": "620902",
		"parent": "620900"
	},
	{
		"name": "金塔县",
		"value": "620921",
		"parent": "620900"
	},
	{
		"name": "瓜州县",
		"value": "620922",
		"parent": "620900"
	},
	{
		"name": "肃北蒙古族自治县",
		"value": "620923",
		"parent": "620900"
	},
	{
		"name": "阿克塞哈萨克族自治县",
		"value": "620924",
		"parent": "620900"
	},
	{
		"name": "玉门市",
		"value": "620981",
		"parent": "620900"
	},
	{
		"name": "敦煌市",
		"value": "620982",
		"parent": "620900"
	},
	{
		"name": "西峰区",
		"value": "621002",
		"parent": "621000"
	},
	{
		"name": "庆城县",
		"value": "621021",
		"parent": "621000"
	},
	{
		"name": "环县",
		"value": "621022",
		"parent": "621000"
	},
	{
		"name": "华池县",
		"value": "621023",
		"parent": "621000"
	},
	{
		"name": "合水县",
		"value": "621024",
		"parent": "621000"
	},
	{
		"name": "正宁县",
		"value": "621025",
		"parent": "621000"
	},
	{
		"name": "宁县",
		"value": "621026",
		"parent": "621000"
	},
	{
		"name": "镇原县",
		"value": "621027",
		"parent": "621000"
	},
	{
		"name": "安定区",
		"value": "621102",
		"parent": "621100"
	},
	{
		"name": "通渭县",
		"value": "621121",
		"parent": "621100"
	},
	{
		"name": "陇西县",
		"value": "621122",
		"parent": "621100"
	},
	{
		"name": "渭源县",
		"value": "621123",
		"parent": "621100"
	},
	{
		"name": "临洮县",
		"value": "621124",
		"parent": "621100"
	},
	{
		"name": "漳县",
		"value": "621125",
		"parent": "621100"
	},
	{
		"name": "岷县",
		"value": "621126",
		"parent": "621100"
	},
	{
		"name": "武都区",
		"value": "621202",
		"parent": "621200"
	},
	{
		"name": "成县",
		"value": "621221",
		"parent": "621200"
	},
	{
		"name": "文县",
		"value": "621222",
		"parent": "621200"
	},
	{
		"name": "宕昌县",
		"value": "621223",
		"parent": "621200"
	},
	{
		"name": "康县",
		"value": "621224",
		"parent": "621200"
	},
	{
		"name": "西和县",
		"value": "621225",
		"parent": "621200"
	},
	{
		"name": "礼县",
		"value": "621226",
		"parent": "621200"
	},
	{
		"name": "徽县",
		"value": "621227",
		"parent": "621200"
	},
	{
		"name": "两当县",
		"value": "621228",
		"parent": "621200"
	},
	{
		"name": "临夏市",
		"value": "622901",
		"parent": "622900"
	},
	{
		"name": "临夏县",
		"value": "622921",
		"parent": "622900"
	},
	{
		"name": "康乐县",
		"value": "622922",
		"parent": "622900"
	},
	{
		"name": "永靖县",
		"value": "622923",
		"parent": "622900"
	},
	{
		"name": "广河县",
		"value": "622924",
		"parent": "622900"
	},
	{
		"name": "和政县",
		"value": "622925",
		"parent": "622900"
	},
	{
		"name": "东乡族自治县",
		"value": "622926",
		"parent": "622900"
	},
	{
		"name": "积石山保安族东乡族撒拉族自治县",
		"value": "622927",
		"parent": "622900"
	},
	{
		"name": "合作市",
		"value": "623001",
		"parent": "623000"
	},
	{
		"name": "临潭县",
		"value": "623021",
		"parent": "623000"
	},
	{
		"name": "卓尼县",
		"value": "623022",
		"parent": "623000"
	},
	{
		"name": "舟曲县",
		"value": "623023",
		"parent": "623000"
	},
	{
		"name": "迭部县",
		"value": "623024",
		"parent": "623000"
	},
	{
		"name": "玛曲县",
		"value": "623025",
		"parent": "623000"
	},
	{
		"name": "碌曲县",
		"value": "623026",
		"parent": "623000"
	},
	{
		"name": "夏河县",
		"value": "623027",
		"parent": "623000"
	},
	{
		"name": "西宁市",
		"value": "630100",
		"parent": "630000"
	},
	{
		"name": "海东市",
		"value": "630200",
		"parent": "630000"
	},
	{
		"name": "海北藏族自治州",
		"value": "632200",
		"parent": "630000"
	},
	{
		"name": "黄南藏族自治州",
		"value": "632300",
		"parent": "630000"
	},
	{
		"name": "海南藏族自治州",
		"value": "632500",
		"parent": "630000"
	},
	{
		"name": "果洛藏族自治州",
		"value": "632600",
		"parent": "630000"
	},
	{
		"name": "玉树藏族自治州",
		"value": "632700",
		"parent": "630000"
	},
	{
		"name": "海西蒙古族藏族自治州",
		"value": "632800",
		"parent": "630000"
	},
	{
		"name": "城东区",
		"value": "630102",
		"parent": "630100"
	},
	{
		"name": "城中区",
		"value": "630103",
		"parent": "630100"
	},
	{
		"name": "城西区",
		"value": "630104",
		"parent": "630100"
	},
	{
		"name": "城北区",
		"value": "630105",
		"parent": "630100"
	},
	{
		"name": "大通回族土族自治县",
		"value": "630121",
		"parent": "630100"
	},
	{
		"name": "湟中县",
		"value": "630122",
		"parent": "630100"
	},
	{
		"name": "湟源县",
		"value": "630123",
		"parent": "630100"
	},
	{
		"name": "乐都区",
		"value": "630202",
		"parent": "630200"
	},
	{
		"name": "平安区",
		"value": "630203",
		"parent": "630200"
	},
	{
		"name": "民和回族土族自治县",
		"value": "630222",
		"parent": "630200"
	},
	{
		"name": "互助土族自治县",
		"value": "630223",
		"parent": "630200"
	},
	{
		"name": "化隆回族自治县",
		"value": "630224",
		"parent": "630200"
	},
	{
		"name": "循化撒拉族自治县",
		"value": "630225",
		"parent": "630200"
	},
	{
		"name": "门源回族自治县",
		"value": "632221",
		"parent": "632200"
	},
	{
		"name": "祁连县",
		"value": "632222",
		"parent": "632200"
	},
	{
		"name": "海晏县",
		"value": "632223",
		"parent": "632200"
	},
	{
		"name": "刚察县",
		"value": "632224",
		"parent": "632200"
	},
	{
		"name": "同仁县",
		"value": "632321",
		"parent": "632300"
	},
	{
		"name": "尖扎县",
		"value": "632322",
		"parent": "632300"
	},
	{
		"name": "泽库县",
		"value": "632323",
		"parent": "632300"
	},
	{
		"name": "河南蒙古族自治县",
		"value": "632324",
		"parent": "632300"
	},
	{
		"name": "共和县",
		"value": "632521",
		"parent": "632500"
	},
	{
		"name": "同德县",
		"value": "632522",
		"parent": "632500"
	},
	{
		"name": "贵德县",
		"value": "632523",
		"parent": "632500"
	},
	{
		"name": "兴海县",
		"value": "632524",
		"parent": "632500"
	},
	{
		"name": "贵南县",
		"value": "632525",
		"parent": "632500"
	},
	{
		"name": "玛沁县",
		"value": "632621",
		"parent": "632600"
	},
	{
		"name": "班玛县",
		"value": "632622",
		"parent": "632600"
	},
	{
		"name": "甘德县",
		"value": "632623",
		"parent": "632600"
	},
	{
		"name": "达日县",
		"value": "632624",
		"parent": "632600"
	},
	{
		"name": "久治县",
		"value": "632625",
		"parent": "632600"
	},
	{
		"name": "玛多县",
		"value": "632626",
		"parent": "632600"
	},
	{
		"name": "玉树市",
		"value": "632701",
		"parent": "632700"
	},
	{
		"name": "杂多县",
		"value": "632722",
		"parent": "632700"
	},
	{
		"name": "称多县",
		"value": "632723",
		"parent": "632700"
	},
	{
		"name": "治多县",
		"value": "632724",
		"parent": "632700"
	},
	{
		"name": "囊谦县",
		"value": "632725",
		"parent": "632700"
	},
	{
		"name": "曲麻莱县",
		"value": "632726",
		"parent": "632700"
	},
	{
		"name": "格尔木市",
		"value": "632801",
		"parent": "632800"
	},
	{
		"name": "德令哈市",
		"value": "632802",
		"parent": "632800"
	},
	{
		"name": "乌兰县",
		"value": "632821",
		"parent": "632800"
	},
	{
		"name": "都兰县",
		"value": "632822",
		"parent": "632800"
	},
	{
		"name": "天峻县",
		"value": "632823",
		"parent": "632800"
	},
	{
		"name": "银川市",
		"value": "640100",
		"parent": "640000"
	},
	{
		"name": "石嘴山市",
		"value": "640200",
		"parent": "640000"
	},
	{
		"name": "吴忠市",
		"value": "640300",
		"parent": "640000"
	},
	{
		"name": "固原市",
		"value": "640400",
		"parent": "640000"
	},
	{
		"name": "中卫市",
		"value": "640500",
		"parent": "640000"
	},
	{
		"name": "兴庆区",
		"value": "640104",
		"parent": "640100"
	},
	{
		"name": "西夏区",
		"value": "640105",
		"parent": "640100"
	},
	{
		"name": "金凤区",
		"value": "640106",
		"parent": "640100"
	},
	{
		"name": "永宁县",
		"value": "640121",
		"parent": "640100"
	},
	{
		"name": "贺兰县",
		"value": "640122",
		"parent": "640100"
	},
	{
		"name": "灵武市",
		"value": "640181",
		"parent": "640100"
	},
	{
		"name": "大武口区",
		"value": "640202",
		"parent": "640200"
	},
	{
		"name": "惠农区",
		"value": "640205",
		"parent": "640200"
	},
	{
		"name": "平罗县",
		"value": "640221",
		"parent": "640200"
	},
	{
		"name": "利通区",
		"value": "640302",
		"parent": "640300"
	},
	{
		"name": "红寺堡区",
		"value": "640303",
		"parent": "640300"
	},
	{
		"name": "盐池县",
		"value": "640323",
		"parent": "640300"
	},
	{
		"name": "同心县",
		"value": "640324",
		"parent": "640300"
	},
	{
		"name": "青铜峡市",
		"value": "640381",
		"parent": "640300"
	},
	{
		"name": "原州区",
		"value": "640402",
		"parent": "640400"
	},
	{
		"name": "西吉县",
		"value": "640422",
		"parent": "640400"
	},
	{
		"name": "隆德县",
		"value": "640423",
		"parent": "640400"
	},
	{
		"name": "泾源县",
		"value": "640424",
		"parent": "640400"
	},
	{
		"name": "彭阳县",
		"value": "640425",
		"parent": "640400"
	},
	{
		"name": "沙坡头区",
		"value": "640502",
		"parent": "640500"
	},
	{
		"name": "中宁县",
		"value": "640521",
		"parent": "640500"
	},
	{
		"name": "海原县",
		"value": "640522",
		"parent": "640500"
	},
	{
		"name": "乌鲁木齐市",
		"value": "650100",
		"parent": "650000"
	},
	{
		"name": "克拉玛依市",
		"value": "650200",
		"parent": "650000"
	},
	{
		"name": "吐鲁番市",
		"value": "650400",
		"parent": "650000"
	},
	{
		"name": "哈密地区",
		"value": "652200",
		"parent": "650000"
	},
	{
		"name": "昌吉回族自治州",
		"value": "652300",
		"parent": "650000"
	},
	{
		"name": "博尔塔拉蒙古自治州",
		"value": "652700",
		"parent": "650000"
	},
	{
		"name": "巴音郭楞蒙古自治州",
		"value": "652800",
		"parent": "650000"
	},
	{
		"name": "阿克苏地区",
		"value": "652900",
		"parent": "650000"
	},
	{
		"name": "克孜勒苏柯尔克孜自治州",
		"value": "653000",
		"parent": "650000"
	},
	{
		"name": "喀什地区",
		"value": "653100",
		"parent": "650000"
	},
	{
		"name": "和田地区",
		"value": "653200",
		"parent": "650000"
	},
	{
		"name": "伊犁哈萨克自治州",
		"value": "654000",
		"parent": "650000"
	},
	{
		"name": "塔城地区",
		"value": "654200",
		"parent": "650000"
	},
	{
		"name": "阿勒泰地区",
		"value": "654300",
		"parent": "650000"
	},
	{
		"name": "石河子市",
		"value": "659001",
		"parent": "650000"
	},
	{
		"name": "阿拉尔市",
		"value": "659002",
		"parent": "650000"
	},
	{
		"name": "图木舒克市",
		"value": "659003",
		"parent": "650000"
	},
	{
		"name": "五家渠市",
		"value": "659004",
		"parent": "650000"
	},
	{
		"name": "天山区",
		"value": "650102",
		"parent": "650100"
	},
	{
		"name": "沙依巴克区",
		"value": "650103",
		"parent": "650100"
	},
	{
		"name": "新市区",
		"value": "650104",
		"parent": "650100"
	},
	{
		"name": "水磨沟区",
		"value": "650105",
		"parent": "650100"
	},
	{
		"name": "头屯河区",
		"value": "650106",
		"parent": "650100"
	},
	{
		"name": "达坂城区",
		"value": "650107",
		"parent": "650100"
	},
	{
		"name": "米东区",
		"value": "650109",
		"parent": "650100"
	},
	{
		"name": "乌鲁木齐县",
		"value": "650121",
		"parent": "650100"
	},
	{
		"name": "独山子区",
		"value": "650202",
		"parent": "650200"
	},
	{
		"name": "克拉玛依区",
		"value": "650203",
		"parent": "650200"
	},
	{
		"name": "白碱滩区",
		"value": "650204",
		"parent": "650200"
	},
	{
		"name": "乌尔禾区",
		"value": "650205",
		"parent": "650200"
	},
	{
		"name": "高昌区",
		"value": "650402",
		"parent": "650400"
	},
	{
		"name": "鄯善县",
		"value": "650421",
		"parent": "650400"
	},
	{
		"name": "托克逊县",
		"value": "650422",
		"parent": "650400"
	},
	{
		"name": "哈密市",
		"value": "652201",
		"parent": "652200"
	},
	{
		"name": "巴里坤哈萨克自治县",
		"value": "652222",
		"parent": "652200"
	},
	{
		"name": "伊吾县",
		"value": "652223",
		"parent": "652200"
	},
	{
		"name": "昌吉市",
		"value": "652301",
		"parent": "652300"
	},
	{
		"name": "阜康市",
		"value": "652302",
		"parent": "652300"
	},
	{
		"name": "呼图壁县",
		"value": "652323",
		"parent": "652300"
	},
	{
		"name": "玛纳斯县",
		"value": "652324",
		"parent": "652300"
	},
	{
		"name": "奇台县",
		"value": "652325",
		"parent": "652300"
	},
	{
		"name": "吉木萨尔县",
		"value": "652327",
		"parent": "652300"
	},
	{
		"name": "木垒哈萨克自治县",
		"value": "652328",
		"parent": "652300"
	},
	{
		"name": "博乐市",
		"value": "652701",
		"parent": "652700"
	},
	{
		"name": "阿拉山口市",
		"value": "652702",
		"parent": "652700"
	},
	{
		"name": "精河县",
		"value": "652722",
		"parent": "652700"
	},
	{
		"name": "温泉县",
		"value": "652723",
		"parent": "652700"
	},
	{
		"name": "库尔勒市",
		"value": "652801",
		"parent": "652800"
	},
	{
		"name": "轮台县",
		"value": "652822",
		"parent": "652800"
	},
	{
		"name": "尉犁县",
		"value": "652823",
		"parent": "652800"
	},
	{
		"name": "若羌县",
		"value": "652824",
		"parent": "652800"
	},
	{
		"name": "且末县",
		"value": "652825",
		"parent": "652800"
	},
	{
		"name": "焉耆回族自治县",
		"value": "652826",
		"parent": "652800"
	},
	{
		"name": "和静县",
		"value": "652827",
		"parent": "652800"
	},
	{
		"name": "和硕县",
		"value": "652828",
		"parent": "652800"
	},
	{
		"name": "博湖县",
		"value": "652829",
		"parent": "652800"
	},
	{
		"name": "阿克苏市",
		"value": "652901",
		"parent": "652900"
	},
	{
		"name": "温宿县",
		"value": "652922",
		"parent": "652900"
	},
	{
		"name": "库车县",
		"value": "652923",
		"parent": "652900"
	},
	{
		"name": "沙雅县",
		"value": "652924",
		"parent": "652900"
	},
	{
		"name": "新和县",
		"value": "652925",
		"parent": "652900"
	},
	{
		"name": "拜城县",
		"value": "652926",
		"parent": "652900"
	},
	{
		"name": "乌什县",
		"value": "652927",
		"parent": "652900"
	},
	{
		"name": "阿瓦提县",
		"value": "652928",
		"parent": "652900"
	},
	{
		"name": "柯坪县",
		"value": "652929",
		"parent": "652900"
	},
	{
		"name": "阿图什市",
		"value": "653001",
		"parent": "653000"
	},
	{
		"name": "阿克陶县",
		"value": "653022",
		"parent": "653000"
	},
	{
		"name": "阿合奇县",
		"value": "653023",
		"parent": "653000"
	},
	{
		"name": "乌恰县",
		"value": "653024",
		"parent": "653000"
	},
	{
		"name": "喀什市",
		"value": "653101",
		"parent": "653100"
	},
	{
		"name": "疏附县",
		"value": "653121",
		"parent": "653100"
	},
	{
		"name": "疏勒县",
		"value": "653122",
		"parent": "653100"
	},
	{
		"name": "英吉沙县",
		"value": "653123",
		"parent": "653100"
	},
	{
		"name": "泽普县",
		"value": "653124",
		"parent": "653100"
	},
	{
		"name": "莎车县",
		"value": "653125",
		"parent": "653100"
	},
	{
		"name": "叶城县",
		"value": "653126",
		"parent": "653100"
	},
	{
		"name": "麦盖提县",
		"value": "653127",
		"parent": "653100"
	},
	{
		"name": "岳普湖县",
		"value": "653128",
		"parent": "653100"
	},
	{
		"name": "伽师县",
		"value": "653129",
		"parent": "653100"
	},
	{
		"name": "巴楚县",
		"value": "653130",
		"parent": "653100"
	},
	{
		"name": "塔什库尔干塔吉克自治县",
		"value": "653131",
		"parent": "653100"
	},
	{
		"name": "和田市",
		"value": "653201",
		"parent": "653200"
	},
	{
		"name": "和田县",
		"value": "653221",
		"parent": "653200"
	},
	{
		"name": "墨玉县",
		"value": "653222",
		"parent": "653200"
	},
	{
		"name": "皮山县",
		"value": "653223",
		"parent": "653200"
	},
	{
		"name": "洛浦县",
		"value": "653224",
		"parent": "653200"
	},
	{
		"name": "策勒县",
		"value": "653225",
		"parent": "653200"
	},
	{
		"name": "于田县",
		"value": "653226",
		"parent": "653200"
	},
	{
		"name": "民丰县",
		"value": "653227",
		"parent": "653200"
	},
	{
		"name": "伊宁市",
		"value": "654002",
		"parent": "654000"
	},
	{
		"name": "奎屯市",
		"value": "654003",
		"parent": "654000"
	},
	{
		"name": "霍尔果斯市",
		"value": "654004",
		"parent": "654000"
	},
	{
		"name": "伊宁县",
		"value": "654021",
		"parent": "654000"
	},
	{
		"name": "察布查尔锡伯自治县",
		"value": "654022",
		"parent": "654000"
	},
	{
		"name": "霍城县",
		"value": "654023",
		"parent": "654000"
	},
	{
		"name": "巩留县",
		"value": "654024",
		"parent": "654000"
	},
	{
		"name": "新源县",
		"value": "654025",
		"parent": "654000"
	},
	{
		"name": "昭苏县",
		"value": "654026",
		"parent": "654000"
	},
	{
		"name": "特克斯县",
		"value": "654027",
		"parent": "654000"
	},
	{
		"name": "尼勒克县",
		"value": "654028",
		"parent": "654000"
	},
	{
		"name": "塔城市",
		"value": "654201",
		"parent": "654200"
	},
	{
		"name": "乌苏市",
		"value": "654202",
		"parent": "654200"
	},
	{
		"name": "额敏县",
		"value": "654221",
		"parent": "654200"
	},
	{
		"name": "沙湾县",
		"value": "654223",
		"parent": "654200"
	},
	{
		"name": "托里县",
		"value": "654224",
		"parent": "654200"
	},
	{
		"name": "裕民县",
		"value": "654225",
		"parent": "654200"
	},
	{
		"name": "和布克赛尔蒙古自治县",
		"value": "654226",
		"parent": "654200"
	},
	{
		"name": "阿勒泰市",
		"value": "654301",
		"parent": "654300"
	},
	{
		"name": "布尔津县",
		"value": "654321",
		"parent": "654300"
	},
	{
		"name": "富蕴县",
		"value": "654322",
		"parent": "654300"
	},
	{
		"name": "福海县",
		"value": "654323",
		"parent": "654300"
	},
	{
		"name": "哈巴河县",
		"value": "654324",
		"parent": "654300"
	},
	{
		"name": "青河县",
		"value": "654325",
		"parent": "654300"
	},
	{
		"name": "吉木乃县",
		"value": "654326",
		"parent": "654300"
	},
	{
		"name": "中西區",
		"value": "810001",
		"parent": "810000"
	},
	{
		"name": "灣仔區",
		"value": "810002",
		"parent": "810000"
	},
	{
		"name": "東區",
		"value": "810003",
		"parent": "810000"
	},
	{
		"name": "南區",
		"value": "810004",
		"parent": "810000"
	},
	{
		"name": "油尖旺區",
		"value": "810005",
		"parent": "810000"
	},
	{
		"name": "深水埗區",
		"value": "810006",
		"parent": "810000"
	},
	{
		"name": "九龍城區",
		"value": "810007",
		"parent": "810000"
	},
	{
		"name": "黃大仙區",
		"value": "810008",
		"parent": "810000"
	},
	{
		"name": "觀塘區",
		"value": "810009",
		"parent": "810000"
	},
	{
		"name": "荃灣區",
		"value": "810010",
		"parent": "810000"
	},
	{
		"name": "屯門區",
		"value": "810011",
		"parent": "810000"
	},
	{
		"name": "元朗區",
		"value": "810012",
		"parent": "810000"
	},
	{
		"name": "北區",
		"value": "810013",
		"parent": "810000"
	},
	{
		"name": "大埔區",
		"value": "810014",
		"parent": "810000"
	},
	{
		"name": "西貢區",
		"value": "810015",
		"parent": "810000"
	},
	{
		"name": "沙田區",
		"value": "810016",
		"parent": "810000"
	},
	{
		"name": "葵青區",
		"value": "810017",
		"parent": "810000"
	},
	{
		"name": "離島區",
		"value": "810018",
		"parent": "810000"
	},
	{
		"name": "花地瑪堂區",
		"value": "820001",
		"parent": "820000"
	},
	{
		"name": "花王堂區",
		"value": "820002",
		"parent": "820000"
	},
	{
		"name": "望德堂區",
		"value": "820003",
		"parent": "820000"
	},
	{
		"name": "大堂區",
		"value": "820004",
		"parent": "820000"
	},
	{
		"name": "風順堂區",
		"value": "820005",
		"parent": "820000"
	},
	{
		"name": "嘉模堂區",
		"value": "820006",
		"parent": "820000"
	},
	{
		"name": "路氹填海區",
		"value": "820007",
		"parent": "820000"
	},
	{
		"name": "聖方濟各堂區",
		"value": "820008",
		"parent": "820000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "110200"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "120200"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "139000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "139001"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "139002"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "310200"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "419000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "419001"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "429000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "429004"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "429005"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "429006"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "429021"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "441900"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "442000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469001"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469002"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469003"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469005"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469006"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469007"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469021"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469022"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469023"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469024"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469025"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469026"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469027"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469028"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469029"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "469030"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "500200"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "620200"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "659000"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "659001"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "659002"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "659003"
	},
	{
		"name": "--",
		"value": "--",
		"parent": "659004"
	}
];

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TabLayout__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TabLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TabLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CellGroup__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CellGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CellGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Column_vue__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TimerTip_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TimerTip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TimerTip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AgreeIterms_vue__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AgreeIterms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AgreeIterms_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Candidate__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Candidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Candidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Panel_vue__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_img_inputer__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_img_inputer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_img_inputer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Occupation_vue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Occupation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Occupation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Login__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vux_src_plugins_alert_index_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vux_src_plugins_ajax_index_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vux_src_components_cell_index_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vux_src_components_confirm_index_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vux_src_components_confirm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vux_src_components_confirm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vux_src_plugins_confirm_index_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_components_datetime_index_vue__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_group_index_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_components_icon_index_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vux_src_plugins_loading_index_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vux_src_components_popup_index_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vux_src_components_popup_picker_index_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vux_src_components_popup_picker_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vux_src_components_popup_picker_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vux_src_components_swiper_swiper_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vux_src_components_swiper_swiper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vux_src_components_swiper_swiper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vux_src_plugins_toast_index_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vux_src_components_view_box_index_vue__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vux_src_plugins_wechat_index_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vux_src_components_x_address_index_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vux_src_components_x_address_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vux_src_components_x_address_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vux_src_components_x_button_index_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vux_src_components_x_dialog_index_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vux_src_components_x_dialog_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vux_src_components_x_dialog_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vux_src_components_x_input_index_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vux_src_components_x_switch_index_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vux_src_components_x_switch_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vux_src_components_x_switch_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vux_src_components_x_textarea_index_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vux_src_components_x_textarea_index_vue__);
__webpack_require__(555).polyfill();









































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vux_src_plugins_ajax_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_22_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_27_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_29_vux_src_plugins_wechat_index_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Cell', __WEBPACK_IMPORTED_MODULE_16_vux_src_components_cell_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Confirm', __WEBPACK_IMPORTED_MODULE_17_vux_src_components_confirm_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Datetime', __WEBPACK_IMPORTED_MODULE_19_vux_src_components_datetime_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Group', __WEBPACK_IMPORTED_MODULE_20_vux_src_components_group_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Icon', __WEBPACK_IMPORTED_MODULE_21_vux_src_components_icon_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Popup', __WEBPACK_IMPORTED_MODULE_23_vux_src_components_popup_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('PopupPicker', __WEBPACK_IMPORTED_MODULE_24_vux_src_components_popup_picker_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Swiper', __WEBPACK_IMPORTED_MODULE_25_vux_src_components_swiper_swiper_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Tabbar', __WEBPACK_IMPORTED_MODULE_26_vux_src_components_tabbar_tabbar_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ViewBox', __WEBPACK_IMPORTED_MODULE_28_vux_src_components_view_box_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XAddress', __WEBPACK_IMPORTED_MODULE_30_vux_src_components_x_address_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XButton', __WEBPACK_IMPORTED_MODULE_31_vux_src_components_x_button_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XDialog', __WEBPACK_IMPORTED_MODULE_32_vux_src_components_x_dialog_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XInput', __WEBPACK_IMPORTED_MODULE_33_vux_src_components_x_input_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XSwitch', __WEBPACK_IMPORTED_MODULE_34_vux_src_components_x_switch_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XTextarea', __WEBPACK_IMPORTED_MODULE_35_vux_src_components_x_textarea_index_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_4__components_TabLayout___default.a.name, __WEBPACK_IMPORTED_MODULE_4__components_TabLayout___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_5__components_CellGroup___default.a.name, __WEBPACK_IMPORTED_MODULE_5__components_CellGroup___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_6__components_Column_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_6__components_Column_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_13__components_Login___default.a.name, __WEBPACK_IMPORTED_MODULE_13__components_Login___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_7__components_TimerTip_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_7__components_TimerTip_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_8__components_AgreeIterms_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_8__components_AgreeIterms_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_9__components_Candidate___default.a.name, __WEBPACK_IMPORTED_MODULE_9__components_Candidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_10__components_Panel_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_10__components_Panel_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_12__components_Occupation_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_12__components_Occupation_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('VueImgInputer', __WEBPACK_IMPORTED_MODULE_11_vue_img_inputer___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'ICBC': '0101',
  'ABC': '0102',
  'CCB': '0104',
  'BOC': '0103',
  'BCOM': '0108',
  'CIB': '0116',
  'CITIC': '0109',
  'CEB': '0110',
  'PAB': '0198',
  'PSBC': '0128',
  'SPDB': '0117',
  'CMBC': '0112',
  'CMB': '0115',
  'GDB': '0113',
  'HXB': '0111'
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '本人',
  value: '1'
}]);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  super: ['110100', '310100', '440100', '440300'],
  first: ['320500', '370200', '210200', '441900', '330200', '120100', '500100', '130100', '140100', '210100', '220100', '230100', '370100', '320100', '330100', '340100', '350100', '360100', '410100', '420100', '430100', '460100', '510100', '520100', '530100', '610100', '620100', '630100', '450100', '150100', '540100', '640100', '650100']
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['1. 电子保单上所填写的信息是否为您本人填写并正确无误？', '2. 您是否已阅读并理解《人身保险投保提示书》，投保单及投保时的各项资料?  ', '3. 您对于合同条款，特别是保险责任、责任免除、保险期间等相关内容是否确认已清楚了解？', '4. 您是否清楚自您收到电子保险单次日起，享有10天的犹豫期，在犹豫期内您可以无条件解除保险合同。犹豫期后解除保险合同您会有一定的损失，我公司将按照合同约定退还保单的现金价值？', '(5) 被保险人过去两年内是否曾接受X光(包括乳房X线检查)、超声波检查、CT检查、活组织切片检查、血液检查、尿液检查、艾滋病检测或其他任何医学检查（不包括轻微疾病如伤风、感冒或常规体检）？', '(6) 被保人目前或曾经是否患有下列疾病或症状：高血压，糖尿病，恶性肿瘤，血管瘤，良性脑肿瘤，脑膜炎/脑炎，脊髓灰质炎，III度房室传导阻滞，冠心病，心肌炎，心肌病，肺动脉高压，心脑血管疾病，运动神经元病，癫痫，重症肌无力，多发性硬化，硬皮病，阿尔茨海默病，帕金森氏症，急性坏死性筋膜炎，精神类疾病，艾滋病或HIV感染，慢性肝炎或肝硬化、肺气肿、肺心病、呼吸功能衰竭、肾功能衰竭、多囊肾等肝肺肾脏器疾病，克隆病、溃疡性结肠炎、硬化性胆管炎等胆道肠道疾病，红斑狼疮，血液病或内分泌代谢疾病，胰腺炎，丝虫病，克-雅氏病，川崎病，嗜铬细胞瘤，肾上腺皮质功能减退， III度烧伤，职业病，风湿免疫性疾病、先天性疾病、遗传性疾病、体表或体内肿块、息肉、结节、黑痣增大、淋巴结肿大？', '(7) 是否有智能障碍、躯体畸形或功能障碍、肢体缺失？是否有言语、咀嚼、视力、听力等机能障碍？是否有酒精、药物滥用成瘾史以及使用毒品、镇静剂及其它违禁药物?', '(8) 被保险人目前是否从事高危职业?是否有参加飞行、潜水、滑水、漂流、跳伞、武术比赛、拳击比赛、赛车、蹦极、特技表演等危险运动的爱好？是否正计划到有战乱的国家工作或居住？', '(9) 被保人目前是否怀孕?（被保人为14周岁（含）以上女性时填写）', '(10) 您是否年收入低于  5万元，且本次所交保费高于年收入的35%？']);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['1. 您近半年内是否在其他保险公司投保过大于100万保额的人身保险（不包括航空意外、公共交通意外和医疗险）？', '2. 您是否在投保或复效时被拒保、延期、加费或除外责任承保？或被解除过保险合同？或申请过重大疾病理赔？', '3. 您最近1年内是否因健康异常发生过住院或手术,或由医师给您提出进一步检查、住院或手术的建议?此处所述住院治疗或手术不包含阑尾炎、脂肪瘤、肺炎、上呼吸道感染、骨折、颈椎疾病、急性胃炎或非萎缩性胃炎、顺产、胆囊炎。', '4. 您是否目前或过去一年内曾有过下列症状？<br>反复头痛或眩晕、晕厥、咯血、胸痛、呼吸困难、呕血、黄疸、便血、听力下降、耳鸣、复视、视力明显下降、原因不明皮肤病和粘膜及齿龈出血、原因不明的发热、原因不明的体重下降超过5公斤、原因不明的肌肉萎缩、原因不明的包块或肿物。', '5. 您是否目前患有或过去曾经患过下列疾病？<br>智能障碍、恶性肿瘤、冠心病、心绞痛、心律失常、先天性心脏病、风湿性心脏病、心肌病、心力衰竭、帕金森氏症、脑梗塞、脑出血、重症肌无力、多发性硬化、呼吸衰竭、肺心病、肝硬化、尿毒症、肾病、肾脏功能障碍、慢性肾炎、再生障碍性贫血、白血病、淋巴瘤、艾滋病或艾滋病毒携带、系统性红斑狼疮、精神疾患、酒精或药物滥用成瘾、身体功能障碍或残疾（包括视力、听力、脊柱、胸廓、四肢）？', '6. 成年女性适用:<br>a.  您是否正处于妊娠期？<br>b.  您是否曾有阴道异常流血、畸胎瘤、葡萄胎、子宫颈重度不典型增生、卵巢肿瘤？', '7. 您是否存在下列习惯或爱好：<br>a.  吸烟，且平均每日吸烟2包以上。<br>b.  饮酒，且平均每日饮酒白酒1斤以上，或啤酒8瓶，或红酒2瓶以上。<br>c.  参加赛车、赛马、搏击类运动、攀岩、潜水、滑雪、蹦极、飞行、探险、特技活动及其它高风险活动。', '8. 您近半年内是否有未如期归还的银行贷款或其他借贷？']);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '30万',
  value: '3'
}, {
  name: '50万',
  value: '5'
}, {
  name: '100万',
  value: '10'
}, {
  name: '150万',
  value: '15'
}]);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '20年期',
  value: '20'
}, {
  name: '30年期',
  value: '30'
}, {
  name: '至60周岁',
  value: '60'
}, {
  name: '至65周岁',
  value: '65'
}, {
  name: '至70周岁',
  value: '70'
}]);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '年交',
  value: '0'
}]);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '5年',
  value: '5'
}, {
  name: '10年',
  value: '10'
}, {
  name: '20年',
  value: '20'
}]);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: '男',
  value: '1'
}, {
  name: '女',
  value: '0'
}]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Evaluation__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Evaluation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Evaluation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Result__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pay__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Pay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Order__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Notify__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Notify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Product__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Form__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Feedback__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Hello__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Hello__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:userId/:productId',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Product___default.a
  }, {
    path: '/:userId/:productId/notify',
    name: 'Notify',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Notify___default.a
  }, {
    path: '/:userId/:productId/form',
    name: 'Form',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Form___default.a
  }, {
    path: '/:userId/:productId/:unionCode/order',
    name: 'Order',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Order___default.a
  }, {
    path: '/:userId/:productId/:unionCode/pay',
    name: 'Pay',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Pay___default.a
  }, {
    path: '/:userId/:productId/:unionCode/feedback',
    name: 'Feedback',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Feedback___default.a
  }, {
    path: '/:userId/:productId/:unionCode/result',
    name: 'Result',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Result___default.a
  }, {
    path: '/:userId/:productId/:unionCode/evaluation',
    name: 'Evaluation',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Evaluation___default.a
  }, {
    path: '*',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Hello___default.a
  }]
});

var _hmt = window._hmt;

router.beforeEach(function (to, from, next) {
  if (to.fullPath !== '/') {
    _hmt.push(['_trackPageview', '/explosions/#' + to.fullPath]);
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_paymentMethods__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_candidateInsureds__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_sexs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getAgeFromBirthday__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getAgeAndSexFromID__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_cities__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_bankCodes__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(203);














__WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  insuranceAmountsByBirthday: function insuranceAmountsByBirthday(state, getters) {
    var age = getters.ageFromBirthday;
    if (age >= 18 && age <= 40 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: true
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 41 && age <= 50 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 41 && age <= 50 && state.holder.area.length === 0) {
      return [{
        name: '30万',
        value: '3',
        accessable: true
      }, {
        name: '50万',
        value: '5',
        accessable: true
      }, {
        name: '100万',
        value: '10',
        accessable: true
      }, {
        name: '150万',
        value: '15',
        accessable: false
      }];
    } else if (age >= 51 && age <= 60 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: false
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 51 && age <= 60 && state.holder.area.length === 0) {
      return [{
        name: '30万',
        value: '3',
        accessable: true
      }, {
        name: '50万',
        value: '5',
        accessable: true
      }, {
        name: '100万',
        value: '10',
        accessable: false
      }, {
        name: '150万',
        value: '15',
        accessable: false
      }];
    } else if (age === null && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: true
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    }
    return __WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  insuranceAmountsByIDNumber: function insuranceAmountsByIDNumber(state, getters) {
    var age = getters.ageFromIDNumber;
    if (age >= 18 && age <= 40 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: true
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 41 && age <= 50 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 41 && age <= 50 && state.holder.area.length === 0) {
      return [{
        name: '30万',
        value: '3',
        accessable: true
      }, {
        name: '50万',
        value: '5',
        accessable: true
      }, {
        name: '100万',
        value: '10',
        accessable: true
      }, {
        name: '150万',
        value: '15',
        accessable: false
      }];
    } else if (age >= 51 && age <= 60 && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: false
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    } else if (age >= 51 && age <= 60 && state.holder.area.length === 0) {
      return [{
        name: '30万',
        value: '3',
        accessable: true
      }, {
        name: '50万',
        value: '5',
        accessable: true
      }, {
        name: '100万',
        value: '10',
        accessable: false
      }, {
        name: '150万',
        value: '15',
        accessable: false
      }];
    } else if (age === null && state.holder.area[1]) {
      if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].super.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: true
        }];
      } else if (__WEBPACK_IMPORTED_MODULE_8__data_cities__["a" /* default */].first.indexOf(state.holder.area[1]) !== -1) {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: true
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      } else {
        return [{
          name: '30万',
          value: '3',
          accessable: true
        }, {
          name: '50万',
          value: '5',
          accessable: true
        }, {
          name: '100万',
          value: '10',
          accessable: false
        }, {
          name: '150万',
          value: '15',
          accessable: false
        }];
      }
    }
    return __WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  paymentPeriodsByBirthday: function paymentPeriodsByBirthday(state, getters) {
    var age = getters.ageFromBirthday;
    if (age >= 41 && age <= 50 && state.order.insurancePeriod === '60' || age >= 46 && age <= 55 && state.order.insurancePeriod === '65' || age >= 51 && age <= 60 && state.order.insurancePeriod === '70') {
      return [{
        name: '5年',
        value: '5',
        accessable: true
      }, {
        name: '10年',
        value: '10',
        accessable: true
      }, {
        name: '20年',
        value: '20',
        accessable: false
      }];
    }
    return __WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  paymentPeriodsByIDNumber: function paymentPeriodsByIDNumber(state, getters) {
    var age = getters.ageFromIDNumber;
    if (age >= 41 && age <= 50 && state.order.insurancePeriod === '60' || age >= 46 && age <= 55 && state.order.insurancePeriod === '65' || age >= 51 && age <= 60 && state.order.insurancePeriod === '70') {
      return [{
        name: '5年',
        value: '5',
        accessable: true
      }, {
        name: '10年',
        value: '10',
        accessable: true
      }, {
        name: '20年',
        value: '20',
        accessable: false
      }];
    }
    return __WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  accessableInsurancePeriodsByBitthday: function accessableInsurancePeriodsByBitthday(state, getters) {
    var age = getters.ageFromBirthday;
    if (age >= 41 && age <= 45) {
      if (state.order.paymentPeriod === '20') {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: false
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      } else {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: true
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      }
    } else if (age >= 46 && age <= 50) {
      if (state.order.paymentPeriod === '20') {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: false
        }, {
          name: '至65周岁',
          value: '65',
          accessable: false
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      } else {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: true
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      }
    } else if (age >= 51 && age <= 55) {
      return [{
        name: '20年期',
        value: '20',
        accessable: false
      }, {
        name: '30年期',
        value: '30',
        accessable: false
      }, {
        name: '至60周岁',
        value: '60',
        accessable: false
      }, {
        name: '至65周岁',
        value: '65',
        accessable: true
      }, {
        name: '至70周岁',
        value: '70',
        accessable: true
      }];
    } else if (age >= 56 && age <= 60) {
      return [{
        name: '20年期',
        value: '20',
        accessable: false
      }, {
        name: '30年期',
        value: '30',
        accessable: false
      }, {
        name: '至60周岁',
        value: '60',
        accessable: false
      }, {
        name: '至65周岁',
        value: '65',
        accessable: false
      }, {
        name: '至70周岁',
        value: '70',
        accessable: true
      }];
    }
    return __WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  accessableInsurancePeriodsByIDNumber: function accessableInsurancePeriodsByIDNumber(state, getters) {
    var age = getters.ageFromIDNumber;
    if (age >= 41 && age <= 45) {
      if (state.order.paymentPeriod === '20') {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: false
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      } else {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: true
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      }
    } else if (age >= 46 && age <= 50) {
      if (state.order.paymentPeriod === '20') {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: false
        }, {
          name: '至65周岁',
          value: '65',
          accessable: false
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      } else {
        return [{
          name: '20年期',
          value: '20',
          accessable: true
        }, {
          name: '30年期',
          value: '30',
          accessable: false
        }, {
          name: '至60周岁',
          value: '60',
          accessable: true
        }, {
          name: '至65周岁',
          value: '65',
          accessable: true
        }, {
          name: '至70周岁',
          value: '70',
          accessable: true
        }];
      }
    } else if (age >= 51 && age <= 55) {
      return [{
        name: '20年期',
        value: '20',
        accessable: false
      }, {
        name: '30年期',
        value: '30',
        accessable: false
      }, {
        name: '至60周岁',
        value: '60',
        accessable: false
      }, {
        name: '至65周岁',
        value: '65',
        accessable: true
      }, {
        name: '至70周岁',
        value: '70',
        accessable: true
      }];
    } else if (age >= 56 && age <= 60) {
      return [{
        name: '20年期',
        value: '20',
        accessable: false
      }, {
        name: '30年期',
        value: '30',
        accessable: false
      }, {
        name: '至60周岁',
        value: '60',
        accessable: false
      }, {
        name: '至65周岁',
        value: '65',
        accessable: false
      }, {
        name: '至70周岁',
        value: '70',
        accessable: true
      }];
    }
    return __WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  accessablePaymentMethods: function accessablePaymentMethods(state) {
    return __WEBPACK_IMPORTED_MODULE_2__data_paymentMethods__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  insurancePeriodName: function insurancePeriodName(state) {
    var period = '';
    for (var i = 0, l = __WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__["a" /* default */].length; i < l; i++) {
      if (__WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__["a" /* default */][i].value === state.order.insurancePeriod) {
        period = __WEBPACK_IMPORTED_MODULE_3__data_insurancePeriods__["a" /* default */][i].name;
      }
    }
    return period;
  },
  paymentMethodName: function paymentMethodName(state) {
    var method = '';
    for (var i = 0, l = __WEBPACK_IMPORTED_MODULE_2__data_paymentMethods__["a" /* default */].length; i < l; i++) {
      if (__WEBPACK_IMPORTED_MODULE_2__data_paymentMethods__["a" /* default */][i].value === state.order.paymentMethod) {
        method = __WEBPACK_IMPORTED_MODULE_2__data_paymentMethods__["a" /* default */][i].name;
      }
    }
    return method;
  },
  paymentByIDNumber: function paymentByIDNumber(state) {
    return 1234;
  },
  paymentByBirthday: function paymentByBirthday(state) {
    return 1234;
  },
  formatCountdownTimer: function formatCountdownTimer(state) {
    var countdownTimer = state.order.countdownTimer;
    var minute = Math.floor(countdownTimer / 60);
    var second = countdownTimer % 60;
    if (minute < 10) {
      minute = '0' + minute;
    }
    if (second < 10) {
      second = '0' + second;
    }
    return {
      minute: minute,
      second: second
    };
  },
  insuranceAmountName: function insuranceAmountName(state) {
    var name = '';
    for (var i = 0, l = __WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__["a" /* default */].length; i < l; i++) {
      if (__WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__["a" /* default */][i].value === state.order.insuranceAmount) {
        name = __WEBPACK_IMPORTED_MODULE_0__data_insuranceAmounts__["a" /* default */][i].name;
        break;
      }
    }
    return name;
  },
  paymentPeriodName: function paymentPeriodName(state) {
    var name = '';
    for (var i = 0, l = __WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__["a" /* default */].length; i < l; i++) {
      if (__WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__["a" /* default */][i].value === state.order.paymentPeriod) {
        name = __WEBPACK_IMPORTED_MODULE_1__data_paymentPeriods__["a" /* default */][i].name;
        break;
      }
    }
    return name;
  },
  limitDate: function limitDate(state) {
    var d = {
      startDate: '',
      endDate: ''
    };
    var now = new Date();
    var nowYear = now.getFullYear();
    var nowMonth = now.getMonth();
    var nowDate = now.getDate();
    var startDate = new Date(nowYear - 61, nowMonth, nowDate + 1);
    var endDate = new Date(nowYear - 18, nowMonth, nowDate);
    d.startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1 < 10 ? '0' + (startDate.getMonth() + 1) : startDate.getMonth() + 1) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate());
    d.endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1 < 10 ? '0' + (endDate.getMonth() + 1) : endDate.getMonth() + 1) + '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate());
    return d;
  },
  candidateInsureds: function candidateInsureds(state) {
    return __WEBPACK_IMPORTED_MODULE_4__data_candidateInsureds__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  sexs: function sexs(state) {
    return __WEBPACK_IMPORTED_MODULE_5__data_sexs__["a" /* default */].map(function (ele) {
      ele.accessable = true;
      return ele;
    });
  },
  ageFromBirthday: function ageFromBirthday(state) {
    var age = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_getAgeFromBirthday__["a" /* default */])(state.insured.birthday);
    return age;
  },
  ageFromIDNumber: function ageFromIDNumber(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_getAgeAndSexFromID__["a" /* default */])(state.insured.IDNumber).age;
  },
  sexFromIDNumber: function sexFromIDNumber(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_getAgeAndSexFromID__["a" /* default */])(state.insured.IDNumber).sex;
  },
  computMeasurePayment: function computMeasurePayment(state) {
    if (state.order.measurePayment === null || state.order.measurePayment === false) {
      return null;
    }
    return state.order.measurePayment * Number(state.order.insuranceAmount);
  },
  computPaymentByIDNumber: function computPaymentByIDNumber(state) {
    if (state.order.paymentByIDNumber === null || state.order.paymentByIDNumber === false) {
      return null;
    }
    return state.order.paymentByIDNumber * Number(state.order.insuranceAmount);
  },
  bankCode: function bankCode(state) {
    if (state.holder.bankName.length === 0) {
      return '';
    }
    return __WEBPACK_IMPORTED_MODULE_9__data_bankCodes__["a" /* default */][state.holder.bankName[0]];
  },
  selectedTickets: function selectedTickets(state) {
    var selected = [];
    state.activity.tickets.forEach(function (ele) {
      if (ele.selected) {
        selected.push(ele);
      }
    });
    return selected;
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_app__ = __webpack_require__(39);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  activity: {
    status: true,
    appid: __WEBPACK_IMPORTED_MODULE_4__config_app__["a" /* default */].app.test ? 'wx9594136eabd26d9f' : 'wxef64cfa3a28363ac',
    redirectURL: __WEBPACK_IMPORTED_MODULE_4__config_app__["a" /* default */].app.test ? 'http://test.m.wkbins.com/hengqin' : 'http://m.wkbins.com/hengqin',
    innerCodes: ['149673178664394306', '148198068433580000'],
    tickets: [],
    amountBySelectedTickets: 0
  },
  h5: {
    configuration: {} },
  order: {
    productId: '',
    userId: '',
    openId: '',
    number: '',
    name: '',
    company: '',
    unionOrderCode: '',
    confirmFeedback: true,
    countdownTimer: 1800,
    beneficiary: '法定',
    paymentMethod: '0',
    insurancePeriod: '20',
    insuranceAmount: '3',
    insuredValue: '1',
    measurePayment: null,
    measureReady: '',
    paymentByIDNumber: null,
    paymentShowNull: '',
    paymentPeriod: '20' },
  holder: {
    name: '',
    message: '',
    IDNumber: '',
    phoneNumber: '',
    CAPTCHA: '',
    realCAPTCHA: '',
    bankName: [],
    bankCardNumber: '',
    email: '',
    area: [],
    positivePicValue: null,
    negativePicValue: null,
    positivePicSrc: '',
    negativePicSrc: '',
    address: '' },
  insured: {
    name: '',
    sex: '1',
    IDNumber: '',
    IDNumberExpire: '',
    occupationCode: '4030504',
    occupationName: '一般内勤人员',
    birthday: '' },
  wechatpaybanklist: [],
  banksFromServer: []
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateProductId: function updateProductId(state, value) {
    state.order.productId = value;
  },
  updateUserId: function updateUserId(state, value) {
    state.order.userId = value;
  },
  updateOrderConfirmFeedback: function updateOrderConfirmFeedback(state, value) {
    state.order.confirmFeedback = value;
  },
  updateHolderMessage: function updateHolderMessage(state, value) {
    state.holder.message = value;
  },
  updateHolderBankName: function updateHolderBankName(state, value) {
    state.holder.bankName = value;
  },
  updateHolderBankCardNumber: function updateHolderBankCardNumber(state, value) {
    state.holder.bankCardNumber = value;
  },
  updateHolderName: function updateHolderName(state, value) {
    state.holder.name = value;
  },
  updateHolderIDNumber: function updateHolderIDNumber(state, value) {
    state.holder.IDNumber = value;
  },
  updateHolderPhoneNumber: function updateHolderPhoneNumber(state, value) {
    state.holder.phoneNumber = value;
  },
  updateHolderAddress: function updateHolderAddress(state, value) {
    state.holder.address = value;
  },
  updateHolderArea: function updateHolderArea(state, value) {
    state.holder.area = value;
  },
  updateHolderEmail: function updateHolderEmail(state, value) {
    state.holder.email = value;
  },
  updateHolderCAPTCHA: function updateHolderCAPTCHA(state, value) {
    state.holder.CAPTCHA = value;
  },
  updateHolderRealCAPTCHA: function updateHolderRealCAPTCHA(state, value) {
    state.holder.realCAPTCHA = value;
  },
  updateInsuredName: function updateInsuredName(state, value) {
    state.insured.name = value;
  },
  updateInsuredIDNumber: function updateInsuredIDNumber(state, value) {
    state.insured.IDNumber = value;
  },
  updateOrderInsuredValue: function updateOrderInsuredValue(state, value) {
    state.order.insuredValue = value;
  },
  updateOrderInsuranceAmount: function updateOrderInsuranceAmount(state, value) {
    state.order.insuranceAmount = value;
  },
  updateOrderPaymentPeriod: function updateOrderPaymentPeriod(state, value) {
    state.order.paymentPeriod = value;
  },
  updateInsuredBirthday: function updateInsuredBirthday(state, value) {
    state.insured.birthday = value;
  },
  updateOrderInsurancePeriod: function updateOrderInsurancePeriod(state, value) {
    state.order.insurancePeriod = value;
  },
  updateOrderPaymentMethod: function updateOrderPaymentMethod(state, value) {
    state.order.paymentMethod = value;
  },
  updateInsuredSex: function updateInsuredSex(state, value) {
    state.insured.sex = value;
  },
  updateMeasurePayment: function updateMeasurePayment(state, value) {
    state.order.measurePayment = value;
  },
  updatePaymentByIDNumber: function updatePaymentByIDNumber(state, value) {
    state.order.paymentByIDNumber = value;
  },
  updateIDNumberExpire: function updateIDNumberExpire(state, value) {
    state.insured.IDNumberExpire = value;
  },
  updateOrderNumber: function updateOrderNumber(state, value) {
    state.order.number = value;
  },
  updateOrderUnionOrderCode: function updateOrderUnionOrderCode(state, value) {
    state.order.unionOrderCode = value;
  },
  updateOrderOpenId: function updateOrderOpenId(state, value) {
    state.order.openId = value;
  },
  updateOrderName: function updateOrderName(state, value) {
    state.order.name = value;
  },
  updateOrderCompany: function updateOrderCompany(state, value) {
    state.order.company = value;
  },
  updateOrderCountdownTimer: function updateOrderCountdownTimer(state, value) {
    state.order.countdownTimer = value;
  },
  updateMeasureReady: function updateMeasureReady(state, value) {
    state.order.measureReady = value;
  },
  updatePaymentShowNull: function updatePaymentShowNull(state, value) {
    state.order.paymentShowNull = value;
  },
  updateOccupationCode: function updateOccupationCode(state, value) {
    state.insured.occupationCode = value;
  },
  updateOccupationName: function updateOccupationName(state, value) {
    state.insured.occupationName = value;
  },
  updatePositivePicValue: function updatePositivePicValue(state, value) {
    state.holder.positivePicValue = value;
  },
  updateNegativePicValue: function updateNegativePicValue(state, value) {
    state.holder.negativePicValue = value;
  },
  updatePositivePicSrc: function updatePositivePicSrc(state, value) {
    state.holder.positivePicSrc = value;
  },
  updateNegativePicSrc: function updateNegativePicSrc(state, value) {
    state.holder.negativePicSrc = value;
  },
  updateH5Configuration: function updateH5Configuration(state, value) {
    state.h5.configuration = value;
  },
  updateTicketSelectedStatus: function updateTicketSelectedStatus(state, index) {
    if (state.activity.tickets[index].selected) {
      state.activity.tickets[index].selected = false;
    } else {
      var type = state.activity.tickets[index].type;
      state.activity.tickets.forEach(function (ele) {
        if (ele.type === type) {
          ele.selected = false;
        }
      });
      state.activity.tickets[index].selected = true;
    }
  },
  updateActivityTickets: function updateActivityTickets(state, value) {
    value.forEach(function (ele) {
      var t = {};
      t.selected = false;
      for (var i in ele) {
        t[i] = ele[i];
      }
      state.activity.tickets.push(t);
    });
  },
  updateAmountBySelectedTickets: function updateAmountBySelectedTickets(state, value) {
    state.activity.amountBySelectedTickets = value;
  },
  UPDATE_RAWBANKSFROMSERVER: function UPDATE_RAWBANKSFROMSERVER(state, value) {
    console.log(value);
    state.banksFromServer = value;
  },
  UPDATE_BANKSFROMSERVER: function UPDATE_BANKSFROMSERVER(state, value) {
    console.log(value);
    state.wechatpaybanklist = value;
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getQueryString: function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateDiff;
function dateDiff(date) {
  var dateY = date.getFullYear();
  var dateM = date.getMonth();
  var dateD = date.getDate();
  var newDate = new Date(dateY, dateM, dateD);

  var now = new Date();
  var nowY = now.getFullYear();
  var nowM = now.getMonth();
  var nowD = now.getDate();
  var nowDate = new Date(nowY, nowM, nowD);

  var day = parseInt(Math.abs(nowDate - newDate) / 1000 / 60 / 60 / 24);
  if (day === 0) {
    return '今天';
  }
  return day + '天前';
}

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatAudioTiming;


function formatAudioTiming(onlySecond) {
  var duration = Math.floor(onlySecond);
  var minute = Math.floor(duration / 60);
  minute = minute < 10 ? '0' + minute : minute;
  var second = duration % 60;
  second = second < 10 ? '0' + second : second;
  return minute + ':' + second;
}

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAgeFromBirthday__ = __webpack_require__(146);


/* harmony default export */ __webpack_exports__["a"] = (function (id) {
  var result = { sex: null, age: null };
  if (id.length === 18) {
    result.sex = Number(id.substr(16, 1)) % 2 === 1 ? 1 : 0;
    result.age = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getAgeFromBirthday__["a" /* default */])(id.substring(6, 10) + '-' + id.substring(10, 12) + '-' + id.substring(12, 14));
  } else if (id.length === 15) {
    result.sex = Number(id.substr(14, 1)) % 2 === 1 ? 1 : 0;
    result.age = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getAgeFromBirthday__["a" /* default */])('19' + id.substring(6, 8) + '-' + id.substring(8, 10) + '-' + id.substring(10, 12));
  }
  return result;
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  verifyIDNumber: function verifyIDNumber(number) {
    number = number.toUpperCase();
    if (/^\d{15}$/.test(number)) {
      return true;
    }
    if (/^\d{17}(\d|X)$/.test(number)) {
      var code = number.split('');

      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      var last = parity[sum % 11];
      if (last != code[17]) {
        return false;
      }
      return true;
    }
    return false;
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(303);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
  },

  computed: {
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    getLabelStyles: function getLabelStyles() {
      return {
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth,
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: false
    };
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.$refs.input.focus();
            }
          }, 300);
        }
        this.$emit('on-show');
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datetimepicker__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_uuid__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_date_format__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_date_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tools_date_format__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datetime',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_uuid__["a" /* default */]],
  components: {
    Group: __WEBPACK_IMPORTED_MODULE_3__group___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_1__icon___default.a
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();
      });
    }
  },

  computed: {
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide() {
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide');
        },
        onShow: function onShow() {
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      if (this.$t) {
        return this.$t('vux.datetime.' + type + '_text');
      } else {
        return this.$el.getAttribute('data-' + type + '-text');
      }
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new __WEBPACK_IMPORTED_MODULE_2__datetimepicker__["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = __WEBPACK_IMPORTED_MODULE_6__tools_date_format___default()(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      if (this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number]
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inline-desc'
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroller__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flexbox__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chain__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_value2name__ = __webpack_require__(95);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'picker',
  components: {
    Flexbox: __WEBPACK_IMPORTED_MODULE_3__flexbox__["a" /* Flexbox */],
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_3__flexbox__["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](this.data, length, this.fixedColumns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: [Array],
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__filters_value2name__["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;

      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.item_class,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);

      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      this.$set(this.currentValue, i, list[0].value);
      this.renderChain(i + 1);
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);

      if (this.columns !== 0) {
        if (val.length > 0) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);

          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.getValue()) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](newData, length, this.fixedColumns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__picker__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters_array2String__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters_value2name__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_mixin_uuid__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_transfer_dom__ = __webpack_require__(313);













var getObject = function getObject(obj) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup-picker',
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_9__directives_transfer_dom__["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__libs_mixin_uuid__["a" /* default */]],
  components: {
    Picker: __WEBPACK_IMPORTED_MODULE_1__picker___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_2__cell___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_3__popup___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_5__flexbox__["a" /* Flexbox */],
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_5__flexbox__["b" /* FlexboxItem */],
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a
  },
  filters: {
    array2string: __WEBPACK_IMPORTED_MODULE_6__filters_array2String__["a" /* default */],
    value2name: __WEBPACK_IMPORTED_MODULE_7__filters_value2name__["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth || 'auto',
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    value2name: __WEBPACK_IMPORTED_MODULE_7__filters_value2name__["a" /* default */],
    getNameValues: function getNameValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters_value2name__["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      this.showValue = true;
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val)) {
        if (this.value.length) {
          var nowData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val);
          }
          this.currentData = nowData;
        } else {}
      }
      var _val = getObject(val);
      this.$emit('on-shadow-change', _val, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters_value2name__["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tempValue)) {
        this.tempValue = getObject(val);
        this.currentValue = getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', getObject(val));
      this.$emit('on-change', getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: getObject(this.value),
      closeType: false,
      currentData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data),
      showValue: false,
      currentValue: this.value
    };
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_dom__ = __webpack_require__(150);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;

      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].removeClass(document.body, 'vux-modal-open');
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this3 = this;

      this.$emit('input', val);
      if (val) {
        this.popup && this.popup.show();
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');
        this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].addClass(document.body, 'vux-modal-open');
        if (!this.hasFirstShow) {
          this.$emit('on-first-show');
          this.hasFirstShow = true;
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this3.fixSafariOverflowScrolling('touch');
          }
          _this3.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_router__ = __webpack_require__(73);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__libs_router__["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new __WEBPACK_IMPORTED_MODULE_1__swiper_js__["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] };
  },

  watch: {
    list: function list(val) {
      this.rerender();
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(316);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* parentMixin */]],
  props: {
    iconClass: String
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(318);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_name2value__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_value2name__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popup_picker__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popup_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__popup_picker__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-address',
  components: {
    PopupPicker: __WEBPACK_IMPORTED_MODULE_2__popup_picker___default.a
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    show: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters_name2value__["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('Vux: Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filters_value2name__["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filters_value2name__["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filters_name2value__["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(73);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: String
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    classes: function classes() {
      return [{
        'weui-btn_disabled': this.disabled,
        'weui-btn_mini': this.mini
      }, 'weui-btn_' + this.type, this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(317);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
      }
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_base__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_debounce__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vanilla_masker__);















var validators = {
  'email': {
    fn: __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;

    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && !this.currentValue) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tools_debounce__["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__libs_base__["a" /* default */]],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__icon___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_3__toast___default.a
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,

    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      this.$emit('on-focus', this.currentValue, $event);
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          if (!this.firstError) {
            this.getError();
          }
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          if (!this.firstError) {
            this.getError();
          }
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;

      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    var data = {
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false
    };
    return data;
  },

  watch: {
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      this.$emit('input', this.maskValue(newVal));
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-switch',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return {
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: Boolean,
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_base__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autosize__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-textarea',
  minxins: [__WEBPACK_IMPORTED_MODULE_0__libs_base__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }

    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
  },

  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_1__inline_desc___default.a
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,

    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default.a.update(this.$refs.textarea);
    },
    bindAutosize: function bindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default.a.destroy(this.$refs.textarea);
    },
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-agree-iterms',
  props: ['value'],
  data: function data() {
    return {
      checked: true
    };
  },

  methods: {
    changeChecked: function changeChecked() {
      this.$emit('input', this.checked);
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-buy',
  props: ['measureState'],
  data: function data() {
    return {
      h5: h5
    };
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    tel: function tel() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && this.$store.state.h5.configuration.serviceTel !== '') return 'tel:' + this.$store.state.h5.configuration.serviceTel;
      return 'tel:400-661-2992';
    },
    number: function number() {
      if (!this.measureState) {
        return '105';
      } else if (this.measureState) {
        if (this.$store.getters.computMeasurePayment === null) {
          return '105';
        }
        return this.$store.getters.computMeasurePayment;
      }
    },
    measureReady: function measureReady() {
      return this.$store.state.order.measureReady;
    },
    showPoster: function showPoster() {
      var isShare = this.$route.query.isShare;

      var isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) !== -1;
      if (isShare === 'true' || isWKB || this.h5) return false;
      return true;
    },
    posterURL: function posterURL() {
      return window.location.protocol + '//' + window.location.hostname + '/illness/sharePoster?productCode=' + this.$store.state.order.productId + '&innerCode=' + this.$store.state.order.userId;
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-candidate',
  props: ['list', 'value'],
  methods: {
    onClick: function onClick(event) {
      this.$emit('input', event.target.dataset.value);
      this.$emit('change', event.target.dataset.value);
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-cell-group'
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-column',
  props: ['title']
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-evaluation',
  mounted: function mounted() {
    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode);
    document.title = '评论详情';
  },

  computed: {
    message: {
      get: function get() {
        return this.$store.state.holder.message;
      },
      set: function set(value) {
        this.$store.commit('updateHolderMessage', value.trim());
      }
    }
  },
  methods: {
    submitMessage: function submitMessage() {
      var _this = this;

      if (this.$store.state.holder.message.trim() === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，给个好评呗~',
          position: 'top',
          width: '20em'
        });
        return;
      }
      this.$vux.loading.show({
        text: '正在提交'
      });
      this.$http.get('/api/hqdqx/orderQueren/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode).then(function (response) {
        if (response.data === 'error') {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'warn',
            text: '提交失败'
          });
          return;
        }
        var phone = response.data.underwritingInfoList[0].policyHolder.holderPhone;
        _this.$http.get('/api/hqdqx/getAgentUserInfoByPhone/' + phone).then(function (response) {
          var data = {
            nickName: '',
            pingjiaValue: _this.$store.state.holder.message
          };
          if (response.data === 'error' || response.data.name === undefined) {
            data.nickName = phone;
          } else {
            data.nickName = response.data.name;
          }
          _this.$http.get('/api/hqdqx/evaluate/' + _this.$store.state.order.unionOrderCode + '/' + _this.$store.state.order.productId + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
            _this.$vux.loading.hide();
            if (response.data === true) {
              _this.$vux.toast.show({
                type: 'success',
                text: '提交成功'
              });
              _this.$router.push({ name: 'Result', params: { productId: _this.$store.state.order.productId, userId: _this.$store.state.order.userId, unionCode: _this.$store.state.order.unionOrderCode }, query: _this.$route.query });
            } else if (response.data === false) {
              _this.$vux.toast.show({
                type: 'text',
                text: '客官，提交失败',
                position: 'top',
                width: '20em'
              });
            } else {
              _this.$vux.toast.show({
                type: 'text',
                text: '客官，' + response.data.substring(6),
                position: 'top',
                width: '20em'
              });
            }
          });
        });
      });
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_feedbacks__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);





var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-notify',
  mounted: function mounted() {
    var _this = this;

    window.jQuery(window).on('popstate', this.go);
    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode);
    this.$http.get((this.h5 ? '/api/channel/hqdqx/orderQueren/' : '/api/hqdqx/orderQueren/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode).then(function (response) {
      _this.contractNumber = response.data.policyInfo;
      _this.$store.commit('updateOrderName', response.data.busProductRelation.productName);
      _this.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername);
      _this.$store.commit('updateOrderNumber', response.data.busOrder.orderCode);
      _this.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName);
      _this.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber);
      _this.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '');
      _this.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '');
      _this.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '');
      _this.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone);
      _this.$store.commit('updatePaymentByIDNumber', response.data.underwritingInfoList[0].premium / response.data.underwritingInfoList[0].coverageMultiples);
    });
    document.title = '回访确认';

    this.currentProductIndexURL = window.location.pathname + '#/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(this.$route.query);
    this.commonResultURL = '/products/' + this.$store.state.order.productId + '/result?' + (this.h5 ? 'merchantCode' : 'innerCode') + '=' + this.$store.state.order.userId + '&unionCode=' + this.$store.state.order.unionOrderCode + '&indexURL=' + encodeURIComponent(this.currentProductIndexURL);
  },
  destroyed: function destroyed() {
    window.jQuery(window).off('popstate', this.go);
  },
  data: function data() {
    return {
      notifies: __WEBPACK_IMPORTED_MODULE_0__data_feedbacks__["a" /* default */],
      h5: h5,
      contractNumber: null,
      currentProductIndexURL: '',
      commonResultURL: ''
    };
  },

  computed: {
    positivePicValue: {
      get: function get() {
        return this.$store.state.holder.positivePicValue;
      },
      set: function set(value) {
        this.$store.commit('updatePositivePicValue', value);
      }
    },
    negativePicValue: {
      get: function get() {
        return this.$store.state.holder.negativePicValue;
      },
      set: function set(value) {
        this.$store.commit('updateNegativePicValue', value);
      }
    },
    positivePicSrc: function positivePicSrc() {
      return this.$store.state.holder.positivePicSrc;
    },
    negativePicSrc: function negativePicSrc() {
      return this.$store.state.holder.negativePicSrc;
    },
    confirmFeedback: function confirmFeedback() {
      return this.$store.state.order.confirmFeedback;
    },
    needIDCard: function needIDCard() {
      if (this.$store.state.order.paymentPeriod * this.$store.getters.computPaymentByIDNumber > 200000) {
        return true;
      }
      if (false) return true;
      return false;
    }
  },
  methods: {
    go: function go(event) {
      window.history.forward(1);
    },
    changeFeedback: function changeFeedback(value) {
      this.$store.commit('updateOrderConfirmFeedback', value);
    },
    compressImg: function compressImg(dataURI, callback) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var image = new Image();
      image.onload = function () {
        var cw = image.width;
        var ch = image.height;
        var w = image.width;
        var h = image.height;
        canvas.width = w;
        canvas.height = h;
        if (cw > 200 && cw > ch) {
          w = 200;
          h = 200 * ch / cw;
          canvas.width = w;
          canvas.height = h;
        }
        if (ch > 200 && ch > cw) {
          h = 200;
          w = 200 * cw / ch;
          canvas.width = w;
          canvas.height = h;
        }
        ctx.drawImage(image, 0, 0, w, h);
        callback(canvas.toDataURL('image/jpeg', 0.7));
      };
      image.src = dataURI;
    },
    next: function next() {
      var _this2 = this;

      if (!this.needIDCard) {
        this.$vux.loading.show({
          text: '正在提交'
        });
        this.$http.post((this.h5 ? '/api/channel/hqdqx/visitFlag/' : '/api/hqdqx/visitFlag/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode, __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({ visitFlag: this.confirmFeedback ? 1 : 0 })).then(function (response) {
          _this2.$vux.loading.hide();
          if (response.data !== 'success') {
            _this2.$vux.toast.show({
              type: 'text',
              text: '客官，回访信息提交失败',
              position: 'top',
              width: '20em'
            });
            return;
          }

          window.location.href = _this2.commonResultURL;
        });
        return;
      }
      if (this.positivePicValue === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请上传身份证正面照片',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (this.positivePicValue.size >= 3 * 1024 * 1024) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，照片不能超过3M',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (this.negativePicValue === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请上传身份证反面照片',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (this.negativePicValue.size >= 3 * 1024 * 1024) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，照片不能超过3M',
          position: 'top',
          width: '20em'
        });
        return;
      }
      var data = {
        visitFlag: this.confirmFeedback ? 1 : 0,
        holderIdCardPositive: '',
        holderIdCardOpposite: ''
      };
      var reader1 = new FileReader();
      var reader2 = new FileReader();
      var that = this;
      reader1.addEventListener('load', function (event) {
        that.compressImg(event.target.result, function (compressedImg) {
          that.$store.commit('updatePositivePicSrc', event.target.result);
          data.holderIdCardPositive = compressedImg.split(',')[1];
          ready(that, data);
        });
      }, false);
      reader2.addEventListener('load', function (event) {
        that.compressImg(event.target.result, function (compressedImg) {
          that.$store.commit('updateNegativePicSrc', event.target.result);
          data.holderIdCardOpposite = compressedImg.split(',')[1];
          ready(that, data);
        });
      }, false);
      reader1.readAsDataURL(this.positivePicValue);
      reader2.readAsDataURL(this.negativePicValue);

      function ready(that, data) {
        var _this3 = this;

        if (data.holderIdCardPositive !== '' && data.holderIdCardOpposite !== '') {
          that.$vux.loading.show({
            text: '正在提交'
          });
          that.$http.post((this.h5 ? '/api/channel/hqdqx/visitFlag/' : '/api/hqdqx/visitFlag/') + that.$store.state.order.userId + '/' + that.$store.state.order.productId + '/' + that.$store.state.order.unionOrderCode, __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data)).then(function (response) {
            that.$vux.loading.hide();
            if (response.data !== 'success') {
              that.$vux.toast.show({
                type: 'text',
                text: '客官，身份证提交失败',
                position: 'top',
                width: '20em'
              });
              return;
            }

            window.location.href = _this3.commonResultURL;
          });
        }
      }
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verify__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_datas_china_address_v2_json__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_datas_china_address_v2_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_datas_china_address_v2_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);







var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-form',
  mounted: function mounted() {
    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    document.title = '填写投保信息';
    if (this.insuredIDNumber !== '') this.checkInsuredIDNumber();
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },
  data: function data() {
    return {
      ChinaAddressV2Data: __WEBPACK_IMPORTED_MODULE_1_vux_src_datas_china_address_v2_json___default.a,
      CAPTCHACountdown: 0,
      IDNumberValue: true,
      h5: h5,
      showLogin: false,
      channelCode: 2,
      launchData: null,
      url: '',
      arrObj: null,
      arrPara: null,
      arr: null
    };
  },

  computed: {
    IDNumberTitle: function IDNumberTitle() {
      if (this.$store.state.insured.IDNumberExpire === '9999-10-10') {
        this.IDNumberValue = true;
      } else {
        this.IDNumberValue = false;
      }
      return '身份证有效期<span class="IDNumber-content">长期有效</span>';
    },
    CAPTCHALabel: function CAPTCHALabel() {
      if (this.CAPTCHACountdown === 0) {
        return '获取';
      }
      return this.CAPTCHACountdown + '秒';
    },

    IDNumberExpire: {
      get: function get() {
        return this.$store.state.insured.IDNumberExpire;
      },
      set: function set(value) {
        this.$store.commit('updateIDNumberExpire', value);
      }
    },
    limitDate: function limitDate() {
      var d = {
        startDate: '',
        endDate: ''
      };
      var now = new Date();
      var nowYear = now.getUTCFullYear();
      var nowMonth = now.getUTCMonth();
      var nowDate = now.getUTCDate();
      var startDate = new Date(nowYear, nowMonth, nowDate);
      var endDate = new Date(nowYear + 50, nowMonth, nowDate);
      d.startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1 < 10 ? '0' : '') + (startDate.getMonth() + 1) + '-' + (startDate.getDate() < 10 ? '0' : '') + startDate.getDate();
      d.endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1 < 10 ? '0' : '') + (endDate.getMonth() + 1) + '-' + (endDate.getDate() < 10 ? '0' : '') + endDate.getDate();
      return d;
    },

    holderPhoneNumber: {
      get: function get() {
        return this.$store.state.holder.phoneNumber;
      },
      set: function set(value) {
        this.$store.commit('updateHolderPhoneNumber', value.trim());
      }
    },
    holderAddress: {
      get: function get() {
        return this.$store.state.holder.address;
      },
      set: function set(value) {
        this.$store.commit('updateHolderAddress', value.trim());
      }
    },
    holderArea: {
      get: function get() {
        return this.$store.state.holder.area;
      },
      set: function set(value) {
        this.$store.commit('updateHolderArea', value);

        for (var i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
          if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount && this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
            this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value);
            break;
          }
        }
      }
    },
    holderEmail: {
      get: function get() {
        return this.$store.state.holder.email;
      },
      set: function set(value) {
        this.$store.commit('updateHolderEmail', value.trim());
      }
    },
    holderCAPTCHA: {
      get: function get() {
        return this.$store.state.holder.CAPTCHA;
      },
      set: function set(value) {
        this.$store.commit('updateHolderCAPTCHA', value.trim());
      }
    },
    insuredName: {
      get: function get() {
        return this.$store.state.insured.name;
      },
      set: function set(value) {
        this.$store.commit('updateInsuredName', value.trim());
      }
    },
    insuredIDNumber: {
      get: function get() {
        return this.$store.state.insured.IDNumber;
      },
      set: function set(value) {
        this.$store.commit('updateInsuredIDNumber', value.trim().toUpperCase());

        for (var i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
          if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount && this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
            this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value);
            break;
          }
        }
      }
    },
    insuredValue: {
      get: function get() {
        return this.$store.state.order.insuredValue;
      },
      set: function set(value) {
        this.$store.commit('updateOrderInsuredValue', value);
      }
    },
    insuranceAmountsByIDNumber: function insuranceAmountsByIDNumber() {
      return this.$store.getters.insuranceAmountsByIDNumber;
    },

    insuranceAmount: {
      get: function get() {
        return this.$store.state.order.insuranceAmount;
      },
      set: function set(value) {
        this.$store.commit('updateOrderInsuranceAmount', value);
      }
    },
    paymentPeriodsByIDNumber: function paymentPeriodsByIDNumber() {
      return this.$store.getters.paymentPeriodsByIDNumber;
    },

    paymentPeriod: {
      get: function get() {
        return this.$store.state.order.paymentPeriod;
      },
      set: function set(value) {
        this.$store.commit('updateOrderPaymentPeriod', value);
      }
    },
    number: function number() {
      if (this.$store.getters.computPaymentByIDNumber === null) {
        return '105';
      }
      return this.$store.getters.computPaymentByIDNumber;
    },

    orderInsurancePeriod: {
      get: function get() {
        return this.$store.state.order.insurancePeriod;
      },
      set: function set(value) {
        this.$store.commit('updateOrderInsurancePeriod', value);
      }
    },
    insurancePeriods: function insurancePeriods() {
      return this.$store.getters.accessableInsurancePeriodsByIDNumber;
    },
    paymentShowNull: function paymentShowNull() {
      return this.$store.state.order.paymentShowNull;
    },
    occupationCode: function occupationCode() {
      return this.$store.state.insured.occupationCode;
    },
    occupationName: function occupationName() {
      return this.$store.state.insured.occupationName;
    }
  },
  methods: {
    getQueryString: function getQueryString(name) {
      this.url = location.hash;
      this.arrObj = this.url.split('?');
      this.arrPara = this.arrObj[1].split('&');
      for (var i = 0; i < this.arrPara.length; i++) {
        this.arr = this.arrPara[i].split('=');
        if (this.arr[0] === name) {
          if (this.arr != null) return decodeURIComponent(this.arr[1]);
        }
      }
    },
    launchCommon: function launchCommon() {
      if (String(this.$store.state.order.userId) === '148198068433580000') {
        this.channelCode = 1;
      } else if (this.h5 !== false) {
        this.channelCode = 3;
      }
      this.launchData = { anchorCode: 1, channelCode: this.channelCode, linkedProduct: '优爱宝定期寿险', utSource: this.getQueryString('hmsr'), phoneNumber: this.holderPhoneNumber, personName: this.insuredName, identityCard: this.insuredIDNumber, verifyCode: this.holderCAPTCHA };
      console.log(this.launchData);
      this.$http.post('/api/pageView/savePageViewRecord', __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(this.launchData)).then(function (response) {
        console.log(response);
      });
    },
    submitOrder: function submitOrder() {
      var _this = this;

      if (this.checkInsuredName() && this.checkInsuredIDNumber() && this.checkIDNumberExpire() && this.checkHolderPhoneNumber() && this.checkHolderCAPTCHA() && this.checkHolderEmail() && this.checkHolderArea() && this.checkHolderAddress()) {
        var data = {
          'productCode': this.$store.state.order.productId,
          'verificationCode': this.$store.state.holder.CAPTCHA,
          'policyInsuredList[0].coverageMultiples': this.$store.state.order.insuranceAmount + '00',
          'policyInsuredList[0].insurePayWay': this.$store.state.order.paymentPeriod,
          'policyInsuredList[0].durationPeriodType': this.$store.state.order.insurancePeriod === '20' || this.$store.state.order.insurancePeriod === '30' ? '1' : '2',
          'policyInsuredList[0].durationPeriodValue': this.$store.state.order.insurancePeriod,
          'innerCode': this.$store.state.order.userId,
          'policyHolder.holderName': this.insuredName,
          'policyHolder.holderPhone': this.holderPhoneNumber,
          'policyHolder.holderIdType': '1',
          'policyHolder.holderIdNumber': this.insuredIDNumber,
          'policyHolder.holderArea': this.holderArea[0] + ',' + this.holderArea[1] + ',' + this.holderArea[2],
          'policyHolder.holderAddress': this.holderAddress,
          'policyHolder.holderEmail': this.holderEmail,
          'policyHolder.holderIdEffective': this.$store.state.insured.IDNumberExpire,
          'policyHolder.holderOccupation': this.$refs.occupation.getAttribute('code'),
          'policyInsuredList[0].insuredOccupation': this.$refs.occupation.getAttribute('code'),
          'policyInsuredList[0].holdInsRelation': '1',
          'isNeedFillInsued': '1'
        };

        if (this.$route.query.activityCode) {
          data.activityCode = this.$route.query.activityCode;
        }

        if (this.$route.query.agentCode) {
          data.agentCode = this.$route.query.agentCode;
        }

        if (this.$route.query.utm_source) {
          data['orderSource'] = this.$route.query.utm_source;
        }
        if (this.$route.query.utm_media) {
          data['utmMedia'] = this.$route.query.utm_media;
        }
        if (this.$route.query.utm_campaign) {
          data['utmCampaign'] = this.$route.query.utm_campaign;
        }
        if (this.$route.query.utm_term) {
          data['utmTerm'] = this.$route.query.utm_term;
        }
        if (this.$route.query.utm_content) {
          data['utmContent'] = this.$route.query.utm_content;
        }

        if (this.h5) {
          data.merchantCode = this.$store.state.order.userId;
          for (var i in this.$route.query) {
            data[i] = this.$route.query[i];
          }
        }
        this.$store.commit('updateOccupationCode', this.$refs.occupation.getAttribute('code'));
        this.$store.commit('updateOccupationName', this.$refs.occupation.innerText || this.$refs.occupation.textContent);
        this.$vux.loading.show({
          text: '正在提交'
        });
        var goInsurePolicy = '/api/illness/goInsurePolicy';
        if (this.h5) goInsurePolicy = '/api/channel/illness/goInsurePolicy';
        this.$http.post(goInsurePolicy, __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data)).then(function (response) {
          _this.$vux.loading.hide();

          if (response.data.code === 400) {
            _this.showLogin = true;
            return false;
          }
          if (!response.data.unionOrderCode) {
            _this.$vux.toast.show({
              type: 'text',
              text: '客官，' + response.data.substring(6),
              position: 'top',
              width: '20em'
            });
            return false;
          }
          _this.$store.commit('updateOrderNumber', response.data.orderInfo[0].orderCode);
          _this.$store.commit('updateOrderUnionOrderCode', response.data.unionOrderCode);
          _this.$store.commit('updateOrderCountdownTimer', 1800);
          _this.$router.push({ name: 'Order', params: { productId: _this.$store.state.order.productId, userId: _this.$store.state.order.userId, unionCode: _this.$store.state.order.unionOrderCode }, query: _this.$route.query });
        });
      }
    },
    changeIDNumberExpire: function changeIDNumberExpire() {
      if (this.IDNumberValue) {
        this.$store.commit('updateIDNumberExpire', '9999-10-10');
        this.IDNumberValue = true;
      } else {
        this.$store.commit('updateIDNumberExpire', '');
        this.IDNumberValue = false;
      }
    },
    checkIDNumberExpire: function checkIDNumberExpire() {
      if (this.IDNumberExpire === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请选择身份证有效期',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkHolderPhoneNumber: function checkHolderPhoneNumber() {
      if (this.holderPhoneNumber === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入手机号',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (!/^1[23456789]\d{9}$/.test(this.holderPhoneNumber)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入手机号',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkHolderCAPTCHA: function checkHolderCAPTCHA() {
      if (this.holderCAPTCHA === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入验证码',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (!/^\d{4}$/.test(this.holderCAPTCHA)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入验证码',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (this.checkHolderPhoneNumber()) {
        this.launchCommon();
      }
      return true;
    },
    sendCAPTCHA: function sendCAPTCHA() {
      var _this2 = this;

      if (this.checkHolderPhoneNumber()) {
        var that = this;
        var utmSourcePhone = 'wechat170913';
        var random = Math.random();
        var needBusParam = this.holderPhoneNumber + '?utm_source_phone=' + utmSourcePhone + '&v=' + random;
        var sendMessageCode = '/api/common/sendMessageCodeNew/' + this.holderPhoneNumber + '?v=' + random + '&serviceName=' + window.hex_md5(needBusParam);
        if (this.h5) sendMessageCode = '/api/channel/illness/sendMessageCodeNew/' + this.$route.params.productId + '/' + this.$route.params.userId + '/' + this.holderPhoneNumber;
        this.$http.get(sendMessageCode).then(function (response) {
          if (response.data.statusCode == '000000') {
            that.CAPTCHACountdown = 60;
            var CAPTCHATimer = setInterval(function () {
              if (that.CAPTCHACountdown === 0) {
                clearInterval(CAPTCHATimer);
              } else {
                that.CAPTCHACountdown--;
              }
            }, 1000);
            that.$store.commit('updateHolderRealCAPTCHA', response.data.statusCode);
          } else {
            _this2.$vux.toast.show({
              type: 'text',
              text: response.data.statusMsg,
              position: 'top',
              width: '20em'
            });
          }
        });
      }
    },
    checkHolderEmail: function checkHolderEmail() {
      if (this.holderEmail === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入个人电子邮箱',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.holderEmail)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入个人电子邮箱',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkHolderArea: function checkHolderArea() {
      if (this.holderArea.length === 0) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请选择所在地区',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkHolderAddress: function checkHolderAddress() {
      if (this.holderAddress === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入详细地址',
          position: 'top',
          width: '20em'
        });
        return false;
      }

      var holderAddressChineseCount = 0;
      for (var i = 0; i < this.holderAddress.length; i++) {
        if (/[\u4E00-\u9FA5]/.test(this.holderAddress[i])) {
          holderAddressChineseCount++;
        }
      }
      if (holderAddressChineseCount < 6) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，详细地址需大于等于6个汉字',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (this.holderAddress.match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) !== null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入详细地址',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkInsuredName: function checkInsuredName() {
      if (this.insuredName === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入投保姓名',
          position: 'top',
          width: '20em'
        });
        return false;
      }

      if (!/^[\u4E00-\u9FA5]{2,12}$/.test(this.insuredName)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请填写正确的投保姓名',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkInsuredIDNumber: function checkInsuredIDNumber() {
      if (this.insuredIDNumber === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请填写身份证号',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateOrderInsuranceAmount', '3');
        this.$store.commit('updateOrderPaymentPeriod', '20');
        this.$store.commit('updateOrderInsurancePeriod', '20');
        this.$store.commit('updatePaymentShowNull', true);
        return false;
      }

      if (!__WEBPACK_IMPORTED_MODULE_0__utils_verify__["a" /* default */].verifyIDNumber(this.insuredIDNumber)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请填写正确的身份证号',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateOrderInsuranceAmount', '3');
        this.$store.commit('updateOrderPaymentPeriod', '20');
        this.$store.commit('updateOrderInsurancePeriod', '20');
        this.$store.commit('updatePaymentShowNull', true);
        this.$store.commit('updatePaymentByIDNumber', null);
        return false;
      }

      if (this.$store.getters.ageFromIDNumber > 60 || this.$store.getters.ageFromIDNumber < 18) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，投保年龄18周岁-60周岁哦',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateOrderInsuranceAmount', '3');
        this.$store.commit('updateOrderPaymentPeriod', '20');
        this.$store.commit('updateOrderInsurancePeriod', '20');
        this.$store.commit('updatePaymentShowNull', false);
        this.$store.commit('updatePaymentByIDNumber', null);
        return false;
      }

      for (var i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
        if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount && this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
          this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value);
          break;
        }
      }

      for (var _i = 0; _i <= this.$store.getters.accessableInsurancePeriodsByIDNumber.length - 1; _i++) {
        if (this.$store.getters.accessableInsurancePeriodsByIDNumber[_i].value === this.$store.state.order.insurancePeriod && this.$store.getters.accessableInsurancePeriodsByIDNumber[_i].accessable === false) {
          this.$store.commit('updateOrderInsurancePeriod', '70');

          if (this.$store.getters.accessableInsurancePeriodsByIDNumber[0].accessable) {
            this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByIDNumber[0].value);
          } else if (this.$store.getters.accessableInsurancePeriodsByIDNumber[3].accessable) {
            this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByIDNumber[3].value);
          } else {
            this.$store.commit('updateOrderInsurancePeriod', '70');
          }
        }
      }

      for (var _i2 = this.$store.getters.paymentPeriodsByIDNumber.length - 1; _i2 >= 0; _i2--) {
        if (this.$store.getters.paymentPeriodsByIDNumber[_i2].value === this.$store.state.order.paymentPeriod && this.$store.getters.paymentPeriodsByIDNumber[_i2].accessable === false) {
          this.$store.commit('updateOrderPaymentPeriod', this.$store.getters.paymentPeriodsByIDNumber[_i2 - 1].value);
        }
      }
      var that = this;
      this.$store.commit('updatePaymentShowNull', true);
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPaymentByIDNumber(that);
      return true;
    },
    changePaymentPeriod: function changePaymentPeriod() {
      if (this.$store.getters.ageFromIDNumber === null) {
        return;
      }
      var that = this;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPaymentByIDNumber(that);
    },
    changeInsurancePeriod: function changeInsurancePeriod() {
      if (this.$store.getters.ageFromIDNumber === null) {
        return;
      }
      var that = this;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPaymentByIDNumber(that);
    },
    closeLogin: function closeLogin() {
      this.showLogin = false;
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello'
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Voice_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Voice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Voice_vue__);





var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-intro',
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__Voice_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_1__Voice_vue___default.a),
  data: function data() {
    return {
      h5: h5
    };
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    showMedia: function showMedia() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && Number(this.$store.state.h5.configuration.homeMedia) === 0) return false;
      return true;
    },
    VSSrc: function VSSrc() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) return 'static/images/channel_vs.png';
      return 'static/images/vs.png';
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-login',
  data: function data() {
    return {
      holderPhone: '',
      holderPhoneCAPTCHA: '',
      CAPTCHACountdown: 0
    };
  },

  computed: {
    show2: function show2() {
      return this.showLogin;
    },
    CAPTCHALabel: function CAPTCHALabel() {
      if (this.CAPTCHACountdown === 0) {
        return '获取';
      }
      return this.CAPTCHACountdown + '秒';
    }
  },
  props: ['showLogin'],
  methods: {
    onCancel: function onCancel() {
      this.$emit('close');
    },
    onConfirm: function onConfirm() {
      var _this = this;

      var data = {
        'phoneNum': this.holderPhone,
        'messageValidCode': this.holderPhoneCAPTCHA
      };
      this.$http.post('/api/user/bind', __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
        console.log(response.data);
        if (response.data.result === 'true') {
          _this.$vux.toast.show({
            type: 'text',
            text: '客官，' + response.data.msg,
            position: 'top',
            width: '20em'
          });
          _this.$emit('close');
        } else {
          _this.$vux.toast.show({
            type: 'text',
            text: '客官，登录失败',
            position: 'top',
            width: '20em'
          });
        }
      });
    },
    sendCAPTCHA: function sendCAPTCHA() {
      var _this2 = this;

      if (this.checkHolderPhone()) {
        var that = this;
        this.$http.get('/api/common/getvalidatecodeForH5').then(function (response) {
          var sendMessageCode = '/api/common/sendMessageCodeDefault/' + response.data + '/' + _this2.holderPhone;
          _this2.$http.get(sendMessageCode).then(function (response) {
            console.log(response.data);
            if (response.data.statusCode == '000000') {
              that.CAPTCHACountdown = 60;
              var CAPTCHATimer = setInterval(function () {
                if (that.CAPTCHACountdown === 0) {
                  clearInterval(CAPTCHATimer);
                } else {
                  that.CAPTCHACountdown--;
                }
              }, 1000);
            } else {
              _this2.$vux.toast.show({
                type: 'text',
                text: '客官，获取验证码失败',
                position: 'top',
                width: '20em'
              });
            }
          });
        });
      }
    },
    checkHolderPhone: function checkHolderPhone() {
      if (this.holderPhone === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入手机号',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (!/^1[34578]\d{9}$/.test(this.holderPhone)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入手机号',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkHolderPhoneCAPTCHA: function checkHolderPhoneCAPTCHA() {
      if (this.holderPhoneCAPTCHA === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入验证码',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      if (!/^\d{4}$/.test(this.holderPhoneCAPTCHA)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入验证码',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_datas_china_address_v2_json__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_datas_china_address_v2_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_datas_china_address_v2_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-measure',
  data: function data() {
    return {
      ChinaAddressV2Data: __WEBPACK_IMPORTED_MODULE_0_vux_src_datas_china_address_v2_json___default.a
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      return function () {
        _this.$refs.measureBody.style.maxHeight = window.innerHeight - 120 + 'px';
      }();
    };

    if (this.insuredBirthday !== '') this.getMeasurePayment();
  },

  computed: {
    insuredValue: {
      get: function get() {
        return this.$store.state.order.insuredValue;
      }
    },
    insuredBirthday: {
      get: function get() {
        return this.$store.state.insured.birthday;
      },
      set: function set(value) {
        this.$store.commit('updateInsuredBirthday', value);
      }
    },
    holderArea: {
      get: function get() {
        return this.$store.state.holder.area;
      },
      set: function set(value) {
        this.$store.commit('updateHolderArea', value);

        for (var i = this.$store.getters.insuranceAmountsByBirthday.length - 1; i >= 0; i--) {
          if (this.$store.getters.insuranceAmountsByBirthday[i].value === this.$store.state.order.insuranceAmount && this.$store.getters.insuranceAmountsByBirthday[i].accessable === false) {
            this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByBirthday[0].value);
            break;
          }
        }
      }
    },
    sexs: function sexs() {
      return this.$store.getters.sexs;
    },

    sex: {
      get: function get() {
        return this.$store.state.insured.sex;
      },
      set: function set(value) {
        this.$store.commit('updateInsuredSex', value);
      }
    },
    insuranceAmountsByBirthday: function insuranceAmountsByBirthday() {
      return this.$store.getters.insuranceAmountsByBirthday;
    },

    insuranceAmount: {
      get: function get() {
        return this.$store.state.order.insuranceAmount;
      },
      set: function set(value) {
        this.$store.commit('updateOrderInsuranceAmount', value);
      }
    },
    paymentPeriodsByBirthday: function paymentPeriodsByBirthday() {
      return this.$store.getters.paymentPeriodsByBirthday;
    },

    paymentPeriod: {
      get: function get() {
        return this.$store.state.order.paymentPeriod;
      },
      set: function set(value) {
        this.$store.commit('updateOrderPaymentPeriod', value);
      }
    },
    insurancePeriods: function insurancePeriods() {
      return this.$store.getters.accessableInsurancePeriodsByBitthday;
    },

    orderInsurancePeriod: {
      get: function get() {
        return this.$store.state.order.insurancePeriod;
      },
      set: function set(value) {
        this.$store.commit('updateOrderInsurancePeriod', value);
      }
    },
    paymentMethods: function paymentMethods() {
      return this.$store.getters.accessablePaymentMethods;
    },

    orderPaymentMethod: {
      get: function get() {
        return this.$store.state.order.paymentMethod;
      },
      set: function set(value) {
        this.$store.commit('updateOrderPaymentMethod', value);
      }
    },
    birthdayPlaceholder: function birthdayPlaceholder() {
      return '被保险人年龄(18周岁-60周岁)';
    },
    limitDate: function limitDate() {
      return this.$store.getters.limitDate;
    },
    candidateInsureds: function candidateInsureds() {
      return this.$store.getters.candidateInsureds;
    }
  },
  methods: {
    onForWho: function onForWho(value) {
      this.$store.commit('updateInsuredBirthday', '');
      this.$store.commit('updateForWhoValue', value);
    },
    onBirthday: function onBirthday(value) {
      this.$store.commit('updatePaymentPeriod', '10');
      this.$store.commit('updateInsuredBirthday', value);
    },
    onSex: function onSex(value) {
      this.$store.commit('updateInsuredSex', value);
    },
    onAmount: function onAmount(value) {
      this.$store.commit('updateAmount', value);
    },
    onPaymentPeriod: function onPaymentPeriod(value) {
      this.$store.commit('updatePaymentPeriod', value);
    },
    onJobChange: function onJobChange(value) {
      this.$store.commit('updateJob', value);
    },
    getMeasurePayment: function getMeasurePayment(value) {
      this.$store.commit('updateInsuredBirthday', value);

      for (var i = this.$store.getters.insuranceAmountsByBirthday.length - 1; i >= 0; i--) {
        if (this.$store.getters.insuranceAmountsByBirthday[i].value === this.$store.state.order.insuranceAmount && this.$store.getters.insuranceAmountsByBirthday[i].accessable === false) {
          this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByBirthday[0].value);
          break;
        }
      }

      for (var _i = 0; _i <= this.$store.getters.accessableInsurancePeriodsByBitthday.length - 1; _i++) {
        if (this.$store.getters.accessableInsurancePeriodsByBitthday[_i].value === this.$store.state.order.insurancePeriod && this.$store.getters.accessableInsurancePeriodsByBitthday[_i].accessable === false) {
          if (this.$store.getters.accessableInsurancePeriodsByBitthday[0].accessable) {
            this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByBitthday[0].value);
          } else if (this.$store.getters.accessableInsurancePeriodsByBitthday[3].accessable) {
            this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByBitthday[3].value);
          } else {
            this.$store.commit('updateOrderInsurancePeriod', '70');
          }
        }
      }

      for (var _i2 = this.$store.getters.paymentPeriodsByBirthday.length - 1; _i2 >= 0; _i2--) {
        if (this.$store.getters.paymentPeriodsByBirthday[_i2].value === this.$store.state.order.paymentPeriod && this.$store.getters.paymentPeriodsByBirthday[_i2].accessable === false) {
          this.$store.commit('updateOrderPaymentPeriod', this.$store.getters.paymentPeriodsByBirthday[_i2 - 1].value);
        }
      }
      if (this.$store.getters.ageFromBirthday === null) {
        return;
      }
      var that = this;
      this.$store.commit('updateMeasureReady', true);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getMeasurePayment(that);
    },
    changeSex: function changeSex() {
      if (this.$store.getters.ageFromBirthday === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，不选择年龄无法测算保费',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateMeasureReady', false);
        return;
      }
      var that = this;
      this.$store.commit('updateMeasureReady', true);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getMeasurePayment(that);
    },
    changeAmountsByBirthday: function changeAmountsByBirthday() {
      if (this.$store.getters.ageFromBirthday === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，不选择年龄无法测算保费',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateMeasureReady', false);
        return;
      }
      this.$store.commit('updateMeasureReady', true);

      if (this.$route.query.calculationCode && this.$route.query.calculationCode !== null) {
        console.log(this.$route.query.calculationCode);
        var that = this;
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getMeasurePayment(that);
      }
    },
    changePaymentPeriod: function changePaymentPeriod() {
      if (this.$store.getters.ageFromBirthday === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，不选择年龄无法测算保费',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateMeasureReady', false);
        return;
      }
      var that = this;
      this.$store.commit('updateMeasureReady', true);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getMeasurePayment(that);
    },
    changeInsurancePeriod: function changeInsurancePeriod() {
      if (this.$store.getters.ageFromBirthday === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，不选择年龄无法测算保费',
          position: 'top',
          width: '20em'
        });
        this.$store.commit('updateMeasureReady', false);
        return;
      }
      var that = this;
      this.$store.commit('updateMeasureReady', true);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getMeasurePayment(that);
    },
    stopPropagation: function stopPropagation(e) {
      console.log(e);
      e.stopPropagation();
      e.prevent;
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dateDiff__ = __webpack_require__(248);





var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-message',
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
    var data = {
      'productsCode': this.$route.params.productId,
      'page.currentPage': ++this.currentPage,
      'page.showCount': 10
    };
    var evaluationPageURL = '/api/baokuan/evaluationPage';
    if (this.h5) evaluationPageURL = '/api/baokuan/evaluationPage';
    this.$http.get(evaluationPageURL + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
      _this.totalNumber = response.data.page.totalResult;
      _this.totalPage = Math.ceil(response.data.page.totalResult / 10);
      response.data.dataList.forEach(function (ele) {
        if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
          var s1 = ele.utTdnick.substr(0, 3);
          var s2 = ele.utTdnick.substr(8, 4);
          ele.utTdnick = s1 + '****' + s2;
        }
        _this.allMessages.push({ user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime) });
      });
      setTimeout(function () {
        _this.$emit('on-messageReady');
      }, 300);
    });
  },
  data: function data() {
    return {
      showMoreState: true,
      currentPage: 0,
      totalPage: 0,
      totalNumber: 0,
      allMessages: [],
      h5: h5
    };
  },

  computed: {
    messages: function messages() {
      this.allMessages.forEach(function (ele) {
        if (typeof ele.date !== 'string') {
          ele.date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dateDiff__["a" /* default */])(ele.date);
        }
      });
      if (this.showMoreState) {
        return this.allMessages.slice(0, (this.currentPage - 1) * 10 + 4);
      } else {
        return this.allMessages;
      }
    },
    moreTips: function moreTips() {
      if (this.showMoreState) {
        return '查看更多(' + (this.totalNumber - (this.currentPage - 1) * 10 - 4) + ')';
      } else {
        return '收起全部';
      }
    }
  },
  methods: {
    showMore: function showMore() {
      var _this2 = this;

      if (this.currentPage >= this.totalPage && this.showMoreState === true) {
        this.showMoreState = false;
        return;
      }
      if (this.showMoreState === false) {
        this.currentPage = 1;
        this.allMessages = this.allMessages.slice(0, 10);
        this.showMoreState = true;
        return;
      }
      var data = {
        'productsCode': this.$route.params.productId,
        'page.currentPage': ++this.currentPage,
        'page.showCount': 10
      };
      this.$http.get('/api/baokuan/evaluationPage?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
        response.data.dataList.forEach(function (ele) {
          if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
            var s1 = ele.utTdnick.substr(0, 3);
            var s2 = ele.utTdnick.substr(8, 4);
            ele.utTdnick = s1 + '****' + s2;
          }
          _this2.allMessages.push({ user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime) });
        });
        if (_this2.messages.length === _this2.totalNumber) {
          _this2.showMoreState = false;
        }
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_healthyNotifies__ = __webpack_require__(237);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-notify',
  mounted: function mounted() {
    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    document.title = '被保险人告知';
  },
  data: function data() {
    return {
      fit: '',
      notifies: __WEBPACK_IMPORTED_MODULE_0__data_healthyNotifies__["a" /* default */]
    };
  },

  methods: {
    next: function next() {
      if (this.fit !== true && this.fit !== false) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请确认被保险人是否具有以上情况',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (this.fit === false) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，您的告知不符合投保要求，谢谢惠顾',
          position: 'top',
          width: '20em'
        });
        return;
      }
      this.$router.push({ name: 'Form', params: { productId: this.$store.state.order.productId, userId: this.$store.state.order.userId }, query: this.$route.query });
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-occupation'
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Window__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Cookie__ = __webpack_require__(145);






var h5 = false;

var timer = null;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-order',
  data: function data() {
    return {
      agreeTerms: true,
      Window: __WEBPACK_IMPORTED_MODULE_1__utils_Window__["a" /* default */],
      h5: h5,
      showTicket: false,
      isUseCoupon: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);


    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode);

    var data = {};
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode;
    }
    this.$http.get((this.h5 ? '/api/channel/hqdqx/orderQueren/' : '/api/hqdqx/orderQueren/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
      _this.$store.commit('updateOrderName', response.data.busProductRelation.productName);
      _this.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername);
      _this.$store.commit('updateOrderNumber', response.data.busOrder.orderCode);
      _this.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName);
      _this.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber);
      _this.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '');
      _this.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '');
      _this.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '');
      _this.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone);
      _this.$store.commit('updatePaymentByIDNumber', response.data.underwritingInfoList[0].premium / response.data.underwritingInfoList[0].coverageMultiples);
      _this.isUseCoupon = response.data.isUseCoupon === 1;
      var passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000);
      var countdownTimer = 1800 - passSeconds;
      _this.$store.commit('updateOrderCountdownTimer', countdownTimer < 0 ? 0 : countdownTimer);
      timer = setInterval(function () {
        if (_this.$store.state.order.countdownTimer <= 0) {
          clearInterval(timer);
        }
        _this.$store.commit('updateOrderCountdownTimer', _this.$store.state.order.countdownTimer - 1);
      }, 1000);

      if (_this.$store.state.activity.tickets.length === 0) {
        _this.$http.post('/api/coupon/getUserValidCouponCount', __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({ 'productCode': _this.$store.state.order.productId, orderCode: response.data.underwritingInfoList[0].orderCode, 'openid': __WEBPACK_IMPORTED_MODULE_2__utils_Cookie__["a" /* default */].getCookie('session_wechat_user_openid') })).then(function (response) {
          if (response.data.data && response.data.data.length > 0) {
            _this.$store.commit('updateActivityTickets', response.data.data);
          }
        });
      }
    });
    document.title = '订单确认';
  },
  destroyed: function destroyed() {
    clearInterval(timer);
  },

  computed: {
    orderName: function orderName() {
      return this.$store.state.order.name;
    },
    orderCompany: function orderCompany() {
      return this.$store.state.order.company;
    },
    orderNumber: function orderNumber() {
      return this.$store.state.order.number;
    },
    holderName: function holderName() {
      return this.$store.state.holder.name;
    },
    holderIDNumber: function holderIDNumber() {
      return this.$store.state.holder.IDNumber;
    },
    insuredName: function insuredName() {
      return this.$store.state.insured.name;
    },
    insuredIDNumber: function insuredIDNumber() {
      return this.$store.state.insured.IDNumber;
    },
    insuranceAmountName: function insuranceAmountName() {
      return this.$store.getters.insuranceAmountName;
    },
    paymentPeriodName: function paymentPeriodName() {
      return this.$store.getters.paymentPeriodName;
    },
    insurancePeriodName: function insurancePeriodName() {
      return this.$store.getters.insurancePeriodName;
    },
    paymentMethodName: function paymentMethodName() {
      return this.$store.getters.paymentMethodName;
    },
    paymentByIDNumber: function paymentByIDNumber() {
      return this.$store.getters.computPaymentByIDNumber;
    },
    beneficiary: function beneficiary() {
      return this.$store.state.order.beneficiary;
    },
    tickedBtnText: function tickedBtnText() {
      if (this.$store.getters.selectedTickets.length > 0) {
        return '您已使用' + this.$store.getters.selectedTickets.length + '张券,已优惠' + this.$store.state.activity.amountBySelectedTickets + '元';
      }
      return '有' + this.$store.state.activity.tickets.length + '张可用';
    }
  },
  methods: {
    payNow: function payNow() {
      var _this2 = this;

      if (this.$store.state.order.countdownTimer <= 0) {
        var that = this;
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm: function onConfirm() {
            that.$router.push({ name: 'Form', params: { productId: that.$store.state.order.productId, userId: that.$store.state.order.userId }, query: that.$route.query });
          }
        });
        return;
      }

      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意相关内容后再试',
          position: 'top',
          width: '20em'
        });
        return;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });

      var judgeURL = (this.h5 ? '/api/channel/illness/judgeInsurance/' : '/api/illness/judgeInsurance/') + this.$store.state.order.unionOrderCode;
      judgeURL += '?innerCode=' + this.$store.state.order.userId;
      if (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) {
        if (this.$store.getters.selectedTickets.length > 0) {
          var coupons = '';
          this.$store.getters.selectedTickets.forEach(function (ele) {
            coupons += ele.couponCode + ',';
          });
          coupons = coupons.substring(0, coupons.length - 1);
          judgeURL += '&coupons=' + coupons;
        }
        judgeURL += '&openid=' + __WEBPACK_IMPORTED_MODULE_2__utils_Cookie__["a" /* default */].getCookie('session_wechat_user_openid');
      }
      this.$http.get(judgeURL).then(function (response) {
        _this2.$vux.loading.hide();
        if (response.data[0].undwrtStatus === 0) {
          _this2.$vux.toast.show({
            type: 'text',
            text: '客官，正在核保中，请稍后再试',
            position: 'top',
            width: '20em'
          });
          return;
        }
        if (response.data[0].undwrtStatus === 2) {
          _this2.$vux.alert.show({
            title: '核保失败',
            content: response.data[0].undwrtMsg || '核保超时',
            buttonText: '知道了'
          });
          return;
        }
        _this2.$router.push({ name: 'Pay', params: { productId: _this2.$store.state.order.productId, userId: _this2.$store.state.order.userId, unionCode: _this2.$store.state.order.unionOrderCode }, query: _this2.$route.query });
      });
    },
    showTickets: function showTickets() {
      if (this.$store.state.activity.tickets.length > 0) {
        this.showTicket = true;
        return;
      }
      this.$vux.toast.show({
        type: 'text',
        text: '客官，您没有可用的优惠券',
        position: 'top',
        width: '20em'
      });
    },
    ticketType: function ticketType(value) {
      if (value === 1) {
        return '现金券';
      } else if (value === 2) {
        return '折扣券';
      } else if (value === 5) {
        return '现金券';
      } else if (value === 6) {
        return '折扣券';
      }
    },
    ticketValue: function ticketValue(type, value) {
      if (type === 1 || type === 5) {
        return value / 100 + '元';
      } else if (type === 2 || type === 6) {
        return value / 10 + '折';
      }
    },
    selectTicket: function selectTicket(index) {
      var _this3 = this;

      this.$store.commit('updateTicketSelectedStatus', index);

      if (this.$store.getters.selectedTickets.length === 0) {
        this.$store.commit('updateAmountBySelectedTickets', 0);
        return;
      }
      var data = { coupons: '', orderSum: this.paymentByIDNumber * 100, openid: __WEBPACK_IMPORTED_MODULE_2__utils_Cookie__["a" /* default */].getCookie('session_wechat_user_openid') };
      this.$store.getters.selectedTickets.forEach(function (ele) {
        data.coupons += ele.couponCode + ',';
      });
      data.coupons = data.coupons.substring(0, data.coupons.length - 1);
      this.$http.post('/api/coupon/calcUserChoseCoupon', __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
        _this3.$store.commit('updateAmountBySelectedTickets', Number(response.data) / 100);
      });
    },
    sureTicket: function sureTicket() {
      this.showTicket = false;
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-panel',
  props: ['close', 'title', 'label']
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Window__ = __webpack_require__(94);





var h5 = false;
var timer = null;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-pay',
  data: function data() {
    return {
      bankList: [],
      banksFromServerData: [],
      agreeTerms: true,
      ticketDialog: false,
      productBackMoney: 0,
      couponsName: '',
      actualPrice: 0,
      thisPrice: 0,
      backMoney: 0,
      h5: h5,
      Window: __WEBPACK_IMPORTED_MODULE_1__utils_Window__["a" /* default */],
      productCode: location.host === 'test.m.wkbins.com' ? '149673981474815463' : '149674766585200396',
      currentProductIndexURL: '',
      commonResultURL: ''
    };
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/api/bank/quota/getListByProductsCode?productCode=' + this.productCode).then(function (response) {
      var banksFromServer = response.data;
      _this2.banksFromServerData = banksFromServer.data;

      if ((banksFromServer.result === 'true' || banksFromServer.result === true) && banksFromServer.data.length > 0) {
        banksFromServer.data.forEach(function (ele) {
          _this2.bankList.push({ name: ele.bankName, value: ele.bankCode });
        });
      }
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode);

    this.currentProductIndexURL = window.location.pathname + '#/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(this.$route.query);
    this.commonResultURL = '/products/' + this.$store.state.order.productId + '/result?' + (this.h5 ? 'merchantCode' : 'innerCode') + '=' + this.$store.state.order.userId + '&unionCode=' + this.$store.state.order.unionOrderCode + '&indexURL=' + encodeURIComponent(this.currentProductIndexURL);

    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
    var data = {};
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode;
    }
    this.$http.get((this.h5 ? '/api/channel/hqdqx/orderQueren/' : '/api/hqdqx/orderQueren/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
      _this3.$store.commit('updateOrderName', response.data.busProductRelation.productName);
      _this3.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername);
      _this3.$store.commit('updateOrderNumber', response.data.busOrder.orderCode);
      _this3.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName);
      _this3.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber);
      _this3.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '');
      _this3.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '');
      _this3.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '');
      _this3.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone);

      _this3.thisPrice = response.data.underwritingInfoList[0].premium / 100;
      _this3.actualPrice = response.data.actualPrice / 100;
      _this3.productBackMoney = response.data.productBackMoney;
      _this3.backMoney = response.data.backMoney;
      _this3.couponsName = response.data.couponsName;
      var passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000);
      var countdownTimer = 1800 - passSeconds;
      _this3.$store.commit('updateOrderCountdownTimer', countdownTimer < 0 ? 0 : countdownTimer);
      timer = setInterval(function () {
        if (_this3.$store.state.order.countdownTimer <= 0) {
          clearInterval(timer);
        }
        _this3.$store.commit('updateOrderCountdownTimer', _this3.$store.state.order.countdownTimer - 1);
      }, 1000);
    });
    document.title = '支付详情';
  },
  destroyed: function destroyed() {
    clearInterval(timer);
  },

  computed: {
    orderNumber: function orderNumber() {
      return this.$store.state.order.number;
    },
    orderName: function orderName() {
      return this.$store.state.order.name;
    },
    paymentByIDNumber: function paymentByIDNumber() {
      return this.$store.getters.computPaymentByIDNumber;
    },
    insuredName: function insuredName() {
      return this.$store.state.insured.name;
    },
    insuredIDNumber: function insuredIDNumber() {
      return this.$store.state.insured.IDNumber;
    },
    holderPhoneNumber: function holderPhoneNumber() {
      return this.$store.state.holder.phoneNumber;
    },

    bankName: {
      get: function get() {
        console.log(this.$store.state.holder.bankName);
        return this.$store.state.holder.bankName;
      },
      set: function set(value) {
        console.log(value);
        console.log(this.$store.state.holder.bankName);
        this.$store.commit('updateHolderBankName', value);
      }
    },
    bankCardNumber: {
      get: function get() {
        return this.$store.state.holder.bankCardNumber;
      },
      set: function set(value) {
        this.$store.commit('updateHolderBankCardNumber', value);
      }
    }
  },
  methods: {
    payWithWX: function payWithWX() {
      var price = this.actualPrice || this.thisPrice;

      for (var i = 0; i < this.banksFromServerData.length; i++) {
        console.log(this.banksFromServerData[i].bankCode, this.bankName[0], price, this.banksFromServerData[i].bankSingleQuota / 100);
        if (this.banksFromServerData[i].bankCode === this.bankName[0] && price > this.banksFromServerData[i].bankSingleQuota / 100) {
          return true;
        }
      }
      return false;
    },
    openNewWindow: function openNewWindow(url) {
      window.open(url);
    },
    submitPay: function submitPay() {
      var _this4 = this;

      if (this.bankName.length === 0) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请选择银行',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (this.bankCardNumber.length === 0) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入银行卡号',
          position: 'top',
          width: '20em'
        });
        return;
      }

      if (!(this.bankCardNumber.length > 14 && this.bankCardNumber.length < 20)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入银行卡号',
          position: 'top',
          width: '20em'
        });
        return;
      }
      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意支付授权声明后再试',
          position: 'top',
          width: '20em'
        });
        return;
      }
      var data = {
        orderCode: this.$store.state.order.number,
        innerCode: this.$store.state.order.userId,
        bankCode: this.$store.state.holder.bankName[0],
        hengqinBankCode: this.$store.getters.bankCode,
        bankCardNum: this.$store.state.holder.bankCardNumber
      };
      if (this.$route.query.activityCode) {
        data.activityCode = this.$route.query.activityCode;
      }
      if (this.$store.state.order.countdownTimer <= 0) {
        var that = this;
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm: function onConfirm() {
            that.$router.push({ name: 'Form', params: { productId: that.$store.state.order.productId, userId: that.$store.state.order.userId }, query: that.$route.query });
          }
        });
        return;
      }

      this.$vux.loading.show({
        text: '正在支付'
      });
      if (this.payWithWX()) {
        if (this.isWX()) {
          data.payWay = 1;
        } else {
          data.payWay = 12;
        }
      }
      this.$http.post('/api/pay/baofooPayWithholdFresh/' + this.$store.state.order.unionOrderCode + '/' + this.$store.state.order.userId, __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data)).then(function (response) {
        _this4.$vux.loading.hide();

        if (response.data === 302) {
          _this4.$http.get('/api/pay/bankcard/check?' + 'bankCode=' + _this4.bankName[0] + '&bankCardNum=' + _this4.bankCardNumber + '&unionOrderCode=' + _this4.$store.state.order.unionOrderCode).then(function (response) {
            var _this = _this4;
            var resultdata = response.data;
            if (resultdata.code === 'false') {
              _this.$vux.confirm.show({
                title: '提示',
                content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + resultdata.msg + '</p>',
                confirmText: '咨询客服',
                cancelText: '取消',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  window.location.href = 'tel:400-661-2992';
                }
              });
            } else {
              window.location.href = '/common/wxpay?order=' + _this.$store.state.order.unionOrderCode + '&redirect_uri=' + encodeURIComponent(_this.commonResultURL) + '&pay_uri=' + encodeURIComponent(window.location.href);
            }
          });
          return false;
        }
        if (response.data !== true) {
          _this4.$vux.confirm.show({
            title: '提示',
            content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + response.data.substring(6) + '</p>',
            confirmText: '咨询客服',
            cancelText: '取消',
            onCancel: function onCancel() {},
            onConfirm: function onConfirm() {
              window.location.href = 'tel:400-661-2992';
            }
          });

          return false;
        }

        window.location.href = _this4.commonResultURL;
      });
    },
    showTicketDialog: function showTicketDialog() {
      this.ticketDialog = true;
    },
    isWX: function isWX() {
      return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);




var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-process',
  data: function data() {
    return {
      AppConfig: __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */],
      h5: h5
    };
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    lipeiliucheng: function lipeiliucheng() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) {
        return '保险公司<a href="tel:400-69-12345">400-69-12345</a>申请协助';
      }
      return '致电悟空保<a href="tel:400-661-2992">400-661-2992</a>或保险公司<a href="tel:400-69-12345">400-69-12345</a>申请协助';
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductHeader_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProductHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductNav_vue__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProductNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Intro_vue__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Intro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Question_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Question_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Question_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Message_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Process_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Process_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Process_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buy_vue__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Buy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Measure_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Measure_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Measure_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_URL__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_Cookie__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_Window__ = __webpack_require__(94);


var _components;















var code = __WEBPACK_IMPORTED_MODULE_11__utils_URL__["a" /* default */].getQueryString('code');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-product',
  data: function data() {
    return {
      codeOK: false,
      showWhat: false,

      showFixedNav: false,
      scrollTop: 0,
      navOffsetTop: 0,
      nav1OffsetTop: 0,
      nav2OffsetTop: 0,
      nav3OffsetTop: 0,
      nav4OffsetTop: 0,
      active: {},
      scrollTo: 0,
      measureState: false,
      showAgent: false,
      agentName: '',
      agentJobNum: '',
      show: false };
  },

  computed: {
    h5: function h5() {
      if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
        return true;
      }
      return false;
    },
    isDailiren: function isDailiren() {
      var isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) !== -1;
      if (!this.h5 && !isWKB) {
        return true;
      }
      return false;
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    if (this.$store.state.activity.status && __WEBPACK_IMPORTED_MODULE_13__utils_Window__["a" /* default */].isWX() && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) {
      var cacheOpenId = __WEBPACK_IMPORTED_MODULE_12__utils_Cookie__["a" /* default */].getCookie('session_wechat_user_openid');
      var redirectUri = this.$store.state.activity.redirectURL + '/#/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/?' + __WEBPACK_IMPORTED_MODULE_10_qs___default.a.stringify(this.$route.query);
      if (this.$route.query.activityCode) {
        redirectUri += '?activityCode=' + this.$route.query.activityCode;
      }
      var authorizationURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$store.state.activity.appid + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=code&scope=snsapi_base#wechat_redirect';
      if (cacheOpenId === null) {
        if (code === null) {
          window.location.href = authorizationURL;
        } else {
          this.$http.get('/api/interface/getOpenIdByCode?code=' + code).then(function (response) {
            if (response.data.openid) {
              _this.codeOK = true;
              __WEBPACK_IMPORTED_MODULE_12__utils_Cookie__["a" /* default */].setCookie('session_wechat_user_openid', response.data.openid);
            } else {
              window.location.href = authorizationURL;
            }
          });
        }
      } else {
        this.codeOK = true;
      }
    } else {
      this.codeOK = true;
    }

    var agentCode = this.$route.query.agentCode;
    var supAgentCode = this.$route.query.supAgentCode;


    var shareData = {};
    shareData.title = '至尊保之优爱宝定期寿险';
    shareData.desc = '性价比完胜香港保险 按需灵活投保 保障最优 价格最低 后顾无忧';
    shareData.link = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + '#/' + this.$route.params.userId + '/' + this.$route.params.productId;

    shareData.imgUrl = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/wechat_share.png';

    var url = encodeURIComponent(window.location.href.replace(/#.+$/, ''));
    if (this.h5) {
      document.title = '至尊保定期寿险';

      __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].getH5Configuration(this).then(function (data) {
        _this.show = true;
        if (data !== null) {
          shareData.title = _this.$store.state.h5.configuration.shareTitle || '至尊保之优爱宝定期寿险';
          shareData.desc = _this.$store.state.h5.configuration.shareDesc || '性价比完胜香港保险 按需灵活投保 保障最优 价格最低 后顾无忧';
          shareData.link = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + '#/' + _this.$route.params.userId + '/' + _this.$route.params.productId + '/?' + __WEBPACK_IMPORTED_MODULE_10_qs___default.a.stringify(_this.$route.query);
          shareData.imgUrl = _this.$store.state.h5.configuration.shareImgurl || window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/wechat_share.png';
          _this.$wechat.ready(function () {
            if (_this.showAgent) {
              _this.$wechat.hideMenuItems({
                menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone']
              });
            }

            _this.$wechat.onMenuShareAppMessage({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareTimeline({
              title: shareData.title,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareQQ({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareWeibo({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });
          });
          _this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(function (response) {
            _this.$wechat.config({
              debug: false,
              appId: response.data.appId,
              timestamp: response.data.timestamp,
              nonceStr: response.data.nonceStr,
              signature: response.data.signature,
              jsApiList: ['hideMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] });
          });
        } else {
          if (_this.showAgent) {
            _this.$wechat.hideMenuItems({
              menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone']
            });
          }
          _this.$wechat.ready(function () {
            _this.$wechat.onMenuShareAppMessage({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareTimeline({
              title: shareData.title,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareQQ({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });

            _this.$wechat.onMenuShareWeibo({
              title: shareData.title,
              desc: shareData.desc,
              link: shareData.link,
              imgUrl: shareData.imgUrl });
          });
          _this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(function (response) {
            _this.$wechat.config({
              debug: false,
              appId: response.data.appId,
              timestamp: response.data.timestamp,
              nonceStr: response.data.nonceStr,
              signature: response.data.signature,
              jsApiList: ['hideMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] });
          });
        }
      });
    } else {
      this.show = true;

      if (this.isDailiren) {
        shareData.link += '?isShare=true&isProspectus=true';
      }
      this.$wechat.ready(function () {
        _this.$wechat.onMenuShareAppMessage({
          title: shareData.title,
          desc: shareData.desc,
          link: shareData.link,
          imgUrl: shareData.imgUrl });

        _this.$wechat.onMenuShareTimeline({
          title: shareData.title,
          link: shareData.link,
          imgUrl: shareData.imgUrl });

        _this.$wechat.onMenuShareQQ({
          title: shareData.title,
          desc: shareData.desc,
          link: shareData.link,
          imgUrl: shareData.imgUrl });

        _this.$wechat.onMenuShareWeibo({
          title: shareData.title,
          desc: shareData.desc,
          link: shareData.link,
          imgUrl: shareData.imgUrl });
      });
      this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(function (response) {
        _this.$wechat.config({
          debug: false,
          appId: response.data.appId,
          timestamp: response.data.timestamp,
          nonceStr: response.data.nonceStr,
          signature: response.data.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] });
      });
      this.$http.get('/api/hqdqx/getAgentUserInfo/' + this.$store.state.order.userId).then(function (response) {
        document.title = (response.data.authorityStatus === 3 && response.data.name || response.data.nickname || response.data.phone) + '推荐：至尊保定期寿险';
      });
    }
  },
  destroyed: function destroyed() {},

  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__ProductHeader_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_1__ProductHeader_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__ProductNav_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_2__ProductNav_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__Process_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_6__Process_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__Message_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_5__Message_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__Question_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_4__Question_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__Intro_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_3__Intro_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__Buy_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_7__Buy_vue___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8__Measure_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_8__Measure_vue___default.a), _components),
  methods: {
    onScroll: function onScroll(scrollTop) {
      this.scrollTop = scrollTop;
      this.navOffsetTop = this.$refs.nav.offsetTop;
      this.nav1OffsetTop = this.$refs.nav1.$el.offsetTop;
      this.nav2OffsetTop = this.$refs.nav2.$el.offsetTop;
      this.nav3OffsetTop = this.$refs.nav3.$el.offsetTop;
      this.nav4OffsetTop = this.$refs.nav4.$el.offsetTop;
      this.active = { nav1: this.nav1OffsetTop, nav2: this.nav2OffsetTop, nav3: this.nav3OffsetTop, nav4: this.nav4OffsetTop, scroller: this.$refs.scroller.$el.querySelector('.scroller') };
    },
    reActiveNav: function reActiveNav() {
      var _this2 = this;

      setTimeout(function () {
        _this2.navOffsetTop = _this2.$refs.nav.offsetTop;
        _this2.nav1OffsetTop = _this2.$refs.nav1.$el.offsetTop;
        _this2.nav2OffsetTop = _this2.$refs.nav2.$el.offsetTop;
        _this2.nav3OffsetTop = _this2.$refs.nav3.$el.offsetTop;
        _this2.nav4OffsetTop = _this2.$refs.nav4.$el.offsetTop;
        _this2.active = { nav1: _this2.nav1OffsetTop, nav2: _this2.nav2OffsetTop, nav3: _this2.nav3OffsetTop, nav4: _this2.nav4OffsetTop, scroller: _this2.$refs.scroller.$el.querySelector('.scroller') };
      }, 100);
    },
    recordScroll: function recordScroll() {
      localStorage.setItem('scroll', 'true');
      localStorage.setItem('scrollTo', this.scrollTop);
    },
    onClickNav: function onClickNav(data) {
      this.scrollTo = this.$refs[data].$el.offsetTop;
      this.$refs.scroller.$el.querySelector('.scroller').scrollTop = this.scrollTo - 50;
    },
    onClickBuy: function onClickBuy() {
      console.log(this.measureState);
      this.measureState = !this.measureState;
      if (!this.measureState) {
        this.$router.push({ name: 'Notify', params: { productId: this.$store.state.order.productId, userId: this.$store.state.order.userId }, query: this.$route.query });
      }
    },
    messageReady: function messageReady() {
      if (localStorage.getItem('scroll')) {
        this.scrollTo = localStorage.getItem('scrollTo');
        this.$refs.scroller.$el.querySelector('.scroller').scrollTop = this.scrollTo;
        localStorage.removeItem('scroll');
      }
    },
    onShowWhat: function onShowWhat() {
      this.showWhat = true;
    },
    onCloseWhat: function onCloseWhat() {
      this.showWhat = false;
    },
    checkAgentName: function checkAgentName() {
      if (this.agentName === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入姓名',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    checkAgentJobNum: function checkAgentJobNum() {
      if (this.agentJobNum === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入工号',
          position: 'top',
          width: '20em'
        });
        return false;
      }
      return true;
    },
    onConfirmAgent: function onConfirmAgent() {
      if (!this.checkAgentName() || !this.checkAgentJobNum()) return;
      this.showAgent = false;
      if (window.location.href.indexOf('agentCode') !== -1) {
        window.location.href = window.location.href.replace(/agentCode.*?(?=(&|$))/, 'agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum));
        window.location.reload();
      } else {
        window.location.href = window.location.href + '&agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum);
        window.location.reload();
      }
    },
    onCloseFollowWX: function onCloseFollowWX() {
      this.followWX = false;
      localStorage.setItem(this.currentHref, 'activated');
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);




var h5 = false;

var isYuandan = false;
var now = Date.now();
var yuandan = new Date(2018, 0, 1).getTime();
if (now > yuandan) {
  isYuandan = true;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-product-header',
  data: function data() {
    return {
      h5: h5,
      inActivity: false,
      activityId: '151019418799579',
      isYuandan: isYuandan
    };
  },
  created: function created() {
    var _this = this;

    this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(function (response) {
      if (response.data.resultCode === 'error') {
        _this.inActivity = false;
      } else {
        _this.inActivity = true;
      }
    });
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    banner: function banner() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && this.$store.state.h5.configuration.homeBanner) return this.$store.state.h5.configuration.homeBanner;
      return __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.root + __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.banner + '?productCode=' + this.$store.state.order.productId + '&innerCode=' + this.$store.state.order.userId + '&utm_source=' + (this.$route.query.utm_source || '');
    },
    isWKB: function isWKB() {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) === -1) {
        return false;
      }
      return true;
    },
    activityURL: function activityURL() {
      return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2018/jixiangsanbao';
    },
    wkbLogo: function wkbLogo() {
      if (this.h5 && this.homeLogoDisplay && this.$store.state.h5.configuration.homeLogoWkb) {
        return this.$store.state.h5.configuration.homeLogoWkb;
      }
      return __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.root + __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.wkbLogo;
    },
    partnerLogo: function partnerLogo() {
      if (this.h5 && this.homeLogoDisplay && this.$store.state.h5.configuration.homeLogoHengqin) {
        return this.$store.state.h5.configuration.homeLogoHengqin;
      }
      return __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.root + __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].images.partnerLogo;
    },
    homeLogoDisplay: function homeLogoDisplay() {
      if (this.$store.state.h5.configuration.homeLogoDisplay === 0 && this.h5) {
        return false;
      }
      return true;
    },
    hidePartnerLogo: function hidePartnerLogo() {
      if (this.$store.state.h5.configuration.homeLogoDisplay === 2 && this.h5) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-product-nav',
  props: ['scroll-top', 'offset-top', 'active', 'show'],
  data: function data() {
    return {
      navs: __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].navs
    };
  },

  computed: {
    fixed: function fixed() {
      if (this.scrollTop > this.offsetTop) {
        this.$emit('fixedNavChange', true);
        return true;
      }
      this.$emit('fixedNavChange', false);
      return false;
    },
    activeNav: function activeNav() {
      if (this.scrollTop >= this.active.nav4 - 50 || this.active.scroller && this.scrollTop + this.active.scroller.clientHeight === this.active.scroller.scrollHeight) {
        return 'nav4';
      } else if (this.scrollTop >= this.active.nav3 - 50) {
        return 'nav3';
      } else if (this.scrollTop >= this.active.nav2 - 50) {
        return 'nav2';
      } else if (this.scrollTop >= this.active.nav1 - 50) {
        return 'nav1';
      }
    }
  },
  methods: {
    onClickNav: function onClickNav(event) {
      this.$emit('clickNav', event.target.dataset.ref);
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);




var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-question',
  data: function data() {
    return {
      showMore: false,
      h5: h5
    };
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    allQuestions: function allQuestions() {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) return __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].h5Questions;
      return __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].questions;
    },
    questions: function questions() {
      if (this.showMore) {
        return this.allQuestions;
      } else {
        return this.allQuestions.slice(0, 2);
      }
    },
    moreTips: function moreTips() {
      if (this.showMore) {
        return '收起全部';
      } else {
        return '查看更多(' + (this.allQuestions.length - 2) + ')';
      }
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);






var h5 = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-result',
  created: function created() {
    var _this2 = this;

    delete this.$route.query.activityCode;

    this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(function (response) {
      if (response.data.resultCode === 'error') {
        _this2.inActivity = false;
      } else {
        _this2.inActivity = true;
      }
    });

    this.$http.get('/api/activity/getDiscountInfoByProduct?handOutNode=4&productCode=' + this.$route.params.productId).then(function (response) {
      if (response.data.resultCode === 'success') {
        _this2.jdCardValue = response.data.data;
        _this2.hasJDCard = true;
      }
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    var _this = this;
    if (this.$store.state.app.innerCode === '148198068433580000') {
      var utmSource = _this.$route.query.utm_source;
      if (!utmSource || utmSource === 'wechat' || utmSource === 'wx') {
        utmSource = 'wechat';
      }
      var orderQuerenURL = '/api/hqdqx/orderQueren/';
      if (this.h5) {
        orderQuerenURL = '/api/channel/hqdqx/orderQueren/';
      }
      this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode).then(function (response) {
        window._hmt.push(['_trackOrder', {
          'orderId': response.data.busOrder.orderCode,
          'orderTotal': response.data.underwritingInfoList[0].premium / 100,
          'item': [{
            'skuId': _this.$store.state.app.productCode,
            'skuName': response.data.busProductRelation.productName,
            'category': utmSource,
            'Price': response.data.underwritingInfoList[0].premium / 100,
            'Quantity': 1
          }] }]);
      });
    }
    window.jQuery(window).on('popstate', this.go);
    this.$store.commit('updateProductId', this.$route.params.productId);
    this.$store.commit('updateUserId', this.$route.params.userId);

    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode);
    document.title = '提交详情';

    setTimeout(function () {
      _this3.changeSwiperPositon();
    }, 500);
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.$route.query.requireJsApi = true;
      this.h5 = true;
    }
    if (!this.h5) {
      this.show = true;
    } else {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getH5Configuration(this).then(function (data) {
        if (!_this3.$store.state.h5.configuration.isNull && data.successFinalPage === 'submitSucc') {
          _this3.show = true;
          _this3.successFinalPage = true;
        } else if (!_this3.$store.state.h5.configuration.isNull && data.successUrl !== '') {
          window.location.replace(data.successUrl);
        } else {
          _this3.show = true;
        }
      });
    }
  },
  destroyed: function destroyed() {
    window.jQuery(window).off('popstate', this.go);
  },
  data: function data() {
    return {
      index: 0,
      show: false,
      successFinalPage: false,
      h5: h5,
      hasJDCard: false,
      jdCardValue: '0元京东卡',
      inActivity: false,
      activityId: '151019418799579'
    };
  },

  computed: {
    isWKB: function isWKB() {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) === -1) {
        return false;
      }
      return true;
    },
    activity1111DrawURL: function activity1111DrawURL() {
      return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2017/1111-draw';
    },
    xPath: function xPath() {
      if (window.location.pathname.indexOf('insurePolicy') !== -1) {
        return 'activityProduct';
      }
      return 'illness';
    },
    swiperList: function swiperList() {
      return [{
        img: 'static/images/zxb_banner.png',
        url: this.h5 ? window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '152411995379088878' : '152524346503451854') + '/' + this.$route.params.userId + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query) : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '152411995379088878' : '152524346503451854') + '?requireJsApi=true'
      }, {
        img: 'static/images/nianjinxian_banner.png',
        url: window.location.protocol + '//' + window.location.hostname + '/' + 'explosions/#/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '151013300258317638' : '151072428587363110') + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query)
      }, {
        img: 'static/images/xiaoqinbao_banner.png',
        url: window.location.protocol + '//' + window.location.hostname + '/' + 'explosions/#/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '150831059068987214' : '150840325766681140') + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query)
      }, {
        img: 'static/images/aeonlife_zhongji.png',
        url: window.location.protocol + '//' + window.location.hostname + '/' + 'explosions/#/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '150476691002746473' : '150537492578996275') + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query)
      }, {
        img: 'static/images/dread_disease_banner.png',
        url: this.h5 ? window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149559395942738681' : '149614236499831794') + '/' + this.$route.params.userId + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query) : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149559395942738681' : '149614236499831794') + '?requireJsApi=true'
      }, {
        img: 'static/images/hqdy_recommen_banner.png',
        url: window.location.protocol + '//' + window.location.hostname + '/' + 'hqdy/#/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149792907872138096' : '149792885824813849') + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query)
      }, {
        img: 'static/images/bybs_banner.png',
        url: this.h5 ? window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149301981977264138' : '149421366832021029') + '/' + this.$route.params.userId + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query) : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149301981977264138' : '149421366832021029') + '?requireJsApi=true'
      }, {
        img: 'static/images/life_banner.png',
        url: this.h5 ? window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149146529095616548' : '149251955998404923') + '/' + this.$route.params.userId + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query) : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149146529095616548' : '149251955998404923') + '?requireJsApi=true'
      }, {
        img: 'static/images/accident_banner.png',
        url: this.h5 ? window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149173252548863780' : '149329577605090390') + '/' + this.$route.params.userId + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.$route.query) : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (__WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].app.test ? '149173252548863780' : '149329577605090390') + '?requireJsApi=true'
      }];
    },
    tip: function tip() {
      if (this.$store.state.order.confirmFeedback) {
        return '如果您在回访问卷中点选为“否”或未进行在线回访，保险公司的客服将以电话方式再次和您确认回访内容，来电号码为0756-6997966，请保持手机畅通；';
      }
      return '如果您在回访问卷中点选为“否”或未进行在线回访，保险公司的客服将以电话方式再次和您确认回访内容，来电号码为0756-6997966，请保持手机畅通；';
    }
  },
  methods: {
    go: function go(event) {
      window.history.forward(1);
    },
    changeSwiperPositon: function changeSwiperPositon() {
      var height = window.jQuery('.vux-slider').height() / 2;
      window.jQuery('.left-nav, .right-nav').css({ top: height + 'px', opacity: 0.3 });
    },
    goEvaluation: function goEvaluation() {
      var _this4 = this;

      this.$http.get('/api/hqdqx/findEvaluate/' + this.$store.state.order.unionOrderCode).then(function (response) {
        if (response.data) {
          _this4.$vux.toast.show({
            type: 'text',
            text: '客官，不能重复评价哦',
            position: 'top',
            width: '20em'
          });
        } else {
          _this4.$router.push({ name: 'Evaluation', params: { productId: _this4.$store.state.order.productId, userId: _this4.$store.state.order.userId, unionCode: _this4.$store.state.order.unionOrderCode }, query: _this4.$route.query });
        }
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-tab-layout'
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-timer-tip',
  computed: {
    timerTip: function timerTip() {
      if (this.$store.state.order.countdownTimer <= 0) {
        return '支付逾期订单已取消，请重新下单';
      }
      return '请在<span>' + this.$store.getters.formatCountdownTimer.minute + '</span>分<span>' + this.$store.getters.formatCountdownTimer.second + '</span>秒' + '内完成支付，逾期订单将自动取消';
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_formatAudioTiming__ = __webpack_require__(249);





var h5 = false;

var playAudioTimer = null;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-voice',
  data: function data() {
    return {
      audio: __WEBPACK_IMPORTED_MODULE_0__config_app__["a" /* default */].audio,
      isPlaying: false,
      currentAudioTime: '01:11',
      h5: h5
    };
  },
  mounted: function mounted() {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true;
    }
  },

  computed: {
    wx: function wx() {
      if (this.isPlaying) {
        return 'static/images/wx_voice_active.gif';
      } else {
        return 'static/images/wx_voice.png';
      }
    },
    onOff: function onOff() {
      if (this.isPlaying) {
        return 'static/images/audio_start.png';
      } else {
        return 'static/images/audio_pause.svg';
      }
    }
  },
  methods: {
    play: function play() {
      var _this = this;

      this.isPlaying = !this.isPlaying;
      if (this.isPlaying) {
        this.$refs.audio.play();
        playAudioTimer = setInterval(function () {
          _this.currentAudioTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_formatAudioTiming__["a" /* default */])(_this.$refs.audio.currentTime);
          if (_this.$refs.audio.ended) {
            _this.isPlaying = false;
            clearInterval(playAudioTimer);
          }
        }, 1000);
      } else {
        this.$refs.audio.pause();
        clearInterval(playAudioTimer);
      }
    },
    getAudioDuration: function getAudioDuration() {
      if (this.h5) return;
      this.currentAudioTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_formatAudioTiming__["a" /* default */])(this.$refs.audio.duration);
    }
  }
});

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tabbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('confirm', {
    attrs: {
      "value": _vm.show2,
      "title": "登录",
      "close-on-confirm": false
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm
    }
  }, [_c('group', [_c('x-input', {
    attrs: {
      "max": 11,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机号",
      "placeholder": "请输入手机号码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhone
    },
    model: {
      value: (_vm.holderPhone),
      callback: function($$v) {
        _vm.holderPhone = $$v
      },
      expression: "holderPhone"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 4,
      "keyboard": "number",
      "show-clear": false,
      "title": "验证码",
      "placeholder": "请输入手机验证码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhoneCAPTCHA
    },
    model: {
      value: (_vm.holderPhoneCAPTCHA),
      callback: function($$v) {
        _vm.holderPhoneCAPTCHA = $$v
      },
      expression: "holderPhoneCAPTCHA"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCAPTCHA($event)
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-layout"
  }, [_c('div', {
    ref: "scroller",
    staticClass: "scroller",
    on: {
      "scroll": function () {
        this$1.$emit('scroll', this$1.$refs.scroller.scrollTop)
      }
    }
  }, [_vm._t("scroller")], 2), _vm._v(" "), _c('div', [_vm._t("tab")], 2)])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-datetime weui-cell",
    class: {
      'weui-cell_access': !_vm.readonly
    },
    attrs: {
      "data-cancel-text": '取消',
      "data-confirm-text": '确定',
      "href": "javascript:"
    }
  }, [_vm._t("default", [_c('div', [_vm._t("title", [_c('p', {
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft vux-cell-primary vux-datetime-value",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [(!_vm.currentValue && _vm.placeholder) ? _c('span', {
    staticClass: "vux-cell-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.currentValue) ? _c('span', {
    staticClass: "vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.valid),
      expression: "!valid"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": _vm.firstError
    }
  })], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: [_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']
  })
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical',
        'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("尊敬的"), _c('a', [_vm._v(_vm._s(this.$store.state.insured.name))]), _vm._v("先生/女士，您好！感谢您选择了横琴人寿"), _c('a', [_vm._v(_vm._s(this.$store.state.order.name))]), _vm._v("保险产品，"), _vm._v("为保障您的权益，请您详细阅读并确认下列问题：")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, [_c('li', [_vm._v("1. 电子保单上所填写的信息是否为您本人填写并正确无误？")]), _vm._v(" "), _c('li', [_vm._v("2. 您是否已阅读并理解《人身保险投保提示书》，投保单及投保时的各项资料?  ")]), _vm._v(" "), _c('li', [_vm._v("3. 您对于合同条款，特别是保险责任、责任免除、保险期间等相关内容是否确认已清楚了解？")]), _vm._v(" "), _c('li', [_vm._v("4. 您是否清楚自您收到电子保险单次日起，享有10天的犹豫期，在犹豫期内您可以无条件解除保险合同。犹豫期后解除保险合同您会有一定的损失，我公司将按照合同约定退还保单的现金价值？")]), _vm._v(" "), _c('li', [_vm._v("5. 您所购买产品的缴费期间是"), _c('a', [_vm._v(_vm._s(this.$store.state.order.paymentPeriod) + "年")]), _vm._v("，缴费频率是"), _c('a', [_vm._v("每年")]), _vm._v("，保险期间为"), _c('a', [_vm._v(_vm._s((this.$store.state.order.insurancePeriod == '20' || this.$store.state.order.insurancePeriod == '30') ? this.$store.state.order.insurancePeriod + '年' : '至' + this.$store.state.order.insurancePeriod + '周岁'))]), _vm._v("，每期缴纳保费"), _c('a', [_vm._v(_vm._s(this.$store.getters.computPaymentByIDNumber) + "元")]), _vm._v("。请问您是否清楚？")]), _vm._v(" "), _c('li', [_vm._v("提示您，请确认您投保时留下的基本身份信息、联系电话、地址准确、完整、有效。您有关信息的真实有效将直接影响您保单权益得到切实保障。如果您的联系方式需要变更，可拨打我公司全国统一客服热线400-69-12345通知我们，对于您不清楚的内容，我司会尽快通过全国客服热线与您联系为您详细讲解，谢谢！")])]), _vm._v(" "), (_vm.needIDCard) ? _c('div', [_c('p', {
    staticClass: "tip"
  }, [_vm._v("根据国家反洗钱法规定，您必须上传投保人身份证正反面")]), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "上传身份证正面照片",
      "imgSrc": _vm.positivePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.positivePicValue),
      callback: function($$v) {
        _vm.positivePicValue = $$v
      },
      expression: "positivePicValue"
    }
  }), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "placeholder": "上传身份证反面照片",
      "imgSrc": _vm.negativePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.negativePicValue),
      callback: function($$v) {
        _vm.negativePicValue = $$v
      },
      expression: "negativePicValue"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.confirmFeedback === true
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(true)
      }
    }
  }, [_vm._v("是，我已全部确认")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.confirmFeedback === false
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(false)
      }
    }
  }, [_vm._v("否，我需要电话回访")])]), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("确认提交")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.title)), _vm._t("label")], 2), _vm._v(" "), (_vm.close) ? _c('span', {
    staticClass: "right",
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("×")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": _vm.changeChecked,
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('icon', {
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('span', [_vm._v("提交成功")])], 1), _vm._v(" "), (!_vm.successFinalPage) ? _c('m-column', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px"
    },
    attrs: {
      "title": "爆款推荐"
    }
  }, [_c('div', {
    staticClass: "recommendation",
    slot: "body"
  }, [_c('swiper', {
    attrs: {
      "auto": "",
      "loop": "",
      "aspect-ratio": 260 / 702,
      "interval": 8000,
      "list": _vm.swiperList,
      "show-desc-mask": false,
      "dots-position": "center"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left-nav",
    on: {
      "click": function($event) {
        _vm.index = _vm.index - 1 < 0 ? _vm.swiperList.length - 1 : _vm.index - 1
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "right-nav",
    on: {
      "click": function($event) {
        _vm.index = _vm.index + 1 > _vm.swiperList.length - 1 ? 0 : _vm.index + 1
      }
    }
  }, [_vm._v(">")]), _vm._v(" "), (_vm.index === 0) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("年轻人的第一款国民级年金险"), _c('span', [_vm._v("¥500.00/月起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("无需健康告知")]), _vm._v(" "), _c('span', [_vm._v("满5年后开始领取")]), _vm._v(" "), _c('span', [_vm._v("领取直至终身")]), _vm._v(" "), _c('span', [_vm._v("身故至少返还保费")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 1) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("孝亲宝老年恶性肿瘤疾病保险"), _c('span', [_vm._v("¥461.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("癌症全面保障")]), _vm._v(" "), _c('span', [_vm._v("45-75岁均可保")]), _vm._v(" "), _c('span', [_vm._v("无需体检")]), _vm._v(" "), _c('span', [_vm._v("三高可投保")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 2) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("【轻症豁免版】至尊保重疾险"), _c('span', [_vm._v("¥180.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("保障病种高达130种")]), _vm._v(" "), _c('span', [_vm._v("轻症确诊后额外赔付")]), _vm._v(" "), _c('span', [_vm._v("不影响重疾保障")]), _vm._v(" "), _c('span', [_vm._v("且豁免后期所有保费")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 3) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("【升级轻症版】至尊保重大疾病保险"), _c('span', [_vm._v("¥414.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("保障覆盖131种常见疾病（81种重疾+50种轻症）")]), _vm._v(" "), _c('span', [_vm._v("价格超低")]), _vm._v(" "), _c('span', [_vm._v("确诊即赔")]), _vm._v(" "), _c('span', [_vm._v("保障终身")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 4) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优护宝定期意外险"), _c('span', [_vm._v("¥249.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("价格行业最低")]), _vm._v(" "), _c('span', [_vm._v("免检保额最高")]), _vm._v(" "), _c('span', [_vm._v("按需灵活投保")]), _vm._v(" "), _c('span', [_vm._v("责任涵盖伤残")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 5) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("百医百顺百万医疗险"), _c('span', [_vm._v("¥117.00起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("百万保额")]), _vm._v(" "), _c('span', [_vm._v("百元价格")]), _vm._v(" "), _c('span', [_vm._v("投保三年")]), _vm._v(" "), _c('span', [_vm._v("可续保到百岁")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 6) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优爱宝终身寿险"), _c('span', [_vm._v("¥270.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("首创交至百岁")]), _vm._v(" "), _c('span', [_vm._v("免检保额最高")]), _vm._v(" "), _c('span', [_vm._v("价格行业最低")]), _vm._v(" "), _c('span', [_vm._v("责任涵盖全残")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 7) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优护宝终身意外险"), _c('span', [_vm._v("¥240.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("首创终身意外险")]), _vm._v(" "), _c('span', [_vm._v("老有所保")]), _vm._v(" "), _c('span', [_vm._v("涵盖意外身故")]), _vm._v(" "), _c('span', [_vm._v("全残和伤残")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.successFinalPage) ? _c('div', {
    staticClass: "wkb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("温馨提示：")]), _vm._v(" "), _c('p', [_vm._v("1、" + _vm._s(_vm.tip))]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (!_vm.successFinalPage) ? _c('div', {
    staticClass: "btns"
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goEvaluation($event)
      }
    }
  }, [_vm._v("我要评价")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Product',
        params: {
          productId: this.$store.state.order.productId,
          userId: this.$store.state.order.userId
        },
        query: this.$route.query.activityCode ? '' : this.$route.query
      }
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("再次购买")])], 1), _vm._v(" "), _vm._m(2)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wkb-wx"
  }, [_c('img', {
    attrs: {
      "src": "static/images/wkb_wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("更多爆款产品，请关注悟空保微信号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2、关注悟空保微信号"), _c('a', [_vm._v("iwukongbao")]), _vm._v("，点击底部“我的”菜单>个人中心，用投保手机号登录查看投保详情。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("悟空保客服热线："), _c('a', {
    attrs: {
      "id": "tel-ask-about",
      "href": "tel:400-661-2992"
    }
  }, [_vm._v("400-661-2992")])])
}]}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('x-textarea', {
    attrs: {
      "show-counter": "",
      "max": 360,
      "rows": 8,
      "placeholder": "客官，给产品写个好评吧~"
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitMessage($event)
      }
    }
  }, [_vm._v("提交评价")])], 1)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-slider"
  }, [_c('div', {
    staticClass: "vux-swiper",
    style: ({
      height: _vm.xheight
    })
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "vux-swiper-item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.clickListItem(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('div', {
      staticClass: "vux-img",
      style: ({
        backgroundImage: _vm.buildBackgroundUrl(item)
      })
    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
      staticClass: "vux-swiper-desc"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.listTwoLoopItem), function(item, index) {
    return (_vm.listTwoLoopItem.length > 0) ? _c('div', {
      staticClass: "vux-swiper-item vux-swiper-item-clone",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.clickListItem(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('div', {
      staticClass: "vux-img",
      style: ({
        backgroundImage: _vm.buildBackgroundUrl(item)
      })
    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
      staticClass: "vux-swiper-desc"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDots),
      expression: "showDots"
    }],
    class: [_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]
  }, _vm._l((_vm.length), function(key) {
    return _c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('i', {
      staticClass: "vux-icon-dot",
      class: {
        'active': key - 1 === _vm.current
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "fixed-columns": _vm.hideDistrict ? 2 : 0,
      "columns": 3,
      "data": _vm.list,
      "title": _vm.title,
      "show-name": "",
      "inline-desc": _vm.inlineDesc,
      "placeholder": _vm.placeholder,
      "value-text-align": _vm.valueTextAlign,
      "confirm-text": _vm.confirmText,
      "cancel-text": _vm.cancelText,
      "display-format": _vm.displayFormat,
      "popup-style": _vm.popupStyle,
      "show": _vm.showValue
    },
    on: {
      "on-hide": _vm.emitHide,
      "on-show": function($event) {
        _vm.$emit('on-show')
      },
      "update:show": function($event) {
        _vm.showValue = $event
      },
      "on-shadow-change": _vm.onShadowChange
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return [_vm._t("title", [(props.labelTitle) ? _c('label', {
          class: [props.labelClass, _vm.labelClass],
          style: (props.labelStyle),
          domProps: {
            "innerHTML": _vm._s(props.labelTitle)
          }
        }) : _vm._e()], {
          labelClass: props.labelClass,
          labelStyle: props.labelStyles,
          labelTitle: props.title
        })]
      }
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "nav",
    class: {
      'fixed': _vm.fixed
    }
  }, [_c('ul', _vm._l((_vm.navs), function(nav) {
    return _c('li', {
      class: {
        active: (_vm.activeNav === nav.ref)
      },
      attrs: {
        "data-ref": nav.ref
      },
      on: {
        "click": _vm.onClickNav
      }
    }, [_vm._v(_vm._s(nav.name))])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "voice"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "static/images/boss.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wx",
    attrs: {
      "src": _vm.wx
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "audio",
    attrs: {
      "src": _vm.onOff
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.currentAudioTime))])])]), _vm._v(" "), _c('audio', {
    ref: "audio",
    on: {
      "canplay": _vm.getAudioDuration
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.audio
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("北美精算师点评")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("悟空保产品定制理念")])])
}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "candidate"
  }, _vm._l((_vm.list), function(item) {
    return _c('x-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accessable !== false),
        expression: "item.accessable !== false"
      }],
      key: item.id,
      attrs: {
        "data-value": item.value,
        "type": item.value === _vm.value ? 'primary' : 'default',
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClick($event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "measure",
    on: {
      "touchmove": _vm.stopPropagation
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "保费测算"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    ref: "measureBody",
    staticStyle: {
      "overflow": "auto"
    },
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "给谁投保"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.candidateInsureds
    },
    model: {
      value: (_vm.insuredValue),
      callback: function($$v) {
        _vm.insuredValue = $$v
      },
      expression: "insuredValue"
    }
  })], 1), _vm._v(" "), _c('datetime', {
    class: {
      active: _vm.insuredBirthday !== ''
    },
    attrs: {
      "default-selected-value": "1988-08-18",
      "min-year": 1900,
      "start-date": _vm.limitDate.startDate,
      "end-date": _vm.limitDate.endDate,
      "confirm-text": "确定",
      "cancel-text": "取消",
      "title": "出生日期",
      "placeholder": _vm.birthdayPlaceholder
    },
    on: {
      "on-change": _vm.getMeasurePayment
    },
    model: {
      value: (_vm.insuredBirthday),
      callback: function($$v) {
        _vm.insuredBirthday = $$v
      },
      expression: "insuredBirthday"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在地区",
      "list": _vm.ChinaAddressV2Data,
      "confirm-text": "确定",
      "placeholder": "请选择所在地区"
    },
    model: {
      value: (_vm.holderArea),
      callback: function($$v) {
        _vm.holderArea = $$v
      },
      expression: "holderArea"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "性别"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.sexs
    },
    on: {
      "change": _vm.changeSex
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保障额度"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insuranceAmountsByBirthday
    },
    on: {
      "change": _vm.changeAmountsByBirthday
    },
    model: {
      value: (_vm.insuranceAmount),
      callback: function($$v) {
        _vm.insuranceAmount = $$v
      },
      expression: "insuranceAmount"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentPeriodsByBirthday
    },
    on: {
      "change": _vm.changePaymentPeriod
    },
    model: {
      value: (_vm.paymentPeriod),
      callback: function($$v) {
        _vm.paymentPeriod = $$v
      },
      expression: "paymentPeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "id": "when-wrap",
      "title": "保险期间",
      "primary": "content"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insurancePeriods
    },
    on: {
      "change": _vm.changeInsurancePeriod
    },
    model: {
      value: (_vm.orderInsurancePeriod),
      callback: function($$v) {
        _vm.orderInsurancePeriod = $$v
      },
      expression: "orderInsurancePeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费方式"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentMethods
    },
    model: {
      value: (_vm.orderPaymentMethod),
      callback: function($$v) {
        _vm.orderPaymentMethod = $$v
      },
      expression: "orderPaymentMethod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    staticClass: "occupation",
    attrs: {
      "title": "职业类别"
    }
  }, [_c('span', [_vm._v("1-4类")]), _c('x-button', {
    staticClass: "holderOccupationName",
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "mini": ""
    }
  }, [_vm._v("查询职业")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox-item",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell vux-x-textarea"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'),
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "weui-textarea",
    style: (_vm.textareaStyle),
    attrs: {
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.$emit('on-focus')
      },
      "blur": function($event) {
        _vm.$emit('on-blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCounter && _vm.max),
      expression: "showCounter && max"
    }],
    staticClass: "weui-textarea-counter",
    on: {
      "click": _vm.focus
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-picker"
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0
    }
  }, _vm._l((_vm.currentData), function(one, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "margin-left": "0"
      },
      attrs: {
        "span": _vm.columnWidth && _vm.columnWidth[index]
      }
    }, [_c('div', {
      staticClass: "vux-picker-item",
      attrs: {
        "id": ("vux-picker-" + _vm.uuid + "-" + index)
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "product-wrap"
  }, [_c('view-box', [_c('m-product-nav', {
    attrs: {
      "scroll-top": _vm.scrollTop,
      "offset-top": _vm.navOffsetTop,
      "active": _vm.active,
      "show": _vm.showFixedNav
    },
    on: {
      "fixedNavChange": function (value) {
        _vm.showFixedNav = value
      },
      "clickNav": _vm.onClickNav
    }
  }), _vm._v(" "), _c('m-tab-layout', {
    ref: "scroller",
    staticClass: "product",
    attrs: {
      "scrollTo": _vm.scrollTo
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    slot: "scroller"
  }, [_c('m-product-header', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    ref: "nav",
    staticClass: "nav"
  }, [_c('m-product-nav', {
    attrs: {
      "scroll-top": _vm.scrollTop,
      "offset-top": _vm.navOffsetTop,
      "active": _vm.active,
      "show": !_vm.showFixedNav
    },
    on: {
      "fixedNavChange": function (value) {
        _vm.showFixedNav = value
      },
      "clickNav": _vm.onClickNav
    }
  })], 1), _vm._v(" "), _c('m-intro', {
    ref: "nav1",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-recordScroll": _vm.recordScroll,
      "on-openDialog": _vm.onShowWhat
    }
  }), _vm._v(" "), _c('m-question', {
    ref: "nav2",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-reActiveNav": _vm.reActiveNav
    }
  }), _vm._v(" "), _c('m-message', {
    ref: "nav3",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-reActiveNav": _vm.reActiveNav,
      "on-messageReady": _vm.messageReady
    }
  }), _vm._v(" "), _c('m-process', {
    ref: "nav4",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "on-recordScroll": _vm.recordScroll
    }
  })], 1)]), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom",
    slot: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "measure-wrap",
    class: {
      'measure-wrap--active': _vm.measureState
    }
  }, [_c('m-measure', {
    on: {
      "close": function () {
        _vm.measureState = false
      }
    }
  }), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1), _vm._v(" "), _c('x-dialog', {
    staticClass: "show-what",
    attrs: {
      "hide-on-blur": ""
    },
    model: {
      value: (_vm.showWhat),
      callback: function($$v) {
        _vm.showWhat = $$v
      },
      expression: "showWhat"
    }
  }, [_c('div', {
    staticClass: "close"
  }, [_c('span', [_vm._v("3+5按需定制")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": _vm.onCloseWhat
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show-what-body"
  }, [_c('p', [_vm._v("3种交费方式：5年、10年、20年;")]), _vm._v(" "), _c('p', [_vm._v("5种保险期间：20年、30年、至60岁、至65岁、至70岁;")]), _vm._v(" "), _c('p', [_vm._v("自由组合")])])]), _vm._v(" "), _c('confirm', {
    staticClass: "agent",
    attrs: {
      "value": _vm.showAgent,
      "title": "统计业绩需要，请正确填写以下信息",
      "close-on-confirm": false
    },
    on: {
      "on-confirm": _vm.onConfirmAgent
    }
  }, [_c('group', [_c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "姓名",
      "placeholder": "请输入姓名",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentName
    },
    model: {
      value: (_vm.agentName),
      callback: function($$v) {
        _vm.agentName = $$v
      },
      expression: "agentName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "工号",
      "placeholder": "请输入工号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentJobNum
    },
    model: {
      value: (_vm.agentJobNum),
      callback: function($$v) {
        _vm.agentJobNum = $$v
      },
      expression: "agentJobNum"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-panel', {
    attrs: {
      "title": "常见问题"
    }
  }, [_c('ul', _vm._l((_vm.questions), function(question) {
    return _c('li', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "user"
    }, [_vm._v(_vm._s(question.q))])]), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_vm._v(_vm._s(question.a))])])
  }))]), _vm._v(" "), (_vm.allQuestions.length > 2) ? _c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "more",
    class: {
      'more--active': _vm.showMore
    },
    on: {
      "click": function () {
        this$1.$emit('on-reActiveNav');
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v(_vm._s(_vm.moreTips))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "order"
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('m-timer-tip'), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "产品名称",
      "value": _vm.orderName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "承保公司",
      "value": _vm.orderCompany
    }
  })], 1), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "保险信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单号",
      "value": _vm.orderNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "投保人",
      "value": _vm.insuredName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.insuredIDNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "被保险人",
      "value": _vm.insuredName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.insuredIDNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保障额度",
      "value": _vm.insuranceAmountName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间",
      "value": _vm.paymentPeriodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保险期间",
      "value": _vm.insurancePeriodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费方式",
      "value": _vm.paymentMethodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "每年保费"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "rgb(252, 158, 137)"
    }
  }, [_vm._v(_vm._s(_vm.paymentByIDNumber) + ".00")]), _vm._v("元\n            ")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "受益人",
      "value": _vm.beneficiary
    }
  })], 1)], 1)]), _vm._v(" "), (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1 && _vm.isUseCoupon) ? _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#ccc"
    },
    slot: "right"
  }, [_c('x-button', {
    staticStyle: {
      "border-radius": "100px"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTickets($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.tickedBtnText))]), _vm._v(" >\n      ")], 1)]) : _vm._e(), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("本人已认真阅读理解并同意"), _c('a', {
    attrs: {
      "href": "static/docs/toubaoxuzhi.html",
      "target": "_blank"
    }
  }, [_vm._v("《投保须知》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/baoxiantiaokuan.html",
      "target": "_blank"
    }
  }, [_vm._v("《保险条款》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/gaozhiyushengming.html",
      "target": "_blank"
    }
  }, [_vm._v("《投保人声明》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/tishishu.html",
      "target": "_blank"
    }
  }, [_vm._v("《人身保险投保提示书》")]), _vm._v("的全部内容。")])])])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "payNow",
    on: {
      "click": _vm.payNow
    }
  }, [_c('span', [_vm._v("立即支付")])])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showTicket),
      callback: function($$v) {
        _vm.showTicket = $$v
      },
      expression: "showTicket"
    }
  }, [_c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showTicket = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets",
    slot: "body"
  }, [_c('div', {
    staticClass: "tickets-list"
  }, [_c('ul', _vm._l((this.$store.state.activity.tickets), function(ticket, index) {
    return _c('li', {
      key: index,
      staticClass: "cf",
      class: {
        active: ticket.selected
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(index)
        }
      }
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/juanpic3.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "li-left"
    }, [_c('p', {
      staticClass: "li-left-number"
    }, [_c('span', [_vm._v(_vm._s(_vm.ticketValue(ticket.type, ticket.couponValue)))])]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.ticketType(ticket.type)) + ")")]), _vm._v(" "), _c('span', {
      staticClass: "circle cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/selected_ticket.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "li-right"
    }, [_c('p', {
      staticClass: "li-right-title"
    }, [_vm._v(_vm._s(ticket.configName))]), _vm._v(" "), _c('p', [_vm._v("使用范围：" + _vm._s(ticket.includeProductsName))]), _vm._v(" "), _c('p', [_vm._v("使用期限：" + _vm._s(new Date(ticket.beginDate).getFullYear()) + "." + _vm._s(new Date(ticket.beginDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.beginDate).getDate()) + "~" + _vm._s(new Date(ticket.endDate).getFullYear()) + "." + _vm._s(new Date(ticket.endDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.endDate).getDate()))]), _vm._v(" "), _c('p', [_vm._v("使用说明：" + _vm._s(ticket.mark))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tickets-btn"
  }, [_c('div', {
    staticClass: "tickets-des"
  }, [_c('p', [_vm._v("已选择" + _vm._s(this.$store.getters.selectedTickets.length) + "张券，可优惠" + _vm._s(this.$store.state.activity.amountBySelectedTickets) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets-submit",
    on: {
      "click": _vm.sureTicket
    }
  }, [_c('p', [_vm._v("确认使用")])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    attrs: {
      "dialogClass": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (!_vm.showInput) ? _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2) : _c('div', {
    staticClass: "vux-prompt"
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }, 'input', _vm.inputAttrs))]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": _vm.banner
    }
  })]), _vm._v(" "), (_vm.homeLogoDisplay) ? _c('div', {
    staticClass: "partner"
  }, [(!_vm.hidePartnerLogo) ? _c('img', {
    attrs: {
      "src": _vm.wkbLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.partnerLogo
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
        'weui-cell_access': _vm.isLink || !!_vm.link,
        'vux-cell-no-border-intent': !_vm.borderIntent,
        'vux-cell-disabled': _vm.disabled
    },
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    class: _vm.labelClass,
    style: (_vm.getLabelStyles())
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", [_vm._v(_vm._s(_vm.inlineDesc))])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    ref: "viewBoxBody",
    staticClass: "weui-tab__panel vux-fix-safari-overflow-scrolling",
    style: ({
      paddingTop: _vm.bodyPaddingTop,
      paddingBottom: _vm.bodyPaddingBottom
    }),
    attrs: {
      "id": "vux_view_box_body"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "viewbox1",
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("被保险人是否具有以下任何一种情况？")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, _vm._l((_vm.notifies), function(notify) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(notify)
      }
    })
  }))]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.fit === false
    },
    on: {
      "click": function () {
        _vm.fit = false
      }
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.fit === true
    },
    on: {
      "click": function () {
        _vm.fit = true
      }
    }
  }, [_vm._v("确认无以上情况")])]), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("下一步")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', [_c('m-timer-tip'), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单号",
      "value": _vm.orderNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "产品名称",
      "value": _vm.orderName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "支付金额"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.thisPrice))]), _vm._v("元\n      ")])]), _vm._v(" "), (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) ? _c('cell', {
    attrs: {
      "title": "返现金额",
      "primary": "content"
    }
  }, [_c('div', [_c('span', {
    staticClass: "ticket-tip",
    on: {
      "click": _vm.showTicketDialog
    }
  }, [_vm._v("?")]), _vm._v(_vm._s(this.backMoney) + "元")])]) : _vm._e(), _vm._v(" "), (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) ? _c('cell', {
    attrs: {
      "title": "实际支付",
      "primary": "content"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "rgb(252, 158, 137)"
    }
  }, [_vm._v(_vm._s(_vm.actualPrice || _vm.thisPrice))]), _vm._v("元")])]) : _vm._e()], 1), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "支付信息"
    }
  }, [_c('div', {
    staticClass: "payment-info",
    slot: "right"
  }, [_c('p', [_vm._v("提示：剩余各期保费将从该银行卡中扣除")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "持卡人姓名",
      "value": _vm.insuredName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.insuredIDNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "手机",
      "value": _vm.holderPhoneNumber
    }
  }), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "银行",
      "data": _vm.bankList,
      "show-name": "",
      "columns": 1,
      "placeholder": "请选择银行"
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "银行卡号",
      "max": 19,
      "keyboard": "number",
      "show-clear": false,
      "placeholder": "请输入银行卡号(不支持信用卡)",
      "text-align": "right",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.bankCardNumber),
      callback: function($$v) {
        _vm.bankCardNumber = $$v
      },
      expression: "bankCardNumber"
    }
  })], 1)], 1)]), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("本人已认真阅读理解并同意"), _c('a', {
    on: {
      "click": function($event) {
        _vm.openNewWindow('static/docs/zhuanzhangshengming.html')
      }
    }
  }, [_vm._v("《支付授权声明》")]), _vm._v("，且声明本人仅为中国税收居民。")])])]), _vm._v(" "), _c('tabbar', {
    staticClass: "payBar",
    slot: "bottom"
  }, [_c('div', {
    staticClass: "payBar-price"
  }, [_c('p', [_vm._v("价格："), _c('span', [_vm._v("￥"), _c('label', [_vm._v(_vm._s(_vm.actualPrice || _vm.thisPrice))]), _vm._v("/年")])])]), _vm._v(" "), _c('div', {
    staticClass: "payBar-btn",
    on: {
      "click": _vm.submitPay
    }
  }, [_c('span', [_vm._v("提交支付")])])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "rules",
    model: {
      value: (_vm.ticketDialog),
      callback: function($$v) {
        _vm.ticketDialog = $$v
      },
      expression: "ticketDialog"
    }
  }, [_c('div', {
    staticClass: "head cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/rules_bg.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("返现金额")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": function($event) {
        _vm.ticketDialog = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "body"
  }, [_c('p', [_vm._v("商品价格：" + _vm._s(_vm.actualPrice || _vm.thisPrice) + "元")]), _vm._v(" "), _c('p', [_vm._v("商品优惠：" + _vm._s(_vm.productBackMoney) + "元")]), _vm._v(" "), (_vm.couponsName) ? _c('p', [_vm._v("优惠劵：" + _vm._s(_vm.couponsName))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("返现金额：" + _vm._s(_vm.backMoney) + "元")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("注：返现金额将在支付成功后存入您的账户，关注悟空保微信号iwukongbao，进入“我的>个人中心>我的钱包”查看。")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-switch weui-cell weui-cell_switch"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: (_vm.labelStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-switch",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.currentValue = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.currentValue = $$c
        }
      }
    }
  }), _vm._v(" "), (_vm.preventDefault) ? _c('div', {
    staticClass: "vux-x-switch-overlay",
    on: {
      "click": _vm.onClick
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('m-column', {
    attrs: {
      "title": "投保人暨被保险人信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('x-input', {
    attrs: {
      "max": 8,
      "show-clear": false,
      "type": "text",
      "title": "投保姓名",
      "placeholder": "请输入投保姓名",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkInsuredName
    },
    model: {
      value: (_vm.insuredName),
      callback: function($$v) {
        _vm.insuredName = $$v
      },
      expression: "insuredName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 18,
      "show-clear": false,
      "type": "text",
      "title": "身份证号",
      "placeholder": "请输入身份证号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkInsuredIDNumber
    },
    model: {
      value: (_vm.insuredIDNumber),
      callback: function($$v) {
        _vm.insuredIDNumber = $$v
      },
      expression: "insuredIDNumber"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "id": "IDNumber-wrap",
      "title": _vm.IDNumberTitle
    },
    on: {
      "on-change": _vm.changeIDNumberExpire
    },
    model: {
      value: (_vm.IDNumberValue),
      callback: function($$v) {
        _vm.IDNumberValue = $$v
      },
      expression: "IDNumberValue"
    }
  }), _vm._v(" "), (!_vm.IDNumberValue) ? _c('datetime', {
    ref: "IDNumberExpire",
    class: {
      active: !(_vm.IDNumberExpire === '' || _vm.IDNumberExpire === '9999-10-10')
    },
    attrs: {
      "default-selected-value": "2030-08-18",
      "max-year": 3017,
      "start-date": _vm.limitDate.startDate,
      "end-date": _vm.limitDate.endDate,
      "placeholder": "请选择身份证有效期",
      "confirm-text": "确定",
      "cancel-text": "取消",
      "title": "&nbsp;"
    },
    model: {
      value: (_vm.IDNumberExpire),
      callback: function($$v) {
        _vm.IDNumberExpire = $$v
      },
      expression: "IDNumberExpire"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 11,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机号码",
      "placeholder": "请输入手机号码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhoneNumber
    },
    model: {
      value: (_vm.holderPhoneNumber),
      callback: function($$v) {
        _vm.holderPhoneNumber = $$v
      },
      expression: "holderPhoneNumber"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 4,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机验证码",
      "placeholder": "请输入手机验证码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderCAPTCHA
    },
    model: {
      value: (_vm.holderCAPTCHA),
      callback: function($$v) {
        _vm.holderCAPTCHA = $$v
      },
      expression: "holderCAPTCHA"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCAPTCHA($event)
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 50,
      "show-clear": false,
      "type": "text",
      "title": "电子邮箱",
      "placeholder": "请输入个人电子邮箱",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderEmail
    },
    model: {
      value: (_vm.holderEmail),
      callback: function($$v) {
        _vm.holderEmail = $$v
      },
      expression: "holderEmail"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在地区",
      "list": _vm.ChinaAddressV2Data,
      "placeholder": "请选择所在地区"
    },
    model: {
      value: (_vm.holderArea),
      callback: function($$v) {
        _vm.holderArea = $$v
      },
      expression: "holderArea"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false,
      "max": 50,
      "type": "text",
      "title": "详细地址",
      "placeholder": "请输入详细地址",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderAddress
    },
    model: {
      value: (_vm.holderAddress),
      callback: function($$v) {
        _vm.holderAddress = $$v
      },
      expression: "holderAddress"
    }
  }), _vm._v(" "), _c('cell', {
    staticClass: "occupation holderOccupationName",
    attrs: {
      "title": "职业类别",
      "is-link": "",
      "primary": "content"
    }
  }, [_c('span', {
    ref: "occupation",
    staticClass: "selected-occupation",
    staticStyle: {
      "margin-left": "3px"
    },
    attrs: {
      "code": _vm.occupationCode
    }
  }, [_vm._v(_vm._s(_vm.occupationName))])])], 1)], 1)]), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "title": "其他信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "保障额度"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insuranceAmountsByIDNumber
    },
    model: {
      value: (_vm.insuranceAmount),
      callback: function($$v) {
        _vm.insuranceAmount = $$v
      },
      expression: "insuranceAmount"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentPeriodsByIDNumber
    },
    on: {
      "change": _vm.changePaymentPeriod
    },
    model: {
      value: (_vm.paymentPeriod),
      callback: function($$v) {
        _vm.paymentPeriod = $$v
      },
      expression: "paymentPeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "id": "when-wrap",
      "title": "保险期间",
      "primary": "content"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insurancePeriods
    },
    on: {
      "change": _vm.changeInsurancePeriod
    },
    model: {
      value: (_vm.orderInsurancePeriod),
      callback: function($$v) {
        _vm.orderInsurancePeriod = $$v
      },
      expression: "orderInsurancePeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "受益人",
      "value": "法定"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格："), (_vm.paymentShowNull === false) ? _c('label', {
    staticClass: "mark"
  }, [_c('span', {
    staticClass: "payment"
  }, [_vm._v("暂无")])]) : _c('label', {
    staticClass: "mark"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "payment"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".00/年"), (typeof _vm.number === 'string') ? _c('span', [_vm._v(" 起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submitOrder
    }
  }, [_c('span', [_vm._v("提交订单")])])])]), _vm._v(" "), _c('m-login', {
    attrs: {
      "showLogin": _vm.showLogin
    },
    on: {
      "close": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-input weui-cell",
    class: {
      'weui-cell_warn': _vm.showWarn
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: ({
      width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    attrs: {
      "for": ("vux-x-input-" + _vm.uuid)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd weui-cell__primary",
    class: _vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''
  }, [(!_vm.type || _vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "text",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "number",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": [_vm.onBlur, function($event) {
        _vm.$forceUpdate()
      }],
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "email",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "password",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "tel",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.equalWith && _vm.showClear && _vm.currentValue && !_vm.readonly && !_vm.disabled),
      expression: "!equalWith && showClear && currentValue && !readonly && !disabled"
    }],
    attrs: {
      "type": "clear"
    },
    nativeOn: {
      "click": function($event) {
        _vm.clear($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarn),
      expression: "showWarn"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": !_vm.valid ? _vm.firstError : ''
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClickErrorIcon($event)
      }
    }
  }), _vm._v(" "), (!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid) ? _c('icon', {
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClickErrorIcon($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),
      expression: "!novalidate && equalWith && equalWith === currentValue && valid"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'success'),
      expression: "novalidate && iconType === 'success'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'error'),
      expression: "novalidate && iconType === 'error'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    }
  }), _vm._v(" "), _vm._t("right")], 2), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "width": "auto",
      "time": 600
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v(_vm._s(_vm.firstError))])], 1)
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timer-tip"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.timerTip)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-panel', {
    attrs: {
      "title": "用户评价"
    }
  }, [_c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "user"
    }, [_vm._v(_vm._s(message.user))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(message.date))])]), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_vm._v(_vm._s(message.message))])])
  }))]), _vm._v(" "), (_vm.allMessages.length > 4) ? _c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "more",
    class: {
      'more--active': !_vm.showMoreState
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.moreTips))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-cell-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCell),
      expression: "showCell"
    }],
    staticClass: "weui-cell vux-tap-active weui-cell_access",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("title", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: (_vm.labelStyles),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e()], {
    labelClass: "weui-label",
    labelStyle: _vm.labelStyles,
    labelTitle: _vm.title
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-primary vux-popup-picker-select-box"
  }, [_c('div', {
    staticClass: "vux-popup-picker-select",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [(!_vm.displayFormat && !_vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]) : _vm._e(), _vm._v(" "), (!_vm.displayFormat && _vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("value2name")(_vm.value, _vm.data)))]) : _vm._e(), _vm._v(" "), (_vm.displayFormat && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]) : _vm._e(), _vm._v(" "), (!_vm.value.length && _vm.placeholder) ? _c('span', {
    staticClass: "vux-popup-picker-placeholder vux-cell-placeholder",
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: (_vm.isTransferDom),
      expression: "isTransferDom"
    }]
  }, [_c('popup', {
    staticClass: "vux-popup-picker",
    attrs: {
      "id": ("vux-popup-picker-" + _vm.uuid),
      "popup-style": _vm.popupStyle
    },
    on: {
      "on-hide": _vm.onPopupHide,
      "on-show": _vm.onPopupShow
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "vux-popup-picker-container"
  }, [_c('div', {
    staticClass: "vux-popup-picker-header",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('flexbox', [_c('flexbox-item', {
    staticClass: "vux-popup-picker-header-menu vux-popup-picker-cancel",
    nativeOn: {
      "click": function($event) {
        _vm.onHide(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "vux-popup-picker-header-menu vux-popup-picker-header-menu-right",
    nativeOn: {
      "click": function($event) {
        _vm.onHide(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '完成'))])], 1)], 1), _vm._v(" "), _c('picker', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "fixed-columns": _vm.fixedColumns,
      "container": '#vux-popup-picker-' + _vm.uuid,
      "column-width": _vm.columnWidth
    },
    on: {
      "on-change": _vm.onPickerChange
    },
    model: {
      value: (_vm.tempValue),
      callback: function($$v) {
        _vm.tempValue = $$v
      },
      expression: "tempValue"
    }
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('m-panel', {
    attrs: {
      "title": "理赔流程"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("(理赔材料详见"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.AppConfig.processNotice
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("《理赔须知》")]), _vm._v(")")]), _vm._v(" "), _c('ul', {
    staticClass: "process"
  }, [_c('li', [_c('p', {
    staticClass: "title"
  }, [_vm._v("申请理赔")]), _vm._v(" "), _c('p', {
    staticClass: "content",
    staticStyle: {
      "background-image": "url('static/images/process_line_1.png')"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lipeiliucheng)
    }
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_2.png')"
    }
  }, [_vm._v("提交材料")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("按照保险公司的要求准备理赔资料并提交")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_3.png')"
    }
  }, [_vm._v("理赔审核")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("保险公司根据理赔材料进行理赔审核")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_4.png')"
    }
  }, [_vm._v("获得赔款")]), _vm._v(" "), _c('p', {
    staticClass: "content",
    staticStyle: {
      "background-image": "url('static/images/process_line_3.png')"
    }
  }, [_vm._v("保险公司支付理赔")])])])])
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('img', {
    attrs: {
      "src": "static/images/logo.png"
    }
  })])
}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [(_vm.showMedia) ? _c('div', {
    staticClass: "row voice"
  }, [_c('m-voice')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      paddingTop10: _vm.h5
    },
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "static/images/slogan.png"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zhi slogon"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "zhi-item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("3+5按需定制")]), _c('label', {
    on: {
      "click": function () {
        this$1.$emit('on-openDialog')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/what.png"
    }
  })])])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": _vm.VSSrc
    }
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    attrs: {
      "href": "static/docs/baoxiantiaokuan.html",
      "target": "_blank"
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("保险条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/docs/xinxipilou.html",
      "target": "_blank"
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("信息披露")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "static/images/uses.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("投保年龄"), _c('span', [_vm._v("(宽)")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("18-60周岁")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("保障责任"), _c('span', [_vm._v("(全)")])]), _vm._v(" "), _c('p', {
    staticClass: "small exclamation"
  }, [_c('span', [_vm._v("身故及全残")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("保险方式"), _c('span', [_vm._v("(多)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("等待期"), _c('span', [_vm._v("(短)")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("90天")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("人寿保险成本结构对比")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("同类定期寿险对比 "), _c('span', [_vm._v("(以女性，100万保额，20年交，保30年为例)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row image-pk"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/pk.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "niu",
    attrs: {
      "src": "static/images/niu.png"
    }
  })])
}]}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy"
  }, [_c('div', {
    staticClass: "service"
  }, [(_vm.showPoster) ? _c('a', {
    staticClass: "dial",
    attrs: {
      "href": _vm.posterURL
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/poster.png"
    }
  }), _c('span', [_vm._v("海报")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dial",
    attrs: {
      "id": "tel-ask-about",
      "href": _vm.tel
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/phone.png"
    }
  }), _c('span', [_vm._v("客服")])])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格: "), (_vm.measureReady === false) ? _c('span', [_c('i', {
    staticClass: "number"
  }, [_vm._v("暂无")])]) : _c('span', [_vm._v("￥"), _c('i', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".00/年"), (_vm.measureReady === '') ? _c('i', [_vm._v(" 起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function () {
        this$1.$emit('clickBuy')
      }
    }
  }, [_c('span', [_vm._v("立即购买")])])])
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "occupation"
  }, [_c('popup', {
    attrs: {
      "height": "80%"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('scroller', {
    attrs: {
      "height": "100px"
    }
  }, [_c('div', _vm._l((10), function(i) {
    return _c('p', [_vm._v(_vm._s(i))])
  }))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: ({
      color: _vm.titleColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: ({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    })
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog"
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": _vm.hide
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-183c1df5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  "data-v-c5aa1e1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  "data-v-3ad2972e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  "data-v-9387c230",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  "data-v-cf3db98a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  "data-v-1bf1f4be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  "data-v-10d4a6ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)
__webpack_require__(593)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  "data-v-61b7a4e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  "data-v-9959c706",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-c01de5d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-3c0c4a49",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  "data-v-741a2872",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  "data-v-5f1e94a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  "data-v-d2146fa0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)
__webpack_require__(583)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  "data-v-54a7ecf9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  "data-v-13a224af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)
__webpack_require__(590)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  "data-v-5fa14213",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  "data-v-97925a4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)
__webpack_require__(580)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  "data-v-4f3c415a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-575b5807",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-2de18c19",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  "data-v-5430e48b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-186b46fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  "data-v-0b40926c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)
__webpack_require__(597)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  "data-v-7356608a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  "data-v-2f41b4dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */,
/* 717 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(212);
module.exports = __webpack_require__(211);


/***/ })
]),[718]);


// WEBPACK FOOTER //
// static/js/app.16be47001b3d763172e8.js